var __defProp = Object.defineProperty;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __esm = (fn, res) => function __init() {
  return fn && (res = (0, fn[__getOwnPropNames(fn)[0]])(fn = 0)), res;
};
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};

// src/icons/payments/helpers.tsx
import { jsx } from "@emotion/react/jsx-runtime";
function PaymentIconWrapper({
  size,
  children,
  viewBox = "0 0 70 48"
}) {
  const [width, height] = SIZES[size];
  return /* @__PURE__ */ jsx(
    "svg",
    {
      width,
      height,
      viewBox,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children
    }
  );
}
var PaymentIconSize, SIZES;
var init_helpers = __esm({
  "src/icons/payments/helpers.tsx"() {
    "use strict";
    PaymentIconSize = /* @__PURE__ */ ((PaymentIconSize2) => {
      PaymentIconSize2["SMALL"] = "small";
      PaymentIconSize2["MEDIUM"] = "medium";
      PaymentIconSize2["X_LARGE"] = "x-large";
      PaymentIconSize2["XX_LARGE"] = "xx-large";
      return PaymentIconSize2;
    })(PaymentIconSize || {});
    SIZES = {
      ["xx-large" /* XX_LARGE */]: [70, 48],
      ["x-large" /* X_LARGE */]: [58, 40],
      ["medium" /* MEDIUM */]: [35, 24],
      ["small" /* SMALL */]: [23, 16]
    };
  }
});

// src/icons/payments/amex.tsx
import { jsx as jsx2, jsxs } from "@emotion/react/jsx-runtime";
function Amex({ size }) {
  return /* @__PURE__ */ jsxs(PaymentIconWrapper, { size, children: [
    /* @__PURE__ */ jsx2(
      "rect",
      {
        x: "0.5",
        y: "0.5",
        width: "69",
        height: "47",
        rx: "5.5",
        fill: "#1F72CD",
        stroke: "#D9D9D9"
      }
    ),
    /* @__PURE__ */ jsx2(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12.5493 17L6 31.4935H13.8405L14.8125 29.1826H17.0342L18.0062 31.4935H26.6364V29.7298L27.4054 31.4935H31.8696L32.6386 29.6925V31.4935H50.587L52.7695 29.2426L54.813 31.4935L64.0317 31.5121L57.4617 24.2872L64.0317 17H54.956L52.8315 19.2093L50.8523 17H31.3268L29.6501 20.7409L27.9341 17H20.11V18.7037L19.2396 17H12.5493ZM39.3516 19.0581H49.6584L52.8108 22.4633L56.0648 19.0581H59.2172L54.4275 24.2852L59.2172 29.452H55.9218L52.7695 26.0073L49.4989 29.452H39.3516V19.0581ZM41.8968 23.1099V21.2114V21.2096H48.328L51.1342 24.2458L48.2036 27.2986H41.8968V25.226H47.5197V23.1099H41.8968ZM14.0664 19.0581H17.8883L22.2324 28.8862V19.0581H26.4191L29.7745 26.1048L32.8668 19.0581H37.0326V29.4581H34.4978L34.4771 21.3087L30.7817 29.4581H28.5142L24.7981 21.3087V29.4581H19.5836L18.595 27.1266H13.254L12.2675 29.4561H9.47358L14.0664 19.0581ZM14.166 24.9712L15.9256 20.8177L17.6832 24.9712H14.166Z",
        fill: "white"
      }
    )
  ] });
}
var init_amex = __esm({
  "src/icons/payments/amex.tsx"() {
    "use strict";
    init_helpers();
  }
});

// src/icons/payments/mastercard.tsx
import { jsx as jsx3, jsxs as jsxs2 } from "@emotion/react/jsx-runtime";
function Mastercard({ size }) {
  return /* @__PURE__ */ jsxs2(PaymentIconWrapper, { size, children: [
    /* @__PURE__ */ jsx3(
      "rect",
      {
        x: "0.5",
        y: "0.5",
        width: "69",
        height: "47",
        rx: "5.5",
        fill: "white",
        stroke: "#D9D9D9"
      }
    ),
    /* @__PURE__ */ jsx3(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M35.5 34.3139C33.1169 36.3704 30.0255 37.6119 26.6475 37.6119C19.1102 37.6119 13 31.4308 13 23.806C13 16.1811 19.1102 10 26.6475 10C30.0255 10 33.1169 11.2415 35.5 13.2981C37.8831 11.2415 40.9745 10 44.3525 10C51.8898 10 58 16.1811 58 23.806C58 31.4308 51.8898 37.6119 44.3525 37.6119C40.9745 37.6119 37.8831 36.3704 35.5 34.3139Z",
        fill: "#ED0006"
      }
    ),
    /* @__PURE__ */ jsx3(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M35.5 34.3139C38.4344 31.7816 40.2951 28.0136 40.2951 23.806C40.2951 19.5983 38.4344 15.8303 35.5 13.2981C37.8831 11.2415 40.9745 10 44.3525 10C51.8898 10 58 16.1811 58 23.806C58 31.4308 51.8898 37.6119 44.3525 37.6119C40.9745 37.6119 37.8831 36.3704 35.5 34.3139Z",
        fill: "#F9A000"
      }
    ),
    /* @__PURE__ */ jsx3(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M35.5001 13.2981C38.4345 15.8304 40.2951 19.5983 40.2951 23.806C40.2951 28.0136 38.4345 31.7815 35.5001 34.3138C32.5657 31.7815 30.7051 28.0136 30.7051 23.806C30.7051 19.5983 32.5657 15.8304 35.5001 13.2981Z",
        fill: "#FF5E00"
      }
    )
  ] });
}
var init_mastercard = __esm({
  "src/icons/payments/mastercard.tsx"() {
    "use strict";
    init_helpers();
  }
});

// src/icons/payments/paypal.tsx
import { jsx as jsx4, jsxs as jsxs3 } from "@emotion/react/jsx-runtime";
function Paypal({ size }) {
  return /* @__PURE__ */ jsxs3(PaymentIconWrapper, { size, children: [
    /* @__PURE__ */ jsx4(
      "rect",
      {
        x: 0.5,
        y: 0.5,
        width: 69,
        height: 47,
        rx: 5.5,
        fill: "#fff",
        stroke: "#D9D9D9"
      }
    ),
    /* @__PURE__ */ jsx4(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M19.8 30.482h-3.111a.432.432 0 0 0-.427.365l-1.259 7.978c-.025.157.097.3.257.3h1.485a.432.432 0 0 0 .427-.366l.34-2.152a.432.432 0 0 1 .427-.365h.984c2.05 0 3.233-.992 3.542-2.957.139-.86.006-1.535-.397-2.009-.442-.52-1.227-.794-2.268-.794Zm.359 2.914c-.17 1.116-1.023 1.116-1.848 1.116h-.47l.33-2.085a.26.26 0 0 1 .256-.218h.215c.562 0 1.092 0 1.366.32.163.19.213.475.151.867Zm8.941-.036h-1.49a.26.26 0 0 0-.256.219l-.066.417-.104-.151c-.323-.468-1.042-.625-1.76-.625-1.646 0-3.052 1.247-3.326 2.996-.142.873.06 1.707.555 2.289.454.535 1.104.758 1.877.758 1.326 0 2.062-.853 2.062-.853l-.067.414a.26.26 0 0 0 .256.3h1.342a.432.432 0 0 0 .427-.365l.805-5.1a.258.258 0 0 0-.255-.299Zm-2.077 2.9c-.143.851-.819 1.422-1.68 1.422-.433 0-.779-.138-1-.401-.221-.261-.305-.633-.235-1.047a1.668 1.668 0 0 1 1.67-1.434c.423 0 .767.14.993.406.227.268.317.642.252 1.054Zm8.515-2.9h1.497a.26.26 0 0 1 .213.407l-4.98 7.188a.432.432 0 0 1-.355.186h-1.495a.26.26 0 0 1-.212-.41l1.55-2.189-1.648-4.84a.26.26 0 0 1 .246-.342h1.47c.192 0 .36.125.416.308l.875 2.923 2.065-3.041a.433.433 0 0 1 .358-.19Z",
        fill: "#253B80"
      }
    ),
    /* @__PURE__ */ jsx4(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "m51.77 38.825 1.278-8.124a.26.26 0 0 1 .255-.22h1.438a.26.26 0 0 1 .255.3l-1.259 7.978a.432.432 0 0 1-.427.365h-1.284a.259.259 0 0 1-.255-.3Zm-9.778-8.343H38.88a.432.432 0 0 0-.427.365l-1.258 7.978c-.025.157.097.3.256.3h1.597a.302.302 0 0 0 .298-.256l.357-2.262a.432.432 0 0 1 .427-.365h.984c2.05 0 3.233-.992 3.542-2.957.14-.86.005-1.536-.397-2.009-.442-.52-1.226-.794-2.267-.794Zm.359 2.914c-.17 1.116-1.023 1.116-1.848 1.116h-.47l.33-2.085a.258.258 0 0 1 .256-.219h.215c.562 0 1.092 0 1.366.32.164.192.213.476.151.868Zm8.94-.036h-1.488a.258.258 0 0 0-.256.219l-.066.417-.105-.151c-.322-.469-1.041-.625-1.759-.625-1.646 0-3.052 1.247-3.326 2.996-.142.873.06 1.707.555 2.289.455.535 1.103.758 1.876.758 1.327 0 2.062-.853 2.062-.853l-.066.414a.26.26 0 0 0 .257.3h1.341a.432.432 0 0 0 .427-.365l.805-5.1a.26.26 0 0 0-.257-.299Zm-2.076 2.9c-.143.85-.82 1.422-1.681 1.422-.432 0-.779-.138-1-.401-.22-.261-.304-.633-.234-1.047a1.668 1.668 0 0 1 1.67-1.434c.422 0 .766.14.993.406.228.268.318.642.252 1.054Z",
        fill: "#179BD7"
      }
    ),
    /* @__PURE__ */ jsx4(
      "path",
      {
        d: "m31.314 27.628.383-2.43-.852-.02h-4.069l2.828-17.927a.231.231 0 0 1 .23-.196h6.86c2.277 0 3.848.474 4.669 1.41.385.438.63.896.748 1.401.124.53.127 1.162.005 1.934l-.009.056v.495l.385.217c.324.172.581.37.779.594.33.375.542.852.632 1.418.093.581.062 1.273-.09 2.056-.176.901-.46 1.686-.843 2.328a4.793 4.793 0 0 1-1.334 1.463 5.416 5.416 0 0 1-1.798.811c-.663.172-1.418.26-2.247.26h-.534c-.381 0-.752.137-1.043.384a1.616 1.616 0 0 0-.544.97l-.04.22-.676 4.281-.031.158c-.008.05-.022.074-.042.091a.115.115 0 0 1-.07.026h-3.297Z",
        fill: "#253B80"
      }
    ),
    /* @__PURE__ */ jsx4(
      "path",
      {
        d: "M42.856 11.914c-.02.13-.044.264-.07.402-.905 4.644-4 6.25-7.953 6.25h-2.012a.978.978 0 0 0-.966.827l-1.031 6.535-.292 1.853a.515.515 0 0 0 .508.595h3.57a.859.859 0 0 0 .849-.724l.035-.181.672-4.265.043-.234a.858.858 0 0 1 .848-.726h.534c3.459 0 6.166-1.404 6.958-5.468.33-1.697.16-3.114-.716-4.111a3.41 3.41 0 0 0-.977-.753Z",
        fill: "#179BD7"
      }
    ),
    /* @__PURE__ */ jsx4(
      "path",
      {
        d: "M41.91 11.536a7.115 7.115 0 0 0-.88-.195 11.186 11.186 0 0 0-1.775-.13H33.88a.857.857 0 0 0-.848.726l-1.144 7.245-.033.211a.978.978 0 0 1 .966-.828h2.013c3.953 0 7.048-1.605 7.953-6.249.027-.138.05-.271.07-.402a4.825 4.825 0 0 0-.946-.378Z",
        fill: "#222D65"
      }
    ),
    /* @__PURE__ */ jsx4(
      "path",
      {
        d: "M33.031 11.937a.855.855 0 0 1 .848-.725h5.377c.637 0 1.231.042 1.774.13a7.158 7.158 0 0 1 1.083.258c.267.088.515.193.744.314.27-1.717-.002-2.886-.93-3.944-1.023-1.165-2.87-1.664-5.233-1.664h-6.86a.98.98 0 0 0-.97.829l-2.857 18.112a.59.59 0 0 0 .582.681h4.235l1.063-6.746 1.144-7.245Z",
        fill: "#253B80"
      }
    )
  ] });
}
var init_paypal = __esm({
  "src/icons/payments/paypal.tsx"() {
    "use strict";
    init_helpers();
  }
});

// src/icons/payments/sepa.tsx
import { jsx as jsx5, jsxs as jsxs4 } from "@emotion/react/jsx-runtime";
function Sepa({ size }) {
  return /* @__PURE__ */ jsxs4(
    PaymentIconWrapper,
    {
      size,
      viewBox: "-.28266667 -10.16017133 891.07166667 253.68217133",
      children: [
        /* @__PURE__ */ jsx5(
          "path",
          {
            d: "m197.703 77.694h-60.973q0-15.005-3.52-20.137-5.44-7.583-30.029-7.587-23.875 0-31.615 4.369-7.722 4.39-7.726 19.079 0 13.294 6.854 17.5 4.918 2.977 13 3.5l12.294.867q39.534 2.616 49.373 3.682 31.263 3.151 45.324 16.621 11.061 10.511 13.176 27.469a191.207 191.207 0 0 1 1.229 22.929q0 29.412-5.612 43.056-10.177 25.043-45.765 31.671-14.915 2.8-45.607 2.806-51.221 0-71.374-6.117-24.73-7.506-32.621-30.4-4.4-12.752-4.381-42.473h60.967v5.069q0 15.861 9.108 20.4a35.743 35.743 0 0 0 15.239 3.316h22.418q17.155 0 21.885-1.762 8.41-3.3 11.042-10.657a40.749 40.749 0 0 0 1.4-11.724q0-16.076-11.724-19.58-4.4-1.384-40.784-3.845-29.231-2.087-40.6-4.03-29.941-5.6-39.9-23.072-8.761-14.857-8.751-44.943 0-22.894 4.73-36.712t15.246-20.986q15.429-11.019 39.439-12.939 19.993-1.742 44.354-1.757 38.379 0 54.7 4.392 39.8 10.692 39.8 59.9 0 4.035-.594 12.1m268.101 165.823v-243.5h122.1q25.12 0 38.307 4.1 30.122 9.433 40.454 38.641 5.343 15.332 5.347 46.154 0 37.05-5.89 53.254-11.748 32.051-48.294 36.87-4.292.723-36.545 1.252l-10.875.362h-39.069v62.867zm65.539-119.35h40.858q19.43-.7 23.666-3.019c3.872-2.129 6.474-6.4 7.768-12.791q1.245-6.379 1.243-18.991 0-15.45-2.477-22.919-3.534-10.483-16.941-12.786-2.657-.348-12.712-.357h-41.4zm280.56 77.268h-87.623l-11.775 42.082h-67.8l73.166-243.5h98.857l74.059 243.5h-66.38zm-13.013-47.434-30.71-105.553-29.8 105.553z",
            fill: "#10298e"
          }
        ),
        /* @__PURE__ */ jsx5(
          "path",
          {
            d: "m375.353 34.281a86.153 86.153 0 0 1 67.01 31.954l14.126-30.289a123.816 123.816 0 0 0 -85.328-33.767c-51.64 0-95.814 31.193-113.938 75.344h-27.548l-16.269 34.87h35.436q-.422 4.875-.441 9.772a117.841 117.841 0 0 0 .6 11.849h-17.805l-16.264 34.88h43.13c18.643 43.033 62.265 73.243 113.094 73.243a124.152 124.152 0 0 0 69.076-20.791v-42.745a86.218 86.218 0 0 1 -137.131-9.707h90.309l16.262-34.88h-119.856a87.87 87.87 0 0 1 -.51-21.625h130.453l16.26-34.866h-135.443a86.367 86.367 0 0 1 74.778-43.246",
            fill: "#ffbe00"
          }
        ),
        /* @__PURE__ */ jsx5(
          "path",
          {
            d: "m375.353 35.325a85.022 85.022 0 0 1 66.2 31.573l1.053 1.3.714-1.517 14.124-30.29.315-.691-.543-.519a125.936 125.936 0 0 0 -156.172-12.744 121.519 121.519 0 0 0 -44.786 54.692l.965-.649h-28.221l-.278.6-16.264 34.877-.7 1.489h37.084l-1.043-1.136q-.422 4.919-.441 9.86c0 3.914.2 7.944.6 11.956l1.043-1.15h-18.466l-.278.6-16.274 34.877-.691 1.489h44.772l-.96-.631c19.441 44.874 64.213 73.873 114.054 73.873a125.107 125.107 0 0 0 69.648-20.958l.459-.306v-46.093l-1.827 2.087a85.181 85.181 0 0 1 -135.471-9.591l-.872 1.623h90.982l.278-.6 16.264-34.885.7-1.484h-121.51l1.039.9a86.817 86.817 0 0 1 -.506-21.374l-1.043.941h131.126l.278-.6 16.26-34.875.7-1.489h-137.09l.9 1.572a85.721 85.721 0 0 1 73.878-42.727m-74.778 43.246h135.439l-.951-1.489-16.255 34.875.946-.6h-131.4l-.1.946a90.248 90.248 0 0 0 .519 21.876l.139.9h120.76l-.946-1.493-16.26 34.875.941-.6h-92.252l1.067 1.614a87.289 87.289 0 0 0 138.8 9.832l-1.837-.691v42.745l.464-.863a123.084 123.084 0 0 1 -68.484 20.605c-49.011 0-93.022-28.508-112.13-72.617l-.278-.626h-43.821l.955 1.5 16.253-34.901-.951.612h18.971l-.12-1.159c-.394-3.942-.6-7.9-.6-11.743 0-2.954.148-6.126.441-9.683l.093-1.132h-36.568l.941 1.489 16.265-34.875-.941.6h28.243l.264-.649a119.518 119.518 0 0 1 44.03-53.751 123.856 123.856 0 0 1 153.558 12.535l-.232-1.206-14.117 30.297 1.762-.223a87.318 87.318 0 0 0 -143.517 11.432l-.909 1.572z",
            fill: "#10298e"
          }
        )
      ]
    }
  );
}
var init_sepa = __esm({
  "src/icons/payments/sepa.tsx"() {
    "use strict";
    init_helpers();
  }
});

// src/icons/payments/visa.tsx
import { jsx as jsx6, jsxs as jsxs5 } from "@emotion/react/jsx-runtime";
function Visa({ size }) {
  return /* @__PURE__ */ jsxs5(PaymentIconWrapper, { size, children: [
    /* @__PURE__ */ jsx6(
      "rect",
      {
        x: "0.5",
        y: "0.5",
        width: "69",
        height: "47",
        rx: "5.5",
        fill: "white",
        stroke: "#D9D9D9"
      }
    ),
    /* @__PURE__ */ jsx6(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M21.2505 32.5165H17.0099L13.8299 20.3847C13.679 19.8267 13.3585 19.3333 12.8871 19.1008C11.7106 18.5165 10.4142 18.0514 9 17.8169V17.3498H15.8313C16.7742 17.3498 17.4813 18.0514 17.5991 18.8663L19.2491 27.6173L23.4877 17.3498H27.6104L21.2505 32.5165ZM29.9675 32.5165H25.9626L29.2604 17.3498H33.2653L29.9675 32.5165ZM38.4467 21.5514C38.5646 20.7346 39.2717 20.2675 40.0967 20.2675C41.3931 20.1502 42.8052 20.3848 43.9838 20.9671L44.6909 17.7016C43.5123 17.2345 42.216 17 41.0395 17C37.1524 17 34.3239 19.1008 34.3239 22.0165C34.3239 24.2346 36.3274 25.3992 37.7417 26.1008C39.2717 26.8004 39.861 27.2675 39.7431 27.9671C39.7431 29.0165 38.5646 29.4836 37.3881 29.4836C35.9739 29.4836 34.5596 29.1338 33.2653 28.5494L32.5582 31.8169C33.9724 32.3992 35.5025 32.6338 36.9167 32.6338C41.2752 32.749 43.9838 30.6502 43.9838 27.5C43.9838 23.5329 38.4467 23.3004 38.4467 21.5514ZM58 32.5165L54.82 17.3498H51.4044C50.6972 17.3498 49.9901 17.8169 49.7544 18.5165L43.8659 32.5165H47.9887L48.8116 30.3004H53.8772L54.3486 32.5165H58ZM51.9936 21.4342L53.1701 27.1502H49.8723L51.9936 21.4342Z",
        fill: "#172B85"
      }
    )
  ] });
}
var init_visa = __esm({
  "src/icons/payments/visa.tsx"() {
    "use strict";
    init_helpers();
  }
});

// src/icons/payments/klarna.tsx
import { jsx as jsx7, jsxs as jsxs6 } from "@emotion/react/jsx-runtime";
function Klarna({ size }) {
  return /* @__PURE__ */ jsxs6(PaymentIconWrapper, { size, children: [
    /* @__PURE__ */ jsx7(
      "rect",
      {
        x: 0.5,
        y: 0.5,
        width: 69,
        height: 47,
        rx: 5.5,
        fill: "#FEB4C7",
        stroke: "#D9D9D9"
      }
    ),
    /* @__PURE__ */ jsx7(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10.848 30.76H8V18h2.848v12.76ZM17.96 18h-2.786c0 2.348-1.05 4.503-2.881 5.913l-1.104.85 4.278 5.997h3.517l-3.936-5.518c1.865-1.91 2.912-4.48 2.912-7.242Zm4.544 12.756h-2.69V18.002h2.69v12.754Zm8.127-8.822v.564a4.418 4.418 0 0 0-2.547-.808c-2.5 0-4.528 2.084-4.528 4.655 0 2.57 2.027 4.655 4.528 4.655.945 0 1.82-.3 2.547-.808v.564h2.569v-8.822h-2.57Zm-.008 4.411c0 1.254-1.043 2.27-2.328 2.27-1.286 0-2.328-1.016-2.328-2.27s1.042-2.27 2.328-2.27c1.285 0 2.328 1.016 2.328 2.27Zm27.112-3.847v-.564h2.57v8.822h-2.57v-.564a4.419 4.419 0 0 1-2.547.808c-2.5 0-4.528-2.084-4.528-4.655s2.028-4.655 4.528-4.655c.945 0 1.821.3 2.547.808Zm-2.336 6.117c1.286 0 2.328-1.016 2.328-2.27s-1.042-2.27-2.328-2.27c-1.286 0-2.328 1.016-2.328 2.27s1.042 2.27 2.328 2.27Zm-9.304-6.918c-1.026 0-1.998.327-2.647 1.23v-.993h-2.558v8.822h2.59V26.12c0-1.342.874-1.999 1.928-1.999 1.13 0 1.778.694 1.778 1.98v4.655h2.566v-5.61c0-2.053-1.587-3.45-3.657-3.45Zm-8.92.237v1.149c.514-.69 1.474-1.149 2.517-1.149v2.567h-.03c-1.017 0-2.482.746-2.482 2.136v4.119h-2.636v-8.822h2.63Zm24.244 7.35c0-.915.722-1.657 1.613-1.657.89 0 1.612.742 1.612 1.657 0 .916-.722 1.658-1.612 1.658-.89 0-1.613-.742-1.613-1.658Z",
        fill: "#17120F"
      }
    )
  ] });
}
var init_klarna = __esm({
  "src/icons/payments/klarna.tsx"() {
    "use strict";
    init_helpers();
  }
});

// src/icons/payments/ideal.tsx
import { jsx as jsx8, jsxs as jsxs7 } from "@emotion/react/jsx-runtime";
function Ideal({ size }) {
  return /* @__PURE__ */ jsxs7(PaymentIconWrapper, { size, children: [
    /* @__PURE__ */ jsx8(
      "rect",
      {
        width: 69,
        height: 47,
        x: 0.5,
        y: 0.5,
        fill: "#fff",
        stroke: "#D9D9D9",
        rx: 5.5
      }
    ),
    /* @__PURE__ */ jsx8(
      "path",
      {
        fill: "#000",
        fillRule: "evenodd",
        d: "M19.027 9.912h16.657c11.319 0 15.669 6.186 15.669 14.005 0 9.353-6.08 14.054-15.669 14.054H19.027V9.911Zm1.581 1.682v24.794h15.076c9.095 0 14.038-4.256 14.038-12.422 0-8.413-5.339-12.372-14.038-12.372H20.608Zm4.449 12.818a3.017 3.017 0 0 0 3.015-3.02 3.017 3.017 0 0 0-3.015-3.018 3.017 3.017 0 0 0-3.015 3.019 3.017 3.017 0 0 0 3.015 3.019Zm-2.422 1.286h4.844v8.611h-4.844v-8.61Z",
        clipRule: "evenodd"
      }
    ),
    /* @__PURE__ */ jsx8(
      "path",
      {
        fill: "#D50072",
        fillRule: "evenodd",
        d: "M44.235 18.622h1.384v4.157h2.027c-.544-7.572-6.525-9.255-11.962-9.255h-5.783v5.098h.84c1.582 0 2.521 1.039 2.521 2.77 0 1.733-.94 2.772-2.471 2.772h-.89V34.31h5.783c8.848 0 11.863-4.107 12.011-10.145h-3.46v-5.542Zm-6.673 4.157v1.385h-3.46v-5.542h3.361v1.385h-1.977v.644h1.879v1.385h-1.83v.742h2.027Zm2.274-4.157h1.977l1.68 5.542H42.06l-.297-1.04h-1.828l-.297 1.04h-1.483l1.68-5.542Zm.51 3.068h-.016v.05l.016-.05Zm0 0h.973l-.445-1.534h-.05l-.478 1.534ZM29.9 22.778v-2.77h.84c.544 0 1.137.148 1.137 1.385s-.544 1.386-1.137 1.386h-.84Z",
        clipRule: "evenodd"
      }
    )
  ] });
}
var init_ideal = __esm({
  "src/icons/payments/ideal.tsx"() {
    "use strict";
    init_helpers();
  }
});

// src/icons/payments/bancontact.tsx
import { jsx as jsx9, jsxs as jsxs8 } from "@emotion/react/jsx-runtime";
function Bancontact() {
  return /* @__PURE__ */ jsxs8(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: 32,
      height: 32,
      "aria-hidden": "true",
      style: { borderRadius: 5 },
      children: [
        /* @__PURE__ */ jsx9("path", { fill: "#EBF1F7", d: "M0 0h32v32H0z" }),
        /* @__PURE__ */ jsxs8("g", { clipPath: "url(#a)", children: [
          /* @__PURE__ */ jsx9(
            "path",
            {
              fill: "url(#b)",
              d: "M8.164 21.448c3.918 0 5.877-2.612 7.836-5.224H3v5.224h5.164Z"
            }
          ),
          /* @__PURE__ */ jsx9(
            "path",
            {
              fill: "url(#c)",
              d: "M23.836 11c-3.918 0-5.877 2.612-7.836 5.224h13V11h-5.164Z"
            }
          )
        ] }),
        /* @__PURE__ */ jsxs8("defs", { children: [
          /* @__PURE__ */ jsxs8(
            "linearGradient",
            {
              id: "b",
              x1: 5.629,
              x2: 15.139,
              y1: 19.077,
              y2: 15.544,
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsx9("stop", { stopColor: "#005AB9" }),
                /* @__PURE__ */ jsx9("stop", { offset: 1, stopColor: "#1E3764" })
              ]
            }
          ),
          /* @__PURE__ */ jsxs8(
            "linearGradient",
            {
              id: "c",
              x1: 16.787,
              x2: 26.885,
              y1: 16.677,
              y2: 13.232,
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsx9("stop", { stopColor: "#FBA900" }),
                /* @__PURE__ */ jsx9("stop", { offset: 1, stopColor: "#FFD800" })
              ]
            }
          ),
          /* @__PURE__ */ jsx9("clipPath", { id: "a", children: /* @__PURE__ */ jsx9("path", { fill: "#fff", d: "M3 11h26v10.447H3z" }) })
        ] })
      ]
    }
  );
}
var init_bancontact = __esm({
  "src/icons/payments/bancontact.tsx"() {
    "use strict";
  }
});

// src/icons/payments/giropay.tsx
import { jsx as jsx10, jsxs as jsxs9 } from "@emotion/react/jsx-runtime";
function Giropay() {
  return /* @__PURE__ */ jsxs9(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: 32,
      height: 32,
      "aria-hidden": "true",
      style: { borderRadius: 5 },
      children: [
        /* @__PURE__ */ jsx10("path", { fill: "#F5F6F8", d: "M0 0h32v32H0z" }),
        /* @__PURE__ */ jsxs9("g", { fillRule: "evenodd", clipPath: "url(#a)", clipRule: "evenodd", children: [
          /* @__PURE__ */ jsx10(
            "path",
            {
              fill: "#04337B",
              d: "M4 11.191c0-1.485 1.239-2.69 2.766-2.69h18.468C26.762 8.5 28 9.705 28 11.19v9.618c0 1.486-1.238 2.691-2.766 2.691H6.766C5.239 23.5 4 22.295 4 20.81v-9.62Zm1.02 9.6c0 .945.783 1.71 1.75 1.71h9.213v-13H6.77c-.967 0-1.75.764-1.75 1.708v9.582Zm13.749-.103h2.272v-3.57h.025c.43.781 1.29 1.072 2.084 1.072 1.957 0 3.004-1.615 3.004-3.558 0-1.59-.997-3.32-2.815-3.32-1.035 0-1.994.418-2.45 1.339h-.025v-1.185h-2.095v9.222Zm5.037-6.005c0 1.047-.518 1.766-1.376 1.766-.758 0-1.39-.72-1.39-1.679 0-.984.556-1.716 1.39-1.716.885 0 1.376.759 1.376 1.629Z"
            }
          ),
          /* @__PURE__ */ jsx10(
            "path",
            {
              fill: "#EE3525",
              d: "M14.153 17.173v-5.71h-2.085v1.167h-.025c-.487-.795-1.282-1.317-2.266-1.317-2.073 0-3.008 1.441-3.008 3.365 0 1.913 1.14 3.253 2.969 3.253.922 0 1.69-.348 2.24-1.106h.026v.348c0 1.267-.717 1.875-2.047 1.875-.96 0-1.55-.198-2.253-.534l-.115 1.764a7.96 7.96 0 0 0 2.547.41c2.688 0 4.018-.857 4.018-3.515Zm-3.698-.956c-.69 0-1.305-.57-1.305-1.576 0-.88.448-1.614 1.305-1.614 1.037 0 1.472.807 1.472 1.527 0 .993-.653 1.663-1.472 1.663Z"
            }
          )
        ] }),
        /* @__PURE__ */ jsx10("defs", { children: /* @__PURE__ */ jsx10("clipPath", { id: "a", children: /* @__PURE__ */ jsx10("path", { fill: "#fff", d: "M4 8.5h24v15H4z" }) }) })
      ]
    }
  );
}
var init_giropay = __esm({
  "src/icons/payments/giropay.tsx"() {
    "use strict";
  }
});

// src/icons/payments/eps.tsx
import { jsx as jsx11, jsxs as jsxs10 } from "@emotion/react/jsx-runtime";
function Eps() {
  return /* @__PURE__ */ jsx11(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: 32,
      height: 32,
      "aria-hidden": "true",
      style: { borderRadius: 5 },
      children: /* @__PURE__ */ jsxs10("g", { fill: "none", fillRule: "evenodd", children: [
        /* @__PURE__ */ jsx11("path", { fill: "#fff", d: "M0 0h32v32H0z" }),
        /* @__PURE__ */ jsxs10("g", { fillRule: "nonzero", children: [
          /* @__PURE__ */ jsx11(
            "path",
            {
              fill: "#5f6360",
              d: "M26.834 16h-2.32a.465.465 0 0 1-.467-.464c0-.258.21-.485.468-.485h3.53v-1.747h-3.53a2.242 2.242 0 0 0-2.236 2.24 2.242 2.242 0 0 0 2.236 2.24h2.288c.258 0 .467.206.467.464s-.21.448-.467.448h-4.907c-.416.798-.821 1.481-1.643 1.823h6.581c1.212-.018 2.203-1.046 2.203-2.268 0-1.222-.991-2.233-2.203-2.251"
            }
          ),
          /* @__PURE__ */ jsx11(
            "path",
            {
              fill: "#5f6360",
              d: "M17.943 13.304c-1.966 0-3.567 1.615-3.567 3.6v7.488h1.78V20.52h1.783c1.966 0 3.561-1.637 3.561-3.622 0-1.984-1.591-3.593-3.557-3.593zm0 5.392h-1.788v-1.799c0-1.005.798-1.822 1.788-1.822.989 0 1.794.817 1.794 1.822s-.805 1.8-1.794 1.8z"
            }
          ),
          /* @__PURE__ */ jsxs10("g", { fill: "#a41760", children: [
            /* @__PURE__ */ jsx11("path", { d: "M8.741 20.519c-1.683 0-3.098-1.203-3.48-2.774 0 0-.111-.519-.111-.861 0-.342.105-.867.105-.867a3.592 3.592 0 0 1 3.478-2.734 3.603 3.603 0 0 1 3.598 3.592v.872H7.08c.31.607.937.95 1.66.95h4.72l.006-5.14c0-.766-.625-1.392-1.39-1.392H5.39c-.764 0-1.389.607-1.389 1.374v6.707c0 .766.625 1.412 1.389 1.412h6.689c.685 0 1.257-.493 1.368-1.139z" }),
            /* @__PURE__ */ jsx11("path", { d: "M8.733 14.988c-.72 0-1.346.442-1.657 1.012h3.315c-.31-.57-.937-1.012-1.658-1.012m3.03-5.005c0-1.637-1.357-2.964-3.03-2.964-1.646 0-2.985 1.284-3.029 2.883v.911c0 .107.087.212.195.212h1.115c.11 0 .205-.105.205-.212v-.83c0-.817.679-1.482 1.514-1.482.836 0 1.515.665 1.515 1.482v.83c0 .107.088.212.197.212h1.115c.11 0 .203-.105.203-.212z" })
          ] })
        ] })
      ] })
    }
  );
}
var init_eps = __esm({
  "src/icons/payments/eps.tsx"() {
    "use strict";
  }
});

// src/icons/payments/link.tsx
import { jsx as jsx12, jsxs as jsxs11 } from "@emotion/react/jsx-runtime";
function Link() {
  return /* @__PURE__ */ jsxs11(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: 32,
      height: 32,
      "aria-hidden": "true",
      style: { borderRadius: 5 },
      children: [
        /* @__PURE__ */ jsx12("path", { fill: "#00D66F", d: "M0 0h32v32H0z" }),
        /* @__PURE__ */ jsx12(
          "path",
          {
            fill: "#011E0F",
            d: "M15.144 6H10c1 4.18 3.923 7.753 7.58 10C13.917 18.246 11 21.82 10 26h5.144c1.275-3.867 4.805-7.227 9.142-7.914v-4.18c-4.344-.68-7.874-4.04-9.142-7.906Z"
          }
        )
      ]
    }
  );
}
var init_link = __esm({
  "src/icons/payments/link.tsx"() {
    "use strict";
  }
});

// src/icons/payments/index.tsx
import { createElement } from "react";
function PaymentMethodIcon({
  type,
  brand,
  ...props
}) {
  let icon;
  switch (type) {
    case "paypal" /* PAYPAL */:
      icon = Paypal;
      break;
    case "card" /* CARD */:
      icon = brand ? brands[brand] || Visa : Visa;
      break;
    case "sepa" /* SEPA */:
      icon = Sepa;
      break;
    case "klarna" /* KLARNA */:
      icon = Klarna;
      break;
    case "ideal" /* IDEAL */:
      icon = Ideal;
      break;
    case "link" /* LINK */:
      icon = Link;
      break;
    case "giropay" /* GIROPAY */:
      icon = Giropay;
      break;
    case "eps" /* EPS */:
      icon = Eps;
      break;
    case "bancontact" /* BANCONTACT */:
      icon = Bancontact;
      break;
    default:
  }
  if (!icon) {
    return null;
  }
  return createElement(icon, props);
}
var PaymentMethodType, PaymentCardBrand, brands;
var init_payments = __esm({
  "src/icons/payments/index.tsx"() {
    "use strict";
    init_amex();
    init_mastercard();
    init_paypal();
    init_sepa();
    init_visa();
    init_klarna();
    init_ideal();
    init_bancontact();
    init_giropay();
    init_eps();
    init_link();
    init_helpers();
    PaymentMethodType = /* @__PURE__ */ ((PaymentMethodType2) => {
      PaymentMethodType2["CARD"] = "card";
      PaymentMethodType2["PAYPAL"] = "paypal";
      PaymentMethodType2["SEPA"] = "sepa";
      PaymentMethodType2["KLARNA"] = "klarna";
      PaymentMethodType2["IDEAL"] = "ideal";
      PaymentMethodType2["BANCONTACT"] = "bancontact";
      PaymentMethodType2["GIROPAY"] = "giropay";
      PaymentMethodType2["EPS"] = "eps";
      PaymentMethodType2["LINK"] = "link";
      PaymentMethodType2["UNSUPPORTED"] = "unsupported";
      return PaymentMethodType2;
    })(PaymentMethodType || {});
    PaymentCardBrand = /* @__PURE__ */ ((PaymentCardBrand2) => {
      PaymentCardBrand2["AMEX"] = "amex";
      PaymentCardBrand2["MASTERCARD"] = "mastercard";
      PaymentCardBrand2["VISA"] = "visa";
      return PaymentCardBrand2;
    })(PaymentCardBrand || {});
    brands = {
      ["amex" /* AMEX */]: Amex,
      ["visa" /* VISA */]: Visa,
      ["mastercard" /* MASTERCARD */]: Mastercard
    };
  }
});

// src/icons/types.ts
var IconSize, IconName;
var init_types = __esm({
  "src/icons/types.ts"() {
    "use strict";
    IconSize = /* @__PURE__ */ ((IconSize3) => {
      IconSize3["MEDIUM"] = "medium";
      IconSize3["SMALL"] = "small";
      IconSize3["LARGE"] = "large";
      IconSize3["X_LARGE"] = "x-large";
      return IconSize3;
    })(IconSize || {});
    IconName = /* @__PURE__ */ ((IconName6) => {
      IconName6["TW_PRO_ADD_USER"] = "tw-pro:add-user";
      IconName6["TW_PRO_ARROW_BACK"] = "tw-pro:arrow-back";
      IconName6["TW_PRO_ARROW_FORWARD"] = "tw-pro:arrow-forward";
      IconName6["TW_PRO_AVATAR"] = "tw-pro:avatar";
      IconName6["TW_PRO_BEARD"] = "tw-pro:beard";
      IconName6["TW_PRO_BIN"] = "tw-pro:bin";
      IconName6["TW_PRO_BOX"] = "tw-pro:box";
      IconName6["TW_PRO_CALENDAR"] = "tw-pro:calendar";
      IconName6["TW_PRO_CARD"] = "tw-pro:card";
      IconName6["TW_PRO_CART"] = "tw-pro:cart";
      IconName6["TW_PRO_CASH"] = "tw-pro:cash";
      IconName6["TW_PRO_CAUTION"] = "tw-pro:caution";
      IconName6["TW_PRO_CHAIR"] = "tw-pro:chair";
      IconName6["TW_PRO_CHECK_FILLED"] = "tw-pro:check-filled";
      IconName6["TW_PRO_CHECK_MARK"] = "tw-pro:check-mark";
      IconName6["TW_PRO_CHEVRON_ADD"] = "tw-pro:chevron-add";
      IconName6["TW_PRO_CHEVRON_DOWN"] = "tw-pro:chevron-down";
      IconName6["TW_PRO_CHEVRON_LEFT"] = "tw-pro:chevron-left";
      IconName6["TW_PRO_CHEVRON_RIGHT"] = "tw-pro:chevron-right";
      IconName6["TW_PRO_CHEVRON_UP"] = "tw-pro:chevron-up";
      IconName6["TW_PRO_CLOSE"] = "tw-pro:close";
      IconName6["TW_PRO_DISCOUNT_OUTLINE"] = "tw-pro:discount-outline";
      IconName6["TW_PRO_EXPAND"] = "tw-pro:expand";
      IconName6["TW_PRO_FACE"] = "tw-pro:face";
      IconName6["TW_PRO_FAST_DELIVERY"] = "tw-pro:fast-delivery";
      IconName6["TW_PRO_FIRE"] = "tw-pro:fire";
      IconName6["TW_PRO_GIFT"] = "tw-pro:gift";
      IconName6["TW_PRO_HAIR"] = "tw-pro:hair";
      IconName6["TW_PRO_HAIR_REMOVAL"] = "tw-pro:hair-removal";
      IconName6["TW_PRO_HAMBURGER_NAV"] = "tw-pro:hamburger-nav";
      IconName6["TW_PRO_HAPPY"] = "tw-pro:happy";
      IconName6["TW_PRO_HEART_FILLED"] = "tw-pro:heart-filled";
      IconName6["TW_PRO_HEART_OUTLINE"] = "tw-pro:heart-outline";
      IconName6["TW_PRO_HIDE"] = "tw-pro:hide";
      IconName6["TW_PRO_HIGHLIGHTS"] = "tw-pro:highlights";
      IconName6["TW_PRO_HOME"] = "tw-pro:home";
      IconName6["TW_PRO_HOME_BASED_SALON"] = "tw-pro:home-base-salon";
      IconName6["TW_PRO_LOADING"] = "tw-pro:loading";
      IconName6["TW_PRO_MASSAGE"] = "tw-pro:massage";
      IconName6["TW_PRO_MINUS"] = "tw-pro:minus";
      IconName6["TW_PRO_MOBILE_THERAPIST"] = "tw-pro:mobile-therapist";
      IconName6["TW_PRO_NAILS"] = "tw-pro:nails";
      IconName6["TW_PRO_NEW_VENUE"] = "tw-pro:new-venue";
      IconName6["TW_PRO_ONLINE"] = "tw-pro:online";
      IconName6["TW_PRO_PADLOCK"] = "tw-pro:padlock";
      IconName6["TW_PRO_PEN"] = "tw-pro:pen";
      IconName6["TW_PRO_PERSON"] = "tw-pro:person";
      IconName6["TW_PRO_PERSONS"] = "tw-pro:persons";
      IconName6["TW_PRO_PRODUCTS"] = "tw-pro:products";
      IconName6["TW_PRO_QUESTION"] = "tw-pro:question";
      IconName6["TW_PRO_RECEIPT"] = "tw-pro:receipt";
      IconName6["TW_PRO_SEARCH"] = "tw-pro:search";
      IconName6["TW_PRO_SHOW"] = "tw-pro:show";
      IconName6["TW_PRO_SORT"] = "tw-pro:sort";
      IconName6["TW_PRO_SPA"] = "tw-pro:spa";
      IconName6["TW_PRO_STAR_FILLED"] = "tw-pro:star-filled";
      IconName6["TW_PRO_STAR_HALF"] = "tw-pro:star-half";
      IconName6["TW_PRO_STAR_OUTLINED"] = "tw-pro:star-outlined";
      IconName6["TW_PRO_TIME"] = "tw-pro:time";
      IconName6["TW_PRO_TRUCK"] = "tw-pro:truck";
      IconName6["TW_PRO_UNHAPPY"] = "tw-pro:unhappy";
      IconName6["TW_PRO_USER"] = "tw-pro:user";
      IconName6["TW_PRO_VENUE"] = "tw-pro:venue";
      IconName6["TW_PRO_VENUE_SEARCH"] = "tw-pro:venue-search";
      IconName6["TW_PRO_VOUCHER"] = "tw-pro:voucher";
      IconName6["TW_PRO_WARNING_OUTLINE"] = "tw-pro:warning-outline";
      IconName6["SALONIZED_ACTIVITY"] = "salonized:activity";
      IconName6["SALONIZED_ALERT_CIRCLE"] = "salonized:alert-circle";
      IconName6["SALONIZED_ALERT_TRIANGLE"] = "salonized:alert-triangle";
      IconName6["SALONIZED_ALL_DONE"] = "salonized:all-done";
      IconName6["SALONIZED_ARCHIVE"] = "salonized:archive";
      IconName6["SALONIZED_ARROW_CIRCLE_DOWN"] = "salonized:arrow-circle-down";
      IconName6["SALONIZED_ARROW_CIRCLE_LEFT"] = "salonized:arrow-circle-left";
      IconName6["SALONIZED_ARROW_CIRCLE_RIGHT"] = "salonized:arrow-circle-right";
      IconName6["SALONIZED_ARROW_CIRCLE_UP"] = "salonized:arrow-circle-up";
      IconName6["SALONIZED_ARROW_DOWN"] = "salonized:arrow-down";
      IconName6["SALONIZED_ARROW_DOWN1"] = "salonized:arrow-down1";
      IconName6["SALONIZED_ARROW_IOS_DOWN"] = "salonized:arrow-ios-down";
      IconName6["SALONIZED_ARROW_IOS_LEFT"] = "salonized:arrow-ios-left";
      IconName6["SALONIZED_ARROW_IOS_RIGHT"] = "salonized:arrow-ios-right";
      IconName6["SALONIZED_ARROW_IOS_UP"] = "salonized:arrow-ios-up";
      IconName6["SALONIZED_ARROW_LEFT"] = "salonized:arrow-left";
      IconName6["SALONIZED_ARROW_RIGHT"] = "salonized:arrow-right";
      IconName6["SALONIZED_ARROW_RIGHT1"] = "salonized:arrow-right1";
      IconName6["SALONIZED_ARROW_UP"] = "salonized:arrow-up";
      IconName6["SALONIZED_ARROW_UP1"] = "salonized:arrow-up1";
      IconName6["SALONIZED_ARROWHEAD_DOWN"] = "salonized:arrowhead-down";
      IconName6["SALONIZED_ARROWHEAD_LEFT"] = "salonized:arrowhead-left";
      IconName6["SALONIZED_ARROWHEAD_RIGHT"] = "salonized:arrowhead-right";
      IconName6["SALONIZED_ARROWHEAD_UP"] = "salonized:arrowhead-up";
      IconName6["SALONIZED_ARRROW_LEFT"] = "salonized:arrrow-left";
      IconName6["SALONIZED_AT"] = "salonized:at";
      IconName6["SALONIZED_ATTACH"] = "salonized:attach";
      IconName6["SALONIZED_ATTACH2"] = "salonized:attach2";
      IconName6["SALONIZED_AWARD"] = "salonized:award";
      IconName6["SALONIZED_BACKSPACE"] = "salonized:backspace";
      IconName6["SALONIZED_BAR_CHART"] = "salonized:bar-chart";
      IconName6["SALONIZED_BAR_CHART2"] = "salonized:bar-chart2";
      IconName6["SALONIZED_BATTERY"] = "salonized:battery";
      IconName6["SALONIZED_BATTTERY_CHARGING"] = "salonized:batttery-charging";
      IconName6["SALONIZED_BEHANCE"] = "salonized:behance";
      IconName6["SALONIZED_BELL"] = "salonized:bell";
      IconName6["SALONIZED_BELL_OFF"] = "salonized:bell-off";
      IconName6["SALONIZED_BLUETOOTH"] = "salonized:bluetooth";
      IconName6["SALONIZED_BOOK"] = "salonized:book";
      IconName6["SALONIZED_BOOK_OPEN"] = "salonized:book-open";
      IconName6["SALONIZED_BOOKMARK"] = "salonized:bookmark";
      IconName6["SALONIZED_BRIEFCASE"] = "salonized:briefcase";
      IconName6["SALONIZED_BROWSER"] = "salonized:browser";
      IconName6["SALONIZED_BRUSH"] = "salonized:brush";
      IconName6["SALONIZED_BULB"] = "salonized:bulb";
      IconName6["SALONIZED_CALENDAR"] = "salonized:calendar";
      IconName6["SALONIZED_CAMERA"] = "salonized:camera";
      IconName6["SALONIZED_CAR"] = "salonized:car";
      IconName6["SALONIZED_CAST"] = "salonized:cast";
      IconName6["SALONIZED_CHECKMARK"] = "salonized:checkmark";
      IconName6["SALONIZED_CHECKMARK_CIRCLE"] = "salonized:checkmark-circle";
      IconName6["SALONIZED_CHECKMARK_CIRCLE2"] = "salonized:checkmark-circle2";
      IconName6["SALONIZED_CHECKMARK_SQUARE"] = "salonized:checkmark-square";
      IconName6["SALONIZED_CHECKMARK_SQUARE2"] = "salonized:checkmark-square2";
      IconName6["SALONIZED_CHEVRON_DOWN"] = "salonized:chevron-down";
      IconName6["SALONIZED_CHEVRON_LEFT"] = "salonized:chevron-left";
      IconName6["SALONIZED_CHEVRON_RIGHT"] = "salonized:chevron-right";
      IconName6["SALONIZED_CHEVRON_UP"] = "salonized:chevron-up";
      IconName6["SALONIZED_CLIPBOARD"] = "salonized:clipboard";
      IconName6["SALONIZED_CLOCK"] = "salonized:clock";
      IconName6["SALONIZED_CLOSE"] = "salonized:close";
      IconName6["SALONIZED_CLOSE_CIRCLE"] = "salonized:close-circle";
      IconName6["SALONIZED_CLOSE_CIRCLE1"] = "salonized:close-circle1";
      IconName6["SALONIZED_CLOUD_DOWNLOAD"] = "salonized:cloud-download";
      IconName6["SALONIZED_CLOUD_UPLOAD"] = "salonized:cloud-upload";
      IconName6["SALONIZED_CODE"] = "salonized:code";
      IconName6["SALONIZED_CODE_DOWNLOAD"] = "salonized:code-download";
      IconName6["SALONIZED_COLOR_PALETTE"] = "salonized:color-palette";
      IconName6["SALONIZED_COLOR_PICKER"] = "salonized:color-picker";
      IconName6["SALONIZED_COMPASS"] = "salonized:compass";
      IconName6["SALONIZED_COPY"] = "salonized:copy";
      IconName6["SALONIZED_CORNER_DOWN_LEFT"] = "salonized:corner-down-left";
      IconName6["SALONIZED_CORNER_DOWN_RIGHT"] = "salonized:corner-down-right";
      IconName6["SALONIZED_CORNER_LEFT_DOWN"] = "salonized:corner-left-down";
      IconName6["SALONIZED_CORNER_LEFT_UP"] = "salonized:corner-left-up";
      IconName6["SALONIZED_CORNER_RIGHT_DOWN"] = "salonized:corner-right-down";
      IconName6["SALONIZED_CORNER_RIGHT_UP"] = "salonized:corner-right-up";
      IconName6["SALONIZED_CORNER_UP_LEFT"] = "salonized:corner-up-left";
      IconName6["SALONIZED_CORNER_UP_RIGHT"] = "salonized:corner-up-right";
      IconName6["SALONIZED_CREDIT_CARD"] = "salonized:credit-card";
      IconName6["SALONIZED_CROP"] = "salonized:crop";
      IconName6["SALONIZED_CUBE"] = "salonized:cube";
      IconName6["SALONIZED_DIAGONAL_ARROW_LEFT_DOWN"] = "salonized:diagonal-arrow-left-down";
      IconName6["SALONIZED_DIAGONAL_ARROW_LEFT_UP"] = "salonized:diagonal-arrow-left-up";
      IconName6["SALONIZED_DIAGONAL_ARROW_RIGHT_DOWN"] = "salonized:diagonal-arrow-right-down";
      IconName6["SALONIZED_DIAGONAL_ARROW_RIGHT_UP"] = "salonized:diagonal-arrow-right-up";
      IconName6["SALONIZED_DOWNLOAD"] = "salonized:download";
      IconName6["SALONIZED_DROPLET"] = "salonized:droplet";
      IconName6["SALONIZED_DROPLET_OFF"] = "salonized:droplet-off";
      IconName6["SALONIZED_EDIT"] = "salonized:edit";
      IconName6["SALONIZED_EDIT2"] = "salonized:edit2";
      IconName6["SALONIZED_EMAIL"] = "salonized:email";
      IconName6["SALONIZED_EXPAND"] = "salonized:expand";
      IconName6["SALONIZED_EXTERNAL_LINK"] = "salonized:external-link";
      IconName6["SALONIZED_EYE"] = "salonized:eye";
      IconName6["SALONIZED_EYE_OFF"] = "salonized:eye-off";
      IconName6["SALONIZED_EYE_OFF2"] = "salonized:eye-off2";
      IconName6["SALONIZED_FACEBOOK"] = "salonized:facebook";
      IconName6["SALONIZED_FILE"] = "salonized:file";
      IconName6["SALONIZED_FILE_ADD"] = "salonized:file-add";
      IconName6["SALONIZED_FILE_REMOVE"] = "salonized:file-remove";
      IconName6["SALONIZED_FILE_TEXT"] = "salonized:file-text";
      IconName6["SALONIZED_FILM"] = "salonized:film";
      IconName6["SALONIZED_FIRE"] = "salonized:fire";
      IconName6["SALONIZED_FLAG"] = "salonized:flag";
      IconName6["SALONIZED_FLASH"] = "salonized:flash";
      IconName6["SALONIZED_FLASH_OFF"] = "salonized:flash-off";
      IconName6["SALONIZED_FLIP"] = "salonized:flip";
      IconName6["SALONIZED_FLIP2"] = "salonized:flip2";
      IconName6["SALONIZED_FOLDER"] = "salonized:folder";
      IconName6["SALONIZED_FOLDER_ADD"] = "salonized:folder-add";
      IconName6["SALONIZED_FOLDER_REMOVE"] = "salonized:folder-remove";
      IconName6["SALONIZED_FUNNEL"] = "salonized:funnel";
      IconName6["SALONIZED_GIFT"] = "salonized:gift";
      IconName6["SALONIZED_GITHUB"] = "salonized:github";
      IconName6["SALONIZED_GLOBE"] = "salonized:globe";
      IconName6["SALONIZED_GLOBE2"] = "salonized:globe2";
      IconName6["SALONIZED_GOOGLE"] = "salonized:google";
      IconName6["SALONIZED_GRID"] = "salonized:grid";
      IconName6["SALONIZED_HARD_DRIVE"] = "salonized:hard-drive";
      IconName6["SALONIZED_HASH"] = "salonized:hash";
      IconName6["SALONIZED_HEADPHONES"] = "salonized:headphones";
      IconName6["SALONIZED_HEART"] = "salonized:heart";
      IconName6["SALONIZED_HEIGHT"] = "salonized:height";
      IconName6["SALONIZED_HOME"] = "salonized:home";
      IconName6["SALONIZED_IMAGE"] = "salonized:image";
      IconName6["SALONIZED_INBOX"] = "salonized:inbox";
      IconName6["SALONIZED_INFO"] = "salonized:info";
      IconName6["SALONIZED_KEYPAD"] = "salonized:keypad";
      IconName6["SALONIZED_LAYERS"] = "salonized:layers";
      IconName6["SALONIZED_LAYOUT"] = "salonized:layout";
      IconName6["SALONIZED_LINK"] = "salonized:link";
      IconName6["SALONIZED_LINK2"] = "salonized:link2";
      IconName6["SALONIZED_LINKEDIN"] = "salonized:linkedin";
      IconName6["SALONIZED_LIST"] = "salonized:list";
      IconName6["SALONIZED_LOADER"] = "salonized:loader";
      IconName6["SALONIZED_LOCK"] = "salonized:lock";
      IconName6["SALONIZED_LOG_IN"] = "salonized:log-in";
      IconName6["SALONIZED_LOG_OUT"] = "salonized:log-out";
      IconName6["SALONIZED_MAP"] = "salonized:map";
      IconName6["SALONIZED_MAXIMIZE"] = "salonized:maximize";
      IconName6["SALONIZED_MENU"] = "salonized:menu";
      IconName6["SALONIZED_MENU2"] = "salonized:menu2";
      IconName6["SALONIZED_MENU_ARROW"] = "salonized:menu-arrow";
      IconName6["SALONIZED_MESSAGE_CIRCLE"] = "salonized:message-circle";
      IconName6["SALONIZED_MESSAGE_SQUARE"] = "salonized:message-square";
      IconName6["SALONIZED_MIC"] = "salonized:mic";
      IconName6["SALONIZED_MIC_OFF"] = "salonized:mic-off";
      IconName6["SALONIZED_MINIMIZE"] = "salonized:minimize";
      IconName6["SALONIZED_MINUS"] = "salonized:minus";
      IconName6["SALONIZED_MINUS_CIRCLE"] = "salonized:minus-circle";
      IconName6["SALONIZED_MINUS_SQUARE"] = "salonized:minus-square";
      IconName6["SALONIZED_MONITOR"] = "salonized:monitor";
      IconName6["SALONIZED_MOON"] = "salonized:moon";
      IconName6["SALONIZED_MORE_HORIZONTAL"] = "salonized:more-horizontal";
      IconName6["SALONIZED_MORE_VERTICAL"] = "salonized:more-vertical";
      IconName6["SALONIZED_MOVE"] = "salonized:move";
      IconName6["SALONIZED_MUSIC"] = "salonized:music";
      IconName6["SALONIZED_NAVIGATION"] = "salonized:navigation";
      IconName6["SALONIZED_NAVIGATION2"] = "salonized:navigation2";
      IconName6["SALONIZED_NPM"] = "salonized:npm";
      IconName6["SALONIZED_OPTIONS"] = "salonized:options";
      IconName6["SALONIZED_OPTIONS2"] = "salonized:options2";
      IconName6["SALONIZED_PANTONE"] = "salonized:pantone";
      IconName6["SALONIZED_PAPER_PLANE"] = "salonized:paper-plane";
      IconName6["SALONIZED_PAUSE_CIRCLE"] = "salonized:pause-circle";
      IconName6["SALONIZED_PEOPLE"] = "salonized:people";
      IconName6["SALONIZED_PERCENT"] = "salonized:percent";
      IconName6["SALONIZED_PERSON"] = "salonized:person";
      IconName6["SALONIZED_PERSON_DELETE"] = "salonized:person-delete";
      IconName6["SALONIZED_PERSON_DONE"] = "salonized:person-done";
      IconName6["SALONIZED_PERSON_REMOVE"] = "salonized:person-remove";
      IconName6["SALONIZED_PHONE"] = "salonized:phone";
      IconName6["SALONIZED_PHONE_CALL"] = "salonized:phone-call";
      IconName6["SALONIZED_PHONE_MISSED"] = "salonized:phone-missed";
      IconName6["SALONIZED_PHONE_OFF"] = "salonized:phone-off";
      IconName6["SALONIZED_PIE_CHART"] = "salonized:pie-chart";
      IconName6["SALONIZED_PIN"] = "salonized:pin";
      IconName6["SALONIZED_PLAY_CIRCLE"] = "salonized:play-circle";
      IconName6["SALONIZED_PLUS"] = "salonized:plus";
      IconName6["SALONIZED_PLUS_CIRCLE"] = "salonized:plus-circle";
      IconName6["SALONIZED_PLUS_SQUARE"] = "salonized:plus-square";
      IconName6["SALONIZED_POWER"] = "salonized:power";
      IconName6["SALONIZED_PRICETAG"] = "salonized:pricetag";
      IconName6["SALONIZED_PRINTER"] = "salonized:printer";
      IconName6["SALONIZED_QUESTION_MARK"] = "salonized:question-mark";
      IconName6["SALONIZED_QUESTION_MARK_CIRCLE"] = "salonized:question-mark-circle";
      IconName6["SALONIZED_RADIO"] = "salonized:radio";
      IconName6["SALONIZED_RADIO_BUTTON_OFF"] = "salonized:radio-button-off";
      IconName6["SALONIZED_RADIO_BUTTON_ON"] = "salonized:radio-button-on";
      IconName6["SALONIZED_RECORDING"] = "salonized:recording";
      IconName6["SALONIZED_REFRESH"] = "salonized:refresh";
      IconName6["SALONIZED_REPEAT"] = "salonized:repeat";
      IconName6["SALONIZED_REWIND_LEFT"] = "salonized:rewind-left";
      IconName6["SALONIZED_REWIND_RIGHT"] = "salonized:rewind-right";
      IconName6["SALONIZED_SAVE"] = "salonized:save";
      IconName6["SALONIZED_SCISSORS"] = "salonized:scissors";
      IconName6["SALONIZED_SEARCH"] = "salonized:search";
      IconName6["SALONIZED_SETTINGS"] = "salonized:settings";
      IconName6["SALONIZED_SETTINGS2"] = "salonized:settings2";
      IconName6["SALONIZED_SHAKE"] = "salonized:shake";
      IconName6["SALONIZED_SHARE"] = "salonized:share";
      IconName6["SALONIZED_SHIELD"] = "salonized:shield";
      IconName6["SALONIZED_SHIELD_OFF"] = "salonized:shield-off";
      IconName6["SALONIZED_SHOPPING_BAG"] = "salonized:shopping-bag";
      IconName6["SALONIZED_SHOPPING_CART"] = "salonized:shopping-cart";
      IconName6["SALONIZED_SHUFFLE"] = "salonized:shuffle";
      IconName6["SALONIZED_SHUFFLE2"] = "salonized:shuffle2";
      IconName6["SALONIZED_SKIP_BACK"] = "salonized:skip-back";
      IconName6["SALONIZED_SKIP_FORWARD"] = "salonized:skip-forward";
      IconName6["SALONIZED_SLASH"] = "salonized:slash";
      IconName6["SALONIZED_SMARTPHONE"] = "salonized:smartphone";
      IconName6["SALONIZED_SPEAKER"] = "salonized:speaker";
      IconName6["SALONIZED_SQUARE"] = "salonized:square";
      IconName6["SALONIZED_STAR"] = "salonized:star";
      IconName6["SALONIZED_STOP_CIRCLE"] = "salonized:stop-circle";
      IconName6["SALONIZED_SUN"] = "salonized:sun";
      IconName6["SALONIZED_SWAP"] = "salonized:swap";
      IconName6["SALONIZED_SYNC"] = "salonized:sync";
      IconName6["SALONIZED_TEXT"] = "salonized:text";
      IconName6["SALONIZED_THERMOMETER"] = "salonized:thermometer";
      IconName6["SALONIZED_THERMOMETER_MINUS"] = "salonized:thermometer-minus";
      IconName6["SALONIZED_THERMOMETER_PLUS"] = "salonized:thermometer-plus";
      IconName6["SALONIZED_TIMER"] = "salonized:timer";
      IconName6["SALONIZED_TOGGLE_LEFT"] = "salonized:toggle-left";
      IconName6["SALONIZED_TOGGLE_RIGHT"] = "salonized:toggle-right";
      IconName6["SALONIZED_TRASH"] = "salonized:trash";
      IconName6["SALONIZED_TRASH2"] = "salonized:trash2";
      IconName6["SALONIZED_TRENDING_DOWN"] = "salonized:trending-down";
      IconName6["SALONIZED_TRENDING_UP"] = "salonized:trending-up";
      IconName6["SALONIZED_TV"] = "salonized:tv";
      IconName6["SALONIZED_TWITTER"] = "salonized:twitter";
      IconName6["SALONIZED_UMBRELLA"] = "salonized:umbrella";
      IconName6["SALONIZED_UNDO"] = "salonized:undo";
      IconName6["SALONIZED_UNLOCK"] = "salonized:unlock";
      IconName6["SALONIZED_UPLOAD"] = "salonized:upload";
      IconName6["SALONIZED_VIDEO"] = "salonized:video";
      IconName6["SALONIZED_VIDEO_OFF"] = "salonized:video-off";
      IconName6["SALONIZED_VOLUME"] = "salonized:volume";
      IconName6["SALONIZED_VOLUME_DOWN"] = "salonized:volume-down";
      IconName6["SALONIZED_VOLUME_OFF"] = "salonized:volume-off";
      IconName6["SALONIZED_VOLUME_UP"] = "salonized:volume-up";
      IconName6["SALONIZED_WEIGHT"] = "salonized:weight";
      IconName6["SALONIZED_WIFI"] = "salonized:wifi";
      IconName6["SALONIZED_WIFI_OFF"] = "salonized:wifi-off";
      IconName6["SALONIZED_WORKSHOP"] = "salonized:workshop";
      return IconName6;
    })(IconName || {});
  }
});

// src/icons/treatwell-pro/add-user.tsx
import { jsx as jsx13 } from "@emotion/react/jsx-runtime";
function AddUser(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx13(SvgIcon, { size, viewBox: "0 0 16 14", children: /* @__PURE__ */ jsx13(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M5.66667 1.33333C4.5621 1.33333 3.66667 2.22876 3.66667 3.33333C3.66667 4.4379 4.5621 5.33333 5.66667 5.33333C6.77124 5.33333 7.66667 4.4379 7.66667 3.33333C7.66667 2.22876 6.77124 1.33333 5.66667 1.33333ZM2.33333 3.33333C2.33333 1.49238 3.82572 0 5.66667 0C7.50762 0 9 1.49238 9 3.33333C9 5.17428 7.50762 6.66667 5.66667 6.66667C3.82572 6.66667 2.33333 5.17428 2.33333 3.33333ZM13.3333 3.33333C13.7015 3.33333 14 3.63181 14 4V5.33333H15.3333C15.7015 5.33333 16 5.63181 16 6C16 6.36819 15.7015 6.66667 15.3333 6.66667H14V8C14 8.36819 13.7015 8.66667 13.3333 8.66667C12.9651 8.66667 12.6667 8.36819 12.6667 8V6.66667H11.3333C10.9651 6.66667 10.6667 6.36819 10.6667 6C10.6667 5.63181 10.9651 5.33333 11.3333 5.33333H12.6667V4C12.6667 3.63181 12.9651 3.33333 13.3333 3.33333ZM0.976311 8.97631C1.60143 8.35119 2.44928 8 3.33333 8H8C8.88406 8 9.7319 8.35119 10.357 8.97631C10.9821 9.60143 11.3333 10.4493 11.3333 11.3333V12.6667C11.3333 13.0349 11.0349 13.3333 10.6667 13.3333C10.2985 13.3333 10 13.0349 10 12.6667V11.3333C10 10.8029 9.78929 10.2942 9.41421 9.91912C9.03914 9.54405 8.53043 9.33333 8 9.33333H3.33333C2.8029 9.33333 2.29419 9.54405 1.91912 9.91912C1.54405 10.2942 1.33333 10.8029 1.33333 11.3333V12.6667C1.33333 13.0349 1.03486 13.3333 0.666667 13.3333C0.298477 13.3333 0 13.0349 0 12.6667V11.3333C0 10.4493 0.35119 9.60143 0.976311 8.97631Z",
      fill: color
    }
  ) });
}
var init_add_user = __esm({
  "src/icons/treatwell-pro/add-user.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/treatwell-pro/arrow-back.tsx
import { jsx as jsx14 } from "@emotion/react/jsx-runtime";
function ArrowBack(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx14(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx14(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12.7071 4.29289C13.0976 4.68342 13.0976 5.31658 12.7071 5.70711L7.41421 11H19C19.5523 11 20 11.4477 20 12C20 12.5523 19.5523 13 19 13H7.41421L12.7071 18.2929C13.0976 18.6834 13.0976 19.3166 12.7071 19.7071C12.3166 20.0976 11.6834 20.0976 11.2929 19.7071L4.29289 12.7071C3.90237 12.3166 3.90237 11.6834 4.29289 11.2929L11.2929 4.29289C11.6834 3.90237 12.3166 3.90237 12.7071 4.29289Z",
      fill: color
    }
  ) });
}
var init_arrow_back = __esm({
  "src/icons/treatwell-pro/arrow-back.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/treatwell-pro/arrow-forward.tsx
import { jsx as jsx15 } from "@emotion/react/jsx-runtime";
function ArrowForward(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx15(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx15(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11.2929 4.29289C11.6834 3.90237 12.3166 3.90237 12.7071 4.29289L19.7071 11.2929C20.0976 11.6834 20.0976 12.3166 19.7071 12.7071L12.7071 19.7071C12.3166 20.0976 11.6834 20.0976 11.2929 19.7071C10.9024 19.3166 10.9024 18.6834 11.2929 18.2929L16.5858 13H5C4.44772 13 4 12.5523 4 12C4 11.4477 4.44772 11 5 11H16.5858L11.2929 5.70711C10.9024 5.31658 10.9024 4.68342 11.2929 4.29289Z",
      fill: color
    }
  ) });
}
var init_arrow_forward = __esm({
  "src/icons/treatwell-pro/arrow-forward.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/treatwell-pro/avatar.tsx
import { jsx as jsx16 } from "@emotion/react/jsx-runtime";
function Avatar(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx16(SvgIcon, { size, children: /* @__PURE__ */ jsx16(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M9.11111 9.91445C8.25726 10.594 7.17605 11 6 11C4.82395 11 3.74274 10.594 2.88889 9.91445V9.15C2.88889 8.79196 3.02936 8.44858 3.27941 8.19541C3.52946 7.94223 3.8686 7.8 4.22222 7.8H7.77778C8.1314 7.8 8.47054 7.94223 8.72059 8.19541C8.97064 8.44858 9.11111 8.79196 9.11111 9.15V9.91445ZM9.99548 9.0065C9.96114 8.46214 9.73234 7.94701 9.34913 7.55901C8.93238 7.13705 8.36715 6.9 7.77778 6.9H4.22222C3.63285 6.9 3.06762 7.13705 2.65087 7.55901C2.26766 7.94701 2.03886 8.46214 2.00452 9.0065C1.37388 8.16973 1 7.12853 1 6C1 3.23858 3.23858 1 6 1C8.76142 1 11 3.23858 11 6C11 7.12853 10.6261 8.16973 9.99548 9.0065ZM12 6C12 9.31371 9.31371 12 6 12C2.68629 12 0 9.31371 0 6C0 2.68629 2.68629 0 6 0C9.31371 0 12 2.68629 12 6ZM4.66667 4.25C4.66667 3.50442 5.26362 2.9 6 2.9C6.73638 2.9 7.33333 3.50442 7.33333 4.25C7.33333 4.99558 6.73638 5.6 6 5.6C5.26362 5.6 4.66667 4.99558 4.66667 4.25ZM6 2C4.7727 2 3.77778 3.00736 3.77778 4.25C3.77778 5.49264 4.7727 6.5 6 6.5C7.2273 6.5 8.22222 5.49264 8.22222 4.25C8.22222 3.00736 7.2273 2 6 2Z",
      fill: color
    }
  ) });
}
var init_avatar = __esm({
  "src/icons/treatwell-pro/avatar.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/treatwell-pro/beard.tsx
import { jsx as jsx17 } from "@emotion/react/jsx-runtime";
function Beard(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx17(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx17(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M3 3C3 4.56073 3.0513 6.12074 3.15377 7.67752L6.087 8.777L6.14383 8.69646C7.0832 7.39317 8.45886 6.4638 10.0255 6.08122L10.3039 6.01942L10.7101 5.93819L12 6.797L13.2899 5.93819L13.6961 6.01942C15.3778 6.35575 16.8615 7.31651 17.8562 8.69646L17.912 8.777L20.8462 7.67752C20.9241 6.49518 20.9724 5.31098 20.9911 4.12601L21 3H23C23 5.31559 22.8902 7.62966 22.6709 9.9344L22.5522 11.086L22.3843 12.5965C22.1197 14.9778 21.0908 17.2058 19.4567 18.9493L19.2071 19.2071L18.7574 19.6569C17.3285 21.0857 15.4148 21.9182 13.403 21.9943L13.1005 22H10.8995C8.8788 22 6.93692 21.2355 5.46056 19.8667L5.24264 19.6569L4.79289 19.2071C3.09871 17.5129 2.00171 15.3176 1.66108 12.9525L1.61568 12.5965L1.44784 11.086C1.19213 8.78454 1.04575 6.4725 1.00915 4.15763L1 3H3ZM13.688 8.076L12 9.20185L10.311 8.076L10.2112 8.10434C9.18054 8.42595 8.28665 9.08962 7.68049 9.989L7.54578 10.2007L6.92889 11.2288L3.334 9.881L3.43561 10.8651L3.60345 12.3757C3.81847 14.3108 4.64945 16.1224 5.96917 17.5458L6.20711 17.7929L6.65685 18.2426C7.71588 19.3017 9.13004 19.9239 10.6194 19.9935L10.8995 20H13.1005C14.5982 20 16.0382 19.44 17.1405 18.4361L17.3431 18.2426L17.7929 17.7929C19.1697 16.4161 20.0652 14.6355 20.3522 12.7158L20.3966 12.3757L20.5644 10.8651L20.665 9.881L17.0711 11.2288L16.4542 10.2007C15.8501 9.19375 14.8987 8.45069 13.7888 8.10434L13.688 8.076ZM14 12C15.0544 12 15.9182 12.8159 15.9945 13.8507L16 14H8C8 12.8954 8.89543 12 10 12H14Z",
      fill: color
    }
  ) });
}
var init_beard = __esm({
  "src/icons/treatwell-pro/beard.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/treatwell-pro/bin.tsx
import { jsx as jsx18 } from "@emotion/react/jsx-runtime";
function Bin(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx18(SvgIcon, { size, children: /* @__PURE__ */ jsx18(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M3.5 4V10.0003C3.5 10.5521 3.94745 11 4.49858 11H7.50142C8.05291 11 8.5 10.5525 8.5 10.0003V4H9.5V10.0003C9.5 11.1047 8.60538 12 7.50142 12H4.49858C3.39492 12 2.5 11.1041 2.5 10.0003V4H3.5ZM7.5 5.5V10H6.5V5.5H7.5ZM5.5 4V8.5H4.5V4H5.5ZM7.00095 0C7.55271 0 8.14115 0.423464 8.31641 0.949219L8.333 1H4.99905C4.87576 1 4.67154 1.14767 4.63228 1.26545L4.38743 2H10.5V3H1.5V2H3.333L3.68359 0.949219C3.85834 0.42498 4.44335 0 4.99905 0H7.00095Z",
      fill: color
    }
  ) });
}
var init_bin = __esm({
  "src/icons/treatwell-pro/bin.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/treatwell-pro/box.tsx
import { jsx as jsx19 } from "@emotion/react/jsx-runtime";
function Box(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx19(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx19(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11.4517 1.923C11.8008 1.76786 12.1992 1.76786 12.5483 1.923L20.9483 5.65633C21.4358 5.873 21.75 6.35647 21.75 6.88997V17.1101C21.75 17.6436 21.4358 18.1271 20.9483 18.3438L12.5483 22.0771C12.1992 22.2322 11.8008 22.2322 11.4517 22.0771L3.05171 18.3438C2.56419 18.1271 2.25 17.6436 2.25 17.1101V6.88997C2.25 6.35647 2.56419 5.87301 3.05171 5.65633L7.19238 3.81603C7.19425 3.81519 7.19611 3.81437 7.19798 3.81354L11.4517 1.923ZM7.5 5.32079L4.84666 6.50005L12 9.67931L14.6533 8.50005L7.5 5.32079ZM16.4986 7.67993C16.482 7.67175 16.4653 7.66388 16.4483 7.65633L9.34666 4.50005L12 3.32079L19.1533 6.50005L16.4986 7.67993ZM15.75 9.65412V12.5C15.75 12.9143 16.0858 13.25 16.5 13.25C16.9142 13.25 17.25 12.9143 17.25 12.5V8.98745L20.25 7.65412V17.0126L12.75 20.346V10.9875L15.75 9.65412ZM3.75 17.0126V7.65412L11.25 10.9875V20.346L3.75 17.0126Z",
      fill: color
    }
  ) });
}
var init_box = __esm({
  "src/icons/treatwell-pro/box.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/treatwell-pro/calendar.tsx
import { jsx as jsx20 } from "@emotion/react/jsx-runtime";
function Calendar(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx20(SvgIcon, { size, viewBox: "0 0 12 14", children: /* @__PURE__ */ jsx20(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M2.66667 6.99998H4V8.33331H2.66667V6.99998ZM5.33333 6.99998H6.66667V8.33331H5.33333V6.99998ZM5.33333 9.66665H6.66667V11H5.33333V9.66665ZM8 6.99998H9.33333V8.33331H8V6.99998ZM2.66667 9.66665H4V11H2.66667V9.66665ZM10.6667 1.66665H10.6699C11.4045 1.66665 12 2.26173 12 2.99671V12.3366C12 13.0712 11.4049 13.6666 10.6699 13.6666H1.33006C0.595488 13.6666 0 13.0716 0 12.3366V2.99671C0 2.26213 0.595082 1.66665 1.33006 1.66665H2.66667V0.333313H4V4.33331H2.66667V2.99998H1.33333V12.3333H10.6667V1.66665ZM9.33333 0.333313V4.33331H8V2.99998H5.33333V1.66665H8V0.333313H9.33333Z",
      fill: color
    }
  ) });
}
var init_calendar = __esm({
  "src/icons/treatwell-pro/calendar.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/treatwell-pro/card.tsx
import { jsx as jsx21 } from "@emotion/react/jsx-runtime";
function Card(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx21(SvgIcon, { size, children: /* @__PURE__ */ jsx21(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10 2.5C10.5523 2.5 11 2.94772 11 3.5V8.5C11 9.05228 10.5523 9.5 10 9.5H2C1.44772 9.5 1 9.05228 1 8.5V3.5C1 2.94772 1.44772 2.5 2 2.5H10ZM10 7.5H2V8.5H10V7.5ZM10 3.5H2V6.5H10V3.5Z",
      fill: color
    }
  ) });
}
var init_card = __esm({
  "src/icons/treatwell-pro/card.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/treatwell-pro/cart.tsx
import { jsx as jsx22 } from "@emotion/react/jsx-runtime";
function Cart(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx22(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx22(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M1.25 2C1.25 1.58579 1.58579 1.25 2 1.25C3.96839 1.25 5.05306 2.34155 5.51124 3.25H22C22.2224 3.25 22.4333 3.3487 22.5758 3.51944C22.7183 3.69018 22.7777 3.91536 22.7379 4.13416L20.7402 15.1213C20.7226 15.2295 20.6819 15.33 20.6232 15.4175C20.5904 15.4664 20.552 15.5111 20.5091 15.5508C20.3754 15.6744 20.1965 15.75 20 15.75H7H5.23077C4.43492 15.75 3.93322 15.9259 3.64869 16.1411C3.39118 16.3359 3.25 16.6065 3.25 17C3.25 17.3935 3.39118 17.6641 3.64869 17.8589C3.93322 18.0741 4.43492 18.25 5.23077 18.25H19.5C19.9142 18.25 20.25 18.5858 20.25 19C20.25 19.0647 20.2418 19.1274 20.2264 19.1873C20.6877 19.4431 21 19.9351 21 20.5C21 21.3284 20.3284 22 19.5 22C18.6716 22 18 21.3284 18 20.5C18 20.2268 18.073 19.9706 18.2007 19.75H10.7993C10.927 19.9706 11 20.2268 11 20.5C11 21.3284 10.3284 22 9.5 22C8.67157 22 8 21.3284 8 20.5C8 20.2268 8.07305 19.9706 8.20067 19.75H5.23077C4.24231 19.75 3.37863 19.5353 2.74385 19.0552C2.08205 18.5547 1.75 17.8253 1.75 17C1.75 16.1747 2.08205 15.4453 2.74385 14.9448C3.37863 14.4647 4.24231 14.25 5.23077 14.25H6.10134L4.26716 4.16199C4.15331 3.74877 3.56536 2.75 2 2.75C1.58579 2.75 1.25 2.41421 1.25 2ZM7.62593 14.25H19.3741L21.1013 4.75H5.89866L7.62593 14.25Z",
      fill: color
    }
  ) });
}
var init_cart = __esm({
  "src/icons/treatwell-pro/cart.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/treatwell-pro/cash.tsx
import { jsx as jsx23 } from "@emotion/react/jsx-runtime";
function Cash(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx23(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx23(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M22.9993 4C23.552 4 24 4.44463 24 5.00087V18.9991C24 19.5519 23.5525 20 22.9993 20H1.00069C0.448026 20 0 19.5554 0 18.9991V5.00087C0 4.44811 0.447469 4 1.00069 4H22.9993ZM2 16V18H4C4 16.8954 3.10457 16 2 16ZM22 16C20.9456 16 20.0818 16.8159 20.0055 17.8507L20 18H22V16ZM12 7C14.2091 7 16 9.23858 16 12C16 14.7614 14.2091 17 12 17C9.79086 17 8 14.7614 8 12C8 9.23858 9.79086 7 12 7ZM12 9C11.0059 9 10 10.2573 10 12C10 13.7427 11.0059 15 12 15C12.9941 15 14 13.7427 14 12C14 10.2573 12.9941 9 12 9ZM4 6H2V8C3.05436 8 3.91817 7.18412 3.99451 6.14926L4 6ZM22 6H20C20 6.56949 20.2379 7.09838 20.65 7.47567C21.0167 7.81142 21.4923 8 22 8V6ZM22 10C20.9874 10 20.0314 9.62094 19.2994 8.95078C18.4778 8.19849 18 7.13644 18 6H6C6 8.1422 4.31603 9.89108 2.19964 9.9951L2 10V14C4.20914 14 6 15.7909 6 18H18C18 15.8578 19.684 14.1089 21.8004 14.0049L22 14V10Z",
      fill: color
    }
  ) });
}
var init_cash = __esm({
  "src/icons/treatwell-pro/cash.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/treatwell-pro/caution.tsx
import { jsx as jsx24 } from "@emotion/react/jsx-runtime";
function Caution(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx24(SvgIcon, { size, viewBox: "0 0 12 12", children: /* @__PURE__ */ jsx24(
    "path",
    {
      fill: color,
      fillRule: "evenodd",
      d: "M6 .5a5.5 5.5 0 1 1 0 11 5.5 5.5 0 0 1 0-11Zm0 1a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9Zm0 5.75a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5Zm.5-3.75v3h-1v-3h1Z",
      clipRule: "evenodd"
    }
  ) });
}
var init_caution = __esm({
  "src/icons/treatwell-pro/caution.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/treatwell-pro/chair.tsx
import { jsx as jsx25 } from "@emotion/react/jsx-runtime";
function Chair(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx25(SvgIcon, { size, viewBox: "0 0 16 16", children: /* @__PURE__ */ jsx25(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M3.82611 1.43569C4.18419 1.33974 4.55136 1.5549 4.64251 1.9142L5.76035 6.32566H10.6126C10.9807 6.32566 11.2791 6.62423 11.2792 6.99233H5.92962L6.52272 9.33348H11.8561C12.5924 9.33353 13.1894 9.93048 13.1894 10.6668H9.85606V13.3335H10.5227C11.259 13.3335 11.856 13.9305 11.8561 14.6668H6.52272C6.52274 13.9304 7.11968 13.3335 7.85606 13.3335H8.52272V10.6668H6.52272C5.83226 10.6668 5.26404 10.142 5.1959 9.46954L5.18939 9.33348L3.35475 2.24428C3.2633 1.89094 3.47359 1.5302 3.82611 1.43569Z",
      fill: color
    }
  ) });
}
var init_chair = __esm({
  "src/icons/treatwell-pro/chair.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/treatwell-pro/check-filled.tsx
import { jsx as jsx26 } from "@emotion/react/jsx-runtime";
function CheckFilled(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx26(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx26(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM15.7929 8.29289L10.5 13.5858L8.20711 11.2929L6.79289 12.7071L10.5 16.4142L17.2071 9.70711L15.7929 8.29289Z",
      fill: color
    }
  ) });
}
var init_check_filled = __esm({
  "src/icons/treatwell-pro/check-filled.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/treatwell-pro/check-mark.tsx
import { jsx as jsx27 } from "@emotion/react/jsx-runtime";
function CheckMark(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx27(SvgIcon, { size, children: /* @__PURE__ */ jsx27(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M4.58575 7.69061L9.2998 2.97656L10.2426 3.91937L4.58575 9.57623L1.75732 6.7478L2.70013 5.80499L4.58575 7.69061Z",
      fill: color
    }
  ) });
}
var init_check_mark = __esm({
  "src/icons/treatwell-pro/check-mark.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/treatwell-pro/chevron.tsx
import { jsx as jsx28 } from "@emotion/react/jsx-runtime";
function ChevronDown(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx28(SvgIcon, { size, children: /* @__PURE__ */ jsx28(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M9.14645 4.14645L9.85355 4.85356L6 8.70711L2.14645 4.85356L2.85355 4.14645L6 7.2929L9.14645 4.14645Z",
      fill: color
    }
  ) });
}
function ChevronUp(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx28(SvgIcon, { size, children: /* @__PURE__ */ jsx28(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M2.85356 7.85357L2.14645 7.14646L6.00001 3.29291L9.85356 7.14646L9.14645 7.85357L6.00001 4.70712L2.85356 7.85357Z",
      fill: color
    }
  ) });
}
function ChevronLeft(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx28(SvgIcon, { size, children: /* @__PURE__ */ jsx28(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M7.85355 9.14645L7.14645 9.85356L3.29289 6.00001L7.14645 2.14645L7.85355 2.85356L4.70711 6.00001L7.85355 9.14645Z",
      fill: color
    }
  ) });
}
function ChevronRight(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx28(SvgIcon, { size, children: /* @__PURE__ */ jsx28(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M7.29289 6.00001L4.14645 2.85356L4.85355 2.14645L8.70711 6.00001L4.85355 9.85356L4.14645 9.14645L7.29289 6.00001Z",
      fill: color
    }
  ) });
}
var init_chevron = __esm({
  "src/icons/treatwell-pro/chevron.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/treatwell-pro/chevron-add.tsx
import { jsx as jsx29 } from "@emotion/react/jsx-runtime";
function ChevronAdd(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx29(SvgIcon, { size, children: /* @__PURE__ */ jsx29(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M6.50002 1.99377L6.4996 5.48377L10.0014 5.49378L9.9986 6.49377L6.4996 6.48327L6.50002 9.97107H5.50002L5.4996 6.48077L1.9986 6.47107L2.00143 5.47107L5.4996 5.48077L5.50002 1.99377H6.50002Z",
      fill: color
    }
  ) });
}
var init_chevron_add = __esm({
  "src/icons/treatwell-pro/chevron-add.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/treatwell-pro/close.tsx
import { jsx as jsx30 } from "@emotion/react/jsx-runtime";
function Close(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx30(SvgIcon, { size, children: /* @__PURE__ */ jsx30(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8.64645 2.64645L9.35355 3.35356L6.70695 5.99995L9.35355 8.64645L8.64645 9.35356L5.99995 6.70695L3.35355 9.35356L2.64645 8.64645L5.29295 5.99995L2.64645 3.35356L3.35355 2.64645L5.99995 5.29295L8.64645 2.64645Z",
      fill: color
    }
  ) });
}
var init_close = __esm({
  "src/icons/treatwell-pro/close.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/treatwell-pro/discount-outline.tsx
import { jsx as jsx31 } from "@emotion/react/jsx-runtime";
function DiscountOutline(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx31(SvgIcon, { size, children: /* @__PURE__ */ jsx31(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M6 0.5C9.03757 0.5 11.5 2.96243 11.5 6C11.5 9.03757 9.03757 11.5 6 11.5C2.96243 11.5 0.5 9.03757 0.5 6C0.5 2.96243 2.96243 0.5 6 0.5ZM6 1.5C3.51472 1.5 1.5 3.51472 1.5 6C1.5 8.48528 3.51472 10.5 6 10.5C8.48528 10.5 10.5 8.48528 10.5 6C10.5 3.51472 8.48528 1.5 6 1.5ZM6.62045 3.19553L7.54433 3.57822L5.37955 8.80447L4.45567 8.42178L6.62045 3.19553ZM8 6.5C8.55229 6.5 9 6.94772 9 7.5C9 8.05228 8.55229 8.5 8 8.5C7.44772 8.5 7 8.05228 7 7.5C7 6.94772 7.44772 6.5 8 6.5ZM4 3.5C4.55228 3.5 5 3.94772 5 4.5C5 5.05228 4.55228 5.5 4 5.5C3.44772 5.5 3 5.05228 3 4.5C3 3.94772 3.44772 3.5 4 3.5Z",
      fill: color
    }
  ) });
}
var init_discount_outline = __esm({
  "src/icons/treatwell-pro/discount-outline.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/treatwell-pro/expand.tsx
import { jsx as jsx32 } from "@emotion/react/jsx-runtime";
function Expand(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx32(SvgIcon, { size, children: /* @__PURE__ */ jsx32(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M4.64645 6.64645L5.35355 7.35355L2.707 9.99995L5 10V11H1V7H2V9.29245L4.64645 6.64645ZM11 1V5H10L9.99995 2.707L7.35355 5.35355L6.64645 4.64645L9.29195 2H7V1H11Z",
      fill: color
    }
  ) });
}
var init_expand = __esm({
  "src/icons/treatwell-pro/expand.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/treatwell-pro/face.tsx
import { jsx as jsx33 } from "@emotion/react/jsx-runtime";
function Face(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx33(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx33(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M2 2.5C5.30654 2.5 7.64234 3.9904 8.8285 6.87442L8.93633 7.14888L9.05212 7.45764L5.86263 18.6208C5.71091 19.1519 6.0184 19.7054 6.54944 19.8571C6.66433 19.8899 6.78385 19.9018 6.90234 19.8925L7.02027 19.8761L9.09538 19.4611L10.3143 19.9487C10.7115 20.1076 11.1642 19.9355 11.3556 19.5528C11.5076 19.2487 11.4094 18.885 11.139 18.6957L11.0528 18.6444L10.5528 18.3944L11.4472 16.6056L11.9472 16.8556C13.2696 17.5168 13.8056 19.1248 13.1444 20.4472C12.5153 21.7055 11.0624 22.3004 9.7428 21.8679L9.57151 21.8056L8.904 21.538L7.41251 21.8373C7.02195 21.9154 6.62055 21.9148 6.23165 21.8365L6 21.7801C4.46379 21.3412 3.55116 19.7816 3.89606 18.2423L3.93959 18.0714L6.944 7.555L6.87652 7.39849C6.01728 5.51023 4.52707 4.57086 2.2645 4.50386L2 4.5V2.5ZM18.9116 7.95501L20.5884 9.04499C19.5472 10.6469 18.1609 11.5 16.5 11.5C14.9182 11.5 13.5854 10.7262 12.5626 9.26872L12.4116 9.04499L14.0884 7.95501C14.7806 9.0198 15.5609 9.5 16.5 9.5C17.3804 9.5 18.1213 9.07795 18.7807 8.14783L18.9116 7.95501ZM16.5 2.5C18.9331 2.5 20.9934 3.57273 22.614 5.65404L22.8064 5.90864L21.1936 7.09136C19.9091 5.33974 18.3695 4.5 16.5 4.5C14.7154 4.5 13.2316 5.26514 11.9832 6.85815L11.8064 7.09136L10.1936 5.90864C11.8424 3.66026 13.9695 2.5 16.5 2.5Z",
      fill: color
    }
  ) });
}
var init_face = __esm({
  "src/icons/treatwell-pro/face.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/treatwell-pro/fast-delivery.tsx
import { jsx as jsx34 } from "@emotion/react/jsx-runtime";
function FastDelivery(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx34(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx34(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0.765958 4C0.342931 4 0 4.34293 0 4.76596C0 5.18898 0.342931 5.53192 0.765958 5.53192H14.2979V7.82633L14.2979 7.82979L14.2979 7.83324V15.234H10.6177C10.2843 14.0552 9.20045 13.1915 7.91489 13.1915C6.62933 13.1915 5.5455 14.0552 5.21209 15.234H3.57446V10.383C3.57446 9.95995 3.23153 9.61702 2.8085 9.61702C2.38548 9.61702 2.04254 9.95995 2.04254 10.383V15.3872C2.04254 16.1487 2.65984 16.766 3.42127 16.766H5.21209C5.5455 17.9448 6.62933 18.8085 7.91489 18.8085C9.20045 18.8085 10.2843 17.9448 10.6177 16.766H15.4249C15.7583 17.9448 16.8421 18.8085 18.1277 18.8085C19.4133 18.8085 20.4971 17.9448 20.8305 16.766H22.6213C23.3828 16.766 24 16.1487 24 15.3872V12.5555C24 12.3627 23.9595 12.172 23.8813 11.9958L22.0532 7.88261C21.8319 7.38468 21.3381 7.06383 20.7933 7.06383H15.8298V5.37872C15.8298 4.6173 15.2126 4 14.4511 4H0.765958ZM15.8298 14.3848V8.59575H20.6937L22.4681 12.588V15.234H20.8305C20.4971 14.0552 19.4133 13.1915 18.1277 13.1915C17.1778 13.1915 16.3381 13.663 15.8298 14.3848ZM7.91489 14.7234C7.20983 14.7234 6.63829 15.2949 6.63829 16C6.63829 16.7051 7.20983 17.2766 7.91489 17.2766C8.61994 17.2766 9.19148 16.7051 9.19148 16C9.19148 15.2949 8.61994 14.7234 7.91489 14.7234ZM18.1277 14.7234C17.4226 14.7234 16.8511 15.2949 16.8511 16C16.8511 16.7051 17.4226 17.2766 18.1277 17.2766C18.8327 17.2766 19.4043 16.7051 19.4043 16C19.4043 15.2949 18.8327 14.7234 18.1277 14.7234ZM1.78724 7.06383C1.36422 7.06383 1.02129 7.40676 1.02129 7.82979C1.02129 8.25282 1.36422 8.59575 1.78724 8.59575H5.87235C6.29538 8.59575 6.63831 8.25282 6.63831 7.82979C6.63831 7.40676 6.29538 7.06383 5.87235 7.06383H1.78724Z",
      fill: color
    }
  ) });
}
var init_fast_delivery = __esm({
  "src/icons/treatwell-pro/fast-delivery.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/treatwell-pro/fire.tsx
import { jsx as jsx35 } from "@emotion/react/jsx-runtime";
function Fire(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx35(SvgIcon, { size, viewBox: "0 0 25 24", children: /* @__PURE__ */ jsx35(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12.5449 0.923077L13.102 0.147116C12.7628 -0.0490386 12.3271 -0.0490386 11.9878 0.147116L12.5449 0.923077ZM12.5449 24C8.88761 24 5.85807 23.0532 3.74078 21.1827C1.62132 19.3104 0.544922 16.6264 0.544922 13.3846C0.544922 11.613 1.33513 9.89575 2.41924 8.36214C3.50835 6.82147 4.94303 5.39698 6.34884 4.19217C7.75842 2.98413 9.16375 1.97598 10.2146 1.27068C10.7409 0.917445 11.1805 0.638726 11.4901 0.447383C11.6449 0.35168 11.7674 0.277745 11.8521 0.227184C11.8945 0.201901 11.9274 0.182454 11.9503 0.169045C11.9617 0.16234 11.9706 0.157143 11.9769 0.15348L11.9843 0.149139L11.9866 0.147836L11.9873 0.147403C11.9876 0.147248 11.9878 0.147116 12.5449 0.923077C13.102 0.147116 13.1022 0.147248 13.1025 0.147403L13.1033 0.147836L13.1055 0.149139L13.113 0.15348C13.1193 0.157143 13.1282 0.16234 13.1396 0.169045C13.1624 0.182454 13.1953 0.201901 13.2377 0.227184C13.3224 0.277745 13.4449 0.35168 13.5997 0.447383C13.9093 0.638726 14.3489 0.917445 14.8752 1.27068C15.9261 1.97598 17.3314 2.98413 18.741 4.19217C20.1468 5.39698 21.5815 6.82147 22.6706 8.36214C23.7547 9.89575 24.5449 11.613 24.5449 13.3846C24.5449 16.6264 23.4685 19.3104 21.3491 21.1827C19.2318 23.0532 16.2023 24 12.5449 24ZM18.5424 20.8247C19.1837 18.932 18.5535 16.4128 16.8935 13.4333C16.7355 13.1498 16.4264 12.9588 16.0749 12.9276C15.7233 12.8963 15.3785 13.0292 15.1616 13.2794C14.5979 13.9299 14.1385 14.3197 13.7844 14.5349C13.4322 14.7488 13.254 14.7495 13.2074 14.7452C13.1748 14.7422 13.0894 14.7281 12.9489 14.5795C12.7986 14.4206 12.6363 14.1568 12.4878 13.7737C12.1916 13.0094 12.028 11.976 11.9871 10.9571C11.946 9.9329 12.0327 9.02919 12.1714 8.53157C12.2986 8.07481 12.0224 7.6053 11.5304 7.44195C11.0383 7.2786 10.4881 7.47376 10.2535 7.89488C10.1383 8.10161 10.0226 8.3085 9.90669 8.51564L9.906 8.51687C7.98717 11.9464 6.03064 15.4433 6.03064 19.3846C6.03064 19.8216 6.07734 20.2269 6.16813 20.6008C5.81249 20.3776 5.4844 20.1325 5.1839 19.8671C3.5489 18.4227 2.60206 16.2605 2.60206 13.3846C2.60206 12.0974 3.18329 10.7276 4.15632 9.35112C5.12435 7.98173 6.43253 6.67319 7.76957 5.52731C9.10285 4.38467 10.4404 3.42449 11.4466 2.74912C11.8876 2.45318 12.2633 2.21304 12.5449 2.03737C12.8266 2.21304 13.2023 2.45318 13.6432 2.74912C14.6495 3.42449 15.987 4.38467 17.3203 5.52731C18.6573 6.67319 19.9655 7.98173 20.9335 9.35112C21.9066 10.7276 22.4878 12.0974 22.4878 13.3846C22.4878 16.2605 21.541 18.4227 19.906 19.8671C19.5014 20.2244 19.0469 20.5448 18.5424 20.8247ZM12.5449 22.1538C11.0803 22.1538 9.94903 21.9725 9.20738 21.5605C8.56163 21.2017 8.08779 20.6005 8.08779 19.3846C8.08779 16.991 8.90924 14.7681 10.064 12.4637C10.1633 13.1346 10.3186 13.7963 10.5449 14.3802C10.7392 14.8817 11.0055 15.3775 11.3803 15.7739C11.7647 16.1805 12.3008 16.5174 12.9967 16.5817C13.6787 16.6447 14.3362 16.429 14.9376 16.0637C15.1884 15.9113 15.4414 15.726 15.6975 15.5081C16.8006 17.8501 16.9273 19.456 16.5146 20.4458C16.0924 21.4586 14.9303 22.1538 12.5449 22.1538Z",
      fill: color
    }
  ) });
}
var init_fire = __esm({
  "src/icons/treatwell-pro/fire.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/treatwell-pro/gift.tsx
import { jsx as jsx36 } from "@emotion/react/jsx-runtime";
function Gift(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx36(SvgIcon, { size, children: /* @__PURE__ */ jsx36(
    "path",
    {
      id: "Shape",
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M2.99703 11C2.44639 11 2 10.5563 2 10.0002V7H1V3.99905C1 3.44729 1.44911 3 1.9954 3L3.003 3.00026C2.68844 2.70755 2.5 2.36667 2.5 2C2.5 1.03497 3.14197 0.5 4 0.5C5.25991 0.5 6.26975 1.48747 6.49282 2.9508C6.82072 2.91551 7.10497 2.85994 7.34594 2.78446L7.44839 2.75001L7.44818 2.74852C8.0647 2.5342 8.5 2.22487 8.5 2C8.5 1.63169 8.34197 1.5 8 1.5C7.69581 1.5 7.42067 1.58397 7.19156 1.74963C7.06672 1.42443 6.90559 1.12824 6.71354 0.865334C7.0833 0.627446 7.52065 0.5 8 0.5C8.85803 0.5 9.5 1.03497 9.5 2C9.5 2.36669 9.31154 2.70759 8.99696 3.0003L10.0046 3C10.5543 3 11 3.44335 11 3.99905V7H6.5V10H9V8H10V10.0002C10 10.5524 9.55274 11 9.00297 11H2.99703ZM5.5 7H3V10H5.5V7ZM5.5 3.9995L2 4V6L5.5 5.9995V3.9995ZM6.5 5.9995L10 6V4L6.5 3.9995V5.9995ZM4 1.5C3.65803 1.5 3.5 1.63169 3.5 2C3.5 2.32498 4.40912 2.82633 5.46079 2.96398C5.31041 1.99895 4.74152 1.5 4 1.5Z",
      fill: color
    }
  ) });
}
var init_gift = __esm({
  "src/icons/treatwell-pro/gift.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/treatwell-pro/hair.tsx
import { jsx as jsx37 } from "@emotion/react/jsx-runtime";
function Hair(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx37(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx37(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11 16C12.6569 16 14 17.3431 14 19C14 20.6568 12.6569 22 11 22C9.34315 22 8 20.6568 8 19C8 17.3431 9.34315 16 11 16ZM11 18C10.4477 18 10 18.4477 10 19C10 19.5523 10.4477 20 11 20C11.5523 20 12 19.5523 12 19C12 18.4477 11.5523 18 11 18ZM15.1056 2.55278L16.8944 3.44721L13.236 10.7628L20.5528 7.10557L21.4472 8.89442L11.2802 13.9764L10.7628 14.2205C10.2402 14.4616 9.68561 14.7028 9.12139 14.9285C8.65277 15.1159 8.19718 15.2847 7.76067 15.4302C6.77635 15.7583 5.9297 15.9573 5.22838 15.9939L5 16C3.34315 16 2 14.6568 2 13C2 11.3431 3.34315 9.99999 5 9.99999C6.65685 9.99999 8 11.3431 8 13C8 13.0752 7.99724 13.1497 7.99181 13.2234L8.37861 13.0715C8.73163 12.9303 9.08198 12.7821 9.4224 12.6315L10.0463 12.3481L10.2595 12.2479L15.1056 2.55278ZM5 12C4.44772 12 4 12.4477 4 13C4 13.5523 4.44772 14 5 14C5.55228 14 6 13.5523 6 13C6 12.4477 5.55228 12 5 12Z",
      fill: color
    }
  ) });
}
var init_hair = __esm({
  "src/icons/treatwell-pro/hair.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/treatwell-pro/hair-removal.tsx
import { jsx as jsx38 } from "@emotion/react/jsx-runtime";
function HairRemoval(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx38(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx38(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M21.5 2.5C22.8807 3.88071 22.8807 6.11928 21.5 7.5L7.5 21.5C6.11928 22.8807 3.88071 22.8807 2.5 21.5C1.11928 20.1193 1.11928 17.8807 2.5 16.5L16.5 2.5C17.8807 1.11928 20.1193 1.11928 21.5 2.5ZM19 11.3431L21.7486 15.4836C22.7756 17.0305 22.5699 19.0869 21.257 20.3999C20.0105 21.6464 17.9895 21.6464 16.743 20.3999C15.4301 19.0869 15.2244 17.0305 16.2513 15.4836L19 11.3431ZM12.9995 8.82746L3.91421 17.9142C3.31455 18.5139 3.31455 19.4861 3.91421 20.0858C4.48056 20.6521 5.37924 20.6836 5.98252 20.1802L6.08578 20.0858L12.9995 13.1715V8.82746ZM19 14.9593L17.9176 16.5898C17.4171 17.3436 17.5174 18.3458 18.1572 18.9856C18.6227 19.4511 19.3773 19.4511 19.8428 18.9856C20.445 18.3834 20.5692 17.4603 20.1645 16.7252L20.0824 16.5898L19 14.9593ZM18.0175 3.81982L17.9142 3.91421L14.9995 6.82746V11.1715L20.0858 6.08578C20.6854 5.48612 20.6854 4.51387 20.0858 3.91421C19.5194 3.34786 18.6208 3.3164 18.0175 3.81982Z",
      fill: color
    }
  ) });
}
var init_hair_removal = __esm({
  "src/icons/treatwell-pro/hair-removal.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/treatwell-pro/hamburger-nav.tsx
import { jsx as jsx39 } from "@emotion/react/jsx-runtime";
function HamburgerNav(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx39(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx39(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M22 17V19H2V17H22ZM22 11V13H2V11H22ZM22 5V7H2V5H22Z",
      fill: color
    }
  ) });
}
var init_hamburger_nav = __esm({
  "src/icons/treatwell-pro/hamburger-nav.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/treatwell-pro/happy.tsx
import { jsx as jsx40 } from "@emotion/react/jsx-runtime";
function Happy(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx40(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx40(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12ZM12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1ZM9 8C8.44772 8 8 8.44772 8 9C8 9.55228 8.44772 10 9 10H9.01C9.56228 10 10.01 9.55228 10.01 9C10.01 8.44772 9.56228 8 9.01 8H9ZM15 8C14.4477 8 14 8.44772 14 9C14 9.55228 14.4477 10 15 10H15.01C15.5623 10 16.01 9.55228 16.01 9C16.01 8.44772 15.5623 8 15.01 8H15ZM7.40006 13.2001C7.84049 12.8697 8.46474 12.9577 8.79692 13.3959L8.80156 13.4018C8.80751 13.4093 8.81883 13.4234 8.83537 13.4431C8.86852 13.4826 8.92225 13.5442 8.99548 13.6207C9.14278 13.7744 9.36413 13.9829 9.65073 14.1913C10.2278 14.611 11.0256 15.0001 12.0001 15.0001C12.9745 15.0001 13.7723 14.611 14.3494 14.1913C14.636 13.9829 14.8573 13.7744 15.0046 13.6207C15.0779 13.5442 15.1316 13.4826 15.1647 13.4431C15.1813 13.4234 15.1926 13.4093 15.1986 13.4018L15.2032 13.3959C15.5354 12.9577 16.1596 12.8697 16.6001 13.2001C17.0419 13.5314 17.1314 14.1582 16.8001 14.6001L16.0001 14.0001L16.799 14.6014L16.7979 14.6029L16.7952 14.6066L16.7879 14.616L16.7666 14.6432C16.7494 14.665 16.7261 14.6939 16.6967 14.7289C16.6381 14.7987 16.5551 14.8934 16.4486 15.0045C16.2365 15.2258 15.9266 15.5172 15.5257 15.8088C14.7278 16.3891 13.5256 17.0001 12.0001 17.0001C10.4745 17.0001 9.27233 16.3891 8.47439 15.8088C8.07349 15.5172 7.76358 15.2258 7.55151 15.0045C7.44506 14.8934 7.36207 14.7987 7.30342 14.7289C7.27407 14.6939 7.25071 14.665 7.23347 14.6432L7.21217 14.616L7.20496 14.6066L7.20222 14.6029L7.20107 14.6014L7.20006 14.6001C6.86869 14.1582 6.95823 13.5314 7.40006 13.2001Z",
      fill: color
    }
  ) });
}
function Unhappy(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx40(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx40(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12ZM12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1ZM9 8C8.44772 8 8 8.44772 8 9C8 9.55228 8.44772 10 9 10H9.01C9.56228 10 10.01 9.55228 10.01 9C10.01 8.44772 9.56228 8 9.01 8H9ZM15 8C14.4477 8 14 8.44772 14 9C14 9.55228 14.4477 10 15 10H15.01C15.5623 10 16.01 9.55228 16.01 9C16.01 8.44772 15.5623 8 15.01 8H15ZM8.70711 16.2071C9.0556 15.8586 10.3122 15 12 15C13.6878 15 14.9444 15.8586 15.2929 16.2071C15.6834 16.5976 16.3166 16.5976 16.7071 16.2071C17.0976 15.8166 17.0976 15.1834 16.7071 14.7929C16.0556 14.1414 14.3122 13 12 13C9.68783 13 7.94439 14.1414 7.29289 14.7929C6.90237 15.1834 6.90237 15.8166 7.29289 16.2071C7.68342 16.5976 8.31658 16.5976 8.70711 16.2071Z",
      fill: color
    }
  ) });
}
var init_happy = __esm({
  "src/icons/treatwell-pro/happy.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/treatwell-pro/heart.tsx
import { jsx as jsx41 } from "@emotion/react/jsx-runtime";
function HeartOutline(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx41(SvgIcon, { size, children: /* @__PURE__ */ jsx41(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8 1.5C9.61919 1.5 11 2.79451 11 5C11 7.20944 7.6033 10.5 6 10.5C4.3967 10.5 1 7.20944 1 5C1 2.79451 2.38081 1.5 4 1.5C4.8514 1.5 5.35371 1.72558 6 2.3085C6.64629 1.72558 7.1486 1.5 8 1.5ZM4 2.5C2.91919 2.5 2 3.36174 2 5C2 6.64993 4.94201 9.5 6 9.5C7.05799 9.5 10 6.64993 10 5C10 3.36174 9.08081 2.5 8 2.5C7.33308 2.5 7.01815 2.68895 6.35355 3.35355L6 3.70711L5.64645 3.35355C4.98185 2.68895 4.66692 2.5 4 2.5Z",
      fill: color
    }
  ) });
}
function HeartFilled(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx41(SvgIcon, { size, children: /* @__PURE__ */ jsx41(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M3.77778 1.5C2.66667 1.5 1 2.34375 1 4.875C1 7.40625 4.88889 10.5 6 10.5C7.11111 10.5 11 7.40625 11 4.875C11 2.34375 9.33333 1.5 8.22222 1.5C7.11111 1.5 6.55556 2.0625 6 2.625C5.44444 2.0625 4.88889 1.5 3.77778 1.5Z",
      fill: color
    }
  ) });
}
var init_heart = __esm({
  "src/icons/treatwell-pro/heart.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/treatwell-pro/highlights.tsx
import { jsx as jsx42 } from "@emotion/react/jsx-runtime";
function Highlights(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx42(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx42(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10 14L9.99976 16.623L12.4952 15.8129L13.1132 17.715L10.6178 18.525L12.1602 20.6483L10.5421 21.8239L8.99976 19.7L7.45788 21.8239L5.83984 20.6483L7.38176 18.526L4.88676 17.715L5.50479 15.8129L7.99976 16.623L8 14H10ZM19 8L18.9998 10.623L21.4952 9.81288L22.1132 11.715L19.6178 12.525L21.1602 14.6483L19.5421 15.8239L17.9998 13.7L16.4579 15.8239L14.8398 14.6483L16.3818 12.526L13.8868 11.715L14.5048 9.81288L16.9998 10.623L17 8H19ZM8 2L7.99975 4.623L10.4952 3.81288L11.1132 5.71499L8.61775 6.525L10.1602 8.64828L8.54212 9.82385L6.99975 7.7L5.45787 9.82385L3.83984 8.64828L5.38175 6.525L2.88675 5.71499L3.50479 3.81288L5.99975 4.623L6 2H8Z",
      fill: color
    }
  ) });
}
var init_highlights = __esm({
  "src/icons/treatwell-pro/highlights.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/treatwell-pro/home.tsx
import { jsx as jsx43 } from "@emotion/react/jsx-runtime";
function Home(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx43(SvgIcon, { size, children: /* @__PURE__ */ jsx43(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M3 11C2.44772 11 2 10.5523 2 10L1.99967 5.1615L0.897457 6.08695L0.254669 5.32091L6 0.5L11.7453 5.32091L11.1025 6.08695L5.99967 1.8055L2.99967 4.3225L3 10H3.99967L4 6.99852C4 6.72319 4.22549 6.5 4.49539 6.5H6.50461C6.77821 6.5 7 6.72652 7 6.99852L6.99967 10H9V6.5H10V10C10 10.5523 9.55229 11 9 11H3ZM6 7.5H5V10H6V7.5Z",
      fill: color
    }
  ) });
}
var init_home = __esm({
  "src/icons/treatwell-pro/home.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/treatwell-pro/home-based-salon.tsx
import { jsx as jsx44 } from "@emotion/react/jsx-runtime";
function HomeBasedSalon(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx44(SvgIcon, { size, children: /* @__PURE__ */ jsx44(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11.0178 5.1967C12.0398 6.21878 12.1796 7.82754 11.349 9.01051L9.25 12L7.15103 9.01051C6.32045 7.82754 6.46016 6.21878 7.48223 5.1967C8.45855 4.22039 10.0415 4.22039 11.0178 5.1967ZM8.18934 5.90381C7.53416 6.55899 7.4251 7.57728 7.9147 8.35365L7.96945 8.43588L9.24998 10.2594L10.5306 8.43588C11.063 7.67757 10.9949 6.65571 10.3788 5.97537L10.3107 5.90381C9.72488 5.31802 8.77513 5.31802 8.18934 5.90381ZM4.75 0L8.58022 3.21394L7.93744 3.97998L4.75003 1.3055L1.99953 3.613L2 8.5H2.99953L3 5.49852C3 5.22319 3.22549 5 3.49539 5H5.50461C5.77821 5 6 5.22652 6 5.49852V9.5H2C1.44772 9.5 1 9.05229 1 8.5L0.999526 4.452L0.643314 4.75133L0.000526428 3.98528L4.75 0ZM5 6H4V8.5H5V6ZM9.25 6.75C9.52614 6.75 9.75 6.97386 9.75 7.25C9.75 7.52614 9.52614 7.75 9.25 7.75C8.97386 7.75 8.75 7.52614 8.75 7.25C8.75 6.97386 8.97386 6.75 9.25 6.75Z",
      fill: color
    }
  ) });
}
var init_home_based_salon = __esm({
  "src/icons/treatwell-pro/home-based-salon.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/treatwell-pro/loading.tsx
import { jsx as jsx45 } from "@emotion/react/jsx-runtime";
function Loading(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx45(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx45(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M14.2173 4.31503C12.9192 3.93953 11.547 3.89901 10.229 4.19724C8.91091 4.49547 7.68987 5.12273 6.6798 6.02049C5.66972 6.91825 4.90353 8.05726 4.45272 9.33123C4.26848 9.85188 3.69705 10.1246 3.1764 9.94035C2.65576 9.75611 2.38304 9.18469 2.56728 8.66404C3.1308 7.07158 4.08854 5.64782 5.35114 4.52561C6.61373 3.40341 8.14002 2.61933 9.7876 2.24655C11.4352 1.87376 13.1503 1.92442 14.7731 2.39379C16.3906 2.86166 17.8637 3.7304 19.0559 4.91932L22 7.68577V3.99763C22 3.44535 22.4477 2.99763 23 2.99763C23.5523 2.99763 24 3.44535 24 3.99763V9.99763C24 10.5499 23.5523 10.9976 23 10.9976H17C16.4477 10.9976 16 10.5499 16 9.99763C16 9.44535 16.4477 8.99763 17 8.99763H20.4755L17.6752 6.36639C17.6676 6.35923 17.6601 6.35196 17.6527 6.34456C16.6974 5.38875 15.5155 4.69053 14.2173 4.31503ZM0 13.9976C0 13.4453 0.447715 12.9976 1 12.9976H7C7.55228 12.9976 8 13.4453 8 13.9976C8 14.5499 7.55228 14.9976 7 14.9976H3.52455L6.32478 17.6289C6.33239 17.636 6.3399 17.6433 6.34728 17.6507C7.30262 18.6065 8.4845 19.3047 9.78267 19.6802C11.0808 20.0557 12.453 20.0963 13.771 19.798C15.0891 19.4998 16.3101 18.8725 17.3202 17.9748C18.3303 17.077 19.0965 15.938 19.5473 14.664C19.7315 14.1434 20.3029 13.8707 20.8236 14.0549C21.3442 14.2392 21.617 14.8106 21.4327 15.3312C20.8692 16.9237 19.9115 18.3474 18.6489 19.4697C17.3863 20.5919 15.86 21.3759 14.2124 21.7487C12.5648 22.1215 10.8497 22.0709 9.22695 21.6015C7.6094 21.1336 6.13627 20.2649 4.94411 19.0759L2 16.3095V19.9976C2 20.5499 1.55228 20.9976 1 20.9976C0.447715 20.9976 0 20.5499 0 19.9976V13.9976Z",
      fill: color
    }
  ) });
}
var init_loading = __esm({
  "src/icons/treatwell-pro/loading.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/treatwell-pro/massage.tsx
import { jsx as jsx46 } from "@emotion/react/jsx-runtime";
function Massage(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx46(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx46(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M13.5 0C14.7303 0 15.753 0.888719 15.9613 2.05921C16.1339 2.02018 16.3146 2 16.5 2C17.7303 2 18.753 2.88872 18.9613 4.05921C19.1339 4.02018 19.3146 4 19.5 4C20.8255 4 21.91 5.03154 21.9947 6.33562L22 6.5V20C22 22.1422 20.316 23.8911 18.1996 23.9951L18 24V22C19.0544 22 19.9182 21.1841 19.9945 20.1493L20 20V6.5C20 6.22386 19.7761 6 19.5 6C19.2545 6 19.0504 6.17688 19.0081 6.41012L19 6.5V12H17V4.5C17 4.22386 16.7761 4 16.5 4C16.2545 4 16.0504 4.17688 16.0081 4.41012L15.9998 4.499L16 12H14V2.5C14 2.22386 13.7761 2 13.5 2C13.2545 2 13.0504 2.17688 13.0081 2.41012L13 2.5V12H11V4.5C11 4.22386 10.7761 4 10.5 4C10.2545 4 10.0504 4.17688 10.0081 4.41012L10 4.5V17H8.2132L5.16925 15.0975C4.86214 14.9056 4.46319 14.951 4.20711 15.2071C4.03069 15.3835 4.00036 15.6539 4.12278 15.8625L4.17586 15.9376L10.9658 24H8.35075L2.64603 17.2259C1.79639 16.2169 1.86019 14.7256 2.79289 13.7929C3.66178 12.924 4.99118 12.7341 6.06237 13.305L6.22925 13.4015L7.999 14.508L8 4.5C8 3.17452 9.03154 2.08996 10.3356 2.00532L10.5 2C10.6856 2 10.8666 2.02023 11.0407 2.05862C11.247 0.88872 12.2697 0 13.5 0Z",
      fill: color
    }
  ) });
}
var init_massage = __esm({
  "src/icons/treatwell-pro/massage.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/treatwell-pro/minus.tsx
import { jsx as jsx47 } from "@emotion/react/jsx-runtime";
function Minus(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx47(SvgIcon, { size, children: /* @__PURE__ */ jsx47(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10.0014 5.49377L9.99858 6.49377L1.99858 6.47107L2.00142 5.47107L10.0014 5.49377Z",
      fill: color
    }
  ) });
}
var init_minus = __esm({
  "src/icons/treatwell-pro/minus.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/treatwell-pro/mobile-therapist.tsx
import { jsx as jsx48 } from "@emotion/react/jsx-runtime";
function MobileTherapist(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx48(SvgIcon, { size, children: /* @__PURE__ */ jsx48(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M9.25 7.5C10.2165 7.5 11 8.2835 11 9.25C11 10.2165 10.2165 11 9.25 11C8.2835 11 7.5 10.2165 7.5 9.25C7.5 8.2835 8.2835 7.5 9.25 7.5ZM8.5901 1C9.0403 1 9.43139 1.30011 9.55221 1.72723L9.57068 1.80388L10.6099 7H9.06155C8.11448 7 7.28459 7.62154 7.01294 8.52028L6.98507 8.62127L6.89039 9H5V9.2C5 10.1941 4.2165 11 3.25 11C2.31572 11 1.55244 10.2469 1.50259 9.29876L1.5 9.2V9H1V7C1 5.9289 1.84198 5.05446 2.90018 5.00245L3 5H5.5V8H6.1355L6.17475 7.90356C6.64628 6.80155 7.71561 6.05132 8.9349 6.00253L9.06155 6H9.39L8.5901 2H7V1H8.5901ZM9.25 8.5C8.83579 8.5 8.5 8.83579 8.5 9.25C8.5 9.66421 8.83579 10 9.25 10C9.66421 10 10 9.66421 10 9.25C10 8.83579 9.66421 8.5 9.25 8.5ZM4 9H2.5V9.2C2.5 9.62314 2.80522 9.9606 3.18269 9.99679L3.25 10C3.63515 10 3.96178 9.68606 3.99688 9.27374L4 9.2V9ZM4.5 6H3C2.47282 6 2.04092 6.40794 2.00274 6.92537L2 7V8H4.5V6ZM5.5 3.5V4.5H2.5C2.5 3.94772 2.94772 3.5 3.5 3.5H5.5Z",
      fill: color
    }
  ) });
}
var init_mobile_therapist = __esm({
  "src/icons/treatwell-pro/mobile-therapist.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/treatwell-pro/nails.tsx
import { jsx as jsx49 } from "@emotion/react/jsx-runtime";
function Nails(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx49(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx49(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M9 1C10.1046 1 11 1.89543 11 3V10H9V15.275L9.32781 15.378C10.4085 15.712 11.1795 15.8876 12.0007 15.9597L12 14C12 13.4872 11.614 13.0645 11.1166 13.0067L11 13H10V11H11C12.6569 11 14 12.3431 14 14V23H2V14C2 12.3431 3.34315 11 5 11H6V13H5C4.48716 13 4.06449 13.386 4.00673 13.8834L4 14L4.00148 14.033C4.97169 14.1017 5.84215 14.2838 6.99956 14.6309L7 10H5V3C5 1.89543 5.89543 1 7 1H9ZM19 1C20.6569 1 22 2.34315 22 4V20C22 21.6569 20.6569 23 19 23C17.3431 23 16 21.6569 16 20V4C16 2.34315 17.3431 1 19 1ZM4.00031 16.0404L4 21H12L11.9995 17.9671C11.0293 17.8984 10.1589 17.7165 9.00167 17.3695L9 20H7V16.724L6.67231 16.622C5.592 16.2881 4.82117 16.1125 4.00031 16.0404ZM19 3C18.4872 3 18.0645 3.38604 18.0067 3.88338L18 4V20C18 20.5523 18.4477 21 19 21C19.5128 21 19.9355 20.614 19.9933 20.1166L20 20V4C20 3.44772 19.5523 3 19 3ZM9 3H7V8H9V3Z",
      fill: color
    }
  ) });
}
var init_nails = __esm({
  "src/icons/treatwell-pro/nails.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/treatwell-pro/new-venue.tsx
import { jsx as jsx50, jsxs as jsxs12 } from "@emotion/react/jsx-runtime";
function NewVenue(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsxs12(SvgIcon, { size, viewBox: "0 0 16 16", children: [
    /* @__PURE__ */ jsx50(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9.08956 1.33334C9.7833 1.33334 10.4108 1.86892 10.5245 2.55093L10.8973 4.27534L9.60267 4.59934L9.2093 2.77013C9.20244 2.729 9.12942 2.66668 9.08956 2.66668H2.00058C1.95716 2.66668 1.88831 2.7253 1.88084 2.77013L1.38909 5.054L1.36218 5.16045C1.34305 5.21629 1.33333 5.27398 1.33333 5.33334C1.33333 5.6829 1.69008 6.00001 2.16667 6.00001C2.42645 6.00001 2.66167 5.90359 2.8186 5.74555L3.29167 5.26912L3.76474 5.74555C3.92166 5.90359 4.15689 6.00001 4.41667 6.00001C4.67645 6.00001 4.91167 5.90359 5.0686 5.74555L5.54167 5.26912L6.01474 5.74555C6.17166 5.90359 6.40689 6.00001 6.66667 6.00001C6.92645 6.00001 7.16167 5.90359 7.3186 5.74555L7.33333 5.73001L7.33405 7.23671C7.12128 7.30006 6.89651 7.33334 6.66667 7.33334C6.26361 7.33334 5.87612 7.231 5.54167 7.04358C5.20721 7.231 4.81973 7.33334 4.41667 7.33334C4.01361 7.33334 3.62612 7.231 3.29167 7.04358C3.09877 7.15167 2.88824 7.23147 2.66725 7.27965L2.66667 11.3344L6.26667 11.3333L6.13333 12.6667H2.67291C1.9303 12.6667 1.33333 12.0735 1.33333 11.3353L1.33339 7.18002C0.556373 6.88148 0 6.1769 0 5.33334C0 5.14669 0.027826 4.96295 0.0819588 4.78642L0.565651 2.55093C0.680042 1.86458 1.30395 1.33334 2.00058 1.33334H9.08956Z",
        fill: color
      }
    ),
    /* @__PURE__ */ jsx50(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10.0733 5.33334C9.88024 5.33334 9.70709 5.45226 9.63777 5.63249L9.14275 6.91954C9.01572 7.24981 8.97825 7.33774 8.92823 7.40809C8.87684 7.48036 8.81369 7.54351 8.74141 7.5949C8.67106 7.64493 8.58314 7.6824 8.25287 7.80943L6.96581 8.30445C6.78559 8.37376 6.66667 8.54692 6.66667 8.74001C6.66667 8.9331 6.78559 9.10625 6.96581 9.17557L8.25286 9.67059C8.58314 9.79762 8.67106 9.83509 8.74141 9.88512C8.81369 9.93651 8.87683 9.99965 8.92823 10.0719C8.97825 10.1423 9.01572 10.2302 9.14275 10.5605L9.63777 11.8475C9.70709 12.0278 9.88024 12.1467 10.0733 12.1467C10.2664 12.1467 10.4396 12.0278 10.5089 11.8475L11.0039 10.5605C11.1309 10.2302 11.1684 10.1423 11.2184 10.0719C11.2698 9.99965 11.333 9.93651 11.4053 9.88512C11.4756 9.83509 11.5635 9.79762 11.8938 9.67059L13.1809 9.17557C13.3611 9.10625 13.48 8.9331 13.48 8.74001C13.48 8.54692 13.3611 8.37376 13.1809 8.30445L11.8938 7.80943C11.5635 7.6824 11.4756 7.64493 11.4053 7.5949C11.333 7.54351 11.2698 7.48036 11.2184 7.40809C11.1684 7.33774 11.1309 7.24981 11.0039 6.91954L10.5089 5.63249C10.4396 5.45226 10.2664 5.33334 10.0733 5.33334ZM10.0733 7.09999L10.1328 7.25459C10.1387 7.26993 10.1445 7.28507 10.1503 7.30004C10.2515 7.56377 10.3308 7.77039 10.4578 7.94895C10.5696 8.10626 10.7071 8.24369 10.8644 8.35555C11.0429 8.48251 11.2496 8.56184 11.5133 8.66309C11.5283 8.66884 11.5434 8.67465 11.5588 8.68055L11.7134 8.74001L11.5588 8.79947C11.5434 8.80537 11.5283 8.81118 11.5133 8.81693C11.2496 8.91818 11.0429 8.99751 10.8644 9.12447C10.7071 9.23633 10.5696 9.37376 10.4578 9.53107C10.3308 9.70963 10.2515 9.91625 10.1503 10.18C10.1445 10.1949 10.1387 10.2101 10.1328 10.2254L10.0733 10.38L10.0139 10.2254C10.008 10.2101 10.0022 10.1949 9.99642 10.18C9.89516 9.91625 9.81583 9.70963 9.68887 9.53107C9.57702 9.37376 9.43958 9.23633 9.28227 9.12447C9.10372 8.99751 8.89709 8.91818 8.63336 8.81693C8.61839 8.81118 8.60325 8.80537 8.58791 8.79947L8.43332 8.74001L8.58791 8.68055C8.60325 8.67465 8.61839 8.66884 8.63336 8.66309C8.89709 8.56184 9.10372 8.48251 9.28227 8.35555C9.43958 8.24369 9.57702 8.10626 9.68887 7.94895C9.81584 7.77039 9.89516 7.56377 9.99642 7.30003C10.0022 7.28507 10.008 7.26992 10.0139 7.25459L10.0733 7.09999ZM13.6433 9.95334C13.4666 9.95334 13.305 10.0532 13.2259 10.2113L12.8965 10.8703C12.777 11.1091 12.743 11.1726 12.7025 11.2252C12.6609 11.2792 12.6125 11.3276 12.5585 11.3692C12.5059 11.4097 12.4425 11.4437 12.2036 11.5631L11.5446 11.8926C11.3865 11.9717 11.2867 12.1332 11.2867 12.31C11.2867 12.4868 11.3865 12.6484 11.5446 12.7274L12.2036 13.0569C12.4425 13.1763 12.5059 13.2103 12.5585 13.2508C12.6125 13.2924 12.6609 13.3408 12.7025 13.3948C12.743 13.4474 12.777 13.5109 12.8965 13.7498L13.2259 14.4087C13.305 14.5668 13.4666 14.6667 13.6433 14.6667C13.8201 14.6667 13.9817 14.5668 14.0607 14.4087L14.3902 13.7498C14.5096 13.5109 14.5436 13.4474 14.5842 13.3948C14.6258 13.3408 14.6742 13.2924 14.7281 13.2508C14.7807 13.2103 14.8442 13.1763 15.0831 13.0569L15.742 12.7274C15.9001 12.6484 16 12.4868 16 12.31C16 12.1332 15.9001 11.9717 15.742 11.8926L15.0831 11.5631C14.8442 11.4437 14.7807 11.4097 14.7281 11.3692C14.6742 11.3276 14.6258 11.2792 14.5842 11.2252C14.5436 11.1726 14.5096 11.1091 14.3902 10.8703L14.0607 10.2113C13.9817 10.0532 13.8201 9.95334 13.6433 9.95334ZM13.6433 11.4624C13.7084 11.589 13.7691 11.6966 13.8449 11.795C13.9355 11.9125 14.0408 12.0178 14.1583 12.1084C14.2567 12.1842 14.3643 12.2449 14.4909 12.31C14.3643 12.3751 14.2567 12.4358 14.1583 12.5116C14.0408 12.6022 13.9355 12.7075 13.8449 12.825C13.7691 12.9234 13.7084 13.031 13.6433 13.1576C13.5783 13.031 13.5175 12.9234 13.4417 12.825C13.3512 12.7075 13.2458 12.6022 13.1283 12.5116C13.03 12.4358 12.9224 12.3751 12.7957 12.31C12.9224 12.2449 13.03 12.1842 13.1283 12.1084C13.2458 12.0178 13.3512 11.9125 13.4417 11.795C13.5175 11.6966 13.5783 11.589 13.6433 11.4624Z",
        fill: color
      }
    )
  ] });
}
var init_new_venue = __esm({
  "src/icons/treatwell-pro/new-venue.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/treatwell-pro/online.tsx
import { jsx as jsx51 } from "@emotion/react/jsx-runtime";
function Online(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx51(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx51(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8.99999 5H6.99999V7H8.99999V5ZM11 5V7H19V9H2.99999V20H21V5H11ZM4.99999 5H2.99999V7H4.99999V5ZM21.007 3C22.11 3 23 3.895 23 5V20C23 21.102 22.11 22 21.007 22H2.99299C2.46337 21.9995 1.95569 21.7884 1.58184 21.4132C1.20799 21.038 0.998667 20.5296 0.999976 20V5C0.999976 3.898 1.88999 3 2.99299 3H21.007ZM8.99999 11L15 15L13.083 15.959L14.285 18H11.964L11.29 16.855L8.99999 18V11Z",
      fill: color
    }
  ) });
}
var init_online = __esm({
  "src/icons/treatwell-pro/online.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/treatwell-pro/padlock.tsx
import { jsx as jsx52 } from "@emotion/react/jsx-runtime";
function Padlock(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx52(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx52(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12 2C15.0376 2 17.5 4.46243 17.5 7.5V8H18C19.1046 8 20 8.89543 20 10V20C20 21.1046 19.1046 22 18 22H6C4.89543 22 4 21.1046 4 20V10C4 8.89543 4.89543 8 6 8H6.5V7.5C6.5 4.46243 8.96243 2 12 2ZM18 10H6V20H18V10ZM12 13C13.1046 13 14 13.8954 14 15C14 16.1046 13.1046 17 12 17C10.8954 17 10 16.1046 10 15C10 13.8954 10.8954 13 12 13ZM12 4C10.1314 4 8.60488 5.4643 8.50519 7.30798L8.5 7.5V8H15.5V7.5C15.5 5.63144 14.0357 4.10482 12.192 4.00513L12 4Z",
      fill: color
    }
  ) });
}
var init_padlock = __esm({
  "src/icons/treatwell-pro/padlock.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/treatwell-pro/pen.tsx
import { jsx as jsx53 } from "@emotion/react/jsx-runtime";
function Pen(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx53(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx53(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M19 3.17188C18.7599 3.17188 18.5222 3.21917 18.3003 3.31106C18.0785 3.40294 17.8769 3.53762 17.7071 3.70741L4.39491 17.0196L3.42524 20.5751L6.9807 19.6054L20.2929 6.2932C20.4627 6.12341 20.5974 5.92184 20.6893 5.70001C20.7812 5.47818 20.8284 5.24042 20.8284 5.0003C20.8284 4.76019 20.7812 4.52243 20.6893 4.30059C20.5974 4.07876 20.4627 3.87719 20.2929 3.70741C20.1231 3.53762 19.9216 3.40294 19.6997 3.31106C19.4779 3.21917 19.2401 3.17188 19 3.17188ZM17.5349 1.4633C17.9994 1.2709 18.4973 1.17188 19 1.17188C19.5028 1.17188 20.0006 1.2709 20.4651 1.4633C20.9296 1.65569 21.3516 1.93769 21.7071 2.2932C22.0626 2.6487 22.3446 3.07074 22.537 3.53523C22.7294 3.99972 22.8284 4.49755 22.8284 5.0003C22.8284 5.50306 22.7294 6.00089 22.537 6.46538C22.3446 6.92986 22.0626 7.35191 21.7071 7.70741L8.20713 21.2074C8.08407 21.3305 7.93104 21.4193 7.76314 21.4651L2.26314 22.9651C1.91693 23.0595 1.54667 22.9612 1.29292 22.7074C1.03917 22.4537 0.940838 22.0834 1.03526 21.7372L2.53526 16.2372C2.58105 16.0693 2.66986 15.9163 2.79292 15.7932L16.2929 2.2932C16.6484 1.93769 17.0705 1.65569 17.5349 1.4633Z",
      fill: color
    }
  ) });
}
var init_pen = __esm({
  "src/icons/treatwell-pro/pen.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/treatwell-pro/person.tsx
import { jsx as jsx54 } from "@emotion/react/jsx-runtime";
function Person(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx54(SvgIcon, { size, viewBox: "0 0 16 16", children: /* @__PURE__ */ jsx54(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8 2.66671C6.89543 2.66671 6 3.56214 6 4.66671C6 5.77128 6.89543 6.66671 8 6.66671C9.10457 6.66671 10 5.77128 10 4.66671C10 3.56214 9.10457 2.66671 8 2.66671ZM4.66667 4.66671C4.66667 2.82576 6.15905 1.33337 8 1.33337C9.84095 1.33337 11.3333 2.82576 11.3333 4.66671C11.3333 6.50766 9.84095 8.00004 8 8.00004C6.15905 8.00004 4.66667 6.50766 4.66667 4.66671ZM2.97631 10.3097C3.60143 9.68456 4.44928 9.33337 5.33333 9.33337H10.6667C11.5507 9.33337 12.3986 9.68456 13.0237 10.3097C13.6488 10.9348 14 11.7827 14 12.6667V14C14 14.3682 13.7015 14.6667 13.3333 14.6667C12.9651 14.6667 12.6667 14.3682 12.6667 14V12.6667C12.6667 12.1363 12.456 11.6276 12.0809 11.2525C11.7058 10.8774 11.1971 10.6667 10.6667 10.6667H5.33333C4.8029 10.6667 4.29419 10.8774 3.91912 11.2525C3.54405 11.6276 3.33333 12.1363 3.33333 12.6667V14C3.33333 14.3682 3.03486 14.6667 2.66667 14.6667C2.29848 14.6667 2 14.3682 2 14V12.6667C2 11.7827 2.35119 10.9348 2.97631 10.3097Z",
      fill: color
    }
  ) });
}
var init_person = __esm({
  "src/icons/treatwell-pro/person.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/treatwell-pro/persons.tsx
import { jsx as jsx55 } from "@emotion/react/jsx-runtime";
function Persons(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx55(SvgIcon, { size, viewBox: "0 0 16 16", children: /* @__PURE__ */ jsx55(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M6 2.66671C4.89543 2.66671 4 3.56214 4 4.66671C4 5.77128 4.89543 6.66671 6 6.66671C7.10457 6.66671 8 5.77128 8 4.66671C8 3.56214 7.10457 2.66671 6 2.66671ZM2.66667 4.66671C2.66667 2.82576 4.15905 1.33337 6 1.33337C7.84095 1.33337 9.33333 2.82576 9.33333 4.66671C9.33333 6.50766 7.84095 8.00004 6 8.00004C4.15905 8.00004 2.66667 6.50766 2.66667 4.66671ZM10.0208 1.92135C10.1122 1.56466 10.4753 1.34955 10.832 1.44087C11.549 1.62446 12.1846 2.04146 12.6384 2.62613C13.0922 3.21081 13.3386 3.9299 13.3386 4.67004C13.3386 5.41018 13.0922 6.12927 12.6384 6.71395C12.1846 7.29862 11.549 7.71562 10.832 7.89921C10.4753 7.99053 10.1122 7.77542 10.0208 7.41873C9.92951 7.06205 10.1446 6.69887 10.5013 6.60754C10.9315 6.49739 11.3128 6.24719 11.5851 5.89639C11.8574 5.54558 12.0052 5.11413 12.0052 4.67004C12.0052 4.22596 11.8574 3.7945 11.5851 3.4437C11.3128 3.09289 10.9315 2.84269 10.5013 2.73254C10.1446 2.64122 9.92951 2.27803 10.0208 1.92135ZM0.976311 10.3097C1.60143 9.68456 2.44928 9.33337 3.33333 9.33337H8.66667C9.55072 9.33337 10.3986 9.68456 11.0237 10.3097C11.6488 10.9348 12 11.7827 12 12.6667V14C12 14.3682 11.7015 14.6667 11.3333 14.6667C10.9651 14.6667 10.6667 14.3682 10.6667 14V12.6667C10.6667 12.1363 10.456 11.6276 10.0809 11.2525C9.70581 10.8774 9.1971 10.6667 8.66667 10.6667H3.33333C2.8029 10.6667 2.29419 10.8774 1.91912 11.2525C1.54405 11.6276 1.33333 12.1363 1.33333 12.6667V14C1.33333 14.3682 1.03486 14.6667 0.666667 14.6667C0.298477 14.6667 0 14.3682 0 14V12.6667C0 11.7827 0.35119 10.9348 0.976311 10.3097ZM12.6878 9.92004C12.7799 9.56354 13.1435 9.34916 13.5 9.44121C14.2151 9.62585 14.8486 10.0428 15.3011 10.6265C15.7536 11.2102 15.9994 11.9277 16 12.6662V14C16 14.3682 15.7015 14.6667 15.3333 14.6667C14.9651 14.6667 14.6667 14.3682 14.6667 14V12.6672C14.6663 12.2241 14.5188 11.7936 14.2474 11.4434C13.9759 11.0931 13.5957 10.843 13.1667 10.7322C12.8102 10.6402 12.5958 10.2765 12.6878 9.92004Z",
      fill: color
    }
  ) });
}
var init_persons = __esm({
  "src/icons/treatwell-pro/persons.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/treatwell-pro/products.tsx
import { jsx as jsx56 } from "@emotion/react/jsx-runtime";
function Products(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx56(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx56(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11 2V4L9 3.999V7H12.0046C13.1072 7 14 7.89582 14 8.9985V20.0015C14 21.1026 13.0992 22 12.0046 22H3.9954C2.89276 22 2 21.1042 2 20.0015V8.9985C2 7.89735 2.90077 7 3.9954 7H7V4C6.28499 4 5.68715 4.14946 5.19721 4.39443C5.03371 4.47618 4.89702 4.56161 4.7875 4.64375L4.70711 4.70711L3.29289 3.29289C3.48996 3.09582 3.82532 2.84431 4.30279 2.60557C5.06285 2.22554 5.96501 2 7 2H11ZM20.0092 14C21.1073 14 22 14.8973 22 15.9908V20.0092C22 21.1073 21.1027 22 20.0092 22H16V20H20V16H16V14H20.0092ZM12 9H4.00013L4 20H11.9999L12 9ZM10 12V14H6V12H10Z",
      fill: color
    }
  ) });
}
var init_products = __esm({
  "src/icons/treatwell-pro/products.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/treatwell-pro/question.tsx
import { jsx as jsx57 } from "@emotion/react/jsx-runtime";
function Question(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx57(SvgIcon, { size, children: /* @__PURE__ */ jsx57(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M6 0.5C9.03757 0.5 11.5 2.96243 11.5 6C11.5 9.03757 9.03757 11.5 6 11.5C2.96243 11.5 0.5 9.03757 0.5 6C0.5 2.96243 2.96243 0.5 6 0.5ZM6 1.5C3.51472 1.5 1.5 3.51472 1.5 6C1.5 8.48528 3.51472 10.5 6 10.5C8.48528 10.5 10.5 8.48528 10.5 6C10.5 3.51472 8.48528 1.5 6 1.5ZM6 7.75C6.41421 7.75 6.75 8.08579 6.75 8.5C6.75 8.91421 6.41421 9.25 6 9.25C5.58579 9.25 5.25 8.91421 5.25 8.5C5.25 8.08579 5.58579 7.75 6 7.75ZM6 3C7.27498 3 8 3.7244 8 5C8 5.57442 7.75041 5.96179 7.1955 6.48713L6.90305 6.75616C6.85952 6.79627 6.82256 6.83097 6.78948 6.86292L6.74244 6.90911C6.56529 7.08626 6.5 7.19399 6.5 7.25H5.5C5.5 6.85879 5.68685 6.55049 6.03534 6.202L6.09291 6.14541L6.27598 5.97444L6.41214 5.85017L6.57053 5.70064C6.88302 5.395 7 5.20231 7 5C7 4.27688 6.72289 4 6 4C5.37448 4 5 4.42094 5 5H4C4 3.89301 4.79446 3 6 3Z",
      fill: color
    }
  ) });
}
var init_question = __esm({
  "src/icons/treatwell-pro/question.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/treatwell-pro/receipt.tsx
import { jsx as jsx58 } from "@emotion/react/jsx-runtime";
function Receipt(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx58(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx58(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M5 0V24C3.94354 24 3.08164 23.1827 3.00547 22.1448L3 21.9951V2.00495C3 0.947977 3.81332 0.0820373 4.84612 0.0054993L5 0ZM19 0C20.1074 0 21 0.897645 21 2.00495V21.9951C21 23.0526 20.1861 23.918 19.1538 23.9945L19 24V0ZM9 22V24H7V22H9ZM13 22V24H11V22H13ZM17 22V24H15V22H17ZM11 16V18H7V16H11ZM17 16V18H13V16H17ZM13 10V12H7V10H13ZM17 6V8H7V6H17ZM9 0V2H7V0H9ZM13 0V2H11V0H13ZM17 0V2H15V0H17Z",
      fill: color
    }
  ) });
}
var init_receipt = __esm({
  "src/icons/treatwell-pro/receipt.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/treatwell-pro/search.tsx
import { jsx as jsx59 } from "@emotion/react/jsx-runtime";
function Search(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx59(SvgIcon, { size, children: /* @__PURE__ */ jsx59(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8.85355 8.14645L10.8536 10.1464L10.1464 10.8536L8.14645 8.85355L8.85355 8.14645ZM5 1C7.20914 1 9 2.79086 9 5C9 7.20914 7.20914 9 5 9C2.79086 9 1 7.20914 1 5C1 2.79086 2.79086 1 5 1ZM5 2C3.34315 2 2 3.34315 2 5C2 6.65685 3.34315 8 5 8C6.65685 8 8 6.65685 8 5C8 3.34315 6.65685 2 5 2Z",
      fill: color
    }
  ) });
}
var init_search = __esm({
  "src/icons/treatwell-pro/search.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/treatwell-pro/show.tsx
import { jsx as jsx60, jsxs as jsxs13 } from "@emotion/react/jsx-runtime";
function Show(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx60(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx60(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12 5C14.8776 5 17.4168 6.0674 19.5849 7.83226C20.7899 8.81311 21.646 9.79651 22.1114 10.4727L22.2051 10.6127C22.8083 11.411 22.807 12.6204 22.2346 13.3435C21.7577 14.0738 20.8689 15.1255 19.5796 16.1742C17.4146 17.9351 14.8773 19 12 19C9.12237 19 6.58317 17.9326 4.41506 16.1677C3.13867 15.1287 2.25376 14.0869 1.77194 13.3563C1.19182 12.5581 1.20039 11.3703 1.76544 10.6565C2.24227 9.92623 3.13105 8.87453 4.42039 7.82584C6.58537 6.06493 9.12267 5 12 5ZM12 7C9.62733 7 7.51567 7.88629 5.68238 9.37741C5.03374 9.90499 4.4682 10.4712 3.99112 11.0357L3.85829 11.1955L3.63556 11.4778L3.46143 11.7161C3.43589 11.7525 3.41194 11.7873 3.38938 11.8207C3.33098 11.8951 3.33075 12.1024 3.39055 12.1815L3.52733 12.3781L3.67347 12.5728L3.8677 12.816C3.90405 12.8602 3.94237 12.9062 3.98266 12.9539C4.461 13.52 5.02781 14.0877 5.67765 14.6167C7.5141 16.1115 9.62763 17 12 17C14.3727 17 16.4843 16.1137 18.3176 14.6226C18.9663 14.095 19.5318 13.5288 20.0089 12.9643L20.1417 12.8045L20.3644 12.5222L20.5386 12.2839C20.5641 12.2475 20.5881 12.2127 20.6106 12.1793C20.669 12.1049 20.6692 11.8976 20.5701 11.7625L20.4727 11.6219L20.3265 11.4272L20.1323 11.184C20.096 11.1398 20.0576 11.0938 20.0173 11.0461C19.539 10.48 18.9722 9.91232 18.3223 9.38334C16.4859 7.88846 14.3724 7 12 7ZM12 8C14.2091 8 16 9.79086 16 12C16 14.2091 14.2091 16 12 16C9.79086 16 8 14.2091 8 12C8 9.79086 9.79086 8 12 8ZM12 10C10.8954 10 10 10.8954 10 12C10 13.1046 10.8954 14 12 14C13.1046 14 14 13.1046 14 12C14 10.8954 13.1046 10 12 10Z",
      fill: color
    }
  ) });
}
function Hide(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsxs13(SvgIcon, { size, viewBox: "0 0 24 24", children: [
    /* @__PURE__ */ jsx60(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11.6607 5C14.5384 5 17.0776 6.0674 19.2457 7.83226C20.4506 8.81311 21.3067 9.79651 21.7721 10.4727L21.8659 10.6127C22.469 11.411 22.4677 12.6204 21.8953 13.3435C21.4185 14.0738 20.5297 15.1255 19.2404 16.1742C17.0754 17.9351 14.5381 19 11.6607 19C8.78312 19 6.24391 17.9326 4.0758 16.1677C2.79942 15.1287 1.9145 14.0869 1.43268 13.3563C0.852571 12.5581 0.861141 11.3703 1.42618 10.6565C1.90301 9.92623 2.7918 8.87453 4.08114 7.82584C6.24611 6.06493 8.78341 5 11.6607 5ZM11.6607 7C9.28808 7 7.17642 7.88629 5.34312 9.37741C4.69449 9.90499 4.12895 10.4712 3.65187 11.0357L3.51904 11.1955L3.2963 11.4778L3.12218 11.7161C3.09664 11.7525 3.07269 11.7873 3.05012 11.8207C2.99173 11.8951 2.9915 12.1024 3.0513 12.1815L3.18808 12.3781L3.33422 12.5728L3.52845 12.816C3.56479 12.8602 3.60312 12.9062 3.64341 12.9539C4.12174 13.52 4.68855 14.0877 5.3384 14.6167C7.17484 16.1115 9.28837 17 11.6607 17C14.0334 17 16.1451 16.1137 17.9784 14.6226C18.627 14.095 19.1925 13.5288 19.6696 12.9643L19.8025 12.8045L20.0252 12.5222L20.1993 12.2839C20.2249 12.2475 20.2488 12.2127 20.2714 12.1793C20.3298 12.1049 20.33 11.8976 20.2309 11.7625L20.1334 11.6219L19.9873 11.4272L19.793 11.184C19.7567 11.1398 19.7184 11.0938 19.6781 11.0461C19.1997 10.48 18.6329 9.91232 17.9831 9.38334C16.1466 7.88846 14.0331 7 11.6607 7ZM11.6607 8C13.8699 8 15.6607 9.79086 15.6607 12C15.6607 14.2091 13.8699 16 11.6607 16C9.45161 16 7.66075 14.2091 7.66075 12C7.66075 9.79086 9.45161 8 11.6607 8ZM11.6607 10C10.5562 10 9.66075 10.8954 9.66075 12C9.66075 13.1046 10.5562 14 11.6607 14C12.7653 14 13.6607 13.1046 13.6607 12C13.6607 10.8954 12.7653 10 11.6607 10Z",
        fill: color
      }
    ),
    /* @__PURE__ */ jsx60(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M19.7143 4.28575C20.0952 4.66675 20.0952 5.28447 19.7143 5.66547L5.66547 19.7143C5.28447 20.0952 4.66675 20.0952 4.28575 19.7143C3.90475 19.3333 3.90475 18.7155 4.28575 18.3345L18.3345 4.28575C18.7155 3.90475 19.3333 3.90475 19.7143 4.28575Z",
        fill: color
      }
    ),
    /* @__PURE__ */ jsx60(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M19.7143 4.28575C20.0952 4.66675 20.0952 5.28447 19.7143 5.66547L5.66547 19.7143C5.28447 20.0952 4.66675 20.0952 4.28575 19.7143C3.90475 19.3333 3.90475 18.7155 4.28575 18.3345L18.3345 4.28575C18.7155 3.90475 19.3333 3.90475 19.7143 4.28575Z",
        fill: color
      }
    )
  ] });
}
var init_show = __esm({
  "src/icons/treatwell-pro/show.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/treatwell-pro/sort.tsx
import { jsx as jsx61 } from "@emotion/react/jsx-runtime";
function Sort(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx61(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx61(
    "path",
    {
      fill: color,
      fillRule: "evenodd",
      d: "M15.364 14.314a1 1 0 0 0 1-1V5.828l2.535 2.536a1 1 0 1 0 1.415-1.414L16.07 2.707a1 1 0 0 0-1.414 0L10.414 6.95a1 1 0 0 0 1.414 1.414l2.536-2.536v7.486a1 1 0 0 0 1 1ZM8.5 9.55a1 1 0 0 0-1 1v7.485L4.964 15.5a1 1 0 0 0-1.414 1.414l4.243 4.243a1 1 0 0 0 1.414 0l4.243-4.243a1 1 0 1 0-1.414-1.414L9.5 18.035V10.55a1 1 0 0 0-1-1Z",
      clipRule: "evenodd"
    }
  ) });
}
var init_sort = __esm({
  "src/icons/treatwell-pro/sort.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/treatwell-pro/spa.tsx
import { jsx as jsx62 } from "@emotion/react/jsx-runtime";
function Spa(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx62(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx62(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M18 0.999995C21.336 1.556 23.618 4.67356 23.1398 8.02162L21.5 19.5C21.2131 21.5083 19.4931 23 17.4645 23H17C15.0007 23 13.38 21.3793 13.38 19.38C13.38 19.2598 13.386 19.1395 13.398 19.0198L13.8738 14.262C13.9576 13.424 13.9352 12.5788 13.8071 11.7464L12.9249 6.01202C12.5552 3.60887 14.2036 1.361 16.6068 0.991288C17.0687 0.920223 17.539 0.923162 18 0.999995ZM5.99999 0.999995C6.46098 0.923162 6.93127 0.920223 7.39319 0.991288C9.72566 1.35013 11.3472 3.47826 11.1025 5.80043L11.0751 6.01202L10.1928 11.7464C10.0861 12.4401 10.0528 13.1426 10.0931 13.8425L10.1262 14.262L10.602 19.0198C10.6139 19.1395 10.6199 19.2598 10.6199 19.38C10.6199 21.3148 9.10211 22.895 7.19224 22.995L6.99999 23H6.53552C4.57447 23 2.90189 21.6061 2.53341 19.6991L2.49999 19.5L0.86022 8.02162C0.381925 4.67356 2.66395 1.556 5.99999 0.999995ZM17.9991 8.99909L15.7531 11.2461L15.7839 11.4423C15.9156 12.2985 15.9542 13.166 15.8992 14.0296L15.8639 14.461L15.3881 19.2189C15.3827 19.2724 15.38 19.3262 15.38 19.38C15.38 20.225 16.027 20.9189 16.8525 20.9934L17 21H17.4645C18.4434 21 19.2813 20.318 19.491 19.3764L19.5201 19.2172L20.6061 11.6061L17.9991 8.99909ZM6.00087 8.99909L3.39387 11.6061L4.47989 19.2172L4.50894 19.3764C4.70703 20.2657 5.46538 20.9234 6.37375 20.9938L6.53552 21H6.99999L7.14744 20.9934C7.97301 20.9189 8.61994 20.225 8.61994 19.38L8.61793 19.2993L8.6119 19.2189L8.13612 14.461L8.10082 14.0296C8.05499 13.3099 8.07413 12.5875 8.15801 11.8713L8.2161 11.4423L8.24687 11.2461L6.00087 8.99909ZM16.9109 2.96803C15.6541 3.16138 14.7756 4.29603 14.8821 5.54449L14.9017 5.70791L15.3761 8.79509L16.9991 7.17109L17 4.99999H19L18.9991 7.17009L20.9601 9.13209L21.1599 7.73878C21.4845 5.46625 19.9356 3.35018 17.6712 2.97278C17.4196 2.93085 17.163 2.92925 16.9109 2.96803ZM7.08907 2.96803C6.837 2.92925 6.58035 2.93085 6.32878 2.97278C4.13303 3.33874 2.61 5.3396 2.81573 7.53266L2.84012 7.73878L3.03987 9.13209L5.00087 7.17009L4.99999 4.99999H6.99999L7.00087 7.17109L8.62387 8.79509L9.09832 5.70791L9.11785 5.54449C9.2244 4.29603 8.34586 3.16138 7.08907 2.96803Z",
      fill: color
    }
  ) });
}
var init_spa = __esm({
  "src/icons/treatwell-pro/spa.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/treatwell-pro/star.tsx
import { jsx as jsx63 } from "@emotion/react/jsx-runtime";
function StarFilled(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx63(SvgIcon, { size, children: /* @__PURE__ */ jsx63(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M3.45988 11.3195C2.84158 11.7819 2.20347 11.2961 2.43175 10.5358L3.36846 7.41586L0.846529 5.46857C0.235806 4.997 0.473832 4.20436 1.23586 4.20436H4.38349L5.36714 1.06672C5.60494 0.308195 6.3959 0.313994 6.63188 1.06672L7.61553 4.20436H10.7632C11.5297 4.20436 11.7626 4.99749 11.1525 5.46857L8.63056 7.41586L9.56727 10.5358C9.79541 11.2956 9.15785 11.7822 8.53914 11.3195L5.99951 9.42006L3.45988 11.3195Z",
      fill: color
    }
  ) });
}
function StarHalf(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx63(SvgIcon, { size, children: /* @__PURE__ */ jsx63(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M5.81603 0.532525L5.85994 0.518597L5.90961 0.507612L5.95487 0.501834L6.00019 0.5C6.25715 0.500725 6.51389 0.690357 6.63188 1.06672L7.61553 4.20436H10.7632C11.5297 4.20436 11.7626 4.99749 11.1525 5.46857L8.63056 7.41586L9.56727 10.5358C9.79541 11.2956 9.15785 11.7822 8.53914 11.3195L5.99951 9.42006L3.45988 11.3195C3.30531 11.4351 3.14949 11.4914 3.00629 11.4991L2.95321 11.4996C2.55117 11.487 2.26767 11.0823 2.43175 10.5358L3.36846 7.41586L0.846529 5.46857C0.235806 4.997 0.473832 4.20436 1.23586 4.20436H4.38349L5.3804 1.02682L5.41782 0.933709L5.45243 0.864861L5.49169 0.800179L5.51992 0.760342L5.56393 0.706933L5.61145 0.658917L5.66378 0.615468L5.69614 0.592829C5.73478 0.567567 5.77495 0.547469 5.81603 0.532525ZM6 2.393V8.1715L8.3385 9.9205L7.47502 7.04469L9.8585 5.204L6.88104 5.20436L6 2.393Z",
      fill: color
    }
  ) });
}
function StarOutline(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx63(SvgIcon, { size, children: /* @__PURE__ */ jsx63(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M6.63188 1.06672L7.61553 4.20436H10.7632C11.5297 4.20436 11.7626 4.99749 11.1525 5.46857L8.63056 7.41586L9.56727 10.5358C9.79541 11.2956 9.15785 11.7822 8.53914 11.3195L5.99951 9.42006L3.45988 11.3195C2.84158 11.7819 2.20347 11.2961 2.43175 10.5358L3.36846 7.41586L0.846529 5.46857C0.235806 4.997 0.473832 4.20436 1.23586 4.20436H4.38349L5.36714 1.06672C5.60494 0.308195 6.3959 0.313994 6.63188 1.06672ZM6.88104 5.20436L5.9995 2.392L5.11798 5.20436L2.14 5.204L4.524 7.04469L3.6605 9.9205L5.99951 8.17131L8.3385 9.9205L7.47502 7.04469L9.8585 5.204L6.88104 5.20436Z",
      fill: color
    }
  ) });
}
var init_star = __esm({
  "src/icons/treatwell-pro/star.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/treatwell-pro/time.tsx
import { jsx as jsx64 } from "@emotion/react/jsx-runtime";
function Time(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx64(SvgIcon, { size, children: /* @__PURE__ */ jsx64(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M6 0.5C9.03757 0.5 11.5 2.96243 11.5 6C11.5 9.03757 9.03757 11.5 6 11.5C2.96243 11.5 0.5 9.03757 0.5 6C0.5 2.96243 2.96243 0.5 6 0.5ZM6 1.5C3.51472 1.5 1.5 3.51472 1.5 6C1.5 8.48528 3.51472 10.5 6 10.5C8.48528 10.5 10.5 8.48528 10.5 6C10.5 3.51472 8.48528 1.5 6 1.5ZM6.5 2.69324V5.79289L8.10628 7.54289L7.39917 8.25L5.5 6.20711V2.69324H6.5Z",
      fill: color
    }
  ) });
}
var init_time = __esm({
  "src/icons/treatwell-pro/time.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/treatwell-pro/truck.tsx
import { jsx as jsx65 } from "@emotion/react/jsx-runtime";
function Truck(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx65(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx65(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 5.50698C0 4.6747 0.674698 4 1.50698 4H13.5628C14.3951 4 15.0698 4.67472 15.0698 5.50698V7.34884H20.495C21.0905 7.34884 21.6302 7.69953 21.8721 8.24378L23.8701 12.7393L23.8703 12.7396C23.9558 12.9322 24 13.1406 24 13.3514V16.4465C24 17.2788 23.3253 17.9535 22.493 17.9535H20.5356C20.1712 19.242 18.9866 20.186 17.5814 20.186C16.1762 20.186 14.9916 19.242 14.6272 17.9535H14.2364C14.2351 17.9535 14.2338 17.9535 14.2326 17.9535L14.2326 17.9535H14.2287H9.37282C9.0084 19.242 7.82375 20.186 6.4186 20.186C5.01346 20.186 3.82881 19.242 3.46439 17.9535H1.50698C0.674724 17.9535 0 17.2789 0 16.4465V5.50698ZM13.3953 8.18605L13.3954 8.18221V5.67442H1.67442V16.2791H3.46438C3.8288 14.9906 5.01346 14.0465 6.4186 14.0465C7.82375 14.0465 9.0084 14.9906 9.37282 16.2791H13.3954V8.18988L13.3953 8.18605ZM20.3862 9.02326H15.0698V15.3508C15.6253 14.5619 16.5432 14.0465 17.5814 14.0465C18.9866 14.0465 20.1712 14.9906 20.5356 16.2791H22.3256V13.3869L20.3862 9.02326ZM5.02326 17.1163C5.02326 16.3456 5.64797 15.7209 6.4186 15.7209C7.18924 15.7209 7.81395 16.3456 7.81395 17.1163C7.81395 17.8869 7.18924 18.5116 6.4186 18.5116C5.64797 18.5116 5.02326 17.8869 5.02326 17.1163ZM16.186 17.1163C16.186 16.3456 16.8107 15.7209 17.5814 15.7209C18.3521 15.7209 18.9767 16.3456 18.9767 17.1163C18.9767 17.8869 18.3521 18.5116 17.5814 18.5116C16.8107 18.5116 16.186 17.8869 16.186 17.1163Z",
      fill: color
    }
  ) });
}
var init_truck = __esm({
  "src/icons/treatwell-pro/truck.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/treatwell-pro/user.tsx
import { jsx as jsx66 } from "@emotion/react/jsx-runtime";
function User(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx66(SvgIcon, { size, children: /* @__PURE__ */ jsx66(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8.7998 6.85677C10.1274 7.75564 11 9.27591 11 11H10C10 9.49396 9.16769 8.18232 7.93795 7.49997C8.25393 7.3247 8.54368 7.10782 8.7998 6.85677ZM6 1C7.65685 1 9 2.34315 9 4C9 5.6192 7.71721 6.93879 6.11247 6.99793L6 7C3.79086 7 2 8.79086 2 11H1C1 8.8946 2.3013 7.09313 4.14347 6.35602C3.44687 5.807 3 4.95569 3 4C3 2.34315 4.34315 1 6 1ZM6 2C4.89543 2 4 2.89543 4 4C4 5.10457 4.89543 6 6 6C7.10457 6 8 5.10457 8 4C8 2.89543 7.10457 2 6 2Z",
      fill: color
    }
  ) });
}
var init_user = __esm({
  "src/icons/treatwell-pro/user.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/treatwell-pro/venue.tsx
import { jsx as jsx67 } from "@emotion/react/jsx-runtime";
function Venue(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx67(SvgIcon, { size, viewBox: "0 0 12 12", children: /* @__PURE__ */ jsx67(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8.53125 5.78268C8.28041 5.92324 7.98979 6 7.6875 6C7.38521 6 7.09459 5.92324 6.84375 5.78268C6.59291 5.92324 6.30229 6 6 6C5.69771 6 5.40709 5.92324 5.15625 5.78268C4.90541 5.92324 4.61479 6 4.3125 6C4.01021 6 3.71959 5.92324 3.46875 5.78268C3.32408 5.86375 3.16618 5.92359 3.00044 5.95973L3 9.99862L4 9.9985V7.49852C4 7.22319 4.22549 7 4.49539 7H6.50461C6.77821 7 7 7.22652 7 7.49852V9.999L9.00297 10L9.0005 6.99951L10 7V9.99862C10 10.5517 9.55274 11 9.00297 11H2.99703C2.44639 11 2 10.5532 2 9.99862L2.00005 5.88501C1.41728 5.6611 1 5.13267 1 4.5C1 4.36001 1.02087 4.2222 1.06147 4.0898L1.42424 1.91319C1.51003 1.39843 1.97796 1 2.50044 1H9.49956C10.0199 1 10.4905 1.40168 10.5758 1.91319L10.9385 4.0898C10.9791 4.2222 11 4.36001 11 4.5C11 5.3424 10.2602 6 9.375 6C9.07271 6 8.78209 5.92324 8.53125 5.78268ZM6 8H5V9.999H6V8ZM9.49956 2H2.50044C2.46787 2 2.41624 2.04397 2.41063 2.07759L2.04182 4.29049L2.02163 4.37033C2.00729 4.41221 2 4.45548 2 4.5C2 4.76217 2.26756 5 2.625 5C2.81984 5 2.99625 4.92769 3.11395 4.80916L3.46875 4.45183L3.82355 4.80916C3.94125 4.92769 4.11766 5 4.3125 5C4.50734 5 4.68375 4.92769 4.80145 4.80916L5.15625 4.45183L5.51105 4.80916C5.62875 4.92769 5.80516 5 6 5C6.19484 5 6.37125 4.92769 6.48895 4.80916L6.84375 4.45183L7.19855 4.80916C7.31625 4.92769 7.49266 5 7.6875 5C7.88234 5 8.05875 4.92769 8.17645 4.80916L8.53125 4.45183L8.88605 4.80916C9.00375 4.92769 9.18016 5 9.375 5C9.73244 5 10 4.76217 10 4.5C10 4.45548 9.99271 4.41221 9.97836 4.37033L9.95819 4.29049L9.58937 2.07759C9.58423 2.04674 9.52946 2 9.49956 2Z",
      fill: color
    }
  ) });
}
var init_venue = __esm({
  "src/icons/treatwell-pro/venue.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/treatwell-pro/venue-search.tsx
import { jsx as jsx68 } from "@emotion/react/jsx-runtime";
function VenueSearch(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx68(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx68(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M19.7071 17.2929L23.7071 21.2929L22.2929 22.7071L18.2929 18.7071L19.7071 17.2929ZM13.6343 2C14.6607 2 15.6013 2.78264 15.8158 3.8713L15.9932 5.38346L14.0068 5.61654L13.842 4.18396C13.826 4.1038 13.7012 4 13.6343 4H2.99066C2.92621 4 2.79867 4.10567 2.78301 4.18396L2.11905 7.50375L2.06205 7.69104C2.0209 7.79016 2 7.89341 2 8C2 8.52433 2.53513 9 3.25 9C3.63967 9 3.99251 8.85537 4.22789 8.61831L4.9375 7.90367L5.64711 8.61831C5.88249 8.85537 6.23533 9 6.625 9V11C6.02041 11 5.43918 10.8465 4.9375 10.5654C4.64816 10.7275 4.33236 10.8472 4.00087 10.9195L4 17.0015L8 17V19H4.00937C2.89546 19 2 18.1103 2 17.003L2.00009 10.77C0.834559 10.3222 0 9.26534 0 8C0 7.66483 0.0598141 7.33632 0.175087 7.02554L0.821851 3.79172C1.02363 2.78284 1.96845 2 2.99066 2H13.6343ZM14 7C17.3137 7 20 9.68629 20 13C20 16.3137 17.3137 19 14 19C10.6863 19 8 16.3137 8 13C8 9.68629 10.6863 7 14 7ZM14 9C11.7909 9 10 10.7909 10 13C10 15.2091 11.7909 17 14 17C16.2091 17 18 15.2091 18 13C18 10.7909 16.2091 9 14 9Z",
      fill: color
    }
  ) });
}
var init_venue_search = __esm({
  "src/icons/treatwell-pro/venue-search.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/treatwell-pro/voucher.tsx
import { jsx as jsx69 } from "@emotion/react/jsx-runtime";
function Voucher(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx69(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx69(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M21.0088 3C22.6633 3 24 4.34415 24 6.00488V9.78078L23.2425 9.97014C23.1339 9.9973 22.8982 10.1053 22.6585 10.3151C22.2468 10.6753 22 11.1998 22 12C22 12.8002 22.2468 13.3247 22.6585 13.6849C22.8982 13.8947 23.1339 14.0027 23.2425 14.0299L24 14.2192V17.9951C24 19.6536 22.6637 21 21.0088 21H2.99115C1.33665 21 0 19.6559 0 17.9951V14.2192L0.757464 14.0299C0.866081 14.0027 1.10178 13.8947 1.3415 13.6849C1.75316 13.3247 2 12.8002 2 12C2 11.1998 1.75316 10.6753 1.3415 10.3151C1.10178 10.1053 0.866081 9.9973 0.757464 9.97014L0 9.78078V6.00488C0 4.34638 1.33633 3 2.99115 3H21.0088ZM21.0088 5H2.99115C2.44426 5 2 5.44761 2 6.00488V8.34047C2.21327 8.46099 2.43627 8.61547 2.6585 8.80992C3.49684 9.54347 4 10.6127 4 12C4 13.3873 3.49684 14.4565 2.6585 15.1901C2.43627 15.3845 2.21327 15.539 2 15.6595V17.9951C2 18.5538 2.44373 19 2.99115 19H21.0088C21.5557 19 22 18.5524 22 17.9951V15.6595C21.7867 15.539 21.5637 15.3845 21.3415 15.1901C20.5032 14.4565 20 13.3873 20 12C20 10.6127 20.5032 9.54347 21.3415 8.80992C21.5637 8.61547 21.7867 8.46099 22 8.34047V6.00488C22 5.44622 21.5563 5 21.0088 5ZM13.0636 7.19234L14.6474 7.84837L10.9364 16.8077L9.35257 16.1516L13.0636 7.19234ZM15.4286 12.8571C16.3753 12.8571 17.1429 13.6247 17.1429 14.5714C17.1429 15.5182 16.3753 16.2857 15.4286 16.2857C14.4818 16.2857 13.7143 15.5182 13.7143 14.5714C13.7143 13.6247 14.4818 12.8571 15.4286 12.8571ZM8.57143 7.71429C9.5182 7.71429 10.2857 8.4818 10.2857 9.42857C10.2857 10.3753 9.5182 11.1429 8.57143 11.1429C7.62465 11.1429 6.85714 10.3753 6.85714 9.42857C6.85714 8.4818 7.62465 7.71429 8.57143 7.71429Z",
      fill: color
    }
  ) });
}
var init_voucher = __esm({
  "src/icons/treatwell-pro/voucher.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/treatwell-pro/warning.tsx
import { jsx as jsx70 } from "@emotion/react/jsx-runtime";
function WarningOutline(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx70(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx70(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M14.4605 3.35317L22.5395 17.6468C23.8984 20.051 22.7607 22 20.0023 22H3.99767C1.23753 22 0.0971634 20.0589 1.46048 17.6468L9.53951 3.35317C10.8984 0.948981 13.0972 0.941148 14.4605 3.35317ZM11.2806 4.33728L3.2016 18.631L3.07082 18.8743C2.66646 19.6753 2.82794 19.952 3.72211 19.9941L3.99767 20H20.0023L20.2768 19.994C21.1252 19.9534 21.3135 19.6976 20.9821 18.9839L20.8672 18.7558C20.8456 18.7154 20.8226 18.6738 20.7984 18.631L12.7194 4.33728L12.5773 4.09581L12.4473 3.89825C12.0731 3.37144 11.8294 3.43742 11.4227 4.09586L11.2806 4.33728ZM12 15.5C12.8284 15.5 13.5 16.1716 13.5 17C13.5 17.8284 12.8284 18.5 12 18.5C11.1716 18.5 10.5 17.8284 10.5 17C10.5 16.1716 11.1716 15.5 12 15.5ZM13 8V14H11V8H13Z",
      fill: color
    }
  ) });
}
var init_warning = __esm({
  "src/icons/treatwell-pro/warning.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/treatwell-pro/index.ts
var init_treatwell_pro = __esm({
  "src/icons/treatwell-pro/index.ts"() {
    "use strict";
    init_add_user();
    init_arrow_back();
    init_arrow_forward();
    init_avatar();
    init_beard();
    init_bin();
    init_box();
    init_calendar();
    init_card();
    init_cart();
    init_cash();
    init_caution();
    init_chair();
    init_check_filled();
    init_check_mark();
    init_chevron();
    init_chevron_add();
    init_close();
    init_discount_outline();
    init_expand();
    init_face();
    init_fast_delivery();
    init_fire();
    init_gift();
    init_hair();
    init_hair_removal();
    init_hamburger_nav();
    init_happy();
    init_heart();
    init_highlights();
    init_home();
    init_home_based_salon();
    init_loading();
    init_massage();
    init_minus();
    init_mobile_therapist();
    init_nails();
    init_new_venue();
    init_online();
    init_padlock();
    init_pen();
    init_person();
    init_persons();
    init_products();
    init_question();
    init_receipt();
    init_search();
    init_show();
    init_sort();
    init_spa();
    init_star();
    init_time();
    init_truck();
    init_user();
    init_venue();
    init_venue_search();
    init_voucher();
    init_warning();
  }
});

// src/icons/salonized/workshop.tsx
import { jsx as jsx71 } from "@emotion/react/jsx-runtime";
function Workshop(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx71(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx71(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11.9997 4C10.3428 4 8.99969 5.34315 8.99969 7C8.99969 8.65685 10.3428 10 11.9997 10C13.6565 10 14.9997 8.65685 14.9997 7C14.9997 5.34315 13.6565 4 11.9997 4ZM10.9997 7C10.9997 6.44772 11.4474 6 11.9997 6C12.552 6 12.9997 6.44772 12.9997 7C12.9997 7.55228 12.552 8 11.9997 8C11.4474 8 10.9997 7.55228 10.9997 7Z",
      fill: color
    }
  ) });
}
var init_workshop = __esm({
  "src/icons/salonized/workshop.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/wifi.tsx
import { jsx as jsx72 } from "@emotion/react/jsx-runtime";
function Wifi(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx72(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx72(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11.9994 4.00024C15.6474 4.00024 19.1004 5.39524 21.7244 7.92924C22.1214 8.31224 22.1324 8.94624 21.7494 9.34324C21.5534 9.54624 21.2914 9.64824 21.0304 9.64824C20.7804 9.64824 20.5294 9.55524 20.3354 9.36724C18.0854 7.19624 15.1254 6.00024 11.9994 6.00024C8.87338 6.00024 5.91338 7.19624 3.66338 9.36724C3.26838 9.75224 2.63438 9.74124 2.24938 9.34324C1.86738 8.94624 1.87738 8.31224 2.27538 7.92924C4.89938 5.39524 8.35238 4.00024 11.9994 4.00024ZM11.9998 9.00004C9.57178 9.00004 7.21178 10.001 5.52478 11.748C5.14278 12.146 5.15278 12.779 5.55078 13.162C5.94678 13.546 6.58178 13.535 6.96478 13.138C8.27578 11.779 10.1108 11 11.9998 11C13.8888 11 15.7238 11.779 17.0348 13.138C17.2308 13.341 17.4928 13.443 17.7548 13.443C18.0048 13.443 18.2558 13.35 18.4488 13.162C18.8468 12.779 18.8568 12.146 18.4748 11.748C16.7878 10.001 14.4278 9.00004 11.9998 9.00004ZM8.52678 15.403C9.46378 14.499 10.6968 14 11.9998 14C13.3028 14 14.5358 14.499 15.4728 15.403C15.8698 15.787 15.8808 16.42 15.4978 16.817C15.3018 17.021 15.0398 17.123 14.7778 17.123C14.5278 17.123 14.2768 17.029 14.0838 16.842C12.9588 15.756 11.0408 15.756 9.91578 16.842C9.52078 17.226 8.88678 17.215 8.50178 16.817C8.11878 16.42 8.12978 15.787 8.52678 15.403ZM10.9998 19C10.9998 18.448 11.4468 18 11.9998 18C12.5528 18 12.9998 18.448 12.9998 19C12.9998 19.552 12.5528 20 11.9998 20C11.4468 20 10.9998 19.552 10.9998 19Z",
      fill: color
    }
  ) });
}
var init_wifi = __esm({
  "src/icons/salonized/wifi.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/wifi-off.tsx
import { jsx as jsx73 } from "@emotion/react/jsx-runtime";
function WifiOff(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx73(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx73(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12.4362 11.0225L10.5442 9.13049L8.08218 6.66749L6.53118 5.11749L4.70718 3.29349C4.31618 2.90249 3.68318 2.90249 3.29218 3.29349C2.90218 3.68349 2.90218 4.31649 3.29218 4.70749L4.66818 6.08349L6.12918 7.54349L8.36318 9.77749L9.90918 11.3235L12.6482 14.0625L15.4412 16.8555L19.2922 20.7075C19.4882 20.9025 19.7442 21.0005 19.9992 21.0005C20.2552 21.0005 20.5112 20.9025 20.7072 20.7075C21.0972 20.3165 21.0972 19.6835 20.7072 19.2935L12.4362 11.0225ZM11.9997 18C11.4467 18 10.9997 18.448 10.9997 19C10.9997 19.552 11.4467 20 11.9997 20C12.5527 20 12.9997 19.552 12.9997 19C12.9997 18.448 12.5527 18 11.9997 18ZM11.9993 4.00019C15.6473 4.00019 19.1003 5.39519 21.7243 7.92919C22.1213 8.31219 22.1323 8.94619 21.7493 9.34319C21.5533 9.54619 21.2913 9.64819 21.0303 9.64819C20.7803 9.64819 20.5293 9.55519 20.3353 9.36719C18.0853 7.19619 15.1253 6.00019 11.9993 6.00019C11.0363 6.00019 10.0913 6.12719 9.17528 6.34719L7.56028 4.73219C8.97628 4.26019 10.4683 4.00019 11.9993 4.00019ZM3.82388 6.65279C3.28488 7.04279 2.76188 7.45979 2.27488 7.92879C1.87788 8.31279 1.86688 8.94579 2.24988 9.34279C2.63388 9.74079 3.26888 9.75179 3.66388 9.36779C4.15988 8.88879 4.69588 8.46579 5.25588 8.08379L3.82388 6.65279ZM17.7549 13.4427C17.4929 13.4427 17.2309 13.3407 17.0349 13.1377C16.2429 12.3167 15.2579 11.7117 14.1859 11.3587L11.8369 9.00869C11.862 9.00823 11.887 9.00626 11.9122 9.00428C11.9412 9.00199 11.9704 8.99969 11.9999 8.99969C14.4279 8.99969 16.7879 10.0017 18.4739 11.7477C18.8569 12.1457 18.8469 12.7787 18.4489 13.1617C18.2559 13.3497 18.0049 13.4427 17.7549 13.4427ZM7.43128 10.2603C6.73728 10.6683 6.09028 11.1623 5.52528 11.7483C5.14228 12.1453 5.15328 12.7793 5.55028 13.1623C5.94628 13.5463 6.58028 13.5353 6.96428 13.1373C7.52628 12.5553 8.18828 12.0883 8.90528 11.7343L7.43128 10.2603ZM8.50198 16.8173C8.11898 16.4203 8.12998 15.7873 8.52698 15.4033C9.27898 14.6763 10.226 14.2273 11.244 14.0723L13.761 16.5903C12.619 15.7753 10.941 15.8523 9.91598 16.8413C9.51998 17.2263 8.88598 17.2153 8.50198 16.8173Z",
      fill: color
    }
  ) });
}
var init_wifi_off = __esm({
  "src/icons/salonized/wifi-off.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/weight.tsx
import { jsx as jsx74 } from "@emotion/react/jsx-runtime";
function Weight(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx74(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx74(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M19 19C19 19.552 18.551 20 18 20H6C5.449 20 5 19.552 5 19V8C5 7.448 5.449 7 6 7H7C7 9.757 9.243 12 12 12C14.757 12 17 9.757 17 7H18C18.551 7 19 7.448 19 8V19ZM11 4.172V6C11 6.553 11.448 7 12 7C12.552 7 13 6.553 13 6V4.172C13.923 4.498 14.651 5.267 14.907 6.271C14.97 6.492 15 6.731 15 7C15 8.654 13.654 10 12 10C10.346 10 9 8.654 9 7C9 6.738 9.031 6.505 9.091 6.288C9.094 6.276 9.095 6.265 9.098 6.253L9.102 6.238C9.354 5.256 10.08 4.496 11 4.172ZM18 5H16.578C15.799 3.201 14.017 2 12 2C9.977 2 8.191 3.209 7.42 5H6C4.346 5 3 6.346 3 8V19C3 20.654 4.346 22 6 22H18C19.654 22 21 20.654 21 19V8C21 6.346 19.654 5 18 5Z",
      fill: color
    }
  ) });
}
var init_weight = __esm({
  "src/icons/salonized/weight.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/volume.tsx
import { jsx as jsx75 } from "@emotion/react/jsx-runtime";
function Volume(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx75(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx75(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M6 14.4287H10.333C10.535 14.4287 10.732 14.4907 10.899 14.6037L16 18.1017V5.89865L10.899 9.39665C10.732 9.50965 10.535 9.57165 10.333 9.57165H6V14.4287ZM17 20.9997C16.802 20.9997 16.604 20.9417 16.435 20.8247L10.023 16.4287H5C4.448 16.4287 4 15.9817 4 15.4287V8.57165C4 8.01865 4.448 7.57165 5 7.57165H10.023L16.435 3.17465C16.74 2.96465 17.137 2.94165 17.466 3.11565C17.794 3.28765 18 3.62865 18 3.99965V19.9997C18 20.3707 17.794 20.7117 17.466 20.8847C17.32 20.9617 17.16 20.9997 17 20.9997Z",
      fill: color
    }
  ) });
}
var init_volume = __esm({
  "src/icons/salonized/volume.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/volume-up.tsx
import { jsx as jsx76 } from "@emotion/react/jsx-runtime";
function VolumeUp(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx76(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx76(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M13.5 18.1017L8.399 14.6037C8.232 14.4907 8.035 14.4287 7.833 14.4287H3.5V9.57165H7.833C8.035 9.57165 8.232 9.50965 8.399 9.39665L13.5 5.89865V18.1017ZM14.966 3.11565C14.637 2.94165 14.24 2.96465 13.935 3.17465L7.523 7.57165H2.5C1.948 7.57165 1.5 8.01865 1.5 8.57165V15.4287C1.5 15.9817 1.948 16.4287 2.5 16.4287H7.523L13.935 20.8257C14.104 20.9417 14.302 20.9997 14.5 20.9997C14.66 20.9997 14.82 20.9617 14.966 20.8847C15.294 20.7117 15.5 20.3717 15.5 19.9997V3.99965C15.5 3.62865 15.294 3.28865 14.966 3.11565ZM18.2793 8.37305C17.9323 7.94305 17.3033 7.87605 16.8733 8.22105C16.4433 8.56705 16.3743 9.19605 16.7203 9.62705C17.7563 10.9131 17.7563 13.0871 16.7203 14.3731C16.3743 14.8041 16.4433 15.4331 16.8733 15.7791C17.0583 15.9281 17.2793 16.0001 17.4993 16.0001C17.7913 16.0001 18.0813 15.8721 18.2793 15.6271C19.9153 13.5931 19.9153 10.4071 18.2793 8.37305ZM18.2297 5.36255C18.5817 4.93655 19.2127 4.87755 19.6377 5.22955C21.8057 7.02555 22.9997 9.43055 22.9997 12.0006C22.9997 14.5696 21.8057 16.9746 19.6377 18.7706C19.4507 18.9246 19.2247 19.0006 19.0007 19.0006C18.7127 19.0006 18.4277 18.8766 18.2297 18.6376C17.8777 18.2126 17.9367 17.5826 18.3627 17.2296C20.0627 15.8206 20.9997 13.9636 20.9997 12.0006C20.9997 10.0366 20.0627 8.17955 18.3627 6.77055C17.9367 6.41755 17.8777 5.78755 18.2297 5.36255Z",
      fill: color
    }
  ) });
}
var init_volume_up = __esm({
  "src/icons/salonized/volume-up.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/volume-off.tsx
import { jsx as jsx77 } from "@emotion/react/jsx-runtime";
function VolumeOff(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx77(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx77(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M13.5 10.6714V5.89841L10.668 7.83941L9.229 6.40141L13.935 3.17441C14.24 2.96441 14.637 2.94141 14.966 3.11541C15.294 3.28841 15.5 3.62841 15.5 4.00041V12.6714L13.5 10.6714ZM4.707 3.29301C4.316 2.90201 3.684 2.90201 3.293 3.29301C2.902 3.68401 2.902 4.31601 3.293 4.70701L19.293 20.707C19.488 20.902 19.744 21 20 21C20.256 21 20.512 20.902 20.707 20.707C21.098 20.316 21.098 19.684 20.707 19.293L4.707 3.29301ZM16.9106 14.082L18.3486 15.521C19.9066 13.483 19.8886 10.374 18.2796 8.37301C17.9326 7.94301 17.3036 7.87601 16.8726 8.22101C16.4426 8.56701 16.3746 9.19601 16.7206 9.62701C17.6836 10.823 17.7386 12.778 16.9106 14.082ZM19.222 16.394C20.37 15.121 21 13.599 21 12C21 10.036 20.063 8.18001 18.362 6.77101C17.937 6.41801 17.877 5.78701 18.23 5.36201C18.582 4.93701 19.212 4.87801 19.638 5.22901C21.806 7.02501 23 9.43101 23 12C23 14.137 22.163 16.155 20.637 17.809L19.222 16.394ZM13.5 18.1016L8.399 14.6036C8.232 14.4906 8.035 14.4286 7.833 14.4286H3.5V9.57161H6.743L4.743 7.57161H2.5C1.948 7.57161 1.5 8.01861 1.5 8.57161V15.4286C1.5 15.9816 1.948 16.4286 2.5 16.4286H7.523L13.935 20.8256C14.104 20.9416 14.302 20.9996 14.5 20.9996C14.66 20.9996 14.82 20.9616 14.966 20.8846C15.294 20.7116 15.5 20.3716 15.5 19.9996V18.3286L13.5 16.3286V18.1016Z",
      fill: color
    }
  ) });
}
var init_volume_off = __esm({
  "src/icons/salonized/volume-off.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/volume-down.tsx
import { jsx as jsx78 } from "@emotion/react/jsx-runtime";
function VolumeDown(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx78(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx78(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M9.899 14.6037L15 18.1017V5.89865L9.899 9.39665C9.732 9.50965 9.535 9.57165 9.333 9.57165H5V14.4287H9.333C9.535 14.4287 9.732 14.4907 9.899 14.6037ZM15.435 3.17465C15.741 2.96465 16.138 2.94165 16.466 3.11565C16.794 3.28865 17 3.62865 17 3.99965V19.9997C17 20.3717 16.794 20.7117 16.466 20.8847C16.32 20.9617 16.16 20.9997 16 20.9997C15.802 20.9997 15.604 20.9417 15.435 20.8257L9.023 16.4287H4C3.448 16.4287 3 15.9817 3 15.4287V8.57165C3 8.01865 3.448 7.57165 4 7.57165H9.023L15.435 3.17465ZM19.3733 8.22105C19.8023 7.87605 20.4333 7.94305 20.7793 8.37305C22.4153 10.4071 22.4153 13.5931 20.7793 15.6271C20.5813 15.8721 20.2913 16.0001 19.9993 16.0001C19.7793 16.0001 19.5583 15.9281 19.3733 15.7791C18.9433 15.4331 18.8743 14.8041 19.2203 14.3731C20.2563 13.0871 20.2563 10.9131 19.2203 9.62705C18.8743 9.19605 18.9433 8.56705 19.3733 8.22105Z",
      fill: color
    }
  ) });
}
var init_volume_down = __esm({
  "src/icons/salonized/volume-down.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/video.tsx
import { jsx as jsx79 } from "@emotion/react/jsx-runtime";
function Video(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx79(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx79(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M20 14.5995L17.191 11.9995L20 9.40051V14.5995ZM15 15.9995C15 16.5515 14.552 16.9995 14 16.9995H5C4.448 16.9995 4 16.5515 4 15.9995V7.99951C4 7.44851 4.448 6.99951 5 6.99951H14C14.552 6.99951 15 7.44851 15 7.99951V15.9995ZM21.012 7.14551C20.386 6.87251 19.66 6.99151 19.161 7.45151L17 9.45151V7.99951C17 6.34551 15.654 4.99951 14 4.99951H5C3.346 4.99951 2 6.34551 2 7.99951V15.9995C2 17.6545 3.346 18.9995 5 18.9995H14C15.654 18.9995 17 17.6545 17 15.9995V14.5485L19.161 16.5475C19.481 16.8445 19.896 16.9995 20.319 16.9995C20.553 16.9995 20.788 16.9525 21.012 16.8545C21.621 16.5885 22 16.0195 22 15.3705V8.62951C22 7.98051 21.621 7.41151 21.012 7.14551Z",
      fill: color
    }
  ) });
}
var init_video = __esm({
  "src/icons/salonized/video.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/video-off.tsx
import { jsx as jsx80 } from "@emotion/react/jsx-runtime";
function VideoOff(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx80(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx80(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M17 15.586L15 13.586L8.414 7.00001L6.414 5.00001L4.707 3.29301C4.316 2.90201 3.684 2.90201 3.293 3.29301C2.902 3.68401 2.902 4.31601 3.293 4.70701L3.826 5.24001L5.586 7.00001L14.931 16.345L16.386 17.8L19.293 20.707C19.488 20.902 19.744 21 20 21C20.256 21 20.512 20.902 20.707 20.707C21.098 20.316 21.098 19.684 20.707 19.293L17 15.586ZM20 14.5997L17.191 11.9997L20 9.40071V14.5997ZM21.012 7.14571C20.386 6.87271 19.66 6.99171 19.161 7.45171L17 9.45171V7.99971C17 6.34571 15.654 4.99971 14 4.99971H7.828L9.828 6.99971H14C14.552 6.99971 15 7.44871 15 7.99971V12.1717L19.718 16.8897C19.91 16.9617 20.113 16.9997 20.319 16.9997C20.553 16.9997 20.788 16.9527 21.012 16.8547C21.621 16.5887 22 16.0197 22 15.3707V8.62971C22 7.98071 21.621 7.41171 21.012 7.14571ZM5 17.0001H14C14.0313 17.0001 14.0595 16.9922 14.088 16.9843C14.106 16.9792 14.124 16.9742 14.143 16.9711L15.665 18.4931C15.188 18.8121 14.616 19.0001 14 19.0001H5C3.346 19.0001 2 17.6541 2 16.0001V8.00011C2 7.12911 2.379 6.35111 2.974 5.80211L4.396 7.22411C4.161 7.40711 4 7.68011 4 8.00011V16.0001C4 16.5521 4.448 17.0001 5 17.0001Z",
      fill: color
    }
  ) });
}
var init_video_off = __esm({
  "src/icons/salonized/video-off.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/upload.tsx
import { jsx as jsx81 } from "@emotion/react/jsx-runtime";
function Upload(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx81(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx81(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M5 4H19C19.55 4 20 4.45 20 5V7C20 7.55 19.55 8 19 8C18.45 8 18 7.55 18 7V6H6V7C6 7.55 5.55 8 5 8C4.45 8 4 7.55 4 7V5C4 4.45 4.45 4 5 4ZM8.001 14C7.696 14 7.397 13.862 7.2 13.6C6.868 13.158 6.958 12.531 7.4 12.2L11.4 9.2C11.746 8.94 12.222 8.933 12.575 9.182L16.575 11.996C17.027 12.314 17.136 12.938 16.818 13.389C16.5 13.84 15.877 13.95 15.425 13.632L12.9972 11.9241C12.999 11.9492 13 11.9745 13 12V20C13 20.552 12.553 21 12 21C11.447 21 11 20.552 11 20V12.0002L8.6 13.8C8.42 13.935 8.21 14 8.001 14Z",
      fill: color
    }
  ) });
}
var init_upload = __esm({
  "src/icons/salonized/upload.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/unlock.tsx
import { jsx as jsx82 } from "@emotion/react/jsx-runtime";
function Unlock(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx82(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx82(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12 16C11.448 16 11 15.552 11 15C11 14.448 11.448 14 12 14C12.552 14 13 14.448 13 15C13 15.552 12.552 16 12 16ZM12 12C10.346 12 9 13.346 9 15C9 16.654 10.346 18 12 18C13.654 18 15 16.654 15 15C15 13.346 13.654 12 12 12ZM18 19C18 19.552 17.552 20 17 20H7C6.448 20 6 19.552 6 19V11C6 10.448 6.448 10 7 10H17C17.552 10 18 10.448 18 11V19ZM17 8H10V6C10 4.897 10.897 4 12 4C13.103 4 14 4.897 14 6C14 6.553 14.447 7 15 7C15.553 7 16 6.553 16 6C16 3.794 14.206 2 12 2C9.794 2 8 3.794 8 6V8H7C5.346 8 4 9.346 4 11V19C4 20.654 5.346 22 7 22H17C18.654 22 20 20.654 20 19V11C20 9.346 18.654 8 17 8Z",
      fill: color
    }
  ) });
}
var init_unlock = __esm({
  "src/icons/salonized/unlock.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/undo.tsx
import { jsx as jsx83 } from "@emotion/react/jsx-runtime";
function Undo(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx83(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx83(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10.454 11.5C14.017 11.5 17.231 13.134 19.264 15.759C18.329 11.89 14.734 8.99998 10.454 8.99998C9.901 8.99998 9.454 8.55298 9.454 7.99998V6.07698L4.63 10.251L9.454 14.463V12.5C9.454 11.947 9.901 11.5 10.454 11.5ZM20.221 21C19.76 21 19.358 20.685 19.249 20.237C18.359 16.588 15.228 13.952 11.454 13.553V14.674C11.454 15.38 11.035 16.009 10.361 16.314C9.63 16.647 8.777 16.527 8.184 16.01L3.118 11.586C2.725 11.242 2.5 10.755 2.5 10.25C2.5 9.74498 2.725 9.25798 3.118 8.91398L8.184 4.48998C8.777 3.97298 9.63 3.85298 10.361 4.18598C11.035 4.49098 11.454 5.11998 11.454 5.82598V7.04398C17.078 7.53698 21.5 12.15 21.5 17.75C21.5 18.56 21.396 19.396 21.192 20.236C21.084 20.685 20.683 21 20.221 21Z",
      fill: color
    }
  ) });
}
var init_undo = __esm({
  "src/icons/salonized/undo.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/umbrella.tsx
import { jsx as jsx84 } from "@emotion/react/jsx-runtime";
function Umbrella(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx84(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx84(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M4.06202 11C4.55502 7.06 7.92702 4 11.999 4C16.072 4 19.444 7.06 19.937 11H4.06202ZM11.999 2C6.48602 2 1.99902 6.486 1.99902 12C1.99902 12.553 2.44702 13 3.00002 13H10.999V19C10.999 20.654 12.345 22 14 22C15.654 22 17 20.654 17 19C17 18.447 16.552 18 16 18C15.447 18 15 18.447 15 19C15 19.552 14.551 20 14 20C13.448 20 13 19.552 13 19V13H20.999C21.552 13 21.999 12.553 21.999 12C21.999 6.486 17.513 2 11.999 2Z",
      fill: color
    }
  ) });
}
var init_umbrella = __esm({
  "src/icons/salonized/umbrella.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/twitter.tsx
import { jsx as jsx85 } from "@emotion/react/jsx-runtime";
function Twitter(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx85(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx85(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M19.0156 6.65431V6.65631V6.65431ZM8.51263 17.9973C8.53663 17.9973 8.56263 17.9983 8.58663 18.0003C14.2816 17.9633 17.6806 13.6123 17.6806 9.40631C17.6806 9.02431 17.8766 8.77731 18.0506 8.55831C18.2086 8.35831 18.4536 8.05031 18.6716 7.60631C17.8786 7.59831 17.1706 7.24631 16.7586 6.76431C16.3276 6.30331 15.7086 6.02131 15.0406 6.00131C14.3966 5.97531 13.7396 6.22331 13.2516 6.68631C12.6016 7.30331 12.3236 8.23431 12.5256 9.11431L12.7866 10.2533L11.6206 10.3353C8.60463 10.5613 6.51463 9.27031 5.07963 7.93431C5.08563 9.95431 5.75663 12.6493 8.80663 14.3873L9.76463 14.9333L9.12763 15.8343C8.46463 16.7733 7.46663 17.3723 6.45063 17.7553C7.12163 17.9153 7.81163 17.9973 8.49963 17.9973H8.51163H8.51263ZM8.51263 20.0003C8.48663 20.0003 8.45863 19.9993 8.43263 19.9973C6.82963 19.9863 5.22163 19.6133 3.77763 18.9143C3.23463 18.6503 2.92763 18.0723 3.01463 17.4723C3.10263 16.8653 3.56863 16.3893 4.17263 16.2913C5.21763 16.1193 6.08463 15.8133 6.71263 15.4043C2.83563 12.5053 2.93763 8.16531 3.18863 6.32731C3.26263 5.78931 3.64563 5.34031 4.16363 5.18331C4.68963 5.02331 5.23463 5.18331 5.59463 5.59231C7.13063 7.33331 8.66563 8.20831 10.4656 8.34131C10.5176 7.17631 11.0136 6.05331 11.8746 5.23531C12.7516 4.40231 13.8986 3.96631 15.1026 4.00231C16.3076 4.03931 17.4256 4.54731 18.2496 5.43231C18.3336 5.52831 18.6476 5.70231 19.0266 5.53231C19.5236 5.30931 20.0886 5.38331 20.5006 5.72731C20.9116 6.06831 21.0866 6.60531 20.9586 7.12831C20.6356 8.45931 19.9976 9.31731 19.6756 9.72831C19.5076 14.8333 15.3596 20.0003 8.51263 20.0003Z",
      fill: color
    }
  ) });
}
var init_twitter = __esm({
  "src/icons/salonized/twitter.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/tv.tsx
import { jsx as jsx86 } from "@emotion/react/jsx-runtime";
function Tv(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx86(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx86(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M19 19C19 19.552 18.552 20 18 20H6C5.448 20 5 19.552 5 19V9.00001C5 8.44801 5.448 8.00001 6 8.00001H18C18.552 8.00001 19 8.44801 19 9.00001V19ZM18 6.00001H14.414L16.707 3.70701C17.098 3.31601 17.098 2.68401 16.707 2.29301C16.316 1.90201 15.684 1.90201 15.293 2.29301L12 5.58601L8.707 2.29301C8.316 1.90201 7.684 1.90201 7.293 2.29301C6.902 2.68401 6.902 3.31601 7.293 3.70701L9.586 6.00001H6C4.346 6.00001 3 7.34601 3 9.00001V19C3 20.654 4.346 22 6 22H18C19.654 22 21 20.654 21 19V9.00001C21 7.34601 19.654 6.00001 18 6.00001Z",
      fill: color
    }
  ) });
}
var init_tv = __esm({
  "src/icons/salonized/tv.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/trending-up.tsx
import { jsx as jsx87 } from "@emotion/react/jsx-runtime";
function TrendingUp(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx87(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx87(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M20.9925 6.963C20.9905 6.891 20.9695 6.823 20.9505 6.754C20.9355 6.696 20.9285 6.637 20.9035 6.584C20.8805 6.532 20.8415 6.49 20.8075 6.442C20.7655 6.381 20.7275 6.32 20.6735 6.27C20.6645 6.261 20.6605 6.249 20.6505 6.241C20.6145 6.21 20.5705 6.199 20.5315 6.174C20.4715 6.135 20.4125 6.095 20.3445 6.069C20.2775 6.045 20.2115 6.039 20.1425 6.029C20.0945 6.022 20.0515 6 20.0005 6H15.0005C14.4475 6 14.0005 6.448 14.0005 7C14.0005 7.552 14.4475 8 15.0005 8H17.8265L13.7905 12.708L9.5145 10.143C9.0915 9.887 8.5475 9.981 8.2315 10.36L3.2315 16.36C2.8785 16.784 2.9355 17.415 3.3595 17.768C3.5475 17.924 3.7735 18 3.9995 18C4.2865 18 4.5705 17.878 4.7685 17.64L9.2205 12.298L13.4855 14.858C13.9045 15.109 14.4425 15.021 14.7595 14.651L19.0005 9.703V12C19.0005 12.552 19.4475 13 20.0005 13C20.5535 13 21.0005 12.552 21.0005 12V7C21.0005 6.987 20.9935 6.976 20.9925 6.963Z",
      fill: color
    }
  ) });
}
var init_trending_up = __esm({
  "src/icons/salonized/trending-up.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/trending-down.tsx
import { jsx as jsx88 } from "@emotion/react/jsx-runtime";
function TrendingDown(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx88(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx88(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M21.0002 12C21.0002 11.448 20.5532 11 20.0002 11C19.4472 11 19.0002 11.448 19.0002 12V14.297L14.7592 9.349C14.4432 8.979 13.9052 8.891 13.4852 9.143L9.22017 11.702L4.76917 6.36C4.41517 5.937 3.78617 5.877 3.35917 6.232C2.93617 6.585 2.87817 7.216 3.23117 7.64L8.23117 13.64C8.54817 14.019 9.09317 14.112 9.51517 13.857L13.7902 11.292L17.8262 16H15.0002C14.4472 16 14.0002 16.448 14.0002 17C14.0002 17.552 14.4472 18 15.0002 18H20.0002C20.1242 18 20.2472 17.973 20.3642 17.926C20.4132 17.907 20.4512 17.875 20.4962 17.85C20.5482 17.819 20.6042 17.8 20.6502 17.759C20.6602 17.751 20.6642 17.739 20.6732 17.73C20.7282 17.68 20.7662 17.619 20.8082 17.558C20.8412 17.51 20.8802 17.468 20.9032 17.416C20.9282 17.363 20.9362 17.304 20.9502 17.247C20.9692 17.177 20.9902 17.109 20.9922 17.037C20.9932 17.024 21.0002 17.013 21.0002 17V12Z",
      fill: color
    }
  ) });
}
var init_trending_down = __esm({
  "src/icons/salonized/trending-down.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/trash2.tsx
import { jsx as jsx89 } from "@emotion/react/jsx-runtime";
function Trash2(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx89(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx89(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10 16C10 16.55 9.55 17 9 17C8.45 17 8 16.55 8 16V12C8 11.45 8.45 11 9 11C9.55 11 10 11.45 10 12V16ZM16 16C16 16.55 15.55 17 15 17C14.45 17 14 16.55 14 16V12C14 11.45 14.45 11 15 11C15.55 11 16 11.45 16 12V16ZM18 19C18 19.551 17.552 20 17 20H7C6.448 20 6 19.551 6 19V8H18V19ZM10 4.328C10 4.173 10.214 4 10.5 4H13.5C13.786 4 14 4.173 14 4.328V6H10V4.328ZM21 6H20H16V4.328C16 3.044 14.879 2 13.5 2H10.5C9.121 2 8 3.044 8 4.328V6H4H3C2.45 6 2 6.45 2 7C2 7.55 2.45 8 3 8H4V19C4 20.654 5.346 22 7 22H17C18.654 22 20 20.654 20 19V8H21C21.55 8 22 7.55 22 7C22 6.45 21.55 6 21 6Z",
      fill: color
    }
  ) });
}
var init_trash2 = __esm({
  "src/icons/salonized/trash2.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/trash.tsx
import { jsx as jsx90 } from "@emotion/react/jsx-runtime";
function Trash(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx90(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx90(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M18 19C18 19.551 17.552 20 17 20H7C6.448 20 6 19.551 6 19V8H18V19ZM10 4.328C10 4.173 10.214 4 10.5 4H13.5C13.786 4 14 4.173 14 4.328V6H10V4.328ZM21 6H20H16V4.328C16 3.044 14.879 2 13.5 2H10.5C9.121 2 8 3.044 8 4.328V6H4H3C2.45 6 2 6.45 2 7C2 7.55 2.45 8 3 8H4V19C4 20.654 5.346 22 7 22H17C18.654 22 20 20.654 20 19V8H21C21.55 8 22 7.55 22 7C22 6.45 21.55 6 21 6Z",
      fill: color
    }
  ) });
}
var init_trash = __esm({
  "src/icons/salonized/trash.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/toggle-right.tsx
import { jsx as jsx91 } from "@emotion/react/jsx-runtime";
function ToggleRight(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx91(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx91(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M15 13C14.448 13 14 12.552 14 12C14 11.448 14.448 11 15 11C15.552 11 16 11.448 16 12C16 12.552 15.552 13 15 13ZM15 9C13.346 9 12 10.346 12 12C12 13.654 13.346 15 15 15C16.654 15 18 13.654 18 12C18 10.346 16.654 9 15 9ZM15 17H9C6.243 17 4 14.757 4 12C4 9.243 6.243 7 9 7H15C17.757 7 20 9.243 20 12C20 14.757 17.757 17 15 17ZM15 5H9C5.141 5 2 8.141 2 12C2 15.859 5.141 19 9 19H15C18.859 19 22 15.859 22 12C22 8.141 18.859 5 15 5Z",
      fill: color
    }
  ) });
}
var init_toggle_right = __esm({
  "src/icons/salonized/toggle-right.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/toggle-left.tsx
import { jsx as jsx92 } from "@emotion/react/jsx-runtime";
function ToggleLeft(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx92(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx92(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M9 13C8.448 13 8 12.552 8 12C8 11.448 8.448 11 9 11C9.552 11 10 11.448 10 12C10 12.552 9.552 13 9 13ZM9 9C7.346 9 6 10.346 6 12C6 13.654 7.346 15 9 15C10.654 15 12 13.654 12 12C12 10.346 10.654 9 9 9ZM15 17H9C6.243 17 4 14.757 4 12C4 9.243 6.243 7 9 7H15C17.757 7 20 9.243 20 12C20 14.757 17.757 17 15 17ZM15 5H9C5.141 5 2 8.141 2 12C2 15.859 5.141 19 9 19H15C18.859 19 22 15.859 22 12C22 8.141 18.859 5 15 5Z",
      fill: color
    }
  ) });
}
var init_toggle_left = __esm({
  "src/icons/salonized/toggle-left.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/timer.tsx
import { jsx as jsx93 } from "@emotion/react/jsx-runtime";
function Timer(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx93(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx93(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M15 12H13V10C13 9.447 12.552 9 12 9C11.448 9 11 9.447 11 10V13C11 13.553 11.448 14 12 14H15C15.552 14 16 13.553 16 13C16 12.447 15.552 12 15 12ZM12 19.75C8.278 19.75 5.25 16.722 5.25 13C5.25 9.278 8.278 6.25 12 6.25C15.722 6.25 18.75 9.278 18.75 13C18.75 16.722 15.722 19.75 12 19.75ZM12.988 4.058C12.99 4.037 13 4.021 13 4V3H14C14.552 3 15 2.553 15 2C15 1.447 14.552 1 14 1H10C9.448 1 9 1.447 9 2C9 2.553 9.448 3 10 3H11V4C11 4.021 11.01 4.037 11.012 4.058C6.513 4.552 3 8.372 3 13C3 17.963 7.038 22 12 22C16.962 22 21 17.963 21 13C21 8.372 17.487 4.552 12.988 4.058Z",
      fill: color
    }
  ) });
}
var init_timer = __esm({
  "src/icons/salonized/timer.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/thermometer.tsx
import { jsx as jsx94 } from "@emotion/react/jsx-runtime";
function Thermometer(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx94(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx94(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12 4C11.448 4 11 4.449 11 5V13.54C11 13.898 10.809 14.229 10.498 14.407C9.574 14.938 9 15.932 9 17C9 18.654 10.346 20 12 20C13.654 20 15 18.654 15 17C15 15.932 14.426 14.938 13.502 14.407C13.191 14.229 13 13.898 13 13.54V5C13 4.733 12.897 4.487 12.713 4.306C12.514 4.102 12.267 4 12 4ZM12 22C9.243 22 7 19.757 7 17C7 15.42 7.754 13.938 9 13.003V5C9 3.346 10.346 2 12 2C12.812 2 13.566 2.317 14.127 2.892C14.684 3.434 15 4.189 15 5V13.003C16.246 13.938 17 15.42 17 17C17 19.757 14.757 22 12 22Z",
      fill: color
    }
  ) });
}
var init_thermometer = __esm({
  "src/icons/salonized/thermometer.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/thermometer-plus.tsx
import { jsx as jsx95 } from "@emotion/react/jsx-runtime";
function ThermometerPlus(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx95(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx95(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M14 4C13.448 4 13 4.449 13 5V13.54C13 13.898 12.809 14.229 12.498 14.407C11.574 14.938 11 15.932 11 17C11 18.654 12.346 20 14 20C15.654 20 17 18.654 17 17C17 15.932 16.426 14.938 15.502 14.407C15.191 14.229 15 13.898 15 13.54V5C15 4.733 14.897 4.487 14.713 4.306C14.514 4.102 14.267 4 14 4ZM14 22C11.243 22 9 19.757 9 17C9 15.42 9.754 13.938 11 13.003V5C11 3.346 12.346 2 14 2C14.812 2 15.566 2.317 16.127 2.892C16.684 3.434 17 4.189 17 5V13.003C18.246 13.938 19 15.42 19 17C19 19.757 16.757 22 14 22ZM4 7H3C2.45 7 2 6.55 2 6C2 5.45 2.45 5 3 5H4V4C4 3.45 4.45 3 5 3C5.55 3 6 3.45 6 4V5H7C7.55 5 8 5.45 8 6C8 6.55 7.55 7 7 7H6V8C6 8.55 5.55 9 5 9C4.45 9 4 8.55 4 8V7Z",
      fill: color
    }
  ) });
}
var init_thermometer_plus = __esm({
  "src/icons/salonized/thermometer-plus.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/thermometer-minus.tsx
import { jsx as jsx96 } from "@emotion/react/jsx-runtime";
function ThermometerMinus(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx96(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx96(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M13 5C13 4.449 13.448 4 14 4C14.267 4 14.514 4.102 14.713 4.306C14.897 4.487 15 4.733 15 5V13.54C15 13.898 15.191 14.229 15.502 14.407C16.426 14.938 17 15.932 17 17C17 18.654 15.654 20 14 20C12.346 20 11 18.654 11 17C11 15.932 11.574 14.938 12.498 14.407C12.809 14.229 13 13.898 13 13.54V5ZM9 17C9 19.757 11.243 22 14 22C16.757 22 19 19.757 19 17C19 15.42 18.246 13.938 17 13.003V5C17 4.189 16.684 3.434 16.127 2.892C15.566 2.317 14.812 2 14 2C12.346 2 11 3.346 11 5V13.003C9.754 13.938 9 15.42 9 17ZM3 7H7C7.55 7 8 6.55 8 6C8 5.45 7.55 5 7 5H3C2.45 5 2 5.45 2 6C2 6.55 2.45 7 3 7Z",
      fill: color
    }
  ) });
}
var init_thermometer_minus = __esm({
  "src/icons/salonized/thermometer-minus.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/text.tsx
import { jsx as jsx97 } from "@emotion/react/jsx-runtime";
function Text(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx97(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx97(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M20 4H4C3.447 4 3 4.447 3 5V8C3 8.553 3.447 9 4 9C4.553 9 5 8.553 5 8V6H11V19H9C8.447 19 8 19.447 8 20C8 20.553 8.447 21 9 21H15C15.553 21 16 20.553 16 20C16 19.447 15.553 19 15 19H13V6H19V8C19 8.553 19.447 9 20 9C20.553 9 21 8.553 21 8V5C21 4.447 20.553 4 20 4Z",
      fill: color
    }
  ) });
}
var init_text = __esm({
  "src/icons/salonized/text.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/sync.tsx
import { jsx as jsx98 } from "@emotion/react/jsx-runtime";
function Sync(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx98(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx98(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M21.6828 10.3261C21.6755 10.3419 21.6683 10.3578 21.6615 10.374C21.6546 10.3908 21.6492 10.4082 21.6438 10.4257C21.6351 10.454 21.6264 10.4822 21.6115 10.507C21.5819 10.556 21.5433 10.5972 21.5045 10.6385C21.4934 10.6502 21.4824 10.662 21.4715 10.674C21.4594 10.6865 21.4487 10.7003 21.438 10.714C21.4231 10.7331 21.4081 10.7523 21.3895 10.768C21.3335 10.8137 21.2688 10.8455 21.2043 10.8772C21.1997 10.8795 21.1951 10.8817 21.1905 10.884C21.1769 10.8906 21.1639 10.8989 21.1509 10.9073C21.1325 10.9191 21.114 10.931 21.0935 10.938C20.9855 10.978 20.8705 11 20.7515 11C20.6975 11 20.6415 10.996 20.5865 10.986L16.3365 10.281C15.7915 10.191 15.4235 9.676 15.5135 9.131C15.6035 8.587 16.1175 8.214 16.6635 8.309L18.3075 8.581C17.0625 6.395 14.6855 5 12.0695 5C9.11049 5 6.50349 6.718 5.42649 9.375C5.26949 9.765 4.89449 10 4.49949 10C4.37449 10 4.24749 9.977 4.12449 9.927C3.61249 9.72 3.36549 9.137 3.57349 8.625C4.95749 5.208 8.29249 3 12.0695 3C15.4815 3 18.5825 4.87 20.1475 7.788L20.5165 5.815C20.6185 5.273 21.1425 4.914 21.6835 5.018C22.2265 5.119 22.5845 5.642 22.4825 6.185L21.7335 10.185C21.7239 10.236 21.7033 10.281 21.6828 10.3261ZM18.5734 14.6252C18.7804 14.1122 19.3644 13.8662 19.8754 14.0732C20.3874 14.2802 20.6344 14.8632 20.4264 15.3752C19.0424 18.7922 15.7074 21.0002 11.9304 21.0002C8.51839 21.0002 5.41739 19.1302 3.85239 16.2122L3.48239 18.1842C3.39339 18.6652 2.97339 19.0002 2.50039 19.0002C2.43939 19.0002 2.37739 18.9942 2.31539 18.9822C1.77239 18.8812 1.41539 18.3582 1.51739 17.8152L2.26639 13.8152C2.274 13.7759 2.29083 13.7411 2.30774 13.706C2.31752 13.6858 2.32733 13.6655 2.33539 13.6442C2.3433 13.6243 2.35021 13.6037 2.35712 13.583C2.37208 13.5383 2.3871 13.4935 2.41239 13.4552C2.42715 13.4324 2.44645 13.4142 2.46586 13.3959C2.47802 13.3844 2.49023 13.3729 2.50139 13.3602C2.5102 13.35 2.51891 13.3397 2.52761 13.3295C2.5752 13.2734 2.62236 13.2178 2.68239 13.1772C2.68829 13.1729 2.69533 13.1703 2.7023 13.1678C2.70832 13.1656 2.71429 13.1634 2.71939 13.1602C2.81639 13.0972 2.92039 13.0482 3.03539 13.0232C3.0424 13.0216 3.04969 13.022 3.05696 13.0224C3.06319 13.0228 3.0694 13.0231 3.07539 13.0222C3.18539 13.0042 3.29639 12.9932 3.41339 13.0132L7.66339 13.7192C8.20839 13.8082 8.57639 14.3242 8.48639 14.8692C8.40539 15.3582 7.98139 15.7052 7.50039 15.7052C7.44639 15.7052 7.39139 15.7012 7.33639 15.6912L5.69239 15.4192C6.93739 17.6052 9.31439 19.0002 11.9304 19.0002C14.8894 19.0002 17.4964 17.2822 18.5734 14.6252Z",
      fill: color
    }
  ) });
}
var init_sync = __esm({
  "src/icons/salonized/sync.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/swap.tsx
import { jsx as jsx99 } from "@emotion/react/jsx-runtime";
function Swap(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx99(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx99(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M17 8.00038H4.00002C3.44802 8.00038 3.00002 7.55338 3.00002 7.00038C3.00002 6.44738 3.44802 6.00038 4.00002 6.00038H17.082L15.524 4.79038C15.088 4.45138 15.009 3.82238 15.348 3.38738C15.687 2.95038 16.316 2.87138 16.751 3.21038L20.613 6.21038C20.86 6.40138 21.002 6.69638 21 7.00938C20.998 7.32038 20.85 7.61338 20.6 7.80038L16.6 10.8004C16.42 10.9354 16.209 11.0004 16.001 11.0004C15.697 11.0004 15.396 10.8624 15.2 10.6004C14.869 10.1584 14.958 9.53138 15.4 9.20038L17 8.00038ZM7.00002 15.0004H20C20.552 15.0004 21 15.4474 21 16.0004C21 16.5534 20.552 17.0004 20 17.0004H6.91802L8.47602 18.2104C8.91202 18.5494 8.99102 19.1784 8.65202 19.6134C8.45502 19.8674 8.16002 20.0004 7.86202 20.0004C7.64702 20.0004 7.43102 19.9324 7.24902 19.7904L3.38702 16.7904C3.14002 16.5994 2.99802 16.3044 3.00002 15.9914C3.00202 15.6804 3.15002 15.3874 3.40002 15.2004L7.40002 12.2004C7.84302 11.8694 8.46902 11.9584 8.80002 12.4004C9.13102 12.8424 9.04202 13.4694 8.60002 13.8004L7.00002 15.0004Z",
      fill: color
    }
  ) });
}
var init_swap = __esm({
  "src/icons/salonized/swap.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/sun.tsx
import { jsx as jsx100 } from "@emotion/react/jsx-runtime";
function Sun(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx100(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx100(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12 6C12.552 6 13 5.553 13 5V3C13 2.447 12.552 2 12 2C11.448 2 11 2.447 11 3V5C11 5.553 11.448 6 12 6ZM12 14C10.897 14 10 13.103 10 12C10 10.897 10.897 10 12 10C13.103 10 14 10.897 14 12C14 13.103 13.103 14 12 14ZM12 8C9.794 8 8 9.794 8 12C8 14.206 9.794 16 12 16C14.206 16 16 14.206 16 12C16 9.794 14.206 8 12 8ZM19 11H21C21.552 11 22 11.447 22 12C22 12.553 21.552 13 21 13H19C18.448 13 18 12.553 18 12C18 11.447 18.448 11 19 11ZM6 12C6 11.447 5.552 11 5 11H3C2.448 11 2 11.447 2 12C2 12.553 2.448 13 3 13H5C5.552 13 6 12.553 6 12ZM4.8067 5.0533C5.1907 4.6573 5.8237 4.6453 6.2207 5.0283L7.6597 6.4183C8.0567 6.8013 8.0677 7.4353 7.6837 7.8323C7.4877 8.0353 7.2267 8.1373 6.9647 8.1373C6.7147 8.1373 6.4647 8.0453 6.2697 7.8573L4.8307 6.4673C4.4337 6.0843 4.4227 5.4503 4.8067 5.0533ZM17.0352 8.1377C17.2852 8.1377 17.5352 8.0447 17.7302 7.8577L19.1692 6.4677C19.5662 6.0837 19.5772 5.4497 19.1932 5.0537C18.8102 4.6577 18.1782 4.6457 17.7792 5.0287L16.3402 6.4177C15.9432 6.8017 15.9322 7.4357 16.3162 7.8317C16.5122 8.0347 16.7732 8.1377 17.0352 8.1377ZM11 19C11 18.447 11.448 18 12 18C12.552 18 13 18.447 13 19V21C13 21.553 12.552 22 12 22C11.448 22 11 21.553 11 21V19ZM17.73 16.1426C17.333 15.7596 16.7 15.7716 16.316 16.1676C15.932 16.5646 15.943 17.1986 16.34 17.5816L17.779 18.9716C17.974 19.1596 18.224 19.2516 18.474 19.2516C18.736 19.2516 18.997 19.1496 19.193 18.9466C19.577 18.5496 19.566 17.9156 19.169 17.5326L17.73 16.1426ZM4.831 17.5326L6.27 16.1426C6.668 15.7596 7.301 15.7716 7.684 16.1676C8.068 16.5646 8.057 17.1986 7.66 17.5816L6.221 18.9716C6.026 19.1596 5.776 19.2516 5.526 19.2516C5.264 19.2516 5.003 19.1496 4.807 18.9466C4.423 18.5496 4.434 17.9156 4.831 17.5326Z",
      fill: color
    }
  ) });
}
var init_sun = __esm({
  "src/icons/salonized/sun.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/stop-circle.tsx
import { jsx as jsx101 } from "@emotion/react/jsx-runtime";
function StopCircle(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx101(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx101(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10 14H14V10H10V14ZM14.75 8H9.25C8.561 8 8 8.561 8 9.25V14.75C8 15.439 8.561 16 9.25 16H14.75C15.439 16 16 15.439 16 14.75V9.25C16 8.561 15.439 8 14.75 8ZM12 20C7.589 20 4 16.411 4 12C4 7.589 7.589 4 12 4C16.411 4 20 7.589 20 12C20 16.411 16.411 20 12 20ZM12 2C6.486 2 2 6.486 2 12C2 17.514 6.486 22 12 22C17.514 22 22 17.514 22 12C22 6.486 17.514 2 12 2Z",
      fill: color
    }
  ) });
}
var init_stop_circle = __esm({
  "src/icons/salonized/stop-circle.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/star.tsx
import { jsx as jsx102 } from "@emotion/react/jsx-runtime";
function Star(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx102(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx102(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11.9995 16.05C12.1585 16.05 12.3175 16.088 12.4625 16.163L16.2315 18.133L15.5145 13.976C15.4575 13.65 15.5665 13.318 15.8045 13.087L18.8405 10.151L14.6375 9.539C14.3125 9.492 14.0315 9.289 13.8855 8.995L11.9995 5.201L10.1135 8.995C9.96755 9.289 9.68655 9.492 9.36155 9.539L5.15855 10.151L8.19455 13.087C8.43255 13.318 8.54155 13.65 8.48455 13.976L7.76755 18.133L11.5365 16.163C11.6815 16.088 11.8405 16.05 11.9995 16.05ZM17.5615 20.955C17.4025 20.955 17.2435 20.918 17.0985 20.842L11.9995 18.178L6.90055 20.842C6.56255 21.018 6.15455 20.987 5.84955 20.763C5.54155 20.539 5.38855 20.16 5.45255 19.785L6.42455 14.157L2.30455 10.172C2.02955 9.907 1.93155 9.509 2.04855 9.146C2.16455 8.783 2.47855 8.519 2.85555 8.464L8.55655 7.636L11.1035 2.51C11.4415 1.83 12.5575 1.83 12.8955 2.51L15.4425 7.636L21.1435 8.464C21.5205 8.519 21.8345 8.783 21.9505 9.146C22.0675 9.509 21.9695 9.907 21.6945 10.172L17.5745 14.157L18.5465 19.785C18.6105 20.16 18.4575 20.539 18.1495 20.763C17.9765 20.891 17.7695 20.955 17.5615 20.955Z",
      fill: color
    }
  ) });
}
var init_star2 = __esm({
  "src/icons/salonized/star.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/square.tsx
import { jsx as jsx103 } from "@emotion/react/jsx-runtime";
function Square(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx103(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx103(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M6 5C5.449 5 5 5.449 5 6V18C5 18.551 5.449 19 6 19H18C18.551 19 19 18.551 19 18V6C19 5.449 18.551 5 18 5H6ZM18 21H6C4.346 21 3 19.654 3 18V6C3 4.346 4.346 3 6 3H18C19.654 3 21 4.346 21 6V18C21 19.654 19.654 21 18 21Z",
      fill: color
    }
  ) });
}
var init_square = __esm({
  "src/icons/salonized/square.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/speaker.tsx
import { jsx as jsx104 } from "@emotion/react/jsx-runtime";
function Speaker(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx104(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx104(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M18 19C18 19.552 17.552 20 17 20H7C6.448 20 6 19.552 6 19V5C6 4.448 6.448 4 7 4H17C17.552 4 18 4.448 18 5V19ZM17 2H7C5.346 2 4 3.346 4 5V19C4 20.654 5.346 22 7 22H17C18.654 22 20 20.654 20 19V5C20 3.346 18.654 2 17 2ZM12 17C11.173 17 10.5 16.327 10.5 15.5C10.5 14.673 11.173 14 12 14C12.827 14 13.5 14.673 13.5 15.5C13.5 16.327 12.827 17 12 17ZM12 12C10.07 12 8.5 13.57 8.5 15.5C8.5 17.43 10.07 19 12 19C13.93 19 15.5 17.43 15.5 15.5C15.5 13.57 13.93 12 12 12ZM12 7C12.552 7 13 7.448 13 8C13 8.552 12.552 9 12 9C11.448 9 11 8.552 11 8C11 7.448 11.448 7 12 7ZM12 11C13.654 11 15 9.654 15 8C15 6.346 13.654 5 12 5C10.346 5 9 6.346 9 8C9 9.654 10.346 11 12 11Z",
      fill: color
    }
  ) });
}
var init_speaker = __esm({
  "src/icons/salonized/speaker.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/smartphone.tsx
import { jsx as jsx105 } from "@emotion/react/jsx-runtime";
function Smartphone(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx105(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx105(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M9.5 6H14.5C15.053 6 15.5 6.447 15.5 7C15.5 7.553 15.053 8 14.5 8H9.5C8.947 8 8.5 7.553 8.5 7C8.5 6.447 8.947 6 9.5 6ZM10.5 16.5C10.5 15.672 11.172 15 12 15C12.828 15 13.5 15.672 13.5 16.5C13.5 17.328 12.828 18 12 18C11.172 18 10.5 17.328 10.5 16.5ZM18 19C18 19.552 17.552 20 17 20H7C6.448 20 6 19.552 6 19V5C6 4.448 6.448 4 7 4H17C17.552 4 18 4.448 18 5V19ZM17 2H7C5.346 2 4 3.346 4 5V19C4 20.654 5.346 22 7 22H17C18.654 22 20 20.654 20 19V5C20 3.346 18.654 2 17 2Z",
      fill: color
    }
  ) });
}
var init_smartphone = __esm({
  "src/icons/salonized/smartphone.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/slash.tsx
import { jsx as jsx106 } from "@emotion/react/jsx-runtime";
function Slash(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx106(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx106(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M4 12C4 10.154 4.635 8.458 5.688 7.103L16.897 18.312C15.542 19.366 13.846 20 12 20C7.589 20 4 16.411 4 12ZM20 12C20 13.846 19.365 15.542 18.312 16.897L7.103 5.688C8.458 4.634 10.154 4 12 4C16.411 4 20 7.589 20 12ZM12 2C6.486 2 2 6.486 2 12C2 17.514 6.486 22 12 22C17.514 22 22 17.514 22 12C22 6.486 17.514 2 12 2Z",
      fill: color
    }
  ) });
}
var init_slash = __esm({
  "src/icons/salonized/slash.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/skip-forward.tsx
import { jsx as jsx107 } from "@emotion/react/jsx-runtime";
function SkipForward(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx107(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx107(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8.5 15.9083V8.01427L13.322 11.9983L8.5 15.9083ZM16 6.00027C15.448 6.00027 15 6.44727 15 7.00027V10.8183C14.953 10.7693 14.912 10.7183 14.858 10.6743L9.759 6.46027C9.15 5.95827 8.282 5.85627 7.55 6.20127C6.902 6.50727 6.5 7.11427 6.5 7.78727V16.2133C6.5 16.8863 6.902 17.4933 7.55 17.7993C7.839 17.9343 8.149 18.0013 8.456 18.0013C8.927 18.0013 9.391 17.8443 9.759 17.5393L14.859 13.3263C14.912 13.2823 14.953 13.2303 15 13.1813V17.0003C15 17.5533 15.448 18.0003 16 18.0003C16.552 18.0003 17 17.5533 17 17.0003V7.00027C17 6.44727 16.552 6.00027 16 6.00027Z",
      fill: color
    }
  ) });
}
var init_skip_forward = __esm({
  "src/icons/salonized/skip-forward.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/skip-back.tsx
import { jsx as jsx108 } from "@emotion/react/jsx-runtime";
function SkipBack(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx108(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx108(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M15.5 15.9855L10.678 12.0025L15.5 8.09146V15.9855ZM16.45 6.20146C15.716 5.85646 14.849 5.95846 14.241 6.46146L9.141 10.6735C9.088 10.7175 9.047 10.7695 9 10.8185V7.00046C9 6.44746 8.552 6.00046 8 6.00046C7.448 6.00046 7 6.44746 7 7.00046V17.0005C7 17.5525 7.448 18.0005 8 18.0005C8.552 18.0005 9 17.5525 9 17.0005V13.1815C9.047 13.2305 9.088 13.2825 9.142 13.3265L14.241 17.5405C14.609 17.8435 15.073 18.0015 15.544 18.0015C15.851 18.0015 16.161 17.9345 16.45 17.7985C17.098 17.4935 17.5 16.8855 17.5 16.2135V7.78746C17.5 7.11446 17.098 6.50646 16.45 6.20146Z",
      fill: color
    }
  ) });
}
var init_skip_back = __esm({
  "src/icons/salonized/skip-back.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/shuffle2.tsx
import { jsx as jsx109 } from "@emotion/react/jsx-runtime";
function Shuffle2(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx109(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx109(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M18.709 14.2944C18.319 13.9024 17.685 13.9004 17.295 14.2914C16.903 14.6814 16.901 15.3144 17.291 15.7054L17.584 16.0004H16C13.794 16.0004 12 14.2054 12 12.0004C12 9.7944 13.794 8.0004 16 8.0004H17.588L17.295 8.2914C16.903 8.6814 16.901 9.3144 17.291 9.7054C17.486 9.9014 17.743 10.0004 18 10.0004C18.255 10.0004 18.511 9.9024 18.705 9.7084L20.705 7.7174C20.894 7.5304 20.999 7.2764 21 7.0114C21.001 6.7454 20.896 6.4914 20.709 6.3034L18.709 4.2944C18.319 3.9024 17.685 3.9004 17.295 4.2914C16.903 4.6814 16.901 5.3144 17.291 5.7054L17.584 6.0004H16C13.914 6.0004 12.075 7.0704 11 8.6904C9.925 7.0704 8.086 6.0004 6 6.0004H4C3.447 6.0004 3 6.4474 3 7.0004C3 7.5524 3.447 8.0004 4 8.0004H6C8.206 8.0004 10 9.7944 10 12.0004C10 14.2054 8.206 16.0004 6 16.0004H4C3.447 16.0004 3 16.4474 3 17.0004C3 17.5524 3.447 18.0004 4 18.0004H6C8.086 18.0004 9.925 16.9294 11 15.3094C12.075 16.9294 13.914 18.0004 16 18.0004H17.588L17.295 18.2914C16.903 18.6814 16.901 19.3144 17.291 19.7054C17.486 19.9014 17.743 20.0004 18 20.0004C18.255 20.0004 18.511 19.9024 18.705 19.7084L20.705 17.7174C20.894 17.5304 20.999 17.2764 21 17.0114C21.001 16.7454 20.896 16.4914 20.709 16.3034L18.709 14.2944Z",
      fill: color
    }
  ) });
}
var init_shuffle2 = __esm({
  "src/icons/salonized/shuffle2.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/shuffle.tsx
import { jsx as jsx110 } from "@emotion/react/jsx-runtime";
function Shuffle(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx110(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx110(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M19.0002 10.308C18.4482 10.308 18.0002 9.86 18.0002 9.308L17.9993 7.415L5.70725 19.707C5.51225 19.902 5.25625 20 5.00025 20C4.74425 20 4.48825 19.902 4.29325 19.707C3.90225 19.316 3.90225 18.683 4.29325 18.293L10.5802 12.006L4.74825 6.175C4.35725 5.784 4.35725 5.151 4.74825 4.761C5.13925 4.37 5.77125 4.37 6.16225 4.761L11.9942 10.592L16.5763 6.009L14.6873 6C14.1353 5.997 13.6892 5.547 13.6923 4.995C13.6953 4.443 14.1693 4.01 14.6973 4L19.0022 4.021C19.5522 4.024 19.9972 4.471 19.9972 5.021L20.0002 9.307C20.0002 9.859 19.5533 10.307 19.0013 10.308H19.0002ZM19.0001 13.6791H19.0051C19.5581 13.6821 20.0031 14.1321 20.0001 14.6841L19.9791 18.8921C20.0112 19.1831 19.9312 19.4841 19.7071 19.7071C19.5121 19.9021 19.2561 20.0001 19.0001 20.0001C18.9849 20.0001 18.97 19.996 18.9551 19.9918C18.9435 19.9886 18.9319 19.9854 18.9201 19.9841L14.6931 19.9871C14.1411 19.9871 13.6931 19.5391 13.6931 18.9871C13.6931 18.4351 14.1402 17.9871 14.6922 17.9871L16.5711 17.9861L13.7931 15.2071C13.4022 14.8161 13.4022 14.1831 13.7931 13.7931C14.1841 13.4021 14.8172 13.4021 15.2071 13.7931L17.9902 16.5761L18.0001 14.6741C18.0031 14.1231 18.4501 13.6791 19.0001 13.6791Z",
      fill: color
    }
  ) });
}
var init_shuffle = __esm({
  "src/icons/salonized/shuffle.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/shopping-cart.tsx
import { jsx as jsx111 } from "@emotion/react/jsx-runtime";
function ShoppingCart(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx111(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx111(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M16.382 14H8.764L7.127 8H19.382L16.382 14ZM21.083 6.948C20.716 6.354 20.08 6 19.382 6H6.582L5.965 3.737C5.846 3.302 5.451 3 5 3H3C2.447 3 2 3.448 2 4C2 4.552 2.447 5 3 5H4.236L7.035 15.263C7.154 15.698 7.549 16 8 16H17C17.379 16 17.725 15.786 17.895 15.447L21.171 8.894C21.484 8.269 21.45 7.542 21.083 6.948ZM7.5002 18C6.6722 18 6.0002 18.671 6.0002 19.5C6.0002 20.329 6.6722 21 7.5002 21C8.3282 21 9.0002 20.329 9.0002 19.5C9.0002 18.671 8.3282 18 7.5002 18ZM16.0002 19.5C16.0002 18.671 16.6722 18 17.5002 18C18.3282 18 19.0002 18.671 19.0002 19.5C19.0002 20.329 18.3282 21 17.5002 21C16.6722 21 16.0002 20.329 16.0002 19.5Z",
      fill: color
    }
  ) });
}
var init_shopping_cart = __esm({
  "src/icons/salonized/shopping-cart.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/shopping-bag.tsx
import { jsx as jsx112 } from "@emotion/react/jsx-runtime";
function ShoppingBag(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx112(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx112(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M15 11C14.447 11 14 11.448 14 12C14 13.103 13.103 14 12 14C10.897 14 10 13.103 10 12C10 11.448 9.553 11 9 11C8.447 11 8 11.448 8 12C8 14.206 9.794 16 12 16C14.206 16 16 14.206 16 12C16 11.448 15.553 11 15 11ZM18 19H6C5.448 19 5 18.551 5 18V9H19V18C19 18.551 18.552 19 18 19ZM8.121 5.293C8.308 5.107 8.565 5 8.828 5H15.172C15.435 5 15.692 5.107 15.879 5.293L17.586 7H6.414L8.121 5.293ZM20.121 6.707L17.293 3.879C16.727 3.312 15.973 3 15.172 3H8.828C8.027 3 7.273 3.312 6.707 3.879L3.879 6.707C3.312 7.273 3 8.027 3 8.829V18C3 19.654 4.346 21 6 21H18C19.654 21 21 19.654 21 18V8.829C21 8.027 20.688 7.273 20.121 6.707Z",
      fill: color
    }
  ) });
}
var init_shopping_bag = __esm({
  "src/icons/salonized/shopping-bag.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/shield.tsx
import { jsx as jsx113 } from "@emotion/react/jsx-runtime";
function Shield(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx113(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx113(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12 4.14643L5 8.08443V8.22943C5 12.9694 7.566 17.3584 11.698 19.6834L12 19.8534L12.302 19.6834C16.434 17.3584 19 12.9694 19 8.22943V8.08443L12 4.14643ZM12 21.8504C11.661 21.8504 11.322 21.7664 11.021 21.5964L10.718 21.4254C5.957 18.7484 3 13.6914 3 8.22943V8.08443C3 7.36543 3.39 6.69743 4.018 6.34243L11.02 2.40443C11.625 2.06443 12.376 2.06343 12.979 2.40343L19.98 6.34143C20.61 6.69743 21 7.36543 21 8.08443V8.22943C21 13.6914 18.043 18.7484 13.282 21.4254L12.98 21.5954C12.678 21.7654 12.339 21.8504 12 21.8504Z",
      fill: color
    }
  ) });
}
var init_shield = __esm({
  "src/icons/salonized/shield.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/shield-off.tsx
import { jsx as jsx114 } from "@emotion/react/jsx-runtime";
function ShieldOff(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx114(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx114(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12.9797 2.4038L19.9807 6.34179C20.6107 6.69679 21.0007 7.36479 21.0007 8.08479V8.22979C21.0007 11.0168 20.2257 13.6958 18.8387 16.0108L17.3737 14.5438C18.4187 12.6388 19.0007 10.4748 19.0007 8.22979V8.08479L12.0007 4.1468L8.78475 5.9558L7.31575 4.4878L11.0197 2.4038C11.6257 2.0648 12.3767 2.0638 12.9797 2.4038ZM4.70725 3.293C4.31625 2.902 3.68425 2.902 3.29325 3.293C2.90225 3.684 2.90225 4.31599 3.29325 4.707L19.2932 20.707C19.4882 20.902 19.7442 21 20.0002 21C20.2562 21 20.5122 20.902 20.7072 20.707C21.0982 20.316 21.0982 19.684 20.7072 19.293L4.70725 3.293ZM12.302 19.6836L12 19.8536L11.698 19.6836C7.56705 17.3586 5.00005 12.9696 5.00005 8.2296V8.0846L5.16405 7.9926L3.73205 6.5596C3.28105 6.9356 3.00005 7.4866 3.00005 8.0846V8.2296C3.00005 13.6916 5.95705 18.7476 10.718 21.4256L11.021 21.5966C11.323 21.7666 11.661 21.8506 12 21.8506C12.339 21.8506 12.678 21.7656 12.981 21.5956L13.282 21.4256C14.405 20.7946 15.422 20.0276 16.329 19.1576L14.915 17.7436C14.136 18.4866 13.263 19.1426 12.302 19.6836Z",
      fill: color
    }
  ) });
}
var init_shield_off = __esm({
  "src/icons/salonized/shield-off.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/share.tsx
import { jsx as jsx115 } from "@emotion/react/jsx-runtime";
function Share(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx115(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx115(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M18 19C17.448 19 17 18.552 17 18C17 17.448 17.448 17 18 17C18.552 17 19 17.448 19 18C19 18.552 18.552 19 18 19ZM5 13C4.448 13 4 12.552 4 12C4 11.448 4.448 11 5 11C5.552 11 6 11.448 6 12C6 12.552 5.552 13 5 13ZM18 5C18.552 5 19 5.448 19 6C19 6.552 18.552 7 18 7C17.448 7 17 6.552 17 6C17 5.448 17.448 5 18 5ZM18 15C17.183 15 16.443 15.33 15.901 15.861L7.966 12.335C7.979 12.224 8 12.114 8 12C8 11.886 7.979 11.776 7.966 11.665L15.901 8.139C16.443 8.67 17.183 9 18 9C19.654 9 21 7.654 21 6C21 4.346 19.654 3 18 3C16.346 3 15 4.346 15 6C15 6.114 15.021 6.224 15.034 6.335L7.099 9.861C6.557 9.33 5.817 9 5 9C3.346 9 2 10.346 2 12C2 13.654 3.346 15 5 15C5.817 15 6.557 14.67 7.099 14.139L15.034 17.665C15.021 17.776 15 17.886 15 18C15 19.654 16.346 21 18 21C19.654 21 21 19.654 21 18C21 16.346 19.654 15 18 15Z",
      fill: color
    }
  ) });
}
var init_share = __esm({
  "src/icons/salonized/share.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/shake.tsx
import { jsx as jsx116 } from "@emotion/react/jsx-runtime";
function Shake(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx116(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx116(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12.9995 7.14224C12.6785 7.05924 12.3465 7.00024 11.9995 7.00024C11.6525 7.00024 11.3205 7.05924 10.9995 7.14224V3.00024C10.9995 2.44724 11.4475 2.00024 11.9995 2.00024C12.5515 2.00024 12.9995 2.44724 12.9995 3.00024V7.14224ZM5.49902 18.0002C5.27102 18.0002 5.04302 17.9232 4.85502 17.7652C2.69102 15.9432 1.49902 13.5412 1.49902 11.0002C1.49902 8.45924 2.69102 6.05724 4.85502 4.23524C5.27702 3.87824 5.90802 3.93324 6.26502 4.35624C6.62002 4.77824 6.56602 5.40924 6.14402 5.76524C4.43802 7.20024 3.49902 9.06024 3.49902 11.0002C3.49902 12.9402 4.43802 14.8002 6.14402 16.2352C6.56602 16.5912 6.62002 17.2222 6.26502 17.6442C6.06702 17.8792 5.78402 18.0002 5.49902 18.0002ZM11.9995 12.0002C11.4485 12.0002 10.9995 11.5522 10.9995 11.0002C10.9995 10.4482 11.4485 10.0002 11.9995 10.0002C12.5505 10.0002 12.9995 10.4482 12.9995 11.0002C12.9995 11.5522 12.5505 12.0002 11.9995 12.0002ZM11.9995 15.0002C11.6525 15.0002 11.3205 14.9412 10.9995 14.8582V20.0002C10.9995 20.5532 11.4475 21.0002 11.9995 21.0002C12.5515 21.0002 12.9995 20.5532 12.9995 20.0002V14.8582C12.6785 14.9412 12.3465 15.0002 11.9995 15.0002ZM15.234 15.6452C15.433 15.8792 15.715 16.0002 16 16.0002C16.228 16.0002 16.456 15.9232 16.644 15.7652C18.163 14.4852 19 12.7932 19 11.0002C19 9.20724 18.163 7.51524 16.644 6.23524C16.222 5.87924 15.59 5.93424 15.234 6.35524C14.879 6.77824 14.933 7.40924 15.355 7.76524C16.416 8.65724 17 9.80724 17 11.0002C17 12.1932 16.416 13.3432 15.355 14.2352C14.933 14.5912 14.879 15.2222 15.234 15.6452ZM7.99902 16.0002C7.77102 16.0002 7.54302 15.9232 7.35502 15.7652C5.83602 14.4852 4.99902 12.7932 4.99902 11.0002C4.99902 9.20724 5.83602 7.51524 7.35502 6.23524C7.77702 5.87924 8.40802 5.93324 8.76502 6.35524C9.12002 6.77824 9.06602 7.40924 8.64402 7.76524C7.58302 8.65724 6.99902 9.80724 6.99902 11.0002C6.99902 12.1932 7.58302 13.3432 8.64402 14.2352C9.06602 14.5912 9.12002 15.2222 8.76502 15.6452C8.56702 15.8792 8.28402 16.0002 7.99902 16.0002ZM17.734 17.6442C17.932 17.8792 18.215 18.0002 18.5 18.0002C18.728 18.0002 18.956 17.9232 19.144 17.7652C21.308 15.9432 22.5 13.5412 22.5 11.0002C22.5 8.45924 21.308 6.05724 19.144 4.23524C18.721 3.87924 18.09 3.93324 17.734 4.35624C17.379 4.77824 17.433 5.40924 17.855 5.76524C19.561 7.20024 20.5 9.06024 20.5 11.0002C20.5 12.9402 19.561 14.8002 17.855 16.2352C17.433 16.5912 17.379 17.2222 17.734 17.6442Z",
      fill: color
    }
  ) });
}
var init_shake = __esm({
  "src/icons/salonized/shake.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/settings2.tsx
import { jsx as jsx117 } from "@emotion/react/jsx-runtime";
function Settings2(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx117(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx117(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11.374 20H12.625V19.233C12.625 18.298 13.2 17.458 14.089 17.091C15.009 16.708 16.014 16.896 16.676 17.562L17.215 18.103L18.103 17.215L17.558 16.671C16.895 16.009 16.708 15.005 17.081 14.114C17.081 14.114 17.082 14.113 17.082 14.112L17.093 14.084C17.457 13.201 18.298 12.625 19.233 12.625H19.999V11.375H19.233C18.298 11.375 17.457 10.8 17.091 9.911C16.706 8.991 16.895 7.986 17.561 7.323L18.102 6.784L17.215 5.897L16.67 6.442C16.008 7.104 15.005 7.291 14.114 6.919C13.201 6.542 12.625 5.702 12.625 4.767V4H11.374V4.767C11.374 5.702 10.799 6.542 9.91002 6.909C8.99102 7.294 7.98602 7.105 7.32302 6.438L6.78402 5.897L5.89602 6.785L6.44102 7.329C7.10302 7.991 7.29102 8.995 6.91802 9.886C6.54202 10.799 5.70102 11.375 4.76602 11.375H3.99902V12.625H4.76602C5.70102 12.625 6.54202 13.2 6.90802 14.089C7.29302 15.009 7.10402 16.014 6.43802 16.677L5.89702 17.216L6.78402 18.103L7.32902 17.558C7.99102 16.896 8.99402 16.709 9.88502 17.081C10.798 17.458 11.374 18.298 11.374 19.233V20ZM12.942 22H11.05C10.126 22 9.37402 21.248 9.37402 20.324V19.233C9.37402 19.086 9.25702 18.985 9.14702 18.94C9.00302 18.881 8.84902 18.869 8.74302 18.972L7.97302 19.743C7.31702 20.397 6.25102 20.399 5.59602 19.743L4.25602 18.403C3.93802 18.085 3.76402 17.663 3.76402 17.213C3.76502 16.764 3.94002 16.342 4.25902 16.024L5.02702 15.259C5.13202 15.154 5.12102 15 5.07402 14.889C5.01402 14.742 4.91402 14.625 4.76602 14.625H3.68202C2.75402 14.625 1.99902 13.871 1.99902 12.943V11.051C1.99902 10.126 2.75102 9.375 3.67602 9.375H4.76602C4.91302 9.375 5.01402 9.257 5.05902 9.147C5.11902 9.003 5.13102 8.848 5.02702 8.744L4.25602 7.974C3.60202 7.317 3.60202 6.251 4.25602 5.597L5.59602 4.257C5.91402 3.939 6.33502 3.765 6.78402 3.765H6.78602C7.23502 3.765 7.65802 3.94 7.97502 4.259L8.74002 5.028C8.84502 5.134 9.00002 5.122 9.11102 5.075C9.25702 5.014 9.37402 4.914 9.37402 4.767V3.683C9.37402 2.755 10.129 2 11.057 2H12.949C13.873 2 14.625 2.752 14.625 3.676V4.767C14.625 4.914 14.742 5.015 14.852 5.06C14.997 5.12 15.151 5.133 15.256 5.028L16.026 4.257C16.682 3.603 17.748 3.601 18.403 4.257L19.744 5.598C20.062 5.915 20.236 6.337 20.235 6.787C20.235 7.235 20.06 7.658 19.741 7.975L18.972 8.741C18.867 8.846 18.878 9 18.925 9.111C18.985 9.258 19.085 9.375 19.233 9.375H20.317C21.245 9.375 21.999 10.129 21.999 11.057V12.949C21.999 13.874 21.248 14.625 20.323 14.625H19.233C19.086 14.625 18.985 14.743 18.94 14.853C18.939 14.854 18.927 14.884 18.926 14.886C18.88 14.997 18.868 15.152 18.972 15.256L19.743 16.026C20.397 16.683 20.397 17.749 19.743 18.403L18.403 19.743C18.085 20.061 17.664 20.235 17.215 20.235H17.213C16.764 20.235 16.341 20.06 16.024 19.741L15.259 18.972C15.154 18.867 14.998 18.879 14.888 18.925C14.742 18.986 14.625 19.086 14.625 19.233V20.317C14.625 21.245 13.87 22 12.942 22ZM11.9995 10.5C11.1725 10.5 10.4995 11.173 10.4995 12C10.4995 12.827 11.1725 13.5 11.9995 13.5C12.8265 13.5 13.4995 12.827 13.4995 12C13.4995 11.173 12.8265 10.5 11.9995 10.5ZM11.9995 15.5C10.0695 15.5 8.49952 13.93 8.49952 12C8.49952 10.07 10.0695 8.5 11.9995 8.5C13.9295 8.5 15.4995 10.07 15.4995 12C15.4995 13.93 13.9295 15.5 11.9995 15.5Z",
      fill: color
    }
  ) });
}
var init_settings2 = __esm({
  "src/icons/salonized/settings2.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/settings.tsx
import { jsx as jsx118 } from "@emotion/react/jsx-runtime";
function Settings(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx118(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx118(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M4.40262 11.622C5.51862 12.005 6.40762 12.939 6.77962 14.123L6.81962 14.243C7.24562 15.499 7.07262 16.851 6.35862 17.865C6.22862 18.049 6.25762 18.269 6.39462 18.373L8.46662 19.947C8.53962 20.002 8.61062 20.002 8.65462 19.997C8.70462 19.989 8.77762 19.962 8.83662 19.878L9.06762 19.55C9.75662 18.573 10.8666 17.97 12.0386 17.936C13.3546 17.909 14.5366 18.512 15.2726 19.575L15.3906 19.746C15.4496 19.83 15.5216 19.858 15.5726 19.866C15.6166 19.875 15.6886 19.872 15.7606 19.816L17.8216 18.261C17.9656 18.153 17.9976 17.922 17.8906 17.767L17.6306 17.392C16.9606 16.424 16.7616 15.168 17.0986 14.033C17.4646 12.797 18.3956 11.819 19.5906 11.419L19.7916 11.351C19.9526 11.298 20.0396 11.098 19.9826 10.914L19.1956 8.393C19.1586 8.275 19.0826 8.222 19.0406 8.2C18.9806 8.169 18.9156 8.164 18.8536 8.185L18.5136 8.298C17.3506 8.685 16.0676 8.475 15.0826 7.734L14.9746 7.653C14.0386 6.949 13.4816 5.814 13.4856 4.618L13.4876 4.338C13.4876 4.205 13.4246 4.122 13.3866 4.084C13.3506 4.047 13.2896 4.003 13.2036 4.003L10.6566 4C10.5006 4 10.3736 4.149 10.3726 4.333L10.3716 4.575C10.3666 5.79 9.79762 6.946 8.84962 7.669L8.72062 7.767C7.67762 8.56 6.31762 8.784 5.08562 8.364C5.03862 8.348 4.99462 8.351 4.95262 8.373C4.92062 8.389 4.86262 8.43 4.83462 8.521L4.01762 11.117C3.95862 11.306 4.05562 11.503 4.23862 11.566L4.40262 11.622ZM8.61362 22C8.12762 22 7.65562 21.842 7.25762 21.539L5.18562 19.966C4.19562 19.216 3.97662 17.773 4.69662 16.75C5.07062 16.22 5.14762 15.539 4.92762 14.893L4.87262 14.725C4.68962 14.143 4.27162 13.691 3.75462 13.514H3.75362L3.59062 13.457C2.37262 13.04 1.72262 11.749 2.10962 10.517L2.92562 7.922C3.11062 7.335 3.50962 6.861 4.04962 6.588C4.57762 6.322 5.17462 6.281 5.73262 6.472C6.33162 6.676 6.99662 6.565 7.50962 6.175L7.63862 6.077C8.09462 5.729 8.36962 5.164 8.37162 4.567L8.37262 4.326C8.37762 3.042 9.40262 2 10.6556 2H10.6596L13.2066 2.003C13.8086 2.004 14.3766 2.242 14.8046 2.673C15.2476 3.118 15.4896 3.713 15.4876 4.348L15.4856 4.627C15.4836 5.193 15.7426 5.728 16.1796 6.056L16.2866 6.137C16.7456 6.482 17.3436 6.581 17.8806 6.401L18.2196 6.288C18.7966 6.096 19.4106 6.143 19.9516 6.42C20.5066 6.704 20.9166 7.193 21.1046 7.798L21.8916 10.319C22.2716 11.537 21.6136 12.851 20.4266 13.248L20.2256 13.315C19.6496 13.509 19.1966 13.989 19.0156 14.601C18.8496 15.162 18.9456 15.779 19.2746 16.253L19.5346 16.628C20.2486 17.66 20.0206 19.108 19.0266 19.857L16.9656 21.413C16.4706 21.787 15.8636 21.938 15.2546 21.841C14.6406 21.742 14.1046 21.402 13.7456 20.884L13.6276 20.712C13.2776 20.208 12.7176 19.902 12.1306 19.935C11.5426 19.951 11.0346 20.23 10.7026 20.702L10.4716 21.03C10.1096 21.543 9.57262 21.878 8.96162 21.974C8.84462 21.992 8.72862 22 8.61362 22ZM11.9998 10.4999C11.1728 10.4999 10.4998 11.1729 10.4998 11.9999C10.4998 12.8269 11.1728 13.4999 11.9998 13.4999C12.8268 13.4999 13.4998 12.8269 13.4998 11.9999C13.4998 11.1729 12.8268 10.4999 11.9998 10.4999ZM11.9998 15.4999C10.0698 15.4999 8.49982 13.9299 8.49982 11.9999C8.49982 10.0699 10.0698 8.4999 11.9998 8.4999C13.9298 8.4999 15.4998 10.0699 15.4998 11.9999C15.4998 13.9299 13.9298 15.4999 11.9998 15.4999Z",
      fill: color
    }
  ) });
}
var init_settings = __esm({
  "src/icons/salonized/settings.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/search.tsx
import { jsx as jsx119 } from "@emotion/react/jsx-runtime";
function Search2(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx119(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx119(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M5 11C5 7.691 7.691 5 11 5C14.309 5 17 7.691 17 11C17 14.309 14.309 17 11 17C7.691 17 5 14.309 5 11ZM20.707 19.293L17.312 15.897C18.365 14.543 19 12.846 19 11C19 6.589 15.411 3 11 3C6.589 3 3 6.589 3 11C3 15.411 6.589 19 11 19C12.846 19 14.543 18.365 15.897 17.312L19.293 20.707C19.488 20.902 19.744 21 20 21C20.256 21 20.512 20.902 20.707 20.707C21.098 20.316 21.098 19.684 20.707 19.293Z",
      fill: color
    }
  ) });
}
var init_search2 = __esm({
  "src/icons/salonized/search.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/scissors.tsx
import { jsx as jsx120 } from "@emotion/react/jsx-runtime";
function Scissors(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx120(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx120(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M5.5 18C5.5 18.551 5.948 19 6.5 19C7.052 19 7.5 18.551 7.5 18C7.5 17.449 7.052 17 6.5 17C5.948 17 5.5 17.449 5.5 18ZM5.5 6C5.5 6.551 5.948 7 6.5 7C7.052 7 7.5 6.551 7.5 6C7.5 5.449 7.052 5 6.5 5C5.948 5 5.5 5.449 5.5 6ZM20.206 4.292C20.597 4.682 20.599 5.314 20.208 5.706L9.214 16.74C9.393 17.125 9.5 17.549 9.5 18C9.5 19.654 8.154 21 6.5 21C4.846 21 3.5 19.654 3.5 18C3.5 16.346 4.846 15 6.5 15C6.973 15 7.413 15.12 7.812 15.314L11.1 12.014L7.793 8.707C7.79141 8.70594 7.79066 8.70431 7.78986 8.70257C7.78915 8.70103 7.78841 8.69941 7.787 8.698C7.396 8.886 6.963 9 6.5 9C4.846 9 3.5 7.654 3.5 6C3.5 4.346 4.846 3 6.5 3C8.154 3 9.5 4.346 9.5 6C9.5 6.462 9.386 6.896 9.198 7.287C9.2 7.289 9.202 7.29011 9.204 7.29122C9.205 7.29178 9.206 7.29233 9.207 7.293L12.512 10.597L18.792 4.294C19.182 3.904 19.814 3.902 20.206 4.292ZM13.793 13.293C14.184 12.902 14.816 12.902 15.207 13.293L20.207 18.293C20.598 18.684 20.598 19.316 20.207 19.707C20.012 19.902 19.756 20 19.5 20C19.244 20 18.988 19.902 18.793 19.707L13.793 14.707C13.402 14.316 13.402 13.684 13.793 13.293Z",
      fill: color
    }
  ) });
}
var init_scissors = __esm({
  "src/icons/salonized/scissors.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/save.tsx
import { jsx as jsx121 } from "@emotion/react/jsx-runtime";
function Save(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx121(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx121(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M19 18C19 18.551 18.552 19 18 19H16V16C16 15.448 15.553 15 15 15H9C8.447 15 8 15.448 8 16V19H6C5.448 19 5 18.551 5 18V6C5 5.449 5.448 5 6 5H8V10C8 10.552 8.447 11 9 11H13C13.553 11 14 10.552 14 10C14 9.448 13.553 9 13 9H10V5H13.172C13.435 5 13.692 5.107 13.879 5.293L18.707 10.121C18.896 10.31 19 10.562 19 10.829V18ZM10 19H14V17H10V19ZM20.121 8.707L15.293 3.879C14.727 3.312 13.973 3 13.172 3H6C4.346 3 3 4.346 3 6V18C3 19.654 4.346 21 6 21H9H15H18C19.654 21 21 19.654 21 18V10.829C21 10.027 20.687 9.273 20.121 8.707Z",
      fill: color
    }
  ) });
}
var init_save = __esm({
  "src/icons/salonized/save.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/rewind-right.tsx
import { jsx as jsx122 } from "@emotion/react/jsx-runtime";
function RewindRight(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx122(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx122(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M14.5 15.9083V8.01427L19.322 11.9983L14.5 15.9083ZM6.5 15.9083V8.01427L11.322 11.9983L6.5 15.9083ZM20.858 10.6743L15.759 6.46027C15.15 5.95827 14.282 5.85627 13.55 6.20127C12.902 6.50727 12.5 7.11427 12.5 7.78727V10.3783L7.759 6.46027C7.15 5.95827 6.281 5.85627 5.55 6.20127C4.902 6.50727 4.5 7.11427 4.5 7.78727V16.2133C4.5 16.8863 4.902 17.4933 5.55 17.7993C5.839 17.9343 6.149 18.0013 6.456 18.0013C6.927 18.0013 7.391 17.8443 7.759 17.5393L12.5 13.6233V16.2133C12.5 16.8863 12.902 17.4933 13.55 17.7993C13.839 17.9343 14.149 18.0013 14.456 18.0013C14.927 18.0013 15.391 17.8443 15.759 17.5393L20.859 13.3263C21.266 12.9903 21.5 12.5063 21.5 12.0003C21.5 11.4943 21.266 11.0103 20.858 10.6743Z",
      fill: color
    }
  ) });
}
var init_rewind_right = __esm({
  "src/icons/salonized/rewind-right.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/rewind-left.tsx
import { jsx as jsx123 } from "@emotion/react/jsx-runtime";
function RewindLeft(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx123(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx123(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M17.5 15.9855L12.678 12.0025L17.5 8.09146V15.9855ZM9.5 15.9855L4.678 12.0025L9.5 8.09146V15.9855ZM18.45 6.20146C17.716 5.85646 16.849 5.95846 16.241 6.46146L11.5 10.3775V7.78746C11.5 7.11446 11.098 6.50646 10.45 6.20146C9.716 5.85646 8.849 5.95846 8.241 6.46146L3.141 10.6735C2.734 11.0095 2.5 11.4945 2.5 12.0005C2.5 12.5065 2.734 12.9905 3.142 13.3265L8.241 17.5405C8.609 17.8435 9.073 18.0015 9.544 18.0015C9.851 18.0015 10.161 17.9345 10.45 17.7985C11.098 17.4935 11.5 16.8855 11.5 16.2135V13.6225L16.241 17.5405C16.609 17.8435 17.073 18.0015 17.544 18.0015C17.851 18.0015 18.161 17.9345 18.45 17.7985C19.098 17.4935 19.5 16.8855 19.5 16.2135V7.78746C19.5 7.11446 19.098 6.50646 18.45 6.20146Z",
      fill: color
    }
  ) });
}
var init_rewind_left = __esm({
  "src/icons/salonized/rewind-left.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/repeat.tsx
import { jsx as jsx124 } from "@emotion/react/jsx-runtime";
function Repeat(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx124(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx124(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M5.91425 5.00001H17.9102C19.8892 5.00001 21.5002 6.58301 21.5002 8.52901V11C21.5002 11.553 21.0532 12 20.5002 12C19.9472 12 19.5002 11.553 19.5002 11V8.52901C19.5002 7.68701 18.7872 7.00001 17.9102 7.00001H5.91425L7.20725 8.29301C7.59725 8.68401 7.59725 9.31601 7.20725 9.70701C7.01225 9.90201 6.75625 10 6.50025 10C6.24425 10 5.98825 9.90201 5.79325 9.70701L2.79325 6.70701C2.40225 6.31601 2.40225 5.68401 2.79325 5.29301L5.79325 2.29301C6.18325 1.90201 6.81625 1.90201 7.20725 2.29301C7.59725 2.68401 7.59725 3.31601 7.20725 3.70701L5.91425 5.00001ZM16.793 14.293C17.184 13.902 17.816 13.902 18.207 14.293L21.207 17.293C21.598 17.684 21.598 18.316 21.207 18.707L18.207 21.707C18.012 21.902 17.756 22 17.5 22C17.244 22 16.988 21.902 16.793 21.707C16.402 21.316 16.402 20.684 16.793 20.293L18.086 19H6.09005C4.11005 19 2.50005 17.417 2.50005 15.471V13C2.50005 12.447 2.94805 12 3.50005 12C4.05205 12 4.50005 12.447 4.50005 13V15.471C4.50005 16.314 5.21305 17 6.09005 17H18.086L16.793 15.707C16.402 15.316 16.402 14.684 16.793 14.293Z",
      fill: color
    }
  ) });
}
var init_repeat = __esm({
  "src/icons/salonized/repeat.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/refresh.tsx
import { jsx as jsx125 } from "@emotion/react/jsx-runtime";
function Refresh(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx125(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx125(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M20.303 13.4258C19.777 13.2588 19.215 13.5498 19.047 14.0758C18.11 17.0218 15.352 18.9998 12.184 18.9998C8.222 18.9998 5 15.8598 5 11.9998C5 8.14076 8.222 4.99976 12.184 4.99976C13.912 4.99976 15.542 5.60176 16.829 6.66976L14.663 6.31276C14.113 6.21276 13.603 6.59176 13.513 7.13576C13.423 7.68076 13.792 8.19576 14.337 8.28476L18.583 8.98676C18.638 8.99576 18.694 8.99976 18.747 8.99976C18.866 8.99976 18.982 8.97876 19.09 8.93876C19.127 8.92476 19.157 8.89876 19.193 8.87976C19.259 8.84576 19.328 8.81576 19.385 8.76776C19.421 8.73876 19.444 8.69676 19.475 8.66276C19.522 8.61376 19.572 8.56676 19.607 8.50676C19.632 8.46376 19.642 8.41276 19.661 8.36476C19.685 8.30576 19.717 8.25076 19.729 8.18576L20.483 4.18576C20.585 3.64276 20.228 3.11876 19.685 3.01776C19.144 2.91976 18.619 3.27276 18.517 3.81476L18.245 5.25576C16.581 3.81476 14.448 2.99976 12.184 2.99976C7.12 2.99976 3 7.03676 3 11.9998C3 16.9628 7.12 20.9998 12.184 20.9998C16.226 20.9998 19.75 18.4608 20.953 14.6818C21.12 14.1558 20.829 13.5938 20.303 13.4258Z",
      fill: color
    }
  ) });
}
var init_refresh = __esm({
  "src/icons/salonized/refresh.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/recording.tsx
import { jsx as jsx126 } from "@emotion/react/jsx-runtime";
function Recording(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx126(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx126(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M18 14C16.897 14 16 13.103 16 12C16 10.897 16.897 10 18 10C19.103 10 20 10.897 20 12C20 13.103 19.103 14 18 14ZM4 12C4 10.897 4.897 10 6 10C7.103 10 8 10.897 8 12C8 13.103 7.103 14 6 14C4.897 14 4 13.103 4 12ZM18 8C15.794 8 14 9.794 14 12C14 12.731 14.212 13.409 14.557 14H9.443C9.788 13.409 10 12.731 10 12C10 9.794 8.206 8 6 8C3.794 8 2 9.794 2 12C2 14.206 3.794 16 6 16H18C20.206 16 22 14.206 22 12C22 9.794 20.206 8 18 8Z",
      fill: color
    }
  ) });
}
var init_recording = __esm({
  "src/icons/salonized/recording.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/radio.tsx
import { jsx as jsx127 } from "@emotion/react/jsx-runtime";
function Radio(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx127(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx127(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M3.5 10.9999C3.5 9.0589 4.438 7.1999 6.144 5.7659C6.566 5.4089 6.621 4.7779 6.266 4.3559C5.909 3.9339 5.279 3.8789 4.856 4.2339C2.692 6.0559 1.5 8.4589 1.5 10.9999C1.5 13.5409 2.692 15.9439 4.856 17.7659C5.044 17.9229 5.272 17.9999 5.499 17.9999C5.784 17.9999 6.067 17.8789 6.266 17.6439C6.621 17.2219 6.566 16.5909 6.144 16.2339C4.438 14.7999 3.5 12.9409 3.5 10.9999ZM12 11.9999C11.448 11.9999 11 11.5519 11 10.9999C11 10.4479 11.448 9.9999 12 9.9999C12.552 9.9999 13 10.4479 13 10.9999C13 11.5519 12.552 11.9999 12 11.9999ZM12 7.9999C10.346 7.9999 9 9.3459 9 10.9999C9 12.3139 9.855 13.4219 11.035 13.8259C11.0311 13.8469 11.0255 13.8671 11.02 13.8873L11.02 13.8873L11.02 13.8873L11.02 13.8874C11.0099 13.9238 11 13.96 11 13.9999V19.9999C11 20.5529 11.447 20.9999 12 20.9999C12.553 20.9999 13 20.5529 13 19.9999V13.9999C13 13.96 12.9901 13.9238 12.98 13.8874L12.98 13.8873L12.98 13.8873L12.98 13.8873C12.9745 13.8671 12.9689 13.8469 12.965 13.8259C14.145 13.4219 15 12.3139 15 10.9999C15 9.3459 13.654 7.9999 12 7.9999ZM15.2356 6.3563C15.5896 5.9343 16.2206 5.8783 16.6436 6.2353C18.1636 7.5133 18.9996 9.2063 18.9996 11.0003C18.9996 12.7943 18.1636 14.4863 16.6436 15.7643C16.4566 15.9233 16.2276 16.0003 16.0006 16.0003C15.7156 16.0003 15.4326 15.8793 15.2356 15.6433C14.8786 15.2213 14.9336 14.5903 15.3566 14.2353C16.4156 13.3423 16.9996 12.1933 16.9996 11.0003C16.9996 9.8063 16.4156 8.6573 15.3566 7.7643C14.9336 7.4093 14.8786 6.7783 15.2356 6.3563ZM8.7646 6.3563C8.4106 5.9333 7.7806 5.8773 7.3566 6.2353C5.8366 7.5133 4.9996 9.2063 4.9996 11.0003C4.9996 12.7933 5.8366 14.4863 7.3566 15.7643C7.5436 15.9223 7.7726 16.0003 7.9986 16.0003C8.2846 16.0003 8.5676 15.8783 8.7646 15.6433C9.1206 15.2213 9.0666 14.5903 8.6436 14.2353C7.5836 13.3423 6.9996 12.1933 6.9996 11.0003C6.9996 9.8063 7.5836 8.6573 8.6436 7.7643C9.0666 7.4093 9.1206 6.7783 8.7646 6.3563ZM17.7346 4.3563C18.0906 3.9343 18.7196 3.8803 19.1436 4.2343C21.3076 6.0553 22.4996 8.4593 22.4996 11.0003C22.4996 13.5413 21.3076 15.9443 19.1436 17.7653C18.9566 17.9223 18.7276 18.0003 18.5006 18.0003C18.2156 18.0003 17.9326 17.8793 17.7346 17.6433C17.3786 17.2213 17.4336 16.5903 17.8566 16.2343C19.5616 14.7993 20.4996 12.9413 20.4996 11.0003C20.4996 9.0583 19.5616 7.2003 17.8566 5.7653C17.4336 5.4093 17.3786 4.7783 17.7346 4.3563Z",
      fill: color
    }
  ) });
}
var init_radio = __esm({
  "src/icons/salonized/radio.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/radio-button-on.tsx
import { jsx as jsx128 } from "@emotion/react/jsx-runtime";
function RadioButtonOn(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx128(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx128(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12 15C10.346 15 9 13.654 9 12C9 10.346 10.346 9 12 9C13.654 9 15 10.346 15 12C15 13.654 13.654 15 12 15ZM12 7C9.243 7 7 9.243 7 12C7 14.757 9.243 17 12 17C14.757 17 17 14.757 17 12C17 9.243 14.757 7 12 7ZM12 20C7.589 20 4 16.411 4 12C4 7.589 7.589 4 12 4C16.411 4 20 7.589 20 12C20 16.411 16.411 20 12 20ZM12 2C6.486 2 2 6.486 2 12C2 17.514 6.486 22 12 22C17.514 22 22 17.514 22 12C22 6.486 17.514 2 12 2Z",
      fill: color
    }
  ) });
}
var init_radio_button_on = __esm({
  "src/icons/salonized/radio-button-on.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/radio-button-off.tsx
import { jsx as jsx129 } from "@emotion/react/jsx-runtime";
function RadioButtonOff(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx129(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx129(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12 4C7.589 4 4 7.589 4 12C4 16.411 7.589 20 12 20C16.411 20 20 16.411 20 12C20 7.589 16.411 4 12 4ZM12 22C6.486 22 2 17.514 2 12C2 6.486 6.486 2 12 2C17.514 2 22 6.486 22 12C22 17.514 17.514 22 12 22Z",
      fill: color
    }
  ) });
}
var init_radio_button_off = __esm({
  "src/icons/salonized/radio-button-off.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/question-mark.tsx
import { jsx as jsx130 } from "@emotion/react/jsx-runtime";
function QuestionMark(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx130(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx130(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12 4C14.757 4 17 6.243 17 9C17 11.414 15.279 13.435 13 13.898V15C13 15.553 12.553 16 12 16C11.447 16 11 15.553 11 15V13C11 12.447 11.447 12 12 12C13.654 12 15 10.654 15 9C15 7.346 13.654 6 12 6C10.346 6 9 7.346 9 9C9 9.553 8.553 10 8 10C7.447 10 7 9.553 7 9C7 6.243 9.243 4 12 4ZM11 19C11 18.447 11.447 18 12 18C12.553 18 13 18.447 13 19C13 19.553 12.553 20 12 20C11.447 20 11 19.553 11 19Z",
      fill: color
    }
  ) });
}
var init_question_mark = __esm({
  "src/icons/salonized/question-mark.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/question-mark-circle.tsx
import { jsx as jsx131 } from "@emotion/react/jsx-runtime";
function QuestionMarkCircle(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx131(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx131(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8.5 9.5C8.5 7.57 10.07 6 12 6C13.93 6 15.5 7.57 15.5 9.5C15.5 11.08 14.44 12.403 13 12.837V14C13 14.553 12.553 15 12 15C11.447 15 11 14.553 11 14V12C11 11.447 11.447 11 12 11C12.827 11 13.5 10.327 13.5 9.5C13.5 8.673 12.827 8 12 8C11.173 8 10.5 8.673 10.5 9.5C10.5 10.053 10.053 10.5 9.5 10.5C8.947 10.5 8.5 10.053 8.5 9.5ZM11 17C11 16.447 11.447 16 12 16C12.553 16 13 16.447 13 17C13 17.553 12.553 18 12 18C11.447 18 11 17.553 11 17ZM12 20C7.589 20 4 16.411 4 12C4 7.589 7.589 4 12 4C16.411 4 20 7.589 20 12C20 16.411 16.411 20 12 20ZM12 2C6.486 2 2 6.486 2 12C2 17.514 6.486 22 12 22C17.514 22 22 17.514 22 12C22 6.486 17.514 2 12 2Z",
      fill: color
    }
  ) });
}
var init_question_mark_circle = __esm({
  "src/icons/salonized/question-mark-circle.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/printer.tsx
import { jsx as jsx132 } from "@emotion/react/jsx-runtime";
function Printer(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx132(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx132(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M20 16.333C20 16.701 19.715 17 19.363 17H18.5V15C18.5 13.897 17.603 13 16.5 13H7.5C6.397 13 5.5 13.897 5.5 15V17H4.637C4.285 17 4 16.701 4 16.333V9.667C4 9.299 4.285 9 4.637 9H6H8H16H18H19.363C19.715 9 20 9.299 20 9.667V16.333ZM7.5 19V15H16.5L16.502 19H7.5ZM8.014 5H16V7H8.007L8.014 5ZM19.363 7H18V5C18 3.897 17.178 3 16.167 3H7.833C6.822 3 6 3.897 6 5V7H4.637C3.183 7 2 8.196 2 9.667V16.333C2 17.804 3.183 19 4.637 19H5.5C5.5 20.103 6.397 21 7.5 21H16.5C17.603 21 18.5 20.103 18.5 19H19.363C20.817 19 22 17.804 22 16.333V9.667C22 8.196 20.817 7 19.363 7Z",
      fill: color
    }
  ) });
}
var init_printer = __esm({
  "src/icons/salonized/printer.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/pricetag.tsx
import { jsx as jsx133 } from "@emotion/react/jsx-runtime";
function Pricetag(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx133(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx133(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10.5607 8.43938C11.1467 9.02438 11.1467 9.97538 10.5607 10.5604C9.97467 11.1464 9.02567 11.1464 8.43967 10.5604C7.85367 9.97538 7.85367 9.02438 8.43967 8.43938C9.02567 7.85338 9.97467 7.85338 10.5607 8.43938ZM5.83417 12.8915L11.8662 18.9245L18.9242 11.8665L12.8922 5.83348L5.10717 5.10748L5.83417 12.8915ZM11.8662 20.9985C11.4012 20.9985 10.9372 20.8215 10.5822 20.4685L4.16517 14.0505C4.00017 13.8865 3.89817 13.6685 3.87617 13.4365L3.00417 4.09248C2.97717 3.79648 3.08217 3.50348 3.29317 3.29248C3.50417 3.08148 3.79617 2.97448 4.09317 3.00448L13.4372 3.87648C13.6692 3.89748 13.8862 3.99948 14.0512 4.16448L20.4682 10.5815C20.8112 10.9245 21.0002 11.3805 21.0002 11.8665C21.0002 12.3525 20.8112 12.8085 20.4682 13.1515L13.1512 20.4675C12.7972 20.8215 12.3322 20.9985 11.8662 20.9985Z",
      fill: color
    }
  ) });
}
var init_pricetag = __esm({
  "src/icons/salonized/pricetag.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/power.tsx
import { jsx as jsx134 } from "@emotion/react/jsx-runtime";
function Power(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx134(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx134(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M13.0001 12C13.0001 12.553 12.5521 13 12.0001 13C11.4481 13 11.0001 12.553 11.0001 12V2C11.0001 1.447 11.4481 1 12.0001 1C12.5521 1 13.0001 1.447 13.0001 2V12ZM15.239 3.5413C15.492 3.0503 16.096 2.8593 16.586 3.1113C19.925 4.8383 22 8.2433 22 12.0003C22 17.5133 17.514 22.0003 12 22.0003C6.486 22.0003 2 17.5133 2 12.0003C2 8.2433 4.075 4.8383 7.415 3.1113C7.904 2.8583 8.508 3.0493 8.762 3.5413C9.016 4.0313 8.823 4.6343 8.333 4.8883C5.66 6.2693 4 8.9943 4 12.0003C4 16.4113 7.589 20.0003 12 20.0003C16.411 20.0003 20 16.4113 20 12.0003C20 8.9943 18.34 6.2693 15.668 4.8883C15.177 4.6343 14.985 4.0313 15.239 3.5413Z",
      fill: color
    }
  ) });
}
var init_power = __esm({
  "src/icons/salonized/power.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/plus.tsx
import { jsx as jsx135 } from "@emotion/react/jsx-runtime";
function Plus(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx135(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx135(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M19 11H13V5C13 4.447 12.552 4 12 4C11.448 4 11 4.447 11 5V11H5C4.448 11 4 11.447 4 12C4 12.553 4.448 13 5 13H11V19C11 19.553 11.448 20 12 20C12.552 20 13 19.553 13 19V13H19C19.552 13 20 12.553 20 12C20 11.447 19.552 11 19 11Z",
      fill: color
    }
  ) });
}
var init_plus = __esm({
  "src/icons/salonized/plus.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/plus-square.tsx
import { jsx as jsx136 } from "@emotion/react/jsx-runtime";
function PlusSquare(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx136(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx136(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M15 11H13V9C13 8.45 12.55 8 12 8C11.45 8 11 8.45 11 9V11H9C8.45 11 8 11.45 8 12C8 12.55 8.45 13 9 13H11V15C11 15.55 11.45 16 12 16C12.55 16 13 15.55 13 15V13H15C15.55 13 16 12.55 16 12C16 11.45 15.55 11 15 11ZM19 18C19 18.551 18.552 19 18 19H6C5.448 19 5 18.551 5 18V6C5 5.449 5.448 5 6 5H18C18.552 5 19 5.449 19 6V18ZM18 3H6C4.346 3 3 4.346 3 6V18C3 19.654 4.346 21 6 21H18C19.654 21 21 19.654 21 18V6C21 4.346 19.654 3 18 3Z",
      fill: color
    }
  ) });
}
var init_plus_square = __esm({
  "src/icons/salonized/plus-square.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/plus-circle.tsx
import { jsx as jsx137 } from "@emotion/react/jsx-runtime";
function PlusCircle(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx137(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx137(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M15 11H13V9C13 8.45 12.55 8 12 8C11.45 8 11 8.45 11 9V11H9C8.45 11 8 11.45 8 12C8 12.55 8.45 13 9 13H11V15C11 15.55 11.45 16 12 16C12.55 16 13 15.55 13 15V13H15C15.55 13 16 12.55 16 12C16 11.45 15.55 11 15 11ZM12 20C7.589 20 4 16.411 4 12C4 7.589 7.589 4 12 4C16.411 4 20 7.589 20 12C20 16.411 16.411 20 12 20ZM12 2C6.486 2 2 6.486 2 12C2 17.514 6.486 22 12 22C17.514 22 22 17.514 22 12C22 6.486 17.514 2 12 2Z",
      fill: color
    }
  ) });
}
var init_plus_circle = __esm({
  "src/icons/salonized/plus-circle.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/play-circle.tsx
import { jsx as jsx138 } from "@emotion/react/jsx-runtime";
function PlayCircle(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx138(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx138(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11.5 14.5996V9.4006L14.309 11.9996L11.5 14.5996ZM12.339 7.4526C11.841 6.9906 11.114 6.8706 10.488 7.1456C9.878 7.4116 9.5 7.9806 9.5 8.6296V15.3706C9.5 16.0196 9.878 16.5886 10.488 16.8546C10.711 16.9526 10.948 16.9996 11.181 16.9996C11.604 16.9996 12.019 16.8446 12.338 16.5486L15.98 13.1786C16.311 12.8726 16.5 12.4436 16.5 11.9996C16.5 11.5566 16.311 11.1266 15.98 10.8216L12.339 7.4526ZM12 20C7.589 20 4 16.411 4 12C4 7.589 7.589 4 12 4C16.411 4 20 7.589 20 12C20 16.411 16.411 20 12 20ZM12 2C6.486 2 2 6.486 2 12C2 17.514 6.486 22 12 22C17.514 22 22 17.514 22 12C22 6.486 17.514 2 12 2Z",
      fill: color
    }
  ) });
}
var init_play_circle = __esm({
  "src/icons/salonized/play-circle.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/pin.tsx
import { jsx as jsx139 } from "@emotion/react/jsx-runtime";
function Pin(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx139(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx139(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12 10.9995C11.173 10.9995 10.5 10.3265 10.5 9.4995C10.5 8.6725 11.173 7.9995 12 7.9995C12.827 7.9995 13.5 8.6725 13.5 9.4995C13.5 10.3265 12.827 10.9995 12 10.9995ZM12 5.9995C10.07 5.9995 8.5 7.5695 8.5 9.4995C8.5 11.4295 10.07 12.9995 12 12.9995C13.93 12.9995 15.5 11.4295 15.5 9.4995C15.5 7.5695 13.93 5.9995 12 5.9995ZM12 19.646C10.325 18.062 6 13.615 6 9.922C6 6.657 8.691 4 12 4C15.309 4 18 6.657 18 9.922C18 13.615 13.675 18.062 12 19.646ZM12 2C7.589 2 4 5.553 4 9.922C4 15.397 11.049 21.501 11.349 21.758C11.537 21.919 11.768 22 12 22C12.232 22 12.463 21.919 12.651 21.758C12.951 21.501 20 15.397 20 9.922C20 5.553 16.411 2 12 2Z",
      fill: color
    }
  ) });
}
var init_pin = __esm({
  "src/icons/salonized/pin.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/pie-chart.tsx
import { jsx as jsx140 } from "@emotion/react/jsx-runtime";
function PieChart(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx140(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx140(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M20.821 14.0576C20.298 13.8716 19.728 14.1446 19.545 14.6666C18.417 17.8566 15.384 19.9996 12 19.9996C7.589 19.9996 4 16.4116 4 11.9996C4 8.6156 6.143 5.5826 9.333 4.4546C9.854 4.2716 10.127 3.7006 9.943 3.1796C9.759 2.6596 9.188 2.3856 8.667 2.5706C4.679 3.9796 2 7.7686 2 11.9996C2 17.5136 6.486 21.9996 12 21.9996C16.231 21.9996 20.02 19.3216 21.43 15.3326C21.614 14.8126 21.342 14.2416 20.821 14.0576ZM13.9997 10V4.071C17.0607 4.511 19.4887 6.938 19.9287 10H13.9997ZM12.9997 2C12.4477 2 11.9997 2.447 11.9997 3V11C11.9997 11.553 12.4477 12 12.9997 12H20.9997C21.5517 12 21.9997 11.553 21.9997 11C21.9997 6.037 17.9617 2 12.9997 2Z",
      fill: color
    }
  ) });
}
var init_pie_chart = __esm({
  "src/icons/salonized/pie-chart.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/phone.tsx
import { jsx as jsx141 } from "@emotion/react/jsx-runtime";
function Phone(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx141(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx141(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M6.6 4C5.166 4 4 5.166 4 6.6C4 13.988 10.011 20 17.4 20C18.833 20 20 18.834 20 17.4C20 17.289 19.993 17.18 19.979 17.072L15.359 16.012C15.267 16.188 15.166 16.379 15.074 16.557C14.618 17.427 14.288 18.059 13.446 17.72C10.14 16.56 7.441 13.86 6.266 10.514C5.909 9.729 6.589 9.373 7.451 8.923C7.626 8.831 7.815 8.732 7.988 8.642L6.928 4.021C6.817 4.007 6.709 4 6.6 4ZM17.4 22C8.908 22 2 15.092 2 6.6C2 4.063 4.063 2 6.6 2C6.86 2 7.117 2.022 7.366 2.065C7.609 2.104 7.853 2.166 8.091 2.248C8.416 2.361 8.661 2.634 8.738 2.97L10.107 8.934C10.183 9.262 10.088 9.606 9.854 9.85C9.718 9.992 9.715 9.995 8.475 10.644C9.479 12.818 11.224 14.557 13.354 15.527C14.004 14.286 14.008 14.282 14.15 14.146C14.394 13.912 14.74 13.821 15.066 13.893L21.031 15.262C21.366 15.339 21.639 15.583 21.751 15.908C21.833 16.144 21.895 16.388 21.936 16.639C21.978 16.886 22 17.142 22 17.4C22 19.937 19.936 22 17.4 22Z",
      fill: color
    }
  ) });
}
var init_phone = __esm({
  "src/icons/salonized/phone.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/phone-off.tsx
import { jsx as jsx142 } from "@emotion/react/jsx-runtime";
function PhoneOff(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx142(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx142(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M6.698 14.63C5.012 12.389 4 9.613 4 6.6C4 5.166 5.166 4 6.599 4C6.709 4 6.817 4.007 6.927 4.022L7.988 8.642L7.8178 8.7308L7.81741 8.731C7.69249 8.79612 7.56471 8.86273 7.443 8.927C6.572 9.382 5.943 9.711 6.265 10.514C6.641 11.584 7.186 12.576 7.844 13.484L9.273 12.055C8.971 11.609 8.701 11.139 8.474 10.645C9.714 9.995 9.718 9.992 9.854 9.85C10.088 9.607 10.182 9.262 10.107 8.934L8.738 2.97C8.661 2.634 8.417 2.361 8.092 2.249C7.854 2.166 7.608 2.105 7.365 2.066C7.116 2.023 6.86 2 6.599 2C4.063 2 2 4.064 2 6.6C2 10.166 3.229 13.443 5.271 16.057L6.698 14.63ZM19.7391 4.2608C19.3921 3.9128 18.8301 3.9128 18.4821 4.2608L4.2601 18.4828C4.0871 18.6568 4.0001 18.8838 4.0001 19.1118C4.0001 19.3388 4.0871 19.5668 4.2601 19.7398C4.6071 20.0868 5.1701 20.0868 5.5171 19.7398L19.7391 5.5178C20.0871 5.1698 20.0871 4.6078 19.7391 4.2608ZM21.7503 15.9088C21.8323 16.1438 21.8953 16.3888 21.9353 16.6388C21.9773 16.8868 21.9993 17.1418 21.9993 17.4008C21.9993 19.9368 19.9363 21.9998 17.4003 21.9998C13.8333 21.9998 10.5563 20.7708 7.9433 18.7288L9.3703 17.3018C11.6113 18.9878 14.3863 19.9998 17.4003 19.9998C18.8333 19.9998 19.9993 18.8338 19.9993 17.4008C19.9993 17.2888 19.9933 17.1798 19.9783 17.0728L15.3583 16.0118L15.0733 16.5568L15.0686 16.5657C14.616 17.4311 14.2884 18.0576 13.4463 17.7198C12.3933 17.3508 11.4133 16.8108 10.5123 16.1588L11.9423 14.7288C12.3893 15.0328 12.8603 15.3028 13.3543 15.5278C14.0034 14.2865 14.0073 14.2828 14.1497 14.1464L14.1503 14.1458C14.3933 13.9118 14.7373 13.8198 15.0663 13.8928L21.0303 15.2618C21.3663 15.3388 21.6383 15.5828 21.7503 15.9088Z",
      fill: color
    }
  ) });
}
var init_phone_off = __esm({
  "src/icons/salonized/phone-off.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/phone-missed.tsx
import { jsx as jsx143 } from "@emotion/react/jsx-runtime";
function PhoneMissed(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx143(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx143(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M4 6.6C4 13.988 10.011 20 17.4 20C18.834 20 20 18.834 20 17.4C20 17.289 19.993 17.18 19.978 17.072L15.358 16.012C15.3168 16.0903 15.2743 16.172 15.2314 16.2543C15.1784 16.356 15.1249 16.4586 15.073 16.557L15.0644 16.5734C14.6139 17.4349 14.2887 18.0569 13.446 17.72C10.139 16.56 7.44 13.86 6.265 10.514C5.943 9.711 6.572 9.382 7.443 8.927C7.621 8.833 7.812 8.733 7.988 8.642L6.927 4.021C6.817 4.007 6.709 4 6.599 4C5.166 4 4 5.166 4 6.6ZM21.751 15.908C21.833 16.144 21.895 16.389 21.935 16.639C21.977 16.887 22 17.142 22 17.4C22 19.937 19.936 22 17.4 22C8.908 22 2 15.092 2 6.6C2 4.063 4.063 2 6.599 2C6.86 2 7.116 2.022 7.365 2.065C7.608 2.104 7.854 2.166 8.091 2.249C8.417 2.361 8.661 2.634 8.738 2.97L10.107 8.934C10.182 9.262 10.088 9.606 9.854 9.85C9.717 9.992 9.713 9.995 8.474 10.645C9.465 12.807 11.214 14.553 13.354 15.527C14.004 14.285 14.007 14.282 14.15 14.146C14.393 13.912 14.737 13.819 15.066 13.893L21.03 15.262C21.366 15.339 21.638 15.583 21.751 15.908ZM17.2674 8.6982C16.8634 9.1002 16.2044 9.1002 15.8014 8.6982C15.3994 8.2952 15.3994 7.6362 15.8014 7.2322L16.5344 6.5002L15.8014 5.7672C15.3994 5.3642 15.3994 4.7052 15.8014 4.3022C16.2044 3.8992 16.8634 3.8992 17.2674 4.3022L17.9994 5.0352L18.7324 4.3022C19.1354 3.8992 19.7944 3.8992 20.1974 4.3022C20.6004 4.7052 20.6004 5.3642 20.1974 5.7672L19.4644 6.5002L20.1974 7.2322C20.6004 7.6362 20.6004 8.2952 20.1974 8.6982C19.7944 9.1002 19.1354 9.1002 18.7324 8.6982L17.9994 7.9652L17.2674 8.6982Z",
      fill: color
    }
  ) });
}
var init_phone_missed = __esm({
  "src/icons/salonized/phone-missed.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/phone-call.tsx
import { jsx as jsx144 } from "@emotion/react/jsx-runtime";
function PhoneCall(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx144(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx144(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M17.4 20C10.011 20 4 13.988 4 6.6C4 5.166 5.166 4 6.6 4C6.709 4 6.817 4.007 6.927 4.021L7.988 8.642C7.8567 8.71031 7.71619 8.7838 7.57913 8.85547L7.45 8.923C6.588 9.373 5.908 9.729 6.265 10.514C7.441 13.86 10.14 16.56 13.446 17.72C14.2883 18.0575 14.6151 17.4325 15.067 16.5684L15.073 16.557C15.1249 16.4586 15.1784 16.356 15.2314 16.2543C15.2743 16.172 15.3168 16.0903 15.358 16.012L19.978 17.072C19.993 17.18 20 17.289 20 17.4C20 18.834 18.834 20 17.4 20ZM21.751 15.908C21.638 15.583 21.366 15.339 21.03 15.262L15.066 13.893C14.737 13.819 14.393 13.912 14.15 14.146C14.007 14.282 14.004 14.286 13.354 15.527C11.224 14.557 9.479 12.818 8.475 10.644C9.714 9.995 9.717 9.992 9.854 9.85C10.088 9.606 10.182 9.262 10.107 8.934L8.738 2.97C8.661 2.634 8.416 2.361 8.091 2.248C7.853 2.166 7.608 2.104 7.366 2.065C7.117 2.022 6.86 2 6.6 2C4.063 2 2 4.063 2 6.6C2 15.092 8.908 22 17.4 22C19.936 22 22 19.937 22 17.4C22 17.142 21.977 16.887 21.935 16.639C21.895 16.389 21.833 16.144 21.751 15.908ZM12.9996 8C14.6536 8 15.9996 9.346 15.9996 11C15.9996 11.553 16.4466 12 16.9996 12C17.5526 12 17.9996 11.553 17.9996 11C17.9996 8.243 15.7566 6 12.9996 6C12.4476 6 11.9996 6.447 11.9996 7C11.9996 7.553 12.4476 8 12.9996 8ZM19.9996 11C19.9996 7.141 16.8586 4 12.9996 4C12.4476 4 11.9996 3.553 11.9996 3C11.9996 2.447 12.4476 2 12.9996 2C17.9626 2 21.9996 6.037 21.9996 11C21.9996 11.553 21.5526 12 20.9996 12C20.4466 12 19.9996 11.553 19.9996 11Z",
      fill: color
    }
  ) });
}
var init_phone_call = __esm({
  "src/icons/salonized/phone-call.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/person.tsx
import { jsx as jsx145 } from "@emotion/react/jsx-runtime";
function Person2(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx145(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx145(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M14 7C14 5.897 13.103 5 12 5C10.897 5 10 5.897 10 7C10 8.103 10.897 9 12 9C13.103 9 14 8.103 14 7ZM16 7C16 9.206 14.206 11 12 11C9.794 11 8 9.206 8 7C8 4.794 9.794 3 12 3C14.206 3 16 4.794 16 7ZM5 20C5 16.14 8.141 13 12 13C15.859 13 19 16.14 19 20C19 20.552 18.553 21 18 21C17.447 21 17 20.552 17 20C17 17.243 14.757 15 12 15C9.243 15 7 17.243 7 20C7 20.552 6.553 21 6 21C5.447 21 5 20.552 5 20Z",
      fill: color
    }
  ) });
}
var init_person2 = __esm({
  "src/icons/salonized/person.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/person-remove.tsx
import { jsx as jsx146 } from "@emotion/react/jsx-runtime";
function PersonRemove(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx146(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx146(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10 5C11.103 5 12 5.897 12 7C12 8.103 11.103 9 10 9C8.897 9 8 8.103 8 7C8 5.897 8.897 5 10 5ZM10 11C12.206 11 14 9.206 14 7C14 4.794 12.206 3 10 3C7.794 3 6 4.794 6 7C6 9.206 7.794 11 10 11ZM21 6H17C16.45 6 16 6.45 16 7C16 7.55 16.45 8 17 8H21C21.55 8 22 7.55 22 7C22 6.45 21.55 6 21 6ZM3 20C3 16.14 6.141 13 10 13C13.859 13 17 16.14 17 20C17 20.552 16.553 21 16 21C15.447 21 15 20.552 15 20C15 17.243 12.757 15 10 15C7.243 15 5 17.243 5 20C5 20.552 4.553 21 4 21C3.447 21 3 20.552 3 20Z",
      fill: color
    }
  ) });
}
var init_person_remove = __esm({
  "src/icons/salonized/person-remove.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/person-done.tsx
import { jsx as jsx147 } from "@emotion/react/jsx-runtime";
function PersonDone(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx147(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx147(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10 5C11.103 5 12 5.897 12 7C12 8.103 11.103 9 10 9C8.897 9 8 8.103 8 7C8 5.897 8.897 5 10 5ZM10 11C12.206 11 14 9.206 14 7C14 4.794 12.206 3 10 3C7.794 3 6 4.794 6 7C6 9.206 7.794 11 10 11ZM21.6562 4.2456C21.2392 3.8836 20.6082 3.9266 20.2452 4.3436L18.3792 6.4886L17.7452 5.7796C17.3782 5.3676 16.7462 5.3326 16.3332 5.7016C15.9222 6.0696 15.8862 6.7026 16.2552 7.1136L17.6442 8.6666C17.8342 8.8786 18.1052 8.9996 18.3892 8.9996H18.3962C18.6832 8.9976 18.9562 8.8726 19.1442 8.6566L21.7552 5.6566C22.1172 5.2396 22.0732 4.6076 21.6562 4.2456ZM3 20C3 16.14 6.141 13 10 13C13.859 13 17 16.14 17 20C17 20.552 16.553 21 16 21C15.447 21 15 20.552 15 20C15 17.243 12.757 15 10 15C7.243 15 5 17.243 5 20C5 20.552 4.553 21 4 21C3.447 21 3 20.552 3 20Z",
      fill: color
    }
  ) });
}
var init_person_done = __esm({
  "src/icons/salonized/person-done.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/person-delete.tsx
import { jsx as jsx148 } from "@emotion/react/jsx-runtime";
function PersonDelete(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx148(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx148(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10 5C11.103 5 12 5.897 12 7C12 8.103 11.103 9 10 9C8.897 9 8 8.103 8 7C8 5.897 8.897 5 10 5ZM10 11C12.206 11 14 9.206 14 7C14 4.794 12.206 3 10 3C7.794 3 6 4.794 6 7C6 9.206 7.794 11 10 11ZM20.4648 7.5L21.1978 6.768C21.6008 6.364 21.6008 5.705 21.1978 5.302C20.7948 4.899 20.1358 4.899 19.7328 5.302L18.9998 6.035L18.2678 5.302C17.8638 4.899 17.2048 4.899 16.8018 5.302C16.3998 5.705 16.3998 6.364 16.8018 6.768L17.5348 7.5L16.8018 8.232C16.3998 8.636 16.3998 9.295 16.8018 9.698C17.2048 10.101 17.8638 10.101 18.2678 9.698L18.9998 8.965L19.7328 9.698C20.1358 10.101 20.7948 10.101 21.1978 9.698C21.6008 9.295 21.6008 8.636 21.1978 8.232L20.4648 7.5ZM3 20C3 16.141 6.141 13 10 13C13.859 13 17 16.141 17 20C17 20.553 16.553 21 16 21C15.447 21 15 20.553 15 20C15 17.243 12.757 15 10 15C7.243 15 5 17.243 5 20C5 20.553 4.553 21 4 21C3.447 21 3 20.553 3 20Z",
      fill: color
    }
  ) });
}
var init_person_delete = __esm({
  "src/icons/salonized/person-delete.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/percent.tsx
import { jsx as jsx149 } from "@emotion/react/jsx-runtime";
function Percent(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx149(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx149(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M19.74 4.26076C19.393 3.91276 18.83 3.91276 18.483 4.26076L4.261 18.4828C4.087 18.6568 4 18.8838 4 19.1118C4 19.3388 4.087 19.5668 4.261 19.7398C4.608 20.0868 5.17 20.0868 5.518 19.7398L19.74 5.51776C20.087 5.16976 20.087 4.60776 19.74 4.26076ZM16.0003 19.0001C15.1733 19.0001 14.5003 18.3271 14.5003 17.5001C14.5003 16.6731 15.1733 16.0001 16.0003 16.0001C16.8273 16.0001 17.5003 16.6731 17.5003 17.5001C17.5003 18.3271 16.8273 19.0001 16.0003 19.0001ZM16.0003 14.0001C14.0703 14.0001 12.5003 15.5701 12.5003 17.5001C12.5003 19.4301 14.0703 21.0001 16.0003 21.0001C17.9303 21.0001 19.5003 19.4301 19.5003 17.5001C19.5003 15.5701 17.9303 14.0001 16.0003 14.0001ZM8.0003 6.00006C8.8273 6.00006 9.5003 6.67306 9.5003 7.50006C9.5003 8.32706 8.8273 9.00006 8.0003 9.00006C7.1733 9.00006 6.5003 8.32706 6.5003 7.50006C6.5003 6.67306 7.1733 6.00006 8.0003 6.00006ZM8.0003 11.0001C9.9303 11.0001 11.5003 9.43006 11.5003 7.50006C11.5003 5.57006 9.9303 4.00006 8.0003 4.00006C6.0703 4.00006 4.5003 5.57006 4.5003 7.50006C4.5003 9.43006 6.0703 11.0001 8.0003 11.0001Z",
      fill: color
    }
  ) });
}
var init_percent = __esm({
  "src/icons/salonized/percent.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/people.tsx
import { jsx as jsx150 } from "@emotion/react/jsx-runtime";
function People(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx150(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx150(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M18 10C18 9.449 17.552 9 17 9C16.448 9 16 9.449 16 10C16 10.551 16.448 11 17 11C17.552 11 18 10.551 18 10ZM20 10C20 11.654 18.654 13 17 13C15.346 13 14 11.654 14 10C14 8.346 15.346 7 17 7C18.654 7 20 8.346 20 10ZM11 7C11 5.897 10.103 5 9 5C7.897 5 7 5.897 7 7C7 8.103 7.897 9 9 9C10.103 9 11 8.103 11 7ZM13 7C13 9.206 11.206 11 9 11C6.794 11 5 9.206 5 7C5 4.794 6.794 3 9 3C11.206 3 13 4.794 13 7ZM13.94 15.046C14.809 14.374 15.879 14 17 14C19.757 14 22 16.243 22 19C22 19.552 21.553 20 21 20C20.447 20 20 19.552 20 19C20 17.346 18.654 16 17 16C16.317 16 15.668 16.234 15.144 16.649C15.688 17.645 16 18.787 16 20C16 20.552 15.553 21 15 21C14.447 21 14 20.552 14 20C14 17.243 11.757 15 9 15C6.243 15 4 17.243 4 20C4 20.552 3.553 21 3 21C2.447 21 2 20.552 2 20C2 16.14 5.141 13 9 13C10.927 13 12.673 13.783 13.94 15.046Z",
      fill: color
    }
  ) });
}
var init_people = __esm({
  "src/icons/salonized/people.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/pause-circle.tsx
import { jsx as jsx151 } from "@emotion/react/jsx-runtime";
function PauseCircle(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx151(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx151(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8 9C8 8.45 8.45 8 9 8C9.55 8 10 8.45 10 9V15C10 15.55 9.55 16 9 16C8.45 16 8 15.55 8 15V9ZM13.9995 9C13.9995 8.45 14.4495 8 14.9995 8C15.5495 8 15.9995 8.45 15.9995 9V15C15.9995 15.55 15.5495 16 14.9995 16C14.4495 16 13.9995 15.55 13.9995 15V9ZM12 20C7.589 20 4 16.411 4 12C4 7.589 7.589 4 12 4C16.411 4 20 7.589 20 12C20 16.411 16.411 20 12 20ZM12 2C6.486 2 2 6.486 2 12C2 17.514 6.486 22 12 22C17.514 22 22 17.514 22 12C22 6.486 17.514 2 12 2Z",
      fill: color
    }
  ) });
}
var init_pause_circle = __esm({
  "src/icons/salonized/pause-circle.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/paper-plane.tsx
import { jsx as jsx152 } from "@emotion/react/jsx-runtime";
function PaperPlane(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx152(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx152(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M15 17.8379L13.144 12.2709L18.712 6.70193L15 17.8379ZM17.298 5.28793L11.73 10.8559L6.162 8.99993L17.298 5.28793ZM21.99 2.94793C21.985 2.85493 21.968 2.76493 21.937 2.67793C21.927 2.64693 21.916 2.61693 21.902 2.58693C21.854 2.47993 21.793 2.37893 21.707 2.29293C21.621 2.20693 21.52 2.14593 21.412 2.09793C21.383 2.08393 21.354 2.07293 21.323 2.06293C21.234 2.03193 21.143 2.01393 21.048 2.00893C21.026 2.00793 21.006 2.00293 20.983 2.00293C20.883 2.00493 20.782 2.01893 20.684 2.05093L2.684 8.05093C2.275 8.18793 2 8.56893 2 8.99993C2 9.43093 2.275 9.81293 2.684 9.94893L11.209 12.7909L14.052 21.3169C14.188 21.7249 14.569 21.9999 15 21.9999C15.431 21.9999 15.812 21.7249 15.948 21.3169L21.948 3.31693C21.98 3.21793 21.995 3.11793 21.996 3.01793C21.997 2.99393 21.991 2.97193 21.99 2.94793Z",
      fill: color
    }
  ) });
}
var init_paper_plane = __esm({
  "src/icons/salonized/paper-plane.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/pantone.tsx
import { jsx as jsx153 } from "@emotion/react/jsx-runtime";
function Pantone(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx153(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx153(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M19 19H10.514L14.073 15.182H19V19ZM5 17.091V15H8.818V17.091C8.818 18.144 7.962 19 6.909 19C5.856 19 5 18.144 5 17.091ZM5 8H8.818V5H5V8ZM5 13H8.818V10H5V13ZM13.422 7.588L16.095 10.081L10.818 15.74V10.381L13.422 7.588ZM20 13.182H15.937L18.239 10.713C18.616 10.31 18.594 9.677 18.189 9.3L14.054 5.443C13.859 5.263 13.611 5.159 13.337 5.176C13.072 5.185 12.821 5.299 12.641 5.493L10.818 7.448V4C10.818 3.447 10.371 3 9.818 3H4C3.447 3 3 3.447 3 4V17.091C3 19.246 4.754 21 6.909 21H20C20.553 21 21 20.553 21 20V14.182C21 13.629 20.553 13.182 20 13.182Z",
      fill: color
    }
  ) });
}
var init_pantone = __esm({
  "src/icons/salonized/pantone.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/options2.tsx
import { jsx as jsx154 } from "@emotion/react/jsx-runtime";
function Options2(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx154(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx154(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11 19C10.448 19 10 18.552 10 18C10 17.448 10.448 17 11 17C11.552 17 12 17.448 12 18C12 18.552 11.552 19 11 19ZM21 17H13.815C13.401 15.839 12.302 15 11 15C9.698 15 8.599 15.839 8.185 17H3C2.447 17 2 17.447 2 18C2 18.553 2.447 19 3 19H8.185C8.599 20.161 9.698 21 11 21C12.302 21 13.401 20.161 13.815 19H21C21.553 19 22 18.553 22 18C22 17.447 21.553 17 21 17ZM19 13C18.448 13 18 12.552 18 12C18 11.448 18.448 11 19 11C19.552 11 20 11.448 20 12C20 12.552 19.552 13 19 13ZM19 9C17.698 9 16.599 9.839 16.185 11H3C2.447 11 2 11.447 2 12C2 12.553 2.447 13 3 13H16.185C16.599 14.161 17.698 15 19 15C20.654 15 22 13.654 22 12C22 10.346 20.654 9 19 9ZM7 5C7.552 5 8 5.448 8 6C8 6.552 7.552 7 7 7C6.448 7 6 6.552 6 6C6 5.448 6.448 5 7 5ZM3 7H4.185C4.599 8.161 5.698 9 7 9C8.302 9 9.401 8.161 9.815 7H21C21.553 7 22 6.553 22 6C22 5.447 21.553 5 21 5H9.815C9.401 3.839 8.302 3 7 3C5.698 3 4.599 3.839 4.185 5H3C2.447 5 2 5.447 2 6C2 6.553 2.447 7 3 7Z",
      fill: color
    }
  ) });
}
var init_options2 = __esm({
  "src/icons/salonized/options2.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/options.tsx
import { jsx as jsx155 } from "@emotion/react/jsx-runtime";
function Options(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx155(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx155(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12 6C11.448 6 11 5.552 11 5C11 4.448 11.448 4 12 4C12.552 4 13 4.448 13 5C13 5.552 12.552 6 12 6ZM15 5C15 3.346 13.654 2 12 2C10.346 2 9 3.346 9 5C9 6.302 9.839 7.401 11 7.815V21C11 21.553 11.447 22 12 22C12.553 22 13 21.553 13 21V7.815C14.161 7.401 15 6.302 15 5ZM6 18C5.448 18 5 17.552 5 17C5 16.448 5.448 16 6 16C6.552 16 7 16.448 7 17C7 17.552 6.552 18 6 18ZM7 14.185V3C7 2.447 6.553 2 6 2C5.447 2 5 2.447 5 3V14.185C3.839 14.599 3 15.698 3 17C3 18.302 3.839 19.401 5 19.815V21C5 21.553 5.447 22 6 22C6.553 22 7 21.553 7 21V19.815C8.161 19.401 9 18.302 9 17C9 15.698 8.161 14.599 7 14.185ZM18 14C17.448 14 17 13.552 17 13C17 12.448 17.448 12 18 12C18.552 12 19 12.448 19 13C19 13.552 18.552 14 18 14ZM21 13C21 11.698 20.161 10.599 19 10.185V3C19 2.447 18.553 2 18 2C17.447 2 17 2.447 17 3V10.185C15.839 10.599 15 11.698 15 13C15 14.302 15.839 15.401 17 15.815V21C17 21.553 17.447 22 18 22C18.553 22 19 21.553 19 21V15.815C20.161 15.401 21 14.302 21 13Z",
      fill: color
    }
  ) });
}
var init_options = __esm({
  "src/icons/salonized/options.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/npm.tsx
import { jsx as jsx156 } from "@emotion/react/jsx-runtime";
function Npm(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx156(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx156(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12 19H16V9H12V19ZM6 5C5.449 5 5 5.449 5 6V18C5 18.551 5.449 19 6 19H18C18.551 19 19 18.551 19 18V6C19 5.449 18.551 5 18 5H6ZM18 21H6C4.346 21 3 19.654 3 18V6C3 4.346 4.346 3 6 3H18C19.654 3 21 4.346 21 6V18C21 19.654 19.654 21 18 21Z",
      fill: color
    }
  ) });
}
var init_npm = __esm({
  "src/icons/salonized/npm.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/navigation2.tsx
import { jsx as jsx157 } from "@emotion/react/jsx-runtime";
function Navigation2(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx157(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx157(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M7.86592 9.09849L13.0639 10.1555C13.4579 10.2345 13.7649 10.5415 13.8449 10.9355L14.9009 16.1335L18.4189 5.58049L7.86592 9.09849ZM14.6669 20.9995C14.6459 20.9995 14.6259 20.9985 14.6059 20.9975C14.1539 20.9705 13.7769 20.6425 13.6859 20.1995L12.0169 11.9825L3.80092 10.3125C3.35692 10.2225 3.02892 9.84549 3.00192 9.39349C2.97392 8.94149 3.25392 8.52749 3.68292 8.38449L19.6829 3.05149C20.0429 2.92949 20.4389 3.02449 20.7069 3.29249C20.9749 3.56049 21.0679 3.95649 20.9489 4.31649L15.6149 20.3165C15.4779 20.7265 15.0949 20.9995 14.6669 20.9995Z",
      fill: color
    }
  ) });
}
var init_navigation2 = __esm({
  "src/icons/salonized/navigation2.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/navigation.tsx
import { jsx as jsx158 } from "@emotion/react/jsx-runtime";
function Navigation(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx158(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx158(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12.0002 13.7022C12.1922 13.7022 12.3852 13.7582 12.5522 13.8682L17.4322 17.0992L12.0002 6.23618L6.56823 17.0992L11.4482 13.8682C11.6152 13.7582 11.8082 13.7022 12.0002 13.7022ZM20.0002 21.0002C19.8082 21.0002 19.6162 20.9452 19.4482 20.8342L12.0002 15.9012L4.55223 20.8342C4.17423 21.0832 3.67623 21.0492 3.33723 20.7492C2.99823 20.4482 2.90323 19.9582 3.10523 19.5532L11.1052 3.55318C11.4442 2.87518 12.5562 2.87518 12.8952 3.55318L20.8952 19.5532C21.0972 19.9582 21.0022 20.4482 20.6632 20.7492C20.4752 20.9152 20.2382 21.0002 20.0002 21.0002Z",
      fill: color
    }
  ) });
}
var init_navigation = __esm({
  "src/icons/salonized/navigation.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/music.tsx
import { jsx as jsx159 } from "@emotion/react/jsx-runtime";
function Music(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx159(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx159(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M15.5079 17.0062C14.6849 17.0062 14.0159 16.3372 14.0159 15.5142C14.0159 14.6912 14.6849 14.0222 15.5079 14.0222C16.2289 14.0222 16.8299 14.5342 16.9699 15.2132V15.2142C16.9889 15.3112 16.9999 15.4112 16.9999 15.5142C16.9999 16.3372 16.3309 17.0062 15.5079 17.0062ZM6.53595 19.0002C5.71295 19.0002 5.04395 18.3302 5.04395 17.5072C5.04395 16.6852 5.71295 16.0152 6.53595 16.0152C7.25595 16.0152 7.85795 16.5272 7.99795 17.2062V17.2092C8.01795 17.3052 8.02894 17.4052 8.02894 17.5072C8.02894 18.3302 7.35995 19.0002 6.53595 19.0002ZM18.9469 14.9922V4.00021C18.9469 3.69621 18.8099 3.40921 18.5729 3.21921C18.3359 3.03021 18.0249 2.95821 17.7309 3.02421L8.75895 5.01721C8.30095 5.11921 7.97595 5.52521 7.97595 5.99321V14.3342C7.53495 14.1342 7.05095 14.0152 6.53595 14.0152C4.61095 14.0152 3.04395 15.5822 3.04395 17.5072C3.04395 19.4332 4.61095 21.0002 6.53595 21.0002C8.46195 21.0002 10.0289 19.4332 10.0289 17.5072C10.0289 17.3292 10.0019 17.1572 9.97595 16.9852V6.79621L16.9469 5.24621V12.3402C16.5069 12.1402 16.0229 12.0222 15.5079 12.0222C13.5819 12.0222 12.0159 13.5882 12.0159 15.5142C12.0159 17.4402 13.5819 19.0062 15.5079 19.0062C17.4339 19.0062 18.9999 17.4402 18.9999 15.5142C18.9999 15.3352 18.9739 15.1642 18.9469 14.9922Z",
      fill: color
    }
  ) });
}
var init_music = __esm({
  "src/icons/salonized/music.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/move.tsx
import { jsx as jsx160 } from "@emotion/react/jsx-runtime";
function Move(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx160(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx160(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M21.709 11.3075L18.709 8.29451C18.319 7.90351 17.685 7.90051 17.295 8.29151C16.903 8.68151 16.901 9.31351 17.291 9.70551L18.58 10.9995H13V5.40851L14.291 6.70551C14.486 6.90151 14.743 6.99951 15 6.99951C15.255 6.99951 15.511 6.90251 15.706 6.70851C16.097 6.31851 16.099 5.68551 15.709 5.29451L12.722 2.29451C12.533 2.10551 12.315 2.00851 12.013 1.99951C11.748 1.99951 11.494 2.10451 11.307 2.29151L8.29401 5.29151C7.90301 5.68151 7.90101 6.31451 8.29101 6.70551C8.68001 7.09651 9.31301 7.09851 9.70601 6.70851L11 5.41951V10.9995H5.40801L6.70501 9.70851C7.09701 9.31851 7.09901 8.68551 6.70901 8.29451C6.31901 7.90351 5.68501 7.90051 5.29501 8.29151L2.29501 11.2785C2.10601 11.4655 2.00101 11.7195 2.00001 11.9845C1.99901 12.2495 2.10501 12.5045 2.29101 12.6925L5.29101 15.7055C5.48601 15.9015 5.74301 15.9995 6.00001 15.9995C6.25501 15.9995 6.51101 15.9025 6.70501 15.7085C7.09701 15.3185 7.09901 14.6855 6.70901 14.2945L5.42001 12.9995H11V18.5915L9.70901 17.2945C9.31901 16.9025 8.68601 16.9005 8.29401 17.2915C7.90301 17.6815 7.90101 18.3145 8.29101 18.7055L11.278 21.7055C11.466 21.8935 11.72 21.9995 11.985 21.9995H11.987C12.252 21.9995 12.506 21.8945 12.693 21.7085L15.706 18.7085C16.097 18.3185 16.099 17.6855 15.709 17.2945C15.319 16.9025 14.686 16.9005 14.294 17.2915L13 18.5795V12.9995H18.592L17.295 14.2915C16.903 14.6815 16.901 15.3135 17.291 15.7055C17.486 15.9015 17.743 15.9995 18 15.9995C18.255 15.9995 18.511 15.9025 18.705 15.7085L21.705 12.7215C21.894 12.5345 21.999 12.2805 22 12.0155C22.001 11.7495 21.896 11.4955 21.709 11.3075Z",
      fill: color
    }
  ) });
}
var init_move = __esm({
  "src/icons/salonized/move.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/more-vertical.tsx
import { jsx as jsx161 } from "@emotion/react/jsx-runtime";
function MoreVertical(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx161(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx161(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12 7C13.104 7 14 6.104 14 5C14 3.896 13.104 3 12 3C10.896 3 10 3.896 10 5C10 6.104 10.896 7 12 7ZM12 10C10.896 10 10 10.896 10 12C10 13.104 10.896 14 12 14C13.104 14 14 13.104 14 12C14 10.896 13.104 10 12 10ZM10 19C10 17.896 10.896 17 12 17C13.104 17 14 17.896 14 19C14 20.104 13.104 21 12 21C10.896 21 10 20.104 10 19Z",
      fill: color
    }
  ) });
}
var init_more_vertical = __esm({
  "src/icons/salonized/more-vertical.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/more-horizontal.tsx
import { jsx as jsx162 } from "@emotion/react/jsx-runtime";
function MoreHorizontal(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx162(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx162(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M3 12C3 10.896 3.896 10 5 10C6.104 10 7 10.896 7 12C7 13.104 6.104 14 5 14C3.896 14 3 13.104 3 12ZM12 10C10.896 10 10 10.896 10 12C10 13.104 10.896 14 12 14C13.104 14 14 13.104 14 12C14 10.896 13.104 10 12 10ZM19 10C17.896 10 17 10.896 17 12C17 13.104 17.896 14 19 14C20.104 14 21 13.104 21 12C21 10.896 20.104 10 19 10Z",
      fill: color
    }
  ) });
}
var init_more_horizontal = __esm({
  "src/icons/salonized/more-horizontal.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/moon.tsx
import { jsx as jsx163 } from "@emotion/react/jsx-runtime";
function Moon(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx163(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx163(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M7.44093 4.91804C6.94093 5.27204 6.48193 5.68204 6.06593 6.14604C3.21693 9.31704 3.30993 14.391 6.27293 17.456C7.83893 19.077 9.94293 19.981 12.1969 20C12.2219 20.001 12.2479 20.001 12.2739 20.001C14.4989 20.001 16.5879 19.138 18.1639 17.565C18.4919 17.238 18.7899 16.887 19.0569 16.513C15.9109 16.905 12.6859 15.851 10.3949 13.565C8.10493 11.279 7.04493 8.06104 7.44093 4.91804ZM12.2739 22.001C12.2419 22.001 12.2109 22.001 12.1789 22C9.38493 21.976 6.77593 20.856 4.83493 18.847C1.15793 15.042 1.04293 8.74504 4.57693 4.81004C5.67793 3.58304 7.02193 2.66004 8.57093 2.06704C8.93593 1.92504 9.35093 2.01304 9.62993 2.28904C9.90893 2.56404 10.0019 2.97704 9.86693 3.34504C8.74893 6.40004 9.51093 9.85604 11.8079 12.149C14.1059 14.442 17.5709 15.203 20.6359 14.087C21.0039 13.951 21.4179 14.047 21.6919 14.325C21.9659 14.606 22.0529 15.02 21.9119 15.385C21.3879 16.748 20.6019 17.958 19.5759 18.981C17.6229 20.931 15.0329 22.001 12.2739 22.001Z",
      fill: color
    }
  ) });
}
var init_moon = __esm({
  "src/icons/salonized/moon.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/monitor.tsx
import { jsx as jsx164 } from "@emotion/react/jsx-runtime";
function Monitor(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx164(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx164(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M20 14C20 14.551 19.552 15 19 15H12.087H11.913H5C4.448 15 4 14.551 4 14V6C4 5.449 4.448 5 5 5H19C19.552 5 20 5.449 20 6V14ZM19 3H5C3.346 3 2 4.346 2 6V14C2 15.654 3.346 17 5 17H11V19H7C6.45 19 6 19.45 6 20C6 20.55 6.45 21 7 21H17C17.55 21 18 20.55 18 20C18 19.45 17.55 19 17 19H13V17H19C20.654 17 22 15.654 22 14V6C22 4.346 20.654 3 19 3Z",
      fill: color
    }
  ) });
}
var init_monitor = __esm({
  "src/icons/salonized/monitor.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/minus.tsx
import { jsx as jsx165 } from "@emotion/react/jsx-runtime";
function Minus2(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx165(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx165(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M19 13H5C4.448 13 4 12.553 4 12C4 11.447 4.448 11 5 11H19C19.553 11 20 11.447 20 12C20 12.553 19.553 13 19 13Z",
      fill: color
    }
  ) });
}
var init_minus2 = __esm({
  "src/icons/salonized/minus.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/minus-square.tsx
import { jsx as jsx166 } from "@emotion/react/jsx-runtime";
function MinusSquare(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx166(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx166(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M15 11H9C8.45 11 8 11.45 8 12C8 12.55 8.45 13 9 13H15C15.55 13 16 12.55 16 12C16 11.45 15.55 11 15 11ZM19 18C19 18.551 18.552 19 18 19H6C5.448 19 5 18.551 5 18V6C5 5.449 5.448 5 6 5H18C18.552 5 19 5.449 19 6V18ZM18 3H6C4.346 3 3 4.346 3 6V18C3 19.654 4.346 21 6 21H18C19.654 21 21 19.654 21 18V6C21 4.346 19.654 3 18 3Z",
      fill: color
    }
  ) });
}
var init_minus_square = __esm({
  "src/icons/salonized/minus-square.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/minus-circle.tsx
import { jsx as jsx167 } from "@emotion/react/jsx-runtime";
function MinusCircle(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx167(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx167(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M15 11H9C8.45 11 8 11.45 8 12C8 12.55 8.45 13 9 13H15C15.55 13 16 12.55 16 12C16 11.45 15.55 11 15 11ZM12 20C7.589 20 4 16.411 4 12C4 7.589 7.589 4 12 4C16.411 4 20 7.589 20 12C20 16.411 16.411 20 12 20ZM12 2C6.486 2 2 6.486 2 12C2 17.514 6.486 22 12 22C17.514 22 22 17.514 22 12C22 6.486 17.514 2 12 2Z",
      fill: color
    }
  ) });
}
var init_minus_circle = __esm({
  "src/icons/salonized/minus-circle.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/minimize.tsx
import { jsx as jsx168 } from "@emotion/react/jsx-runtime";
function Minimize(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx168(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx168(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M13 10H9C8.45 10 8 10.45 8 11C8 11.55 8.45 12 9 12H13C13.55 12 14 11.55 14 11C14 10.45 13.55 10 13 10ZM5 11C5 7.691 7.691 5 11 5C14.309 5 17 7.691 17 11C17 14.309 14.309 17 11 17C7.691 17 5 14.309 5 11ZM20.707 19.293L17.312 15.897C18.365 14.543 19 12.846 19 11C19 6.589 15.411 3 11 3C6.589 3 3 6.589 3 11C3 15.411 6.589 19 11 19C12.846 19 14.543 18.365 15.897 17.312L19.293 20.707C19.488 20.902 19.744 21 20 21C20.256 21 20.512 20.902 20.707 20.707C21.098 20.316 21.098 19.684 20.707 19.293Z",
      fill: color
    }
  ) });
}
var init_minimize = __esm({
  "src/icons/salonized/minimize.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/mic.tsx
import { jsx as jsx169 } from "@emotion/react/jsx-runtime";
function Mic(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx169(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx169(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12 4C10.897 4 10 4.897 10 6V11C10 12.103 10.897 13 12 13C13.103 13 14 12.103 14 11V6C14 4.897 13.103 4 12 4ZM16 11C16 13.206 14.206 15 12 15C9.794 15 8 13.206 8 11V6C8 3.794 9.794 2 12 2C14.206 2 16 3.794 16 6V11ZM18 10C18.553 10 19 10.448 19 11C19 14.52 16.387 17.432 13 17.92V20H15.105C15.598 20 16 20.402 16 20.895V21.105C16 21.598 15.598 22 15.105 22H8.895C8.402 22 8 21.598 8 21.105V20.895C8 20.402 8.402 20 8.895 20H11V17.92C7.613 17.432 5 14.52 5 11C5 10.448 5.447 10 6 10C6.553 10 7 10.448 7 11C7 13.757 9.243 16 12 16C14.757 16 17 13.757 17 11C17 10.448 17.447 10 18 10Z",
      fill: color
    }
  ) });
}
var init_mic = __esm({
  "src/icons/salonized/mic.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/mic-off.tsx
import { jsx as jsx170 } from "@emotion/react/jsx-runtime";
function MicOff(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx170(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx170(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10.0002 6C10.0002 4.897 10.8972 4 12.0002 4C13.1032 4 14.0002 4.897 14.0002 6V11C14.0002 11.0325 13.9959 11.0636 13.9916 11.0946L13.9916 11.0946L13.9915 11.0946C13.9887 11.115 13.9858 11.1354 13.9842 11.156L15.5792 12.751C15.8402 12.22 16.0002 11.631 16.0002 11V6C16.0002 3.794 14.2062 2 12.0002 2C10.0522 2 8.43025 3.401 8.07625 5.248L10.0002 7.172V6ZM19.0002 11C19.0002 10.448 18.5532 10 18.0002 10C17.4472 10 17.0002 10.448 17.0002 11C17.0002 11.909 16.7382 12.75 16.3122 13.484L17.7752 14.947C18.5472 13.823 19.0002 12.464 19.0002 11ZM12.0856 14.9918C12.0577 14.9959 12.0296 15 12.0002 15C9.79425 15 8.00025 13.206 8.00025 11V10.828L12.1562 14.984C12.1325 14.9849 12.1091 14.9883 12.0856 14.9918ZM20.7072 19.293L4.70725 3.293C4.31625 2.902 3.68425 2.902 3.29325 3.293C2.90225 3.684 2.90225 4.316 3.29325 4.707L19.2932 20.707C19.4882 20.902 19.7442 21 20.0002 21C20.2562 21 20.5122 20.902 20.7072 20.707C21.0982 20.316 21.0982 19.684 20.7072 19.293ZM13.0002 20H15.0002C15.5502 20 16.0002 20.45 16.0002 21C16.0002 21.55 15.5502 22 15.0002 22H9.00025C8.45025 22 8.00025 21.55 8.00025 21C8.00025 20.45 8.45025 20 9.00025 20H11.0002V17.92C7.61325 17.432 5.00025 14.52 5.00025 11C5.00025 10.448 5.44725 10 6.00025 10C6.55325 10 7.00025 10.448 7.00025 11C7.00025 13.757 9.24325 16 12.0002 16C12.3622 16 12.7142 15.957 13.0552 15.883L14.6482 17.476C14.1272 17.69 13.5732 17.836 13.0002 17.919V20Z",
      fill: color
    }
  ) });
}
var init_mic_off = __esm({
  "src/icons/salonized/mic-off.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/message-square.tsx
import { jsx as jsx171 } from "@emotion/react/jsx-runtime";
function MessageSquare(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx171(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx171(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M7 10C7 9.448 7.448 9 8 9C8.552 9 9 9.448 9 10C9 10.552 8.552 11 8 11C7.448 11 7 10.552 7 10ZM12 9C11.448 9 11 9.448 11 10C11 10.552 11.448 11 12 11C12.552 11 13 10.552 13 10C13 9.448 12.552 9 12 9ZM16 9C15.448 9 15 9.448 15 10C15 10.552 15.448 11 16 11C16.552 11 17 10.552 17 10C17 9.448 16.552 9 16 9ZM20 15C20 15.551 19.551 16 19 16H8.554C8.011 16 7.477 16.148 7.01 16.428L4 18.234V5C4 4.449 4.449 4 5 4H19C19.551 4 20 4.449 20 5V15ZM19 2H5C3.346 2 2 3.346 2 5V20C2 20.36 2.194 20.693 2.507 20.87C2.66 20.957 2.83 21 3 21C3.178 21 3.356 20.953 3.515 20.857L8.039 18.143C8.195 18.049 8.373 18 8.554 18H19C20.654 18 22 16.654 22 15V5C22 3.346 20.654 2 19 2Z",
      fill: color
    }
  ) });
}
var init_message_square = __esm({
  "src/icons/salonized/message-square.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/message-circle.tsx
import { jsx as jsx172 } from "@emotion/react/jsx-runtime";
function MessageCircle(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx172(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx172(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M7.0002 10.9993C7.0002 10.4473 7.4482 9.99927 8.0002 9.99927C8.5522 9.99927 9.0002 10.4473 9.0002 10.9993C9.0002 11.5513 8.5522 11.9993 8.0002 11.9993C7.4482 11.9993 7.0002 11.5513 7.0002 10.9993ZM12.0002 9.99927C11.4482 9.99927 11.0002 10.4473 11.0002 10.9993C11.0002 11.5513 11.4482 11.9993 12.0002 11.9993C12.5522 11.9993 13.0002 11.5513 13.0002 10.9993C13.0002 10.4473 12.5522 9.99927 12.0002 9.99927ZM16.0002 9.99927C15.4482 9.99927 15.0002 10.4473 15.0002 10.9993C15.0002 11.5513 15.4482 11.9993 16.0002 11.9993C16.5522 11.9993 17.0002 11.5513 17.0002 10.9993C17.0002 10.4473 16.5522 9.99927 16.0002 9.99927ZM19.8986 12.2942C19.3916 15.5482 16.7686 18.2472 13.5196 18.8562C11.9506 19.1522 10.3526 18.9832 8.9026 18.3692C8.4916 18.1952 8.0666 18.1072 7.6496 18.1072C7.4596 18.1072 7.2716 18.1252 7.0866 18.1622L4.2746 18.7242L4.8376 15.9072C4.9556 15.3222 4.8836 14.6962 4.6306 14.0972C4.0166 12.6472 3.8486 11.0502 4.1436 9.48017C4.7526 6.23117 7.4506 3.60817 10.7056 3.10117C13.2956 2.69817 15.8286 3.51417 17.6566 5.34217C19.4856 7.17117 20.3026 9.70517 19.8986 12.2942ZM19.0716 3.92817C16.7866 1.64417 13.6266 0.625171 10.3976 1.12417C6.3206 1.76017 2.9406 5.04417 2.1776 9.11117C1.8096 11.0692 2.0216 13.0632 2.7886 14.8762C2.8856 15.1072 2.9156 15.3222 2.8776 15.5152L2.0196 19.8032C1.9536 20.1312 2.0566 20.4702 2.2936 20.7062C2.4826 20.8962 2.7376 20.9992 3.0006 20.9992C3.0656 20.9992 3.1306 20.9932 3.1966 20.9802L7.4796 20.1232C7.7256 20.0762 7.9636 20.1452 8.1226 20.2112C9.9376 20.9782 11.9316 21.1892 13.8876 20.8222C17.9556 20.0592 21.2396 16.6792 21.8756 12.6022C22.3776 9.37517 21.3566 6.21317 19.0716 3.92817Z",
      fill: color
    }
  ) });
}
var init_message_circle = __esm({
  "src/icons/salonized/message-circle.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/menu2.tsx
import { jsx as jsx173 } from "@emotion/react/jsx-runtime";
function Menu2(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx173(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx173(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M3.9355 6H20.0645C20.5795 6 21.0005 6.421 21.0005 6.936V7.064C21.0005 7.579 20.5795 8 20.0645 8H3.9355C3.4205 8 3.0005 7.579 3.0005 7.064V6.936C3.0005 6.421 3.4205 6 3.9355 6ZM5 12C5 12.553 4.552 13 4 13C3.448 13 3 12.553 3 12C3 11.447 3.448 11 4 11C4.552 11 5 11.447 5 12ZM7.9355 11H20.0645C20.5795 11 21.0005 11.421 21.0005 11.936V12.064C21.0005 12.579 20.5795 13 20.0645 13H7.9355C7.4205 13 7.0005 12.579 7.0005 12.064V11.936C7.0005 11.421 7.4205 11 7.9355 11ZM20.0645 16H3.9355C3.4205 16 3.0005 16.421 3.0005 16.936V17.064C3.0005 17.579 3.4205 18 3.9355 18H20.0645C20.5795 18 21.0005 17.579 21.0005 17.064V16.936C21.0005 16.421 20.5795 16 20.0645 16Z",
      fill: color
    }
  ) });
}
var init_menu2 = __esm({
  "src/icons/salonized/menu2.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/menu.tsx
import { jsx as jsx174 } from "@emotion/react/jsx-runtime";
function Menu(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx174(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx174(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M3.948 6H20.051C20.573 6 21 6.427 21 6.949V7.051C21 7.573 20.573 8 20.051 8H3.948C3.426 8 3 7.573 3 7.051V6.949C3 6.427 3.426 6 3.948 6ZM20.051 11H3.948C3.426 11 3 11.427 3 11.949V12.051C3 12.573 3.426 13 3.948 13H20.051C20.573 13 21 12.573 21 12.051V11.949C21 11.427 20.573 11 20.051 11ZM20.051 16H3.948C3.426 16 3 16.427 3 16.949V17.051C3 17.573 3.426 18 3.948 18H20.051C20.573 18 21 17.573 21 17.051V16.949C21 16.427 20.573 16 20.051 16Z",
      fill: color
    }
  ) });
}
var init_menu = __esm({
  "src/icons/salonized/menu.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/menu-arrow.tsx
import { jsx as jsx175 } from "@emotion/react/jsx-runtime";
function MenuArrow(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx175(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx175(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M3.9475 5H20.0515C20.5725 5 20.9995 5.427 20.9995 5.948V6.052C20.9995 6.573 20.5725 7 20.0515 7H3.9475C3.4265 7 2.9995 6.573 2.9995 6.052V5.948C2.9995 5.427 3.4265 5 3.9475 5ZM20.0515 11H5.9135L7.2065 9.707C7.5975 9.316 7.5975 8.684 7.2065 8.293C6.8165 7.902 6.1835 7.902 5.7925 8.293L2.7925 11.293C2.4025 11.684 2.4025 12.316 2.7925 12.707L5.7925 15.707C5.9885 15.902 6.2435 16 6.4995 16C6.7555 16 7.0115 15.902 7.2065 15.707C7.5975 15.316 7.5975 14.684 7.2065 14.293L5.9135 13H20.0515C20.5725 13 20.9995 12.573 20.9995 12.052V11.948C20.9995 11.427 20.5725 11 20.0515 11ZM20.0515 17H3.9475C3.4265 17 2.9995 17.427 2.9995 17.948V18.052C2.9995 18.573 3.4265 19 3.9475 19H20.0515C20.5725 19 20.9995 18.573 20.9995 18.052V17.948C20.9995 17.427 20.5725 17 20.0515 17Z",
      fill: color
    }
  ) });
}
var init_menu_arrow = __esm({
  "src/icons/salonized/menu-arrow.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/maximize.tsx
import { jsx as jsx176 } from "@emotion/react/jsx-runtime";
function Maximize(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx176(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx176(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M13 10H12V9C12 8.45 11.55 8 11 8C10.45 8 10 8.45 10 9V10H9C8.45 10 8 10.45 8 11C8 11.55 8.45 12 9 12H10V13C10 13.55 10.45 14 11 14C11.55 14 12 13.55 12 13V12H13C13.55 12 14 11.55 14 11C14 10.45 13.55 10 13 10ZM5 11C5 7.691 7.691 5 11 5C14.309 5 17 7.691 17 11C17 14.309 14.309 17 11 17C7.691 17 5 14.309 5 11ZM20.707 19.293L17.312 15.897C18.365 14.543 19 12.846 19 11C19 6.589 15.411 3 11 3C6.589 3 3 6.589 3 11C3 15.411 6.589 19 11 19C12.846 19 14.543 18.365 15.897 17.312L19.293 20.707C19.488 20.902 19.744 21 20 21C20.256 21 20.512 20.902 20.707 20.707C21.098 20.316 21.098 19.684 20.707 19.293Z",
      fill: color
    }
  ) });
}
var init_maximize = __esm({
  "src/icons/salonized/maximize.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/map.tsx
import { jsx as jsx177 } from "@emotion/react/jsx-runtime";
function Map(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx177(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx177(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M19 17.4541L17 16.5561V6.54608L19 7.44408V17.4541ZM13 7.44408L15 6.54608V16.5561L13 17.4541V7.44408ZM9 6.54608L11 7.44408V17.4541L9 16.5561V6.54608ZM5 7.44408L7 6.54608V16.5561L5 17.4541V7.44408ZM20.41 5.88608L16.41 4.08808C16.395 4.08108 16.379 4.08008 16.364 4.07408C16.323 4.05808 16.282 4.04708 16.24 4.03608C16.201 4.02608 16.162 4.01708 16.122 4.01308C16.083 4.00808 16.044 4.00708 16.004 4.00708C15.96 4.00708 15.917 4.00808 15.873 4.01308C15.836 4.01708 15.801 4.02608 15.765 4.03508C15.721 4.04608 15.678 4.05808 15.635 4.07408C15.621 4.08008 15.604 4.08108 15.59 4.08808L12 5.70108L8.41 4.08808C8.395 4.08108 8.379 4.08008 8.364 4.07408C8.323 4.05808 8.282 4.04708 8.24 4.03608C8.201 4.02608 8.162 4.01708 8.122 4.01308C8.083 4.00808 8.044 4.00708 8.004 4.00708C7.96 4.00708 7.917 4.00808 7.873 4.01308C7.836 4.01708 7.801 4.02608 7.765 4.03508C7.721 4.04608 7.678 4.05808 7.635 4.07408C7.621 4.08008 7.604 4.08108 7.59 4.08808L3.59 5.88608C3.231 6.04708 3 6.40408 3 6.79808V19.0001C3 19.3391 3.172 19.6551 3.457 19.8401C3.621 19.9461 3.81 20.0001 4 20.0001C4.139 20.0001 4.279 19.9711 4.41 19.9121L8 18.2991L11.59 19.9121C11.605 19.9191 11.621 19.9161 11.637 19.9221C11.754 19.9691 11.875 20.0001 12 20.0001C12.125 20.0001 12.246 19.9691 12.363 19.9221C12.378 19.9161 12.396 19.9191 12.41 19.9121L16 18.2991L19.59 19.9121C19.721 19.9711 19.861 20.0001 20 20.0001C20.19 20.0001 20.379 19.9461 20.543 19.8401C20.828 19.6551 21 19.3391 21 19.0001V6.79808C21 6.40408 20.769 6.04708 20.41 5.88608Z",
      fill: color
    }
  ) });
}
var init_map = __esm({
  "src/icons/salonized/map.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/log-out.tsx
import { jsx as jsx178 } from "@emotion/react/jsx-runtime";
function LogOut(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx178(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx178(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8 5C8 5.55 7.55 6 7 6H6V18H7C7.55 18 8 18.45 8 19C8 19.55 7.55 20 7 20H5C4.45 20 4 19.55 4 19V5C4 4.45 4.45 4 5 4H7C7.55 4 8 4.45 8 5ZM18.0039 7.4248L20.8179 11.4248C21.0679 11.7788 21.0599 12.2538 20.7999 12.5998L17.7999 16.5998C17.6039 16.8618 17.3029 16.9998 16.9989 16.9998C16.7909 16.9998 16.5799 16.9348 16.3999 16.7998C15.9579 16.4688 15.8689 15.8418 16.1999 15.4008L18.0009 12.9998H17.9999H9.9999C9.4479 12.9998 8.9999 12.5528 8.9999 11.9998C8.9999 11.4468 9.4479 10.9998 9.9999 10.9998H17.9999C18.0164 10.9998 18.0317 11.0044 18.0472 11.0089C18.0598 11.0127 18.0724 11.0165 18.0859 11.0178L16.3679 8.5748C16.0499 8.1238 16.1589 7.4998 16.6109 7.1818C17.0619 6.8628 17.6859 6.9728 18.0039 7.4248Z",
      fill: color
    }
  ) });
}
var init_log_out = __esm({
  "src/icons/salonized/log-out.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/log-in.tsx
import { jsx as jsx179 } from "@emotion/react/jsx-runtime";
function LogIn(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx179(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx179(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M17.0002 4H19.0002C19.5502 4 20.0002 4.45 20.0002 5V19C20.0002 19.55 19.5502 20 19.0002 20H17.0002C16.4502 20 16.0002 19.55 16.0002 19C16.0002 18.45 16.4502 18 17.0002 18H18.0002V6H17.0002C16.4502 6 16.0002 5.55 16.0002 5C16.0002 4.45 16.4502 4 17.0002 4ZM10.4 7.2004C10.844 6.8694 11.469 6.9594 11.8 7.4004L14.8 11.4004C15.06 11.7464 15.068 12.2204 14.818 12.5754L12.004 16.5754C11.809 16.8524 11.5 17.0004 11.185 17.0004C10.987 17.0004 10.786 16.9414 10.611 16.8184C10.159 16.5004 10.05 15.8764 10.368 15.4244L12.086 12.9824C12.0725 12.9837 12.0599 12.9875 12.0473 12.9913C12.0318 12.9958 12.0165 13.0004 12 13.0004H4C3.448 13.0004 3 12.5524 3 12.0004C3 11.4474 3.448 11.0004 4 11.0004H12H12.001L10.2 8.5994C9.869 8.1584 9.958 7.5314 10.4 7.2004Z",
      fill: color
    }
  ) });
}
var init_log_in = __esm({
  "src/icons/salonized/log-in.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/lock.tsx
import { jsx as jsx180 } from "@emotion/react/jsx-runtime";
function Lock(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx180(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx180(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12 16C11.448 16 11 15.552 11 15C11 14.448 11.448 14 12 14C12.552 14 13 14.448 13 15C13 15.552 12.552 16 12 16ZM12 12C10.346 12 9 13.346 9 15C9 16.654 10.346 18 12 18C13.654 18 15 16.654 15 15C15 13.346 13.654 12 12 12ZM18 19C18 19.552 17.552 20 17 20H7C6.448 20 6 19.552 6 19V11C6 10.448 6.448 10 7 10H8H10H14H16H17C17.552 10 18 10.448 18 11V19ZM10 6.111C10 4.947 10.897 4 12 4C13.103 4 14 4.947 14 6.111V8H10V6.111ZM17 8H16V6.111C16 3.845 14.206 2 12 2C9.794 2 8 3.845 8 6.111V8H7C5.346 8 4 9.346 4 11V19C4 20.654 5.346 22 7 22H17C18.654 22 20 20.654 20 19V11C20 9.346 18.654 8 17 8Z",
      fill: color
    }
  ) });
}
var init_lock = __esm({
  "src/icons/salonized/lock.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/loader.tsx
import { jsx as jsx181 } from "@emotion/react/jsx-runtime";
function Loader(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx181(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx181(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11 3C11 2.447 11.448 2 12 2C12.552 2 13 2.447 13 3V5C13 5.553 12.552 6 12 6C11.448 6 11 5.553 11 5V3ZM19 11H21C21.552 11 22 11.447 22 12C22 12.553 21.552 13 21 13H19C18.448 13 18 12.553 18 12C18 11.447 18.448 11 19 11ZM6 12C6 11.447 5.552 11 5 11H3C2.448 11 2 11.447 2 12C2 12.553 2.448 13 3 13H5C5.552 13 6 12.553 6 12ZM4.8067 5.0533C5.1917 4.6573 5.8237 4.6443 6.2207 5.0283L7.6597 6.4183C8.0567 6.8013 8.0677 7.4353 7.6837 7.8323C7.4877 8.0353 7.2267 8.1373 6.9647 8.1373C6.7147 8.1373 6.4647 8.0453 6.2697 7.8573L4.8307 6.4673C4.4337 6.0843 4.4227 5.4503 4.8067 5.0533ZM17.0352 8.1377C17.2852 8.1377 17.5352 8.0447 17.7302 7.8577L19.1692 6.4677C19.5662 6.0837 19.5772 5.4497 19.1932 5.0537C18.8102 4.6577 18.1782 4.6447 17.7792 5.0287L16.3402 6.4177C15.9432 6.8017 15.9322 7.4357 16.3162 7.8317C16.5122 8.0347 16.7732 8.1377 17.0352 8.1377ZM11 19C11 18.447 11.448 18 12 18C12.552 18 13 18.447 13 19V21C13 21.553 12.552 22 12 22C11.448 22 11 21.553 11 21V19ZM17.73 16.1426C17.333 15.7596 16.7 15.7716 16.316 16.1676C15.932 16.5646 15.943 17.1986 16.34 17.5816L17.779 18.9716C17.974 19.1596 18.224 19.2516 18.474 19.2516C18.736 19.2516 18.997 19.1496 19.193 18.9466C19.577 18.5496 19.566 17.9156 19.169 17.5326L17.73 16.1426ZM4.831 17.5326L6.27 16.1426C6.668 15.7596 7.301 15.7716 7.684 16.1676C8.068 16.5646 8.057 17.1986 7.66 17.5816L6.221 18.9716C6.026 19.1596 5.776 19.2516 5.526 19.2516C5.264 19.2516 5.003 19.1496 4.807 18.9466C4.423 18.5496 4.434 17.9156 4.831 17.5326Z",
      fill: color
    }
  ) });
}
var init_loader = __esm({
  "src/icons/salonized/loader.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/list.tsx
import { jsx as jsx182 } from "@emotion/react/jsx-runtime";
function List(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx182(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx182(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M3 7C3 6.448 3.448 6 4 6C4.552 6 5 6.448 5 7C5 7.552 4.552 8 4 8C3.448 8 3 7.552 3 7ZM3 12C3 11.448 3.448 11 4 11C4.552 11 5 11.448 5 12C5 12.552 4.552 13 4 13C3.448 13 3 12.552 3 12ZM4 16C3.448 16 3 16.448 3 17C3 17.552 3.448 18 4 18C4.552 18 5 17.552 5 17C5 16.448 4.552 16 4 16ZM7.9355 11H20.0645C20.5795 11 21.0005 11.421 21.0005 11.936V12.064C21.0005 12.579 20.5795 13 20.0645 13H7.9355C7.4205 13 7.0005 12.579 7.0005 12.064V11.936C7.0005 11.421 7.4205 11 7.9355 11ZM20.0645 16H7.9355C7.4205 16 7.0005 16.421 7.0005 16.936V17.064C7.0005 17.579 7.4205 18 7.9355 18H20.0645C20.5795 18 21.0005 17.579 21.0005 17.064V16.936C21.0005 16.421 20.5795 16 20.0645 16ZM7.9355 6H20.0645C20.5795 6 21.0005 6.421 21.0005 6.936V7.064C21.0005 7.579 20.5795 8 20.0645 8H7.9355C7.4205 8 7.0005 7.579 7.0005 7.064V6.936C7.0005 6.421 7.4205 6 7.9355 6Z",
      fill: color
    }
  ) });
}
var init_list = __esm({
  "src/icons/salonized/list.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/linkedin.tsx
import { jsx as jsx183 } from "@emotion/react/jsx-runtime";
function Linkedin(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx183(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx183(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M4 10H3.998L4 20H6V10H4ZM6 22H4C2.897 22 2 21.103 2 20V10C2 8.897 2.897 8 4 8H6C7.103 8 8 8.897 8 10V20C8 21.103 7.103 22 6 22ZM15.5049 11.6924C15.6579 11.6924 15.8129 11.7054 15.9659 11.7294C17.3159 11.9504 18.3329 13.1964 18.3329 14.6294V20.0004H19.9999V14.5384C19.9999 12.0364 17.9819 10.0004 15.4999 10.0004C13.0189 10.0004 10.9999 12.0364 10.9999 14.5384V20.0004H12.6669V14.5384C12.6669 13.6994 13.0319 12.9074 13.6699 12.3654C14.1859 11.9274 14.8349 11.6924 15.5049 11.6924ZM19.9999 22.0004H18.3329C17.2309 22.0004 16.3329 21.1024 16.3329 20.0004V14.6294C16.3329 14.1724 16.0299 13.7664 15.6449 13.7044C15.3089 13.6464 15.0749 13.7964 14.9659 13.8884C14.7759 14.0504 14.6669 14.2874 14.6669 14.5384V20.0004C14.6669 21.1024 13.7699 22.0004 12.6669 22.0004H10.9999C9.8979 22.0004 8.9999 21.1024 8.9999 20.0004V14.5384C8.9999 10.9324 11.9159 8.0004 15.4999 8.0004C19.0839 8.0004 21.9999 10.9324 21.9999 14.5384V20.0004C21.9999 21.1024 21.1029 22.0004 19.9999 22.0004ZM5 3C4.448 3 4 3.448 4 4C4 4.552 4.448 5 5 5C5.552 5 6 4.552 6 4C6 3.448 5.552 3 5 3ZM5 7C3.346 7 2 5.654 2 4C2 2.346 3.346 1 5 1C6.654 1 8 2.346 8 4C8 5.654 6.654 7 5 7Z",
      fill: color
    }
  ) });
}
var init_linkedin = __esm({
  "src/icons/salonized/linkedin.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/link2.tsx
import { jsx as jsx184 } from "@emotion/react/jsx-runtime";
function Link2(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx184(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx184(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11.5267 3.89973C13.7087 1.71273 17.2297 1.31773 19.6617 3.21973C22.5747 5.49773 22.7657 9.74273 20.2347 12.2797L18.8117 13.7047C18.4187 14.0987 17.7827 14.0987 17.3897 13.7047C16.9967 13.3117 16.9967 12.6727 17.3897 12.2797L18.8117 10.8537C20.4667 9.19673 20.3767 6.44173 18.5397 4.90373C16.9127 3.54073 14.4707 3.80073 12.9717 5.30273L11.6987 6.57773C11.3067 6.97173 10.6687 6.97173 10.2767 6.57773C9.88374 6.18473 9.87973 5.54973 10.4537 4.97473L11.5267 3.89973ZM13.2926 9.29303L9.29264 13.293C8.90164 13.684 8.90164 14.316 9.29264 14.707C9.48764 14.902 9.74364 15 9.99964 15C10.2556 15 10.5116 14.902 10.7066 14.707L14.7066 10.707C15.0976 10.316 15.0976 9.68403 14.7066 9.29303C14.3156 8.90203 13.6836 8.90203 13.2926 9.29303ZM12.2799 17.3965L11.0059 18.6675C9.50493 20.1645 7.05794 20.4225 5.42994 19.0655C3.59094 17.5335 3.49994 14.7875 5.15694 13.1345L6.58193 11.7145C6.97494 11.3225 6.97494 10.6865 6.58193 10.2935C6.18893 9.90253 5.55094 9.90253 5.15694 10.2935L3.88194 11.5665C1.70994 13.7325 1.32894 17.2165 3.20694 19.6405C5.47794 22.5735 9.73794 22.7715 12.2799 20.2375L13.7049 18.8175C14.0979 18.4245 14.0979 17.7895 13.7049 17.3965C13.3109 17.0035 12.6739 17.0035 12.2799 17.3965Z",
      fill: color
    }
  ) });
}
var init_link2 = __esm({
  "src/icons/salonized/link2.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/link.tsx
import { jsx as jsx185 } from "@emotion/react/jsx-runtime";
function Link3(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx185(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx185(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8.99966 16H7.20966C5.10366 16 3.20366 14.465 3.01666 12.366C2.80366 9.996 4.67266 8 6.99966 8H8.99966C9.55166 8 9.99966 7.553 9.99966 7C9.99966 6.447 9.55166 6 8.99966 6H7.20866C4.15966 6 1.43866 8.187 1.05066 11.211C0.581663 14.869 3.43166 18 6.99966 18H8.99966C9.55166 18 9.99966 17.553 9.99966 17C9.99966 16.447 9.55166 16 8.99966 16ZM7.99966 12C7.99966 12.553 8.44766 13 8.99966 13H14.9997C15.5517 13 15.9997 12.553 15.9997 12C15.9997 11.447 15.5517 11 14.9997 11H8.99966C8.44766 11 7.99966 11.447 7.99966 12ZM16.7588 6.0002C19.8258 6.0002 22.5778 8.1972 22.9528 11.2422C23.4018 14.8882 20.5578 18.0002 16.9998 18.0002H14.9998C14.4478 18.0002 13.9998 17.5532 13.9998 17.0002C13.9998 16.4472 14.4478 16.0002 14.9998 16.0002H16.9998C19.3268 16.0002 21.1958 14.0042 20.9828 11.6342C20.7958 9.5352 18.8958 8.0002 16.7888 8.0002H14.9998C14.4478 8.0002 13.9998 7.5532 13.9998 7.0002C13.9998 6.4472 14.4428 6.0002 15.2488 6.0002H16.7588Z",
      fill: color
    }
  ) });
}
var init_link3 = __esm({
  "src/icons/salonized/link.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/layout.tsx
import { jsx as jsx186 } from "@emotion/react/jsx-runtime";
function Layout(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx186(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx186(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M18 19H13V10H19V18C19 18.552 18.551 19 18 19ZM5 18V10H11V19H6C5.449 19 5 18.552 5 18ZM6 5H18C18.551 5 19 5.448 19 6V8H5V6C5 5.448 5.449 5 6 5ZM18 3H6C4.346 3 3 4.346 3 6V8.818V9.182V18C3 19.654 4.346 21 6 21H18C19.654 21 21 19.654 21 18V9.182V8.818V6C21 4.346 19.654 3 18 3Z",
      fill: color
    }
  ) });
}
var init_layout = __esm({
  "src/icons/salonized/layout.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/layers.tsx
import { jsx as jsx187 } from "@emotion/react/jsx-runtime";
function Layers(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx187(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx187(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M17.7598 15.54L11.9998 18.847L6.23984 15.54L7.93384 14.819L11.5018 16.867C11.6558 16.956 11.8278 17 11.9998 17C12.1718 17 12.3428 16.956 12.4978 16.867L16.0658 14.818L17.7598 15.54ZM11.5018 12.867C11.6558 12.956 11.8278 13 11.9998 13C12.1718 13 12.3428 12.956 12.4978 12.867L16.0658 10.818L17.7598 11.54L11.9998 14.847L6.23984 11.54L7.93384 10.818L11.5018 12.867ZM11.9998 5.08701L17.7598 7.54001L11.9998 10.847L6.23984 7.54001L11.9998 5.08701ZM20.9978 11.348C20.9748 10.969 20.7398 10.636 20.3908 10.487L18.2388 9.57101L20.4978 8.27401C20.8268 8.08601 21.0198 7.72701 20.9978 7.34801C20.9748 6.97001 20.7398 6.63601 20.3908 6.48701L12.3908 3.08001C12.1408 2.97301 11.8578 2.97301 11.6078 3.08001L3.60784 6.48701C3.25884 6.63601 3.02384 6.97001 3.00184 7.34801C2.97884 7.72701 3.17284 8.08601 3.50184 8.27401L5.75984 9.57101L3.60784 10.487C3.25884 10.636 3.02384 10.969 3.00184 11.348C2.97884 11.727 3.17284 12.086 3.50184 12.274L5.75984 13.571L3.60784 14.487C3.25884 14.636 3.02384 14.969 3.00184 15.348C2.97884 15.727 3.17284 16.086 3.50184 16.274L11.5018 20.867C11.6558 20.956 11.8278 21 11.9998 21C12.1718 21 12.3428 20.956 12.4978 20.867L20.4978 16.274C20.8268 16.086 21.0198 15.727 20.9978 15.348C20.9748 14.97 20.7398 14.636 20.3918 14.487L18.2398 13.57L20.4978 12.274C20.8268 12.086 21.0198 11.727 20.9978 11.348Z",
      fill: color
    }
  ) });
}
var init_layers = __esm({
  "src/icons/salonized/layers.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/keypad.tsx
import { jsx as jsx188 } from "@emotion/react/jsx-runtime";
function Keypad(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx188(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx188(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M19 20C18.447 20 18 19.553 18 19C18 18.447 18.447 18 19 18C19.553 18 20 18.447 20 19C20 19.553 19.553 20 19 20ZM19 16C17.346 16 16 17.346 16 19C16 20.654 17.346 22 19 22C20.654 22 22 20.654 22 19C22 17.346 20.654 16 19 16ZM12 20C11.447 20 11 19.553 11 19C11 18.447 11.447 18 12 18C12.553 18 13 18.447 13 19C13 19.553 12.553 20 12 20ZM12 16C10.346 16 9 17.346 9 19C9 20.654 10.346 22 12 22C13.654 22 15 20.654 15 19C15 17.346 13.654 16 12 16ZM5 20C4.447 20 4 19.553 4 19C4 18.447 4.447 18 5 18C5.553 18 6 18.447 6 19C6 19.553 5.553 20 5 20ZM5 16C3.346 16 2 17.346 2 19C2 20.654 3.346 22 5 22C6.654 22 8 20.654 8 19C8 17.346 6.654 16 5 16ZM19 13C18.447 13 18 12.553 18 12C18 11.447 18.447 11 19 11C19.553 11 20 11.447 20 12C20 12.553 19.553 13 19 13ZM19 9C17.346 9 16 10.346 16 12C16 13.654 17.346 15 19 15C20.654 15 22 13.654 22 12C22 10.346 20.654 9 19 9ZM12 13C11.447 13 11 12.553 11 12C11 11.447 11.447 11 12 11C12.553 11 13 11.447 13 12C13 12.553 12.553 13 12 13ZM12 9C10.346 9 9 10.346 9 12C9 13.654 10.346 15 12 15C13.654 15 15 13.654 15 12C15 10.346 13.654 9 12 9ZM5 13C4.447 13 4 12.553 4 12C4 11.447 4.447 11 5 11C5.553 11 6 11.447 6 12C6 12.553 5.553 13 5 13ZM5 9C3.346 9 2 10.346 2 12C2 13.654 3.346 15 5 15C6.654 15 8 13.654 8 12C8 10.346 6.654 9 5 9ZM19 4C19.553 4 20 4.447 20 5C20 5.553 19.553 6 19 6C18.447 6 18 5.553 18 5C18 4.447 18.447 4 19 4ZM19 8C20.654 8 22 6.654 22 5C22 3.346 20.654 2 19 2C17.346 2 16 3.346 16 5C16 6.654 17.346 8 19 8ZM12 6C11.447 6 11 5.552 11 5C11 4.447 11.447 4 12 4C12.553 4 13 4.447 13 5C13 5.552 12.553 6 12 6ZM12 2C10.346 2 9 3.346 9 5C9 6.654 10.346 8 12 8C13.654 8 15 6.654 15 5C15 3.346 13.654 2 12 2ZM5 6C4.447 6 4 5.553 4 5C4 4.447 4.447 4 5 4C5.553 4 6 4.447 6 5C6 5.553 5.553 6 5 6ZM5 2C3.346 2 2 3.346 2 5C2 6.654 3.346 8 5 8C6.654 8 8 6.654 8 5C8 3.346 6.654 2 5 2Z",
      fill: color
    }
  ) });
}
var init_keypad = __esm({
  "src/icons/salonized/keypad.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/info.tsx
import { jsx as jsx189 } from "@emotion/react/jsx-runtime";
function Info(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx189(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx189(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11 8C11 7.448 11.448 7 12 7C12.552 7 13 7.448 13 8C13 8.552 12.552 9 12 9C11.448 9 11 8.552 11 8ZM11 11C11 10.448 11.448 10 12 10C12.552 10 13 10.448 13 11V16C13 16.552 12.552 17 12 17C11.448 17 11 16.552 11 16V11ZM12 20C7.589 20 4 16.411 4 12C4 7.589 7.589 4 12 4C16.411 4 20 7.589 20 12C20 16.411 16.411 20 12 20ZM12 2C6.477 2 2 6.477 2 12C2 17.523 6.477 22 12 22C17.522 22 22 17.523 22 12C22 6.477 17.522 2 12 2Z",
      fill: color
    }
  ) });
}
var init_info = __esm({
  "src/icons/salonized/info.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/inbox.tsx
import { jsx as jsx190 } from "@emotion/react/jsx-runtime";
function Inbox(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx190(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx190(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M18 19H6C5.449 19 5 18.552 5 18V13H7V16C7 16.553 7.448 17 8 17H16C16.552 17 17 16.553 17 16V13H19V18C19 18.552 18.551 19 18 19ZM8.342 5.553C8.512 5.212 8.855 5 9.236 5H14.764C15.145 5 15.488 5.212 15.658 5.553L18.382 11H16C15.448 11 15 11.447 15 12V15H9V12C9 11.447 8.552 11 8 11H5.618L8.342 5.553ZM20.789 11.342L17.447 4.658C16.936 3.636 15.908 3 14.764 3H9.236C8.092 3 7.064 3.636 6.553 4.658L3.211 11.342C3.073 11.618 3 11.928 3 12.236V18C3 19.654 4.346 21 6 21H18C19.654 21 21 19.654 21 18V12.236C21 11.928 20.927 11.618 20.789 11.342Z",
      fill: color
    }
  ) });
}
var init_inbox = __esm({
  "src/icons/salonized/inbox.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/image.tsx
import { jsx as jsx191 } from "@emotion/react/jsx-runtime";
function Image(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx191(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx191(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8 10C8.828 10 9.5 9.328 9.5 8.5C9.5 7.672 8.828 7 8 7C7.172 7 6.5 7.672 6.5 8.5C6.5 9.328 7.172 10 8 10ZM18 19H6.561L13.566 13.155C13.812 12.946 14.258 12.947 14.499 13.154L19 16.994V18C19 18.552 18.552 19 18 19ZM6 5H18C18.552 5 19 5.448 19 6V14.364L15.797 11.632C14.807 10.79 13.258 10.79 12.277 11.626L5 17.698V6C5 5.448 5.448 5 6 5ZM18 3H6C4.346 3 3 4.346 3 6V18C3 19.654 4.346 21 6 21H18C19.654 21 21 19.654 21 18V6C21 4.346 19.654 3 18 3Z",
      fill: color
    }
  ) });
}
var init_image = __esm({
  "src/icons/salonized/image.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/home.tsx
import { jsx as jsx192 } from "@emotion/react/jsx-runtime";
function Home2(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx192(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx192(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M18.99 20H16V13C16 12.447 15.552 12 15 12H9C8.447 12 8 12.447 8 13V20H5L5.006 11.583L11.998 4.43196L19 11.624L18.99 20ZM10 20H14V14H10V20ZM20.424 10.185L12.715 2.30096C12.338 1.91596 11.662 1.91596 11.285 2.30096L3.575 10.186C3.21 10.561 3 11.085 3 11.624V20C3 21.103 3.847 22 4.888 22H9H15H19.111C20.152 22 21 21.103 21 20V11.624C21 11.085 20.79 10.561 20.424 10.185Z",
      fill: color
    }
  ) });
}
var init_home2 = __esm({
  "src/icons/salonized/home.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/height.tsx
import { jsx as jsx193 } from "@emotion/react/jsx-runtime";
function Height(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx193(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx193(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M3 4H10C10.55 4 11 4.45 11 5C11 5.55 10.55 6 10 6H3C2.45 6 2 5.55 2 5C2 4.45 2.45 4 3 4ZM6 11H10C10.55 11 11 11.45 11 12C11 12.55 10.55 13 10 13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11ZM10 18H8C7.45 18 7 18.45 7 19C7 19.55 7.45 20 8 20H10C10.55 20 11 19.55 11 19C11 18.45 10.55 18 10 18ZM19.0002 16.6438L20.3052 15.3838C20.7032 15.0008 21.3362 15.0118 21.7192 15.4088C22.1032 15.8068 22.0922 16.4398 21.6952 16.8228L18.6952 19.7198C18.5002 19.9058 18.2502 19.9998 18.0002 19.9998C17.7442 19.9998 17.4882 19.9028 17.2932 19.7068L14.2932 16.7068C13.9022 16.3168 13.9022 15.6838 14.2932 15.2928C14.6832 14.9028 15.3162 14.9028 15.7072 15.2928L17.0002 16.5858V7.3568L15.6952 8.6158C15.2982 8.9998 14.6652 8.9878 14.2812 8.5908C13.8972 8.1938 13.9082 7.5608 14.3052 7.1768L17.3052 4.2798C17.6992 3.9038 18.3222 3.9058 18.7072 4.2928L21.7072 7.2928C22.0972 7.6838 22.0972 8.3168 21.7072 8.7068C21.5122 8.9028 21.2562 8.9998 21.0002 8.9998C20.7442 8.9998 20.4882 8.9028 20.2932 8.7068L19.0002 7.4138V16.6438Z",
      fill: color
    }
  ) });
}
var init_height = __esm({
  "src/icons/salonized/height.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/heart.tsx
import { jsx as jsx194 } from "@emotion/react/jsx-runtime";
function Heart(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx194(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx194(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M7.22005 6C6.35605 6 5.54605 6.334 4.94005 6.941C3.68205 8.201 3.68205 10.252 4.94105 11.514L12 18.585L19.06 11.514C20.319 10.252 20.319 8.201 19.06 6.941C17.848 5.726 15.712 5.728 14.5 6.941L12.708 8.736C12.332 9.113 11.668 9.113 11.292 8.736L9.50005 6.94C8.89405 6.334 8.08505 6 7.22005 6ZM12 21C11.735 21 11.48 20.895 11.293 20.706L3.52505 12.926C1.48905 10.886 1.48905 7.567 3.52505 5.527C4.50905 4.543 5.82105 4 7.22005 4C8.61905 4 9.93205 4.543 10.915 5.527L12 6.614L13.085 5.528C14.069 4.543 15.381 4 16.781 4C18.179 4 19.492 4.543 20.475 5.527C22.512 7.567 22.512 10.886 20.476 12.926L12.708 20.707C12.52 20.895 12.266 21 12 21Z",
      fill: color
    }
  ) });
}
var init_heart2 = __esm({
  "src/icons/salonized/heart.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/headphones.tsx
import { jsx as jsx195 } from "@emotion/react/jsx-runtime";
function Headphones(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx195(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx195(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M18 19C16.897 19 16 18.103 16 17C16 15.897 16.897 15 18 15C19.103 15 20 15.897 20 17C20 18.103 19.103 19 18 19ZM6 15C7.103 15 8 15.897 8 17C8 18.103 7.103 19 6 19C4.897 19 4 18.103 4 17C4 15.897 4.897 15 6 15ZM12 2C6.486 2 2 6.65 2 12.366V17C2 19.206 3.794 21 6 21C8.206 21 10 19.206 10 17C10 14.794 8.206 13 6 13C5.268 13 4.591 13.212 4 13.557V12.366C4 7.753 7.589 4 12 4C16.411 4 20 7.753 20 12.366V13.557C19.409 13.212 18.732 13 18 13C15.794 13 14 14.794 14 17C14 19.206 15.794 21 18 21C20.206 21 22 19.206 22 17V12.366C22 6.65 17.514 2 12 2Z",
      fill: color
    }
  ) });
}
var init_headphones = __esm({
  "src/icons/salonized/headphones.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/hash.tsx
import { jsx as jsx196 } from "@emotion/react/jsx-runtime";
function Hash(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx196(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx196(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M9.698 13.9999L10.427 9.99994H14.302L13.573 13.9999H9.698ZM20 13.9999H15.698L16.427 9.99994H20C20.55 9.99994 21 9.54994 21 8.99994C21 8.44994 20.55 7.99994 20 7.99994H16.79L17.484 4.18894C17.584 3.64094 17.202 3.11194 16.635 3.01594C16.068 2.91894 15.523 3.28894 15.423 3.83794L14.665 7.99994H10.79L11.484 4.18894C11.584 3.64094 11.202 3.11194 10.635 3.01594C10.068 2.91894 9.523 3.28894 9.423 3.83794L8.665 7.99994H4C3.45 7.99994 3 8.44994 3 8.99994C3 9.54994 3.45 9.99994 4 9.99994H8.302L7.573 13.9999H4C3.45 13.9999 3 14.4499 3 14.9999C3 15.5499 3.45 15.9999 4 15.9999H7.209L6.515 19.8109C6.416 20.3589 6.798 20.8879 7.365 20.9839C7.931 21.0809 8.477 20.7109 8.576 20.1619L9.334 15.9999H13.209L12.515 19.8109C12.416 20.3589 12.798 20.8879 13.365 20.9839C13.931 21.0809 14.477 20.7109 14.576 20.1619L15.334 15.9999H20C20.55 15.9999 21 15.5499 21 14.9999C21 14.4499 20.55 13.9999 20 13.9999Z",
      fill: color
    }
  ) });
}
var init_hash = __esm({
  "src/icons/salonized/hash.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/hard-drive.tsx
import { jsx as jsx197 } from "@emotion/react/jsx-runtime";
function HardDrive(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx197(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx197(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M7 16C7 15.45 7.45 15 8 15C8.55 15 9 15.45 9 16C9 16.55 8.55 17 8 17C7.45 17 7 16.55 7 16ZM12 15H16C16.55 15 17 15.45 17 16C17 16.55 16.55 17 16 17H12C11.45 17 11 16.55 11 16C11 15.45 11.45 15 12 15ZM18 19H6C5.449 19 5 18.552 5 18V13H19V18C19 18.552 18.551 19 18 19ZM8.342 5.553C8.512 5.212 8.855 5 9.236 5H14.764C15.145 5 15.488 5.212 15.658 5.553L18.382 11H5.618L8.342 5.553ZM20.789 11.342L17.447 4.658C16.936 3.636 15.908 3 14.764 3H9.236C8.092 3 7.064 3.636 6.553 4.658L3.211 11.342C3.073 11.618 3 11.928 3 12.236V18C3 19.654 4.346 21 6 21H18C19.654 21 21 19.654 21 18V12.236C21 11.928 20.927 11.618 20.789 11.342Z",
      fill: color
    }
  ) });
}
var init_hard_drive = __esm({
  "src/icons/salonized/hard-drive.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/grid.tsx
import { jsx as jsx198 } from "@emotion/react/jsx-runtime";
function Grid(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx198(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx198(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M15 19V15H19L19.001 19H15ZM19 13H15C13.897 13 13 13.897 13 15V19C13 20.103 13.897 21 15 21H19C20.103 21 21 20.103 21 19V15C21 13.897 20.103 13 19 13ZM5 19V15H9L9.001 19H5ZM9 13H5C3.897 13 3 13.897 3 15V19C3 20.103 3.897 21 5 21H9C10.103 21 11 20.103 11 19V15C11 13.897 10.103 13 9 13ZM15 9V5H19L19.001 9H15ZM19 3H15C13.897 3 13 3.897 13 5V9C13 10.103 13.897 11 15 11H19C20.103 11 21 10.103 21 9V5C21 3.897 20.103 3 19 3ZM5 9V5H9L9.001 9H5ZM9 3H5C3.897 3 3 3.897 3 5V9C3 10.103 3.897 11 5 11H9C10.103 11 11 10.103 11 9V5C11 3.897 10.103 3 9 3Z",
      fill: color
    }
  ) });
}
var init_grid = __esm({
  "src/icons/salonized/grid.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/google.tsx
import { jsx as jsx199 } from "@emotion/react/jsx-runtime";
function Google(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx199(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx199(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12.0031 4C9.82113 4 7.78313 4.861 6.26313 6.426C4.74313 7.989 3.94113 10.052 4.00413 12.235C4.12113 16.339 7.55313 19.818 11.6531 19.992C16.0351 20.165 19.7721 16.78 19.9951 12.419C20.0021 12.291 20.0011 11.726 19.9991 11.2H12.9971V12.782H18.3061L17.9011 14.08C17.1801 16.394 15.3521 17.982 13.0111 18.328C11.2651 18.581 9.44613 18.082 8.02313 16.945C6.62613 15.832 5.75013 14.214 5.61813 12.505C5.48013 10.698 6.07713 8.976 7.30313 7.653C8.96913 5.853 11.6621 5.16 13.9701 5.909L14.7431 4.48C13.8681 4.161 12.9491 4 12.0031 4ZM11.9961 21.999C11.8551 21.999 11.7121 21.996 11.5691 21.99C6.44113 21.773 2.15113 17.423 2.00413 12.292C1.92713 9.564 2.92913 6.986 4.82813 5.032C6.72913 3.077 9.27613 2 12.0031 2C13.4371 2 14.8231 2.298 16.1221 2.885C16.4831 3.048 16.7641 3.358 16.8911 3.736C17.0201 4.119 16.9841 4.543 16.7921 4.898L15.5001 7.282C15.1491 7.934 14.3571 8.214 13.6651 7.925C12.0121 7.252 9.99213 7.692 8.77013 9.012C7.92813 9.921 7.51713 11.107 7.61213 12.351C7.70213 13.509 8.30613 14.613 9.27013 15.382C10.2641 16.175 11.5261 16.528 12.7181 16.35C13.8181 16.187 14.7301 15.635 15.3501 14.782H12.4471C11.6481 14.782 10.9971 14.132 10.9971 13.332V10.65C10.9971 9.851 11.6481 9.2 12.4471 9.2H20.5471C21.3401 9.2 21.9911 9.845 21.9971 10.638C22.0001 11.269 22.0021 12.336 21.9931 12.52C21.7201 17.832 17.2771 21.999 11.9961 21.999Z",
      fill: color
    }
  ) });
}
var init_google = __esm({
  "src/icons/salonized/google.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/globe2.tsx
import { jsx as jsx200 } from "@emotion/react/jsx-runtime";
function Globe2(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx200(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx200(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M16.889 18.3185C16.717 17.8855 16.473 17.5075 16.259 17.1845C16.151 17.0225 16.04 16.8575 15.943 16.6875C15.554 16.0115 15.688 15.7375 16.319 14.6805L16.421 14.5075C16.932 13.6465 16.96 12.8205 16.986 12.0925C16.998 11.7345 17.01 11.3975 17.079 11.0805C17.24 10.3485 18.787 10.1535 19.746 10.0385C19.907 10.6675 20 11.3225 20 12.0005C20 14.5695 18.778 16.8535 16.889 18.3185ZM4.962 15.7995C5.598 15.9615 6.287 16.0735 6.988 16.0735C8.068 16.0735 9.171 15.8095 10.125 15.0625C11.841 13.7205 11.841 12.0045 11.841 10.6245C11.841 9.73249 11.841 8.96349 12.213 8.28049C12.413 7.91449 12.839 7.66049 13.332 7.36549C13.634 7.18449 13.947 6.99849 14.247 6.76249C14.89 6.25949 15.368 5.61249 15.664 4.89649C17.064 5.62149 18.224 6.74449 18.99 8.11949C17.562 8.31749 15.535 8.78549 15.126 10.6525C15.018 11.1465 15.001 11.6115 14.988 12.0225C14.967 12.6055 14.951 13.0665 14.701 13.4885L14.601 13.6565C13.954 14.7395 13.222 15.9675 14.209 17.6845C14.328 17.8925 14.461 18.0925 14.592 18.2915C14.936 18.8075 15.105 19.0925 15.106 19.3725C14.151 19.7765 13.101 20.0005 12 20.0005C8.963 20.0005 6.317 18.2985 4.962 15.7995ZM12 4.00049C12.616 4.00049 13.211 4.07649 13.787 4.20849C13.618 4.58049 13.357 4.91949 13.013 5.18849C12.795 5.36049 12.55 5.50349 12.307 5.64849C11.656 6.03649 10.919 6.47649 10.457 7.32249C9.841 8.45249 9.841 9.60649 9.841 10.6245C9.841 11.9795 9.797 12.7805 8.893 13.4875C7.524 14.5605 5.429 13.9615 4.133 13.4165C4.051 12.9555 4 12.4835 4 12.0005C4 7.58949 7.589 4.00049 12 4.00049ZM12 2.00049C6.486 2.00049 2 6.48649 2 12.0005C2 17.5135 6.486 22.0005 12 22.0005C17.514 22.0005 22 17.5135 22 12.0005C22 6.48649 17.514 2.00049 12 2.00049Z",
      fill: color
    }
  ) });
}
var init_globe2 = __esm({
  "src/icons/salonized/globe2.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/globe.tsx
import { jsx as jsx201 } from "@emotion/react/jsx-runtime";
function Globe(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx201(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx201(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M14.617 19.552C15.666 18.054 16.757 15.851 16.975 13H19.93C19.547 16.052 17.441 18.57 14.617 19.552ZM4.069 13H7.061C7.267 15.862 8.344 18.056 9.407 19.561C6.57 18.584 4.454 16.061 4.069 13ZM9.438 4.429C8.386 5.927 7.285 8.137 7.065 11H4.069C4.455 7.928 6.586 5.397 9.438 4.429ZM9.079 11C9.385 7.728 11.059 5.45 12.026 4.397C13.026 5.468 14.674 7.725 14.959 11H9.079ZM9.08 13H14.962C14.656 16.277 12.978 18.555 12.012 19.608C10.965 18.498 9.359 16.272 9.08 13ZM19.93 11H16.978C16.773 8.151 15.708 5.964 14.65 4.461C17.458 5.451 19.549 7.96 19.93 11ZM22 12C22 6.496 17.529 2.018 12.028 2.002C12.024 2.002 12.02 2.001 12.015 2.001C12.011 2.001 12.005 2 12 2C6.486 2 2 6.487 2 12C2 17.514 6.486 22 12 22C12.006 22 12.011 21.999 12.015 21.999C12.017 21.999 12.018 22 12.02 22C12.023 22 12.026 21.998 12.028 21.998C17.529 21.983 22 17.504 22 12Z",
      fill: color
    }
  ) });
}
var init_globe = __esm({
  "src/icons/salonized/globe.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/github.tsx
import { jsx as jsx202 } from "@emotion/react/jsx-runtime";
function Github(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx202(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx202(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M16.2404 22C15.6884 22 15.2404 21.553 15.2404 21V18.401C15.2874 17.738 15.0884 17.161 14.6974 16.742C14.4384 16.466 14.3584 16.068 14.4884 15.714C14.6184 15.359 14.9364 15.108 15.3124 15.065C17.7464 14.783 20.0004 13.947 20.0004 9.77399C20.0004 8.97399 19.7684 8.20299 19.3294 7.54699C18.9284 6.94899 18.7824 6.21999 18.9164 5.49399C19.0044 5.02099 18.9994 4.53999 18.9044 4.07499C18.5004 4.19499 17.8084 4.47999 16.8114 5.17399C16.5664 5.34399 16.2554 5.39499 15.9694 5.31499C14.1654 4.80799 12.2584 4.80799 10.4534 5.31499C10.1664 5.39499 9.85741 5.34399 9.61241 5.17399C8.62541 4.48699 7.93741 4.20099 7.51741 4.08299C7.42341 4.54399 7.41941 5.02099 7.50641 5.49099C7.63941 6.21299 7.48841 6.94999 7.08041 7.56799C6.64641 8.22699 6.41941 8.99699 6.42341 9.79699C6.42341 13.691 8.30241 14.73 11.1234 15.093C11.4954 15.141 11.8094 15.393 11.9374 15.746C12.0644 16.099 11.9834 16.493 11.7274 16.767C11.3404 17.182 11.1414 17.753 11.1804 18.334L11.1814 19.122C11.1834 19.162 11.1834 19.202 11.1814 19.242L11.1824 21C11.1824 21.553 10.7354 22 10.1824 22C9.63041 22 9.18241 21.553 9.18241 21V20.429C6.49741 20.779 4.96741 19.34 3.90641 18.34C3.46641 17.927 3.05241 17.536 2.74941 17.457C2.21441 17.318 1.89341 16.772 2.03241 16.238C2.17141 15.704 2.71741 15.378 3.25141 15.521C4.05041 15.729 4.64641 16.29 5.27741 16.884C6.29941 17.847 7.26941 18.759 9.18241 18.404V18.401C9.14541 17.872 9.22441 17.33 9.40741 16.817C7.35341 16.305 4.42341 14.812 4.42341 9.80199C4.41741 8.60999 4.75941 7.45599 5.41041 6.46699C5.53241 6.28199 5.57841 6.06499 5.53941 5.85399C5.33941 4.77099 5.45441 3.65899 5.87441 2.64299C5.98841 2.36699 6.21941 2.15599 6.50441 2.06799C6.83541 1.96599 8.05541 1.77099 10.3664 3.27099C12.2374 2.82199 14.1864 2.82199 16.0564 3.27099C18.3684 1.77099 19.5874 1.96499 19.9184 2.06799C20.2034 2.15599 20.4344 2.36699 20.5484 2.64299C20.9694 3.66099 21.0844 4.77199 20.8834 5.85799C20.8444 6.06699 20.8834 6.27199 20.9914 6.43499C21.6514 7.42199 22.0004 8.57599 22.0004 9.77399C22.0004 14.838 19.0774 16.313 17.0204 16.807C17.2044 17.336 17.2814 17.905 17.2374 18.478L17.2404 21C17.2404 21.553 16.7924 22 16.2404 22Z",
      fill: color
    }
  ) });
}
var init_github = __esm({
  "src/icons/salonized/github.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/gift.tsx
import { jsx as jsx203 } from "@emotion/react/jsx-runtime";
function Gift2(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx203(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx203(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M13 19H17.5V15H13V19ZM6.5 19H11V15H6.5V19ZM5 9.2C5 9.117 5.013 9.05 5.026 9H8.143H11V13H5.026C5.013 12.95 5 12.883 5 12.8V9.2ZM7 6C7 5.448 7.513 5 8.143 5C9.4 5 10.17 6.09 10.594 7H8.143C7.513 7 7 6.552 7 6ZM15.857 5C16.487 5 17 5.448 17 6C17 6.552 16.487 7 15.857 7H13.4C13.82 6.09 14.588 5 15.857 5ZM19 9.2V12.8C19 12.883 18.987 12.95 18.974 13H13V9H15.857H18.974C18.987 9.05 19 9.117 19 9.2ZM19.2 7H18.807C18.925 6.686 19 6.353 19 6C19 4.346 17.59 3 15.857 3C13.935 3 12.729 4.199 12 5.397C11.271 4.199 10.065 3 8.143 3C6.41 3 5 4.346 5 6C5 6.353 5.076 6.686 5.193 7H4.8C3.791 7 3 7.967 3 9.2V12.8C3 13.907 3.64 14.793 4.5 14.964V19.333C4.5 20.252 5.313 21 6.312 21H17.687C18.687 21 19.5 20.252 19.5 19.333V14.964C20.36 14.793 21 13.907 21 12.8V9.2C21 7.967 20.209 7 19.2 7Z",
      fill: color
    }
  ) });
}
var init_gift2 = __esm({
  "src/icons/salonized/gift.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/funnel.tsx
import { jsx as jsx204 } from "@emotion/react/jsx-runtime";
function Funnel(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx204(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx204(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10.8772 17.457L12.9032 18.99V14.437C12.9032 14.271 12.9452 14.108 13.0232 13.962L17.3232 6H6.64323L10.7652 13.978C10.8392 14.12 10.8772 14.278 10.8772 14.437V17.457ZM13.9032 22C13.6902 22 13.4772 21.932 13.3002 21.797L9.27423 18.752C9.02423 18.563 8.87723 18.268 8.87723 17.955V14.681L4.11223 5.459C3.95123 5.149 3.96423 4.778 4.14623 4.48C4.32723 4.182 4.65123 4 5.00023 4H19.0002C19.3522 4 19.6782 4.185 19.8592 4.488C20.0392 4.79 20.0472 5.165 19.8802 5.475L14.9032 14.69V21C14.9032 21.379 14.6892 21.726 14.3492 21.895C14.2082 21.965 14.0552 22 13.9032 22Z",
      fill: color
    }
  ) });
}
var init_funnel = __esm({
  "src/icons/salonized/funnel.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/folder.tsx
import { jsx as jsx205 } from "@emotion/react/jsx-runtime";
function Folder(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx205(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx205(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M4 13.7555V18.0685C4 18.3065 4.224 18.5005 4.5 18.5005H19.5C19.776 18.5005 20 18.3065 20 18.0685V9.47849C20 9.23949 19.776 9.04649 19.5 9.04649H12C11.7 9.04649 11.416 8.91149 11.226 8.67849L8.626 5.50049H4.5C4.224 5.50049 4 5.69349 4 5.93149V13.7555ZM19.5 20.5005H4.5C3.122 20.5005 2 19.4095 2 18.0685V5.93149C2 4.59049 3.122 3.50049 4.5 3.50049H9.101C9.4 3.50049 9.685 3.63449 9.875 3.86749L12.474 7.04649H19.5C20.878 7.04649 22 8.13649 22 9.47849V18.0685C22 19.4095 20.878 20.5005 19.5 20.5005Z",
      fill: color
    }
  ) });
}
var init_folder = __esm({
  "src/icons/salonized/folder.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/folder-remove.tsx
import { jsx as jsx206 } from "@emotion/react/jsx-runtime";
function FolderRemove(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx206(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx206(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M14 13.0001H10C9.45 13.0001 9 13.4501 9 14.0001C9 14.5501 9.45 15.0001 10 15.0001H14C14.55 15.0001 15 14.5501 15 14.0001C15 13.4501 14.55 13.0001 14 13.0001ZM20 18.0685C20 18.3065 19.776 18.5005 19.5 18.5005H4.5C4.224 18.5005 4 18.3065 4 18.0685V13.7555V5.93149C4 5.69349 4.224 5.50049 4.5 5.50049H8.626L11.226 8.67849C11.416 8.91149 11.7 9.04649 12 9.04649H19.5C19.776 9.04649 20 9.23949 20 9.47849V18.0685ZM19.5 7.04649H12.474L9.875 3.86749C9.685 3.63449 9.4 3.50049 9.101 3.50049H4.5C3.122 3.50049 2 4.59049 2 5.93149V18.0685C2 19.4095 3.122 20.5005 4.5 20.5005H19.5C20.878 20.5005 22 19.4095 22 18.0685V9.47849C22 8.13649 20.878 7.04649 19.5 7.04649Z",
      fill: color
    }
  ) });
}
var init_folder_remove = __esm({
  "src/icons/salonized/folder-remove.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/folder-add.tsx
import { jsx as jsx207 } from "@emotion/react/jsx-runtime";
function FolderAdd(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx207(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx207(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M14 13.0001H13V12.0001C13 11.4501 12.55 11.0001 12 11.0001C11.45 11.0001 11 11.4501 11 12.0001V13.0001H10C9.45 13.0001 9 13.4501 9 14.0001C9 14.5501 9.45 15.0001 10 15.0001H11V16.0001C11 16.5501 11.45 17.0001 12 17.0001C12.55 17.0001 13 16.5501 13 16.0001V15.0001H14C14.55 15.0001 15 14.5501 15 14.0001C15 13.4501 14.55 13.0001 14 13.0001ZM20 18.0685C20 18.3065 19.776 18.5005 19.5 18.5005H4.5C4.224 18.5005 4 18.3065 4 18.0685V13.7555V5.93149C4 5.69349 4.224 5.50049 4.5 5.50049H8.626L11.226 8.67849C11.416 8.91149 11.7 9.04649 12 9.04649H19.5C19.776 9.04649 20 9.23949 20 9.47849V18.0685ZM19.5 7.04649H12.474L9.875 3.86749C9.685 3.63449 9.4 3.50049 9.101 3.50049H4.5C3.122 3.50049 2 4.59049 2 5.93149V18.0685C2 19.4095 3.122 20.5005 4.5 20.5005H19.5C20.878 20.5005 22 19.4095 22 18.0685V9.47849C22 8.13649 20.878 7.04649 19.5 7.04649Z",
      fill: color
    }
  ) });
}
var init_folder_add = __esm({
  "src/icons/salonized/folder-add.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/flip2.tsx
import { jsx as jsx208 } from "@emotion/react/jsx-runtime";
function Flip2(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx208(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx208(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M7.20725 9.70699C6.81625 10.098 6.18425 10.098 5.79325 9.70699L2.79325 6.70699C2.40225 6.31599 2.40225 5.68399 2.79325 5.293L5.79325 2.293C5.98825 2.09799 6.24425 1.99999 6.50025 1.99999C6.75625 1.99999 7.01225 2.09799 7.20725 2.293C7.59825 2.68399 7.59825 3.31599 7.20725 3.70699L5.91425 4.99999H17.9102C19.8902 4.99999 21.5002 6.58299 21.5002 8.52899V11C21.5002 11.553 21.0532 12 20.5002 12C19.9472 12 19.5002 11.553 19.5002 11V8.52899C19.5002 7.68599 18.7872 6.99999 17.9102 6.99999L5.91425 6.99999L7.20725 8.29299C7.59825 8.68399 7.59825 9.31599 7.20725 9.70699ZM18.086 19H6.09005C4.11105 19 2.50005 17.417 2.50005 15.471V13C2.50005 12.447 2.94705 12 3.50005 12C4.05305 12 4.50005 12.447 4.50005 13V15.471C4.50005 16.313 5.21305 17 6.09005 17H18.086L16.793 15.707C16.403 15.316 16.403 14.684 16.793 14.293C16.988 14.098 17.244 14 17.5 14C17.756 14 18.012 14.098 18.207 14.293L21.207 17.293C21.598 17.684 21.598 18.316 21.207 18.707L18.207 21.707C17.817 22.098 17.184 22.098 16.793 21.707C16.403 21.316 16.403 20.684 16.793 20.293L18.086 19Z",
      fill: color
    }
  ) });
}
var init_flip2 = __esm({
  "src/icons/salonized/flip2.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/flip.tsx
import { jsx as jsx209 } from "@emotion/react/jsx-runtime";
function Flip(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx209(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx209(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M14.2933 7.20701C13.9023 6.81601 13.9023 6.18401 14.2933 5.79301L17.2933 2.79301C17.6842 2.40201 18.3162 2.40201 18.7072 2.79301L21.7072 5.79301C21.9023 5.98801 22.0002 6.24401 22.0002 6.50001C22.0002 6.75601 21.9023 7.01201 21.7072 7.20701C21.3162 7.59801 20.6842 7.59801 20.2933 7.20701L19.0002 5.91401V17.91C19.0002 19.89 17.4172 21.5 15.4712 21.5H13.0002C12.4473 21.5 12.0002 21.053 12.0002 20.5C12.0002 19.947 12.4473 19.5 13.0002 19.5H15.4712C16.3142 19.5 17.0002 18.787 17.0002 17.91V5.91401L15.7072 7.20701C15.3162 7.59801 14.6842 7.59801 14.2933 7.20701ZM5.00025 18.0858V6.08981C5.00025 4.11081 6.58325 2.49981 8.52925 2.49981H11.0002C11.5532 2.49981 12.0002 2.94681 12.0002 3.49981C12.0002 4.05281 11.5532 4.49981 11.0002 4.49981H8.52925C7.68725 4.49981 7.00025 5.21281 7.00025 6.08981V18.0858L8.29325 16.7928C8.68425 16.4028 9.31625 16.4028 9.70725 16.7928C9.90225 16.9878 10.0002 17.2438 10.0002 17.4998C10.0002 17.7558 9.90225 18.0118 9.70725 18.2068L6.70725 21.2068C6.31625 21.5978 5.68425 21.5978 5.29325 21.2068L2.29325 18.2068C1.90225 17.8168 1.90225 17.1838 2.29325 16.7928C2.68425 16.4028 3.31625 16.4028 3.70725 16.7928L5.00025 18.0858Z",
      fill: color
    }
  ) });
}
var init_flip = __esm({
  "src/icons/salonized/flip.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/flash.tsx
import { jsx as jsx210 } from "@emotion/react/jsx-runtime";
function Flash(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx210(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx210(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M6.87087 12.7997H11.9999C12.2839 12.7997 12.5549 12.9207 12.7439 13.1317C12.9329 13.3427 13.0239 13.6247 12.9939 13.9067L12.5449 18.0567L17.1289 11.1997H11.9999C11.7159 11.1997 11.4449 11.0787 11.2559 10.8677C11.0659 10.6567 10.9749 10.3747 11.0059 10.0927L11.4549 5.94374L6.87087 12.7997ZM11.1109 22.9997C10.9969 22.9997 10.8819 22.9807 10.7689 22.9397C10.3369 22.7817 10.0669 22.3497 10.1169 21.8927L10.8859 14.7997H4.99987C4.63087 14.7997 4.29187 14.5967 4.11787 14.2717C3.94387 13.9457 3.96387 13.5507 4.16887 13.2437L12.0579 1.44474C12.3129 1.06074 12.7969 0.902737 13.2299 1.06074C13.6629 1.21774 13.9329 1.65074 13.8829 2.10774L13.1139 9.19974H18.9999C19.3689 9.19974 19.7079 9.40374 19.8819 9.72874C20.0559 10.0547 20.0359 10.4487 19.8309 10.7557L11.9419 22.5557C11.7529 22.8397 11.4369 22.9997 11.1109 22.9997Z",
      fill: color
    }
  ) });
}
var init_flash = __esm({
  "src/icons/salonized/flash.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/flash-off.tsx
import { jsx as jsx211 } from "@emotion/react/jsx-runtime";
function FlashOff(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx211(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx211(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11.1933 8.36449L11.4553 5.94349L10.3803 7.55149L8.93835 6.11049L12.0583 1.44449C12.3133 1.06049 12.7983 0.902493 13.2303 1.06049C13.6633 1.21749 13.9333 1.65049 13.8833 2.10749L13.1143 9.20049H19.0003C19.3693 9.20049 19.7083 9.40349 19.8823 9.72849C20.0563 10.0545 20.0363 10.4495 19.8313 10.7555L17.3283 14.5005L15.8873 13.0585L17.1293 11.2005H14.0283L11.1933 8.36449ZM20.7072 19.2931L4.70725 3.29309C4.31625 2.90209 3.68425 2.90209 3.29325 3.29309C2.90225 3.68409 2.90225 4.31609 3.29325 4.70709L19.2932 20.7071C19.4882 20.9021 19.7442 21.0001 20.0002 21.0001C20.2562 21.0001 20.5122 20.9021 20.7072 20.7071C21.0982 20.3161 21.0982 19.6841 20.7072 19.2931ZM12.5451 18.0567L12.8071 15.6357L9.97215 12.7997H6.87115L8.11315 10.9417L6.67215 9.49969L4.16915 13.2447C3.96415 13.5507 3.94415 13.9457 4.11815 14.2717C4.29215 14.5967 4.63115 14.7997 5.00015 14.7997H10.8861L10.1171 21.8927C10.0671 22.3497 10.3371 22.7827 10.7701 22.9397C10.8821 22.9807 10.9971 22.9997 11.1111 22.9997C11.4381 22.9997 11.7531 22.8397 11.9421 22.5557L15.0621 17.8897L13.6201 16.4487L12.5451 18.0567Z",
      fill: color
    }
  ) });
}
var init_flash_off = __esm({
  "src/icons/salonized/flash-off.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/flag.tsx
import { jsx as jsx212 } from "@emotion/react/jsx-runtime";
function Flag(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx212(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx212(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M18 14.586C17.604 14.763 16.825 15 15.5 15C14.376 15 13.399 14.617 12.365 14.212C11.203 13.757 10.001 13.286 8.5 13.286C7.443 13.286 6.624 13.413 6 13.584V12V5.416C6.396 5.239 7.177 5 8.5 5C9.624 5 10.601 5.383 11.635 5.788C12.797 6.243 13.999 6.714 15.5 6.714C16.438 6.714 17.276 6.613 18 6.414V14.586ZM19.268 4.68C18.806 4.346 18.208 4.251 17.669 4.427C17.093 4.614 16.343 4.714 15.5 4.714C14.376 4.714 13.399 4.331 12.365 3.926C11.203 3.471 10.001 3 8.5 3C5.613 3 4.495 3.952 4.3 4.144C4.108 4.331 4 4.589 4 4.857V12V15.143V20C4 20.553 4.447 21 5 21C5.553 21 6 20.553 6 20V15.702C6.395 15.526 7.173 15.286 8.5 15.286C9.624 15.286 10.601 15.669 11.635 16.074C12.797 16.529 13.999 17 15.5 17C17.309 17 18.423 16.622 19.041 16.305C19.633 15.998 20 15.402 20 14.749V6.106C20 5.546 19.727 5.013 19.268 4.68Z",
      fill: color
    }
  ) });
}
var init_flag = __esm({
  "src/icons/salonized/flag.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/fire.tsx
import { jsx as jsx213 } from "@emotion/react/jsx-runtime";
function Fire2(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx213(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx213(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M7.49496 9.51647C5.46296 11.7155 5.50596 15.2015 7.62396 17.3605C8.65796 18.4175 10.032 19.0005 11.496 19.0015H11.501C12.968 19.0015 14.347 18.4185 15.386 17.3605C17.542 15.1625 17.538 11.5875 15.377 9.39247L12.391 6.34147C12.089 8.82347 11.158 11.0015 9.49996 11.0015C8.99196 11.0015 8.16396 10.7755 7.49496 9.51647ZM11.501 21.0015H11.494C9.48796 20.9995 7.60596 20.2045 6.19496 18.7595C3.28096 15.7895 3.27696 10.9565 6.18596 7.99147L7.16896 6.99747C7.42296 6.74347 7.79196 6.64547 8.14096 6.73647C8.48796 6.83047 8.75796 7.10347 8.84796 7.45147C9.07796 8.34047 9.35196 8.77747 9.50296 8.94347C9.85796 8.56947 10.5 7.05847 10.5 4.50147C10.5 4.35447 10.5 4.21547 10.492 4.07647C10.473 3.78147 10.586 3.49247 10.8 3.28847C11.197 2.91147 11.833 2.91147 12.214 3.30347L16.804 7.99247C19.724 10.9565 19.729 15.7895 16.814 18.7605C15.395 20.2065 13.509 21.0015 11.501 21.0015Z",
      fill: color
    }
  ) });
}
var init_fire2 = __esm({
  "src/icons/salonized/fire.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/film.tsx
import { jsx as jsx214 } from "@emotion/react/jsx-runtime";
function Film(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx214(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx214(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M19 18.256C19 18.666 18.666 19 18.256 19H17V17H19V18.256ZM5 18.256V17H7V19H5.744C5.334 19 5 18.666 5 18.256ZM5.744 5H7V7H5V5.744C5 5.334 5.334 5 5.744 5ZM19 5.744V7H17V5H18.256C18.666 5 19 5.334 19 5.744ZM17 15H19V13H17V15ZM17 11H19V9H17V11ZM9 19H15V5H9V19ZM5 15H7V13H5V15ZM5 11H7V9H5V11ZM18.256 3H5.744C4.231 3 3 4.232 3 5.744V18.256C3 19.769 4.231 21 5.744 21H18.256C19.769 21 21 19.769 21 18.256V5.744C21 4.232 19.769 3 18.256 3Z",
      fill: color
    }
  ) });
}
var init_film = __esm({
  "src/icons/salonized/film.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/file.tsx
import { jsx as jsx215 } from "@emotion/react/jsx-runtime";
function File(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx215(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx215(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M17.444 20H6.555C6.249 20 6 19.776 6 19.5V4.5C6 4.224 6.249 4 6.555 4H11V8.15C11 9.722 12.217 11 13.714 11H18V19.5C18 19.776 17.75 20 17.444 20ZM17.649 9H13.714C13.32 9 13 8.619 13 8.15V4H13.112L17.649 9ZM19.74 8.328L14.296 2.328C14.107 2.119 13.838 2 13.555 2H6.555C5.146 2 4 3.122 4 4.5V19.5C4 20.878 5.146 22 6.555 22H17.444C18.853 22 20 20.878 20 19.5V9C20 8.751 19.907 8.512 19.74 8.328Z",
      fill: color
    }
  ) });
}
var init_file = __esm({
  "src/icons/salonized/file.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/file-text.tsx
import { jsx as jsx216 } from "@emotion/react/jsx-runtime";
function FileText(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx216(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx216(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11.9997 14H8.9997C8.4477 14 7.9997 13.552 7.9997 13C7.9997 12.448 8.4477 12 8.9997 12H11.9997C12.5517 12 12.9997 12.448 12.9997 13C12.9997 13.552 12.5517 14 11.9997 14ZM7.9997 17C7.9997 16.448 8.4477 16 8.9997 16H14.9997C15.5527 16 15.9997 16.448 15.9997 17C15.9997 17.552 15.5527 18 14.9997 18H8.9997C8.4477 18 7.9997 17.552 7.9997 17ZM17.444 20H6.555C6.249 20 6 19.776 6 19.5V4.5C6 4.224 6.249 4 6.555 4H12V7.15C12 8.722 13.217 10 14.714 10H18V19.5C18 19.776 17.751 20 17.444 20ZM14 4.978L16.742 8H14.714C14.32 8 14 7.619 14 7.15V4.978ZM19.74 8.328L14.296 2.328C14.106 2.119 13.838 2 13.555 2H6.555C5.146 2 4 3.122 4 4.5V19.5C4 20.878 5.146 22 6.555 22H17.444C18.853 22 20 20.878 20 19.5V9C20 8.751 19.907 8.512 19.74 8.328Z",
      fill: color
    }
  ) });
}
var init_file_text = __esm({
  "src/icons/salonized/file-text.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/file-remove.tsx
import { jsx as jsx217 } from "@emotion/react/jsx-runtime";
function FileRemove(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx217(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx217(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M13.9997 13H9.9997C9.4467 13 8.9997 13.448 8.9997 14C8.9997 14.552 9.4467 15 9.9997 15H13.9997C14.5527 15 14.9997 14.552 14.9997 14C14.9997 13.448 14.5527 13 13.9997 13ZM17.444 20H6.555C6.249 20 6 19.776 6 19.5V4.5C6 4.224 6.249 4 6.555 4H12V7.15C12 8.722 13.217 10 14.714 10H18V19.5C18 19.776 17.751 20 17.444 20ZM14 4.978L16.742 8H14.714C14.32 8 14 7.619 14 7.15V4.978ZM19.74 8.328L14.296 2.328C14.106 2.119 13.838 2 13.555 2H6.555C5.146 2 4 3.122 4 4.5V19.5C4 20.878 5.146 22 6.555 22H17.444C18.853 22 20 20.878 20 19.5V9C20 8.751 19.907 8.512 19.74 8.328Z",
      fill: color
    }
  ) });
}
var init_file_remove = __esm({
  "src/icons/salonized/file-remove.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/file-add.tsx
import { jsx as jsx218 } from "@emotion/react/jsx-runtime";
function FileAdd(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx218(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx218(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M13.9997 13H12.9997V12C12.9997 11.448 12.5527 11 11.9997 11C11.4467 11 10.9997 11.448 10.9997 12V13H9.9997C9.4467 13 8.9997 13.448 8.9997 14C8.9997 14.552 9.4467 15 9.9997 15H10.9997V16C10.9997 16.552 11.4467 17 11.9997 17C12.5527 17 12.9997 16.552 12.9997 16V15H13.9997C14.5527 15 14.9997 14.552 14.9997 14C14.9997 13.448 14.5527 13 13.9997 13ZM17.444 20H6.555C6.249 20 6 19.776 6 19.5V4.5C6 4.224 6.249 4 6.555 4H12V7.15C12 8.722 13.217 10 14.714 10H18V19.5C18 19.776 17.751 20 17.444 20ZM14 4.978L16.742 8H14.714C14.32 8 14 7.619 14 7.15V4.978ZM19.74 8.328L14.296 2.328C14.106 2.119 13.838 2 13.555 2H6.555C5.146 2 4 3.122 4 4.5V19.5C4 20.878 5.146 22 6.555 22H17.444C18.853 22 20 20.878 20 19.5V9C20 8.751 19.907 8.512 19.74 8.328Z",
      fill: color
    }
  ) });
}
var init_file_add = __esm({
  "src/icons/salonized/file-add.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/facebook.tsx
import { jsx as jsx219 } from "@emotion/react/jsx-runtime";
function Facebook(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx219(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx219(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10 20H12V13.8C12 13.247 12.447 12.8 13 12.8H15.24L15.685 11.2H13C12.447 11.2 12 10.753 12 10.2V7.5C12 6.452 12.897 5.6 14 5.6H16V4H14C11.794 4 10 5.57 10 7.5V10.2C10 10.753 9.553 11.2 9 11.2H7V12.8H9C9.553 12.8 10 13.247 10 13.8V20ZM13 22H9C8.447 22 8 21.553 8 21V14.8H6C5.447 14.8 5 14.353 5 13.8V10.2C5 9.647 5.447 9.2 6 9.2H8V7.5C8 4.468 10.691 2 14 2H17C17.553 2 18 2.447 18 3V6.6C18 7.152 17.553 7.6 17 7.6H14V9.2H17C17.312 9.2 17.607 9.347 17.796 9.595C17.985 9.844 18.047 10.167 17.964 10.468L16.964 14.067C16.844 14.5 16.449 14.8 16 14.8H14V21C14 21.553 13.553 22 13 22Z",
      fill: color
    }
  ) });
}
var init_facebook = __esm({
  "src/icons/salonized/facebook.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/eye.tsx
import { jsx as jsx220 } from "@emotion/react/jsx-runtime";
function Eye(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx220(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx220(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12 13.5C11.173 13.5 10.5 12.827 10.5 12C10.5 11.173 11.173 10.5 12 10.5C12.827 10.5 13.5 11.173 13.5 12C13.5 12.827 12.827 13.5 12 13.5ZM12 8.50002C10.0701 8.50002 8.50005 10.07 8.50005 12C8.50005 13.93 10.0701 15.5 12 15.5C13.93 15.5 15.5 13.93 15.5 12C15.5 10.07 13.93 8.50002 12 8.50002ZM12.2197 16.9976C7.91375 17.0976 5.10475 13.4146 4.17275 11.9956C5.19875 10.3906 7.78275 7.10462 11.7808 7.00262C16.0697 6.89362 18.8948 10.5856 19.8267 12.0046C18.8018 13.6096 16.2168 16.8956 12.2197 16.9976ZM21.8678 11.5026C21.2297 10.3906 17.7057 4.81662 11.7297 5.00362C6.20175 5.14362 2.98675 10.0136 2.13275 11.5026C1.95575 11.8106 1.95575 12.1896 2.13275 12.4976C2.76175 13.5946 6.16175 18.9996 12.0247 18.9996C12.1067 18.9996 12.1888 18.9986 12.2708 18.9966C17.7978 18.8556 21.0138 13.9866 21.8678 12.4976C22.0438 12.1896 22.0438 11.8106 21.8678 11.5026Z",
      fill: color
    }
  ) });
}
var init_eye = __esm({
  "src/icons/salonized/eye.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/eye-off2.tsx
import { jsx as jsx221 } from "@emotion/react/jsx-runtime";
function EyeOff2(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx221(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx221(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M17.8089 13.395C19.5139 11.978 20.6989 9.95298 20.9919 7.62398C21.0609 7.07698 20.6729 6.57698 20.1239 6.50798C19.5839 6.43398 19.0759 6.82698 19.0079 7.37498C18.5689 10.867 15.5559 13.5 11.9999 13.5C8.44395 13.5 5.43095 10.867 4.99195 7.37498C4.92395 6.82698 4.41395 6.43798 3.87495 6.50798C3.32695 6.57698 2.93895 7.07698 3.00795 7.62398C3.30095 9.95298 4.48595 11.978 6.19095 13.395L3.87895 15.707C3.48995 16.096 3.48995 16.732 3.87895 17.121C4.26695 17.51 4.90395 17.51 5.29295 17.121L7.89595 14.518C8.84995 15 9.89695 15.318 10.9999 15.439V19C10.9999 19.55 11.4499 20 11.9999 20C12.5499 20 12.9999 19.55 12.9999 19V15.439C14.1019 15.318 15.1499 15 16.1029 14.518L18.7069 17.121C19.0959 17.51 19.7319 17.51 20.1209 17.121C20.5099 16.732 20.5099 16.096 20.1209 15.707L17.8089 13.395Z",
      fill: color
    }
  ) });
}
var init_eye_off2 = __esm({
  "src/icons/salonized/eye-off2.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/eye-off.tsx
import { jsx as jsx222 } from "@emotion/react/jsx-runtime";
function EyeOff(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx222(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx222(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12 13.5C11.173 13.5 10.5 12.827 10.5 12C10.5 11.9869 10.5031 11.9741 10.5061 11.9613L10.5061 11.9613C10.5088 11.9496 10.5116 11.9379 10.512 11.926L12.074 13.488C12.0621 13.4885 12.0504 13.4912 12.0388 13.494C12.0259 13.497 12.0131 13.5 12 13.5ZM4.70705 3.29301C4.31605 2.90201 3.68405 2.90201 3.29305 3.29301C2.90205 3.68401 2.90205 4.31601 3.29305 4.70701L8.92305 10.337C8.64705 10.846 8.50005 11.411 8.50005 12C8.50005 13.93 10.0701 15.5 12 15.5C12.5891 15.5 13.154 15.353 13.663 15.077L19.293 20.707C19.488 20.902 19.744 21 20 21C20.2561 21 20.5121 20.902 20.7071 20.707C21.0981 20.316 21.0981 19.684 20.7071 19.293L4.70705 3.29301ZM12.2198 16.9976C7.91475 17.0976 5.10475 13.4146 4.17275 11.9956C4.62975 11.2816 5.39575 10.2356 6.45575 9.28461L5.04475 7.87261C3.52275 9.26161 2.54675 10.7796 2.13275 11.5026C1.95575 11.8106 1.95575 12.1896 2.13275 12.4976C2.76175 13.5946 6.16175 18.9996 12.0247 18.9996C12.1067 18.9996 12.1888 18.9986 12.2708 18.9966C13.4548 18.9666 14.5268 18.7106 15.4978 18.3266L13.9178 16.7466C13.3828 16.8886 12.8198 16.9826 12.2198 16.9976ZM11.7297 5.00341C17.7048 4.81641 21.2297 10.3904 21.8678 11.5024C22.0438 11.8104 22.0438 12.1894 21.8678 12.4974C21.4527 13.2204 20.4767 14.7384 18.9548 16.1274L17.5437 14.7154C18.6038 13.7644 19.3708 12.7184 19.8267 12.0044C18.8948 10.5854 16.0717 6.89441 11.7808 7.00241C11.1807 7.01741 10.6178 7.11141 10.0817 7.25341L8.50175 5.67341C9.47375 5.28941 10.5448 5.03341 11.7297 5.00341Z",
      fill: color
    }
  ) });
}
var init_eye_off = __esm({
  "src/icons/salonized/eye-off.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/external-link.tsx
import { jsx as jsx223 } from "@emotion/react/jsx-runtime";
function ExternalLink(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx223(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx223(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M19 18V12C19 11.448 19.447 11 20 11C20.553 11 21 11.448 21 12V18C21 19.654 19.654 21 18 21H6C4.346 21 3 19.654 3 18V6C3 4.346 4.346 3 6 3H12C12.553 3 13 3.448 13 4C13 4.552 12.553 5 12 5H6C5.448 5 5 5.449 5 6V18C5 18.551 5.448 19 6 19H18C18.552 19 19 18.551 19 18ZM17.5781 5.008L15.9951 5C15.4421 4.997 14.9971 4.547 15.0001 3.995C15.0031 3.444 15.4501 3 16.0001 3H16.0051L20.0021 3.02C20.5521 3.023 20.9971 3.469 20.9971 4.019L21.0001 7.999C21.0001 8.552 20.5531 9 20.0011 9H20.0001C19.4481 9 19.0001 8.553 19.0001 8.001L18.9991 6.415L12.7071 12.707C12.5121 12.902 12.2561 13 12.0001 13C11.7441 13 11.4881 12.902 11.2931 12.707C10.9021 12.316 10.9021 11.684 11.2931 11.293L17.5781 5.008Z",
      fill: color
    }
  ) });
}
var init_external_link = __esm({
  "src/icons/salonized/external-link.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/expand.tsx
import { jsx as jsx224 } from "@emotion/react/jsx-runtime";
function Expand2(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx224(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx224(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M19.0016 4.02549C19.5516 4.02849 19.9966 4.47449 19.9966 5.02449L19.9996 9.99949C20.0006 10.5515 19.5526 11.0005 19.0006 11.0005H18.9996C18.4476 11.0005 18.0006 10.5525 17.9996 10.0015L17.9976 7.41649L14.7066 10.7075C14.5116 10.9025 14.2556 11.0005 13.9996 11.0005C13.7446 11.0005 13.4886 10.9025 13.2926 10.7075C12.9026 10.3165 12.9026 9.68349 13.2926 9.29349L16.5726 6.01349L13.9956 6.00049C13.4426 5.99749 12.9966 5.54649 12.9996 4.99549C13.0026 4.44449 13.4506 4.00049 13.9996 4.00049H14.0046L19.0016 4.02549ZM9.29301 13.2931C9.68401 12.9021 10.316 12.9021 10.707 13.2931C11.098 13.6841 11.098 14.3161 10.707 14.7071L7.41501 17.9991L10 18.0001C10.553 18.0001 11 18.4481 11 19.0011C10.999 19.5531 10.552 20.0001 10 20.0001H9.99901L5.02401 19.9971C4.47402 19.9971 4.02802 19.5521 4.02502 19.0021L4.00002 14.0051C3.99702 13.4531 4.44302 13.0031 4.99501 13.0001H5.00001C5.55001 13.0001 5.99701 13.4441 6.00001 13.9951L6.01301 16.5731L9.29301 13.2931Z",
      fill: color
    }
  ) });
}
var init_expand2 = __esm({
  "src/icons/salonized/expand.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/email.tsx
import { jsx as jsx225 } from "@emotion/react/jsx-runtime";
function Email(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx225(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx225(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M19 18H5C4.449 18 4 17.552 4 17V7.25L11.4 12.8C11.578 12.934 11.789 13 12 13C12.211 13 12.422 12.934 12.6 12.8L20 7.25V17C20 17.552 19.551 18 19 18ZM18.333 6L12 10.75L5.667 6H18.333ZM19 4H5C3.346 4 2 5.346 2 7V17C2 18.654 3.346 20 5 20H19C20.654 20 22 18.654 22 17V7C22 5.346 20.654 4 19 4Z",
      fill: color
    }
  ) });
}
var init_email = __esm({
  "src/icons/salonized/email.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/edit2.tsx
import { jsx as jsx226 } from "@emotion/react/jsx-runtime";
function Edit2(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx226(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx226(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11.9831 7.32281L6.36614 12.9398L6.10214 15.8958L9.07914 15.6248L14.6791 10.0188L11.9831 7.32281ZM17.9661 6.72881L15.2711 4.03481L13.3231 5.98281L16.0181 8.67881L17.9661 6.72881ZM5.09114 17.9958C5.06014 17.9988 5.03014 17.9998 5.00014 17.9998C4.73614 17.9998 4.48114 17.8958 4.29314 17.7068C4.08314 17.4968 3.97714 17.2048 4.00414 16.9098L4.38314 12.7388C4.42514 12.2818 4.62714 11.8508 4.95214 11.5258L13.9481 2.52881C14.6501 1.82481 15.9241 1.85981 16.6641 2.59881L19.4021 5.33681H19.4031C20.1691 6.10381 20.1991 7.32081 19.4711 8.05081L10.4741 17.0478C10.1491 17.3738 9.71914 17.5748 9.26114 17.6168L5.09114 17.9958ZM5 19.9999H19C19.55 19.9999 20 20.4499 20 20.9999C20 21.5499 19.55 21.9999 19 21.9999H5C4.45 21.9999 4 21.5499 4 20.9999C4 20.4499 4.45 19.9999 5 19.9999Z",
      fill: color
    }
  ) });
}
var init_edit2 = __esm({
  "src/icons/salonized/edit2.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/edit.tsx
import { jsx as jsx227 } from "@emotion/react/jsx-runtime";
function Edit(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx227(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx227(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M16.0189 10.6787L13.3239 7.98367L15.2719 6.03467L17.9659 8.72867L16.0189 10.6787ZM9.0799 17.6247L6.1029 17.8957L6.3669 14.9397L11.9839 9.32267L14.6799 12.0187L9.0799 17.6247ZM19.4039 7.33767L19.4029 7.33667L16.6649 4.59867C15.9239 3.85967 14.6509 3.82467 13.9489 4.52967L4.9529 13.5257C4.6269 13.8507 4.4249 14.2827 4.3829 14.7397L4.0039 18.9097C3.9779 19.2047 4.0829 19.4967 4.2929 19.7067C4.4819 19.8957 4.7369 19.9997 4.9999 19.9997C5.0309 19.9997 5.0609 19.9987 5.0909 19.9957L9.2609 19.6167C9.7189 19.5747 10.1499 19.3737 10.4749 19.0487L19.4719 10.0517C20.1999 9.32167 20.1689 8.10367 19.4039 7.33767Z",
      fill: color
    }
  ) });
}
var init_edit = __esm({
  "src/icons/salonized/edit.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/droplet.tsx
import { jsx as jsx228 } from "@emotion/react/jsx-runtime";
function Droplet(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx228(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx228(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12.5585 5.42903L8.64851 9.35503C6.47251 11.538 6.44351 15.114 8.58051 17.327C9.60951 18.394 10.9835 18.988 12.4475 19H12.4495C13.9145 19.011 15.2985 18.44 16.3445 17.39C18.5185 15.211 18.5475 11.636 16.4095 9.42103L12.5585 5.42903ZM12.4315 21C10.4245 20.983 8.54651 20.172 7.14151 18.716C4.25251 15.724 4.29151 10.893 7.22851 7.94603L11.8615 3.29503C12.0515 3.10503 12.3095 2.99803 12.5785 3.00003C12.8475 3.00303 13.1035 3.11403 13.2895 3.30603L17.8495 8.03303C20.7375 11.026 20.6985 15.858 17.7615 18.802C16.3325 20.236 14.4405 21.016 12.4335 21H12.4315Z",
      fill: color
    }
  ) });
}
var init_droplet = __esm({
  "src/icons/salonized/droplet.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/droplet-off.tsx
import { jsx as jsx229 } from "@emotion/react/jsx-runtime";
function DropletOff(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx229(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx229(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11.9968 5.42876L15.8808 9.38775C17.2528 10.7848 17.7448 12.7398 17.3718 14.5428L18.9798 16.1518C20.0268 13.4188 19.4708 10.1908 17.3088 7.98776L12.7098 3.29976C12.5218 3.10876 12.2648 2.99976 11.9968 2.99976H11.9958C11.7268 2.99976 11.4698 3.10876 11.2818 3.30076L8.73185 5.90376L10.1458 7.31876L11.9968 5.42876ZM12.0026 19.0001H12.0006C10.5356 19.0001 9.15665 18.4181 8.11865 17.3601C6.22765 15.4341 5.99665 12.4451 7.42565 10.2541L5.99365 8.82206C3.80765 11.8041 4.03465 16.0551 6.69165 18.7611C8.10865 20.2051 9.99365 21.0001 12.0006 21.0001H12.0026C13.6826 20.9991 15.2726 20.4361 16.5786 19.4061L15.1476 17.9761C14.2306 18.6351 13.1456 18.9991 12.0026 19.0001ZM4.70725 3.29306L20.7072 19.2931C21.0982 19.6841 21.0982 20.3161 20.7072 20.7071C20.5122 20.9021 20.2562 21.0001 20.0002 21.0001C19.7442 21.0001 19.4882 20.9021 19.2932 20.7071L3.29325 4.70706C2.90225 4.31606 2.90225 3.68406 3.29325 3.29306C3.68425 2.90206 4.31625 2.90206 4.70725 3.29306Z",
      fill: color
    }
  ) });
}
var init_droplet_off = __esm({
  "src/icons/salonized/droplet-off.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/download.tsx
import { jsx as jsx230 } from "@emotion/react/jsx-runtime";
function Download(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx230(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx230(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11.0028 12.0759C11.001 12.0508 11 12.0255 11 12V4C11 3.448 11.447 3 12 3C12.553 3 13 3.448 13 4V11.9998L15.4 10.2C15.842 9.867 16.469 9.958 16.8 10.4C17.132 10.842 17.042 11.469 16.6 11.8L12.6 14.8C12.423 14.933 12.211 15 12 15C11.799 15 11.598 14.939 11.425 14.818L7.425 12.004C6.973 11.686 6.864 11.062 7.182 10.611C7.5 10.159 8.123 10.05 8.575 10.368L11.0028 12.0759ZM6 17V18H18V17C18 16.45 18.45 16 19 16C19.55 16 20 16.45 20 17V19C20 19.55 19.55 20 19 20H5C4.45 20 4 19.55 4 19V17C4 16.45 4.45 16 5 16C5.55 16 6 16.45 6 17Z",
      fill: color
    }
  ) });
}
var init_download = __esm({
  "src/icons/salonized/download.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/diagonal-arrow-right-up.tsx
import { jsx as jsx231 } from "@emotion/react/jsx-runtime";
function DiagonalArrowRightUp(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx231(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx231(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M17.9932 7.04876C17.9932 6.49976 17.5493 6.05276 16.9993 6.04976L9.00625 5.99976H9.00025C8.45025 5.99976 8.00425 6.44376 8.00025 6.99376C7.99625 7.54576 8.44125 7.99676 8.99425 7.99976L14.5522 8.03476L6.29325 16.2928C5.90225 16.6838 5.90225 17.3168 6.29325 17.7068C6.48825 17.9028 6.74425 17.9998 7.00025 17.9998C7.25625 17.9998 7.51225 17.9028 7.70725 17.7068L15.9952 9.41876L16.0002 15.0008C16.0002 15.5528 16.4482 15.9998 17.0002 15.9998H17.0013C17.5533 15.9998 18.0002 15.5508 18.0002 14.9988L17.9932 7.04876Z",
      fill: color
    }
  ) });
}
var init_diagonal_arrow_right_up = __esm({
  "src/icons/salonized/diagonal-arrow-right-up.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/diagonal-arrow-right-down.tsx
import { jsx as jsx232 } from "@emotion/react/jsx-runtime";
function DiagonalArrowRightDown(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx232(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx232(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M17.0002 8.00001C16.4473 8.00001 16.0002 8.44801 16.0002 9.00001V14.586L7.70725 6.29301C7.31625 5.90201 6.68425 5.90201 6.29325 6.29301C5.90225 6.68401 5.90225 7.31601 6.29325 7.70701L14.5863 16H9.00025C8.44725 16 8.00025 16.448 8.00025 17C8.00025 17.552 8.44725 18 9.00025 18H17.0002C17.5532 18 18.0002 17.552 18.0002 17V9.00001C18.0002 8.44801 17.5532 8.00001 17.0002 8.00001Z",
      fill: color
    }
  ) });
}
var init_diagonal_arrow_right_down = __esm({
  "src/icons/salonized/diagonal-arrow-right-down.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/diagonal-arrow-left-up.tsx
import { jsx as jsx233 } from "@emotion/react/jsx-runtime";
function DiagonalArrowLeftUp(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx233(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx233(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M17.707 16.293L9.41803 8.004L15.001 8C15.553 8 16 7.551 16 6.999C16 6.447 15.552 6 15 6H14.999L7.04903 6.006C6.49903 6.007 6.05403 6.451 6.05003 7L6.00003 14.994C5.99603 15.546 6.44103 15.997 6.99403 16H7.00003C7.55003 16 7.99603 15.556 8.00003 15.006L8.03503 9.449L16.293 17.707C16.488 17.902 16.744 18 17 18C17.256 18 17.512 17.902 17.707 17.707C18.098 17.316 18.098 16.684 17.707 16.293Z",
      fill: color
    }
  ) });
}
var init_diagonal_arrow_left_up = __esm({
  "src/icons/salonized/diagonal-arrow-left-up.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/diagonal-arrow-left-down.tsx
import { jsx as jsx234 } from "@emotion/react/jsx-runtime";
function DiagonalArrowLeftDown(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx234(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx234(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M17.707 6.29301C17.316 5.90201 16.684 5.90201 16.293 6.29301L8 14.586V9.00001C8 8.44801 7.553 8.00001 7 8.00001C6.447 8.00001 6 8.44801 6 9.00001V17C6 17.552 6.447 18 7 18H15C15.553 18 16 17.552 16 17C16 16.448 15.553 16 15 16H9.414L17.707 7.70701C18.098 7.31601 18.098 6.68401 17.707 6.29301Z",
      fill: color
    }
  ) });
}
var init_diagonal_arrow_left_down = __esm({
  "src/icons/salonized/diagonal-arrow-left-down.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/cube.tsx
import { jsx as jsx235 } from "@emotion/react/jsx-runtime";
function Cube(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx235(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx235(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M18.6901 15.9628L13.0001 18.6068V11.8908L19.0001 9.10379V15.5388C19.0001 15.7128 18.8821 15.8748 18.6901 15.9628ZM5.30308 15.9638C5.11408 15.8758 4.99808 15.7138 5.00008 15.5318V9.10379L11.0001 11.8908V18.6088L5.30308 15.9638ZM11.7071 5.06379C11.7981 5.02079 11.8991 4.99979 12.0001 4.99979C12.1001 4.99979 12.2011 5.02079 12.2921 5.06379L17.6211 7.53779L12.0001 10.1498L6.37808 7.53779L11.7071 5.06379ZM20.6561 7.25879C20.6531 7.25079 20.6541 7.24179 20.6501 7.23379C20.6471 7.22579 20.6391 7.22079 20.6341 7.21279C20.5881 7.13679 20.5321 7.06979 20.4791 6.99979C20.4481 6.96579 20.4231 6.92779 20.3891 6.89879C20.1541 6.62279 19.8771 6.37979 19.5331 6.22079L13.1331 3.24779C13.1321 3.24779 13.1311 3.24779 13.1311 3.24679C12.4121 2.91479 11.5871 2.91579 10.8661 3.24779L4.46908 6.21979C4.12508 6.37879 3.84708 6.62079 3.61208 6.89679C3.57508 6.92779 3.54808 6.96979 3.51508 7.00679C3.46308 7.07379 3.41008 7.13879 3.36608 7.21079C3.36108 7.21979 3.35308 7.22579 3.34908 7.23379C3.34508 7.24279 3.34608 7.25179 3.34208 7.26079C3.13108 7.62279 3.00008 8.02979 3.00008 8.45779V15.5248C2.99208 16.4748 3.56408 17.3588 4.45808 17.7768L10.8571 20.7488C11.2191 20.9178 11.6071 21.0018 11.9961 21.0018C12.3841 21.0018 12.7721 20.9178 13.1331 20.7498L19.5301 17.7778C20.4221 17.3658 20.9991 16.4878 21.0001 15.5398V8.45679C20.9991 8.02879 20.8681 7.62179 20.6561 7.25879Z",
      fill: color
    }
  ) });
}
var init_cube = __esm({
  "src/icons/salonized/cube.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/crop.tsx
import { jsx as jsx236 } from "@emotion/react/jsx-runtime";
function Crop(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx236(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx236(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8.556 16C8.25 16 8 15.751 8 15.444V8H15.445C15.751 8 16 8.249 16 8.556V16H8.556ZM21 16H18V8.556C18 7.146 16.854 6 15.445 6H8V3C8 2.447 7.553 2 7 2C6.448 2 6 2.447 6 3V6H3C2.448 6 2 6.447 2 7C2 7.553 2.448 8 3 8H6V15.444C6 16.854 7.147 18 8.556 18H16V21C16 21.553 16.448 22 17 22C17.553 22 18 21.553 18 21V18H21C21.553 18 22 17.553 22 17C22 16.447 21.553 16 21 16Z",
      fill: color
    }
  ) });
}
var init_crop = __esm({
  "src/icons/salonized/crop.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/credit-card.tsx
import { jsx as jsx237 } from "@emotion/react/jsx-runtime";
function CreditCard(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx237(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx237(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11 15H7C6.45 15 6 14.55 6 14C6 13.45 6.45 13 7 13H11C11.55 13 12 13.45 12 14C12 14.55 11.55 15 11 15ZM17 15H15C14.45 15 14 14.55 14 14C14 13.45 14.45 13 15 13H17C17.55 13 18 13.45 18 14C18 14.55 17.55 15 17 15ZM20 16C20 16.551 19.552 17 19 17H5C4.448 17 4 16.551 4 16V11H20V16ZM4 8C4 7.449 4.448 7 5 7H19C19.552 7 20 7.449 20 8V9H4V8ZM19 5H5C3.346 5 2 6.346 2 8V16C2 17.654 3.346 19 5 19H19C20.654 19 22 17.654 22 16V8C22 6.346 20.654 5 19 5Z",
      fill: color
    }
  ) });
}
var init_credit_card = __esm({
  "src/icons/salonized/credit-card.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/corner-up-right.tsx
import { jsx as jsx238 } from "@emotion/react/jsx-runtime";
function CornerUpRight(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx238(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx238(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M19.781 10.3756L15.781 5.37557C15.434 4.94457 14.806 4.87357 14.375 5.21957C13.944 5.56357 13.874 6.19357 14.219 6.62457L16.92 10.0006H8C6.345 10.0006 5 11.3456 5 13.0006V18.0006C5 18.5526 5.448 19.0006 6 19.0006C6.552 19.0006 7 18.5526 7 18.0006V13.0006C7 12.4486 7.448 12.0006 8 12.0006H16.92L14.219 15.3756C13.874 15.8066 13.944 16.4366 14.375 16.7806C14.559 16.9286 14.78 17.0006 14.999 17.0006C15.293 17.0006 15.583 16.8716 15.781 16.6246L19.781 11.6246C20.073 11.2596 20.073 10.7406 19.781 10.3756Z",
      fill: color
    }
  ) });
}
var init_corner_up_right = __esm({
  "src/icons/salonized/corner-up-right.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/corner-up-left.tsx
import { jsx as jsx239 } from "@emotion/react/jsx-runtime";
function CornerUpLeft(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx239(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx239(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M16 10H7.081L9.781 6.62504C10.126 6.19304 10.056 5.56404 9.625 5.21904C9.194 4.87504 8.564 4.94304 8.219 5.37504L4.219 10.375C3.927 10.741 3.927 11.259 4.219 11.625L8.219 16.625C8.417 16.872 8.707 17 9 17C9.22 17 9.44 16.928 9.625 16.781C10.056 16.436 10.126 15.807 9.781 15.375L7.081 12H16C16.551 12 17 12.449 17 13V18C17 18.552 17.448 19 18 19C18.552 19 19 18.552 19 18V13C19 11.346 17.654 10 16 10Z",
      fill: color
    }
  ) });
}
var init_corner_up_left = __esm({
  "src/icons/salonized/corner-up-left.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/corner-right-up.tsx
import { jsx as jsx240 } from "@emotion/react/jsx-runtime";
function CornerRightUp(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx240(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx240(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M18.624 8.21924L13.624 4.21924C13.259 3.92724 12.74 3.92724 12.375 4.21924L7.37502 8.21924C6.94302 8.56424 6.87402 9.19324 7.21902 9.62424C7.56302 10.0552 8.19302 10.1252 8.62402 9.78124L11.999 7.08024V16.0002C11.999 16.5512 11.551 17.0002 10.999 17.0002H5.99902C5.44702 17.0002 4.99902 17.4482 4.99902 18.0002C4.99902 18.5522 5.44702 19.0002 5.99902 19.0002H10.999C12.654 19.0002 13.999 17.6542 13.999 16.0002V7.08024L17.375 9.78124C17.559 9.92824 17.78 10.0002 17.999 10.0002C18.292 10.0002 18.583 9.87124 18.78 9.62424C19.125 9.19324 19.056 8.56424 18.624 8.21924Z",
      fill: color
    }
  ) });
}
var init_corner_right_up = __esm({
  "src/icons/salonized/corner-right-up.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/corner-right-down.tsx
import { jsx as jsx241 } from "@emotion/react/jsx-runtime";
function CornerRightDown(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx241(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx241(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M18.781 14.3755C18.436 13.9435 17.806 13.8745 17.376 14.2195L14 16.9195V8.00049C14 6.34549 12.655 5.00049 11 5.00049H6C5.448 5.00049 5 5.44749 5 6.00049C5 6.55249 5.448 7.00049 6 7.00049H11C11.552 7.00049 12 7.44849 12 8.00049V16.9195L8.625 14.2195C8.195 13.8745 7.565 13.9435 7.219 14.3755C6.874 14.8065 6.944 15.4365 7.376 15.7805L12.376 19.7805C12.558 19.9265 12.779 20.0005 13 20.0005C13.221 20.0005 13.442 19.9265 13.625 19.7805L18.625 15.7805C19.056 15.4365 19.126 14.8065 18.781 14.3755Z",
      fill: color
    }
  ) });
}
var init_corner_right_down = __esm({
  "src/icons/salonized/corner-right-down.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/corner-left-up.tsx
import { jsx as jsx242 } from "@emotion/react/jsx-runtime";
function CornerLeftUp(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx242(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx242(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M18.0001 17H13.0001C12.4491 17 12.0001 16.551 12.0001 16V7.081L15.3751 9.781C15.5602 9.928 15.7801 10 16.0001 10C16.2921 10 16.5831 9.872 16.7811 9.625C17.1262 9.193 17.0561 8.564 16.6251 8.219L11.6251 4.219C11.2591 3.927 10.7411 3.927 10.3751 4.219L5.37515 8.219C4.94415 8.564 4.87415 9.193 5.21915 9.625C5.56315 10.056 6.19415 10.125 6.62515 9.781L10.0001 7.081V16C10.0001 17.654 11.3461 19 13.0001 19H18.0001C18.5521 19 19.0001 18.552 19.0001 18C19.0001 17.448 18.5521 17 18.0001 17Z",
      fill: color
    }
  ) });
}
var init_corner_left_up = __esm({
  "src/icons/salonized/corner-left-up.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/corner-left-down.tsx
import { jsx as jsx243 } from "@emotion/react/jsx-runtime";
function CornerLeftDown(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx243(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx243(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M18 5H13.0001C11.3461 5 10.0001 6.346 10.0001 8V16.919L6.62513 14.219C6.19414 13.875 5.56314 13.944 5.21915 14.375C4.87415 14.807 4.94415 15.436 5.37515 15.781L10.3751 19.781C10.5581 19.927 10.7791 20 11.0001 20C11.2211 20 11.4421 19.927 11.6251 19.781L16.625 15.781C17.056 15.436 17.126 14.807 16.781 14.375C16.437 13.944 15.807 13.874 15.375 14.219L12.0001 16.919V8C12.0001 7.449 12.4491 7 13.0001 7H18C18.552 7 19 6.552 19 6C19 5.448 18.552 5 18 5Z",
      fill: color
    }
  ) });
}
var init_corner_left_down = __esm({
  "src/icons/salonized/corner-left-down.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/corner-down-right.tsx
import { jsx as jsx244 } from "@emotion/react/jsx-runtime";
function CornerDownRight(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx244(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx244(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M19.781 12.3755L15.781 7.37549C15.436 6.94349 14.806 6.87449 14.376 7.21949C13.944 7.56349 13.874 8.19349 14.219 8.62449L16.92 12.0005H8C7.449 12.0005 7 11.5515 7 11.0005V6.00049C7 5.44749 6.552 5.00049 6 5.00049C5.448 5.00049 5 5.44749 5 6.00049V11.0005C5 12.6545 6.346 14.0005 8 14.0005H16.92L14.219 17.3755C13.874 17.8065 13.944 18.4365 14.376 18.7805C14.56 18.9285 14.781 19.0005 15 19.0005C15.293 19.0005 15.584 18.8715 15.781 18.6245L19.781 13.6245C20.073 13.2595 20.073 12.7405 19.781 12.3755Z",
      fill: color
    }
  ) });
}
var init_corner_down_right = __esm({
  "src/icons/salonized/corner-down-right.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/corner-down-left.tsx
import { jsx as jsx245 } from "@emotion/react/jsx-runtime";
function CornerDownLeft(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx245(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx245(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M19.9705 5.996C19.9685 5.445 19.5205 5 18.9705 5H18.9665C18.4145 5.002 17.9685 5.452 17.9705 6.004L17.9915 11.004C17.9915 11.271 17.8895 11.523 17.7015 11.712C17.5125 11.902 17.2625 12.007 16.9955 12.008L8.07651 12.045L10.7625 8.659C11.1055 8.226 11.0325 7.597 10.6005 7.254C10.1685 6.911 9.53951 6.985 9.19551 7.416L5.21651 12.432C4.92551 12.799 4.92851 13.317 5.22151 13.682L9.24151 18.665C9.43951 18.91 9.72851 19.037 10.0205 19.037C10.2415 19.037 10.4635 18.964 10.6485 18.815C11.0775 18.469 11.1455 17.839 10.7985 17.409L8.08451 14.045L17.0035 14.008C17.8045 14.005 18.5565 13.69 19.1215 13.121C19.6855 12.552 19.9945 11.797 19.9915 10.996L19.9705 5.996Z",
      fill: color
    }
  ) });
}
var init_corner_down_left = __esm({
  "src/icons/salonized/corner-down-left.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/copy.tsx
import { jsx as jsx246 } from "@emotion/react/jsx-runtime";
function Copy(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx246(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx246(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M9 13V12C9 10.346 10.346 9 12 9H13V5.667C13 5.299 12.701 5 12.333 5H5.667C5.299 5 5 5.299 5 5.667V12.333C5 12.701 5.299 13 5.667 13H9ZM9 15H5.667C4.196 15 3 13.804 3 12.333V5.667C3 4.196 4.196 3 5.667 3H12.333C13.804 3 15 4.196 15 5.667V9H18C19.654 9 21 10.346 21 12V18C21 19.654 19.654 21 18 21H12C10.346 21 9 19.654 9 18V15ZM11 12C11 11.449 11.449 11 12 11H18C18.552 11 19 11.449 19 12V18C19 18.551 18.552 19 18 19H12C11.449 19 11 18.551 11 18V12Z",
      fill: color
    }
  ) });
}
var init_copy = __esm({
  "src/icons/salonized/copy.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/compass.tsx
import { jsx as jsx247 } from "@emotion/react/jsx-runtime";
function Compass(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx247(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx247(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10.7969 13.2129L11.5109 11.4709L13.2029 10.7869L12.4889 12.5289L10.7969 13.2129ZM15.6829 8.3179C15.4089 8.0279 14.9789 7.9159 14.5839 8.0719L10.3709 9.7739C10.1209 9.8749 9.9219 10.0719 9.8199 10.3219L8.0749 14.5799C7.9269 14.9409 8.0139 15.3309 8.2529 15.6079C8.2609 15.6179 8.2669 15.6309 8.2759 15.6419C8.2919 15.6589 8.3109 15.6729 8.3289 15.6899C8.5169 15.8829 8.7719 15.9999 9.0419 15.9999C9.1669 15.9999 9.2939 15.9769 9.4159 15.9279L13.6289 14.2269C13.8789 14.1249 14.0779 13.9279 14.1799 13.6779L15.9249 9.4199C16.0869 9.0259 15.9749 8.5939 15.6829 8.3179ZM12 20C7.589 20 4 16.411 4 12C4 7.589 7.589 4 12 4C16.411 4 20 7.589 20 12C20 16.411 16.411 20 12 20ZM12 2C6.486 2 2 6.486 2 12C2 17.514 6.486 22 12 22C17.514 22 22 17.514 22 12C22 6.486 17.514 2 12 2Z",
      fill: color
    }
  ) });
}
var init_compass = __esm({
  "src/icons/salonized/compass.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/color-picker.tsx
import { jsx as jsx248 } from "@emotion/react/jsx-runtime";
function ColorPicker(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx248(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx248(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M16.0559 10.6415L13.3599 7.94553L15.2719 6.03453L17.9659 8.72853L16.0559 10.6415ZM9.0789 17.6245L6.1029 17.8955L6.3669 14.9395L11.9459 9.35953L14.6419 12.0555L9.0789 17.6245ZM19.4029 7.33653L16.6629 4.59753C15.8959 3.82953 14.6769 3.80153 13.9489 4.52953L11.9459 6.53153L10.7069 5.29253C10.3169 4.90253 9.6839 4.90253 9.2929 5.29253C8.9029 5.68353 8.9029 6.31653 9.2929 6.70653L10.5319 7.94553L4.9519 13.5255C4.6269 13.8505 4.4249 14.2825 4.3829 14.7395L4.0039 18.9095C3.9779 19.2045 4.0829 19.4965 4.2929 19.7065C4.4819 19.8955 4.7369 19.9995 4.9999 19.9995C5.0309 19.9995 5.0609 19.9985 5.0909 19.9955L9.2609 19.6175C9.7179 19.5755 10.1499 19.3725 10.4749 19.0475L16.0549 13.4685L17.2929 14.7065C17.4889 14.9025 17.7439 14.9995 17.9999 14.9995C18.2559 14.9995 18.5119 14.9025 18.7069 14.7065C19.0979 14.3165 19.0979 13.6835 18.7069 13.2925L17.4689 12.0545L19.4709 10.0515C20.2009 9.32253 20.1699 8.10453 19.4029 7.33653Z",
      fill: color
    }
  ) });
}
var init_color_picker = __esm({
  "src/icons/salonized/color-picker.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/color-palette.tsx
import { jsx as jsx249 } from "@emotion/react/jsx-runtime";
function ColorPalette(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx249(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx249(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10.5005 6.50003C10.5005 5.67203 11.1725 5.00003 12.0005 5.00003C12.8285 5.00003 13.5005 5.67203 13.5005 6.50003C13.5005 7.32803 12.8285 8.00003 12.0005 8.00003C11.1725 8.00003 10.5005 7.32803 10.5005 6.50003ZM14.7015 9.25023C14.2875 8.53323 14.5335 7.61523 15.2505 7.20123C15.9685 6.78723 16.8855 7.03323 17.2995 7.75023C17.7135 8.46823 17.4675 9.38523 16.7505 9.79923C16.0325 10.2132 15.1155 9.96823 14.7015 9.25023ZM8.75048 7.20123C8.03348 6.78723 7.11548 7.03323 6.70148 7.75023C6.28748 8.46823 6.53348 9.38523 7.25048 9.79923C7.96848 10.2132 8.88548 9.96823 9.29948 9.25023C9.71348 8.53323 9.46848 7.61523 8.75048 7.20123ZM5.75758 13.3388C5.29358 12.6528 5.47458 11.7198 6.16158 11.2568C6.84858 10.7928 7.78058 10.9748 8.24358 11.6608C8.70758 12.3478 8.52558 13.2798 7.83958 13.7428C7.15258 14.2068 6.22058 14.0258 5.75758 13.3388ZM15.8814 15.001H14.2314C12.8524 15.001 11.7314 16.122 11.7314 17.501C11.7314 18.107 11.9554 18.694 12.3624 19.154C12.4864 19.294 12.5274 19.459 12.4834 19.642C12.4344 19.847 12.1984 19.98 11.8894 20C9.60638 19.969 7.43938 18.958 5.94338 17.227C4.42838 15.472 3.76438 13.223 4.07438 10.895C4.58538 7.06203 8.03238 4.03303 11.9234 4.00003H11.9984C14.3554 4.00003 16.5764 4.90003 18.1054 6.47803C19.3934 7.80703 20.0654 9.50203 19.9954 11.25C19.9164 13.248 17.9934 15.001 15.8814 15.001ZM19.5404 5.08503C17.6174 3.10103 14.8154 1.99303 11.9064 2.00003H11.9054C6.96138 2.04203 2.74138 5.75203 2.09238 10.631C1.71038 13.491 2.56338 16.372 4.43038 18.534C6.29838 20.698 9.00738 21.961 11.8614 22H11.8994C13.0994 22 14.1574 21.213 14.4264 20.114C14.6254 19.292 14.4184 18.458 13.8594 17.826C13.7774 17.735 13.7314 17.616 13.7314 17.501C13.7314 17.226 13.9554 17.001 14.2314 17.001H15.8814C19.0734 17.001 21.8724 14.403 21.9934 11.329C22.0854 9.02903 21.2144 6.81203 19.5404 5.08503Z",
      fill: color
    }
  ) });
}
var init_color_palette = __esm({
  "src/icons/salonized/color-palette.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/collapse.tsx
import { jsx as jsx250 } from "@emotion/react/jsx-runtime";
var init_collapse = __esm({
  "src/icons/salonized/collapse.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/code.tsx
import { jsx as jsx251 } from "@emotion/react/jsx-runtime";
function Code(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx251(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx251(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M16.9517 5.37294L21.7797 11.3729C22.0787 11.7439 22.0737 12.2739 21.7687 12.6409L16.7687 18.6409C16.5707 18.8779 16.2867 18.9999 15.9997 18.9999C15.7737 18.9999 15.5477 18.9239 15.3597 18.7689C14.9357 18.4149 14.8787 17.7839 15.2317 17.3589L19.7087 11.9889L15.3927 6.62694C15.0477 6.19594 15.1147 5.56694 15.5457 5.22094C15.9757 4.87294 16.6047 4.94294 16.9517 5.37294ZM7.23204 5.35934C7.58504 4.93534 8.21404 4.87834 8.64104 5.23134C9.06504 5.58534 9.12204 6.21534 8.76904 6.64034L4.29204 12.0103L8.60804 17.3733C8.95304 17.8033 8.88604 18.4323 8.45504 18.7793C8.27104 18.9273 8.04904 19.0003 7.82904 19.0003C7.53704 19.0003 7.24704 18.8723 7.04904 18.6273L2.22104 12.6273C1.92204 12.2553 1.92704 11.7253 2.23204 11.3593L7.23204 5.35934Z",
      fill: color
    }
  ) });
}
var init_code = __esm({
  "src/icons/salonized/code.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/code-download.tsx
import { jsx as jsx252 } from "@emotion/react/jsx-runtime";
function CodeDownload(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx252(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx252(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M21.7795 11.3729L16.9515 5.37294C16.6035 4.94294 15.9745 4.87294 15.5455 5.22094C15.1145 5.56694 15.0475 6.19594 15.3925 6.62694L19.7085 11.9889L15.2315 17.3589C14.8785 17.7839 14.9355 18.4149 15.3595 18.7689C15.5475 18.9239 15.7735 18.9999 15.9995 18.9999C16.2865 18.9999 16.5705 18.8779 16.7685 18.6409L21.7685 12.6409C22.0735 12.2739 22.0785 11.7439 21.7795 11.3729ZM4.29216 12.0106L8.76916 6.64064C9.12216 6.21564 9.06416 5.58464 8.64116 5.23164C8.21516 4.87864 7.58616 4.93564 7.23116 5.35964L2.23116 11.3596C1.92716 11.7256 1.92216 12.2556 2.22116 12.6266L7.04916 18.6266C7.24716 18.8716 7.53616 18.9996 7.82916 18.9996C8.04916 18.9996 8.27116 18.9276 8.45516 18.7796C8.88616 18.4326 8.95316 17.8036 8.60716 17.3726L4.29216 12.0106ZM14.3059 11.3841C14.7019 11.0001 15.3369 11.0131 15.7199 11.4091C16.1029 11.8061 16.0919 12.4391 15.6949 12.8231L12.6949 15.7201C12.5009 15.9061 12.2499 16.0001 11.9999 16.0001C11.7439 16.0001 11.4889 15.9021 11.2929 15.7071L8.29286 12.7071C7.90286 12.3161 7.90286 11.6831 8.29286 11.2931C8.68386 10.9021 9.31686 10.9021 9.70686 11.2931L10.9999 12.5851V8.00014C10.9999 7.44714 11.4479 7.00014 11.9999 7.00014C12.5529 7.00014 12.9999 7.44714 12.9999 8.00014V12.6441L14.3059 11.3841Z",
      fill: color
    }
  ) });
}
var init_code_download = __esm({
  "src/icons/salonized/code-download.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/cloud-upload.tsx
import { jsx as jsx253 } from "@emotion/react/jsx-runtime";
function CloudUpload(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx253(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx253(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12 3C14.581 3 16.855 4.661 17.675 7.045C20.114 7.376 22 9.472 22 12C22 13.221 21.556 14.396 20.75 15.309C20.552 15.532 20.277 15.647 20 15.647C19.765 15.647 19.529 15.565 19.338 15.397C18.925 15.03 18.885 14.399 19.251 13.984C19.734 13.438 20 12.732 20 12C20 10.346 18.654 9 17 9H16.9C16.424 9 16.014 8.664 15.92 8.197C15.546 6.345 13.898 5 12 5C10.103 5 8.454 6.345 8.081 8.197C7.987 8.664 7.576 9 7.1 9H7C5.346 9 4 10.346 4 12C4 12.732 4.266 13.438 4.75 13.984C5.115 14.399 5.076 15.03 4.662 15.397C4.248 15.763 3.616 15.722 3.251 15.309C2.444 14.396 2 13.221 2 12C2 9.472 3.886 7.376 6.325 7.045C7.146 4.661 9.42 3 12 3ZM11.3052 11.2801C11.6992 10.9041 12.3222 10.9071 12.7072 11.2931L15.7072 14.2931C16.0982 14.6841 16.0982 15.3161 15.7072 15.7071C15.5122 15.9021 15.2562 16.0001 15.0002 16.0001C14.7442 16.0001 14.4882 15.9021 14.2932 15.7071L13.0002 14.4141V20.0001C13.0002 20.5531 12.5522 21.0001 12.0002 21.0001C11.4482 21.0001 11.0002 20.5531 11.0002 20.0001V14.3561L9.6952 15.6161C9.2982 16.0011 8.6652 15.9881 8.2812 15.5911C7.8972 15.1931 7.9082 14.5611 8.3052 14.1771L11.3052 11.2801Z",
      fill: color
    }
  ) });
}
var init_cloud_upload = __esm({
  "src/icons/salonized/cloud-upload.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/cloud-download.tsx
import { jsx as jsx254 } from "@emotion/react/jsx-runtime";
function CloudDownload(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx254(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx254(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12 3C14.581 3 16.855 4.661 17.675 7.045C20.114 7.376 22 9.472 22 12C22 13.221 21.556 14.396 20.75 15.309C20.552 15.532 20.277 15.647 20 15.647C19.765 15.647 19.529 15.565 19.338 15.397C18.925 15.03 18.885 14.399 19.251 13.984C19.734 13.438 20 12.732 20 12C20 10.346 18.654 9 17 9H16.9C16.424 9 16.014 8.664 15.92 8.197C15.546 6.345 13.898 5 12 5C10.103 5 8.454 6.345 8.081 8.197C7.987 8.664 7.576 9 7.1 9H7C5.346 9 4 10.346 4 12C4 12.732 4.266 13.438 4.75 13.984C5.115 14.399 5.076 15.03 4.662 15.397C4.247 15.763 3.616 15.722 3.251 15.309C2.444 14.396 2 13.221 2 12C2 9.472 3.886 7.376 6.325 7.045C7.146 4.661 9.42 3 12 3ZM13.0004 17.6439L14.3054 16.3839C14.7034 16.0009 15.3364 16.0119 15.7194 16.4089C16.1034 16.8069 16.0924 17.4399 15.6954 17.8229L12.6954 20.7199C12.5004 20.9059 12.2504 20.9999 12.0004 20.9999C11.7444 20.9999 11.4884 20.9029 11.2934 20.7069L8.2934 17.7069C7.9024 17.3169 7.9024 16.6839 8.2934 16.2929C8.6834 15.9029 9.3164 15.9029 9.7074 16.2929L11.0004 17.5859V11.9999C11.0004 11.4469 11.4484 10.9999 12.0004 10.9999C12.5524 10.9999 13.0004 11.4469 13.0004 11.9999V17.6439Z",
      fill: color
    }
  ) });
}
var init_cloud_download = __esm({
  "src/icons/salonized/cloud-download.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/close.tsx
import { jsx as jsx255 } from "@emotion/react/jsx-runtime";
function Close2(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx255(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx255(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M13.4142 12L17.7072 7.70701C18.0982 7.31601 18.0982 6.68401 17.7072 6.29301C17.3162 5.90201 16.6842 5.90201 16.2933 6.29301L12.0002 10.586L7.70725 6.29301C7.31625 5.90201 6.68425 5.90201 6.29325 6.29301C5.90225 6.68401 5.90225 7.31601 6.29325 7.70701L10.5862 12L6.29325 16.293C5.90225 16.684 5.90225 17.316 6.29325 17.707C6.48825 17.902 6.74425 18 7.00025 18C7.25625 18 7.51225 17.902 7.70725 17.707L12.0002 13.414L16.2933 17.707C16.4882 17.902 16.7443 18 17.0002 18C17.2562 18 17.5122 17.902 17.7072 17.707C18.0982 17.316 18.0982 16.684 17.7072 16.293L13.4142 12Z",
      fill: color
    }
  ) });
}
var init_close2 = __esm({
  "src/icons/salonized/close.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/close-circle1.tsx
import { jsx as jsx256 } from "@emotion/react/jsx-runtime";
function CloseCircle1(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx256(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx256(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M14.707 9.293C14.316 8.902 13.684 8.902 13.293 9.293L12 10.586L10.707 9.293C10.316 8.902 9.684 8.902 9.293 9.293C8.902 9.684 8.902 10.316 9.293 10.707L10.586 12L9.293 13.293C8.902 13.684 8.902 14.316 9.293 14.707C9.488 14.902 9.744 15 10 15C10.256 15 10.512 14.902 10.707 14.707L12 13.414L13.293 14.707C13.488 14.902 13.744 15 14 15C14.256 15 14.512 14.902 14.707 14.707C15.098 14.316 15.098 13.684 14.707 13.293L13.414 12L14.707 10.707C15.098 10.316 15.098 9.684 14.707 9.293ZM19 18C19 18.552 18.552 19 18 19H6C5.448 19 5 18.552 5 18V6C5 5.448 5.448 5 6 5H18C18.552 5 19 5.448 19 6V18ZM18 3H6C4.346 3 3 4.346 3 6V18C3 19.654 4.346 21 6 21H18C19.654 21 21 19.654 21 18V6C21 4.346 19.654 3 18 3Z",
      fill: color
    }
  ) });
}
var init_close_circle1 = __esm({
  "src/icons/salonized/close-circle1.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/close-circle.tsx
import { jsx as jsx257 } from "@emotion/react/jsx-runtime";
function CloseCircle(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx257(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx257(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M14.707 9.293C14.316 8.902 13.684 8.902 13.293 9.293L12 10.586L10.707 9.293C10.316 8.902 9.684 8.902 9.293 9.293C8.902 9.684 8.902 10.316 9.293 10.707L10.586 12L9.293 13.293C8.902 13.684 8.902 14.316 9.293 14.707C9.488 14.902 9.744 15 10 15C10.256 15 10.512 14.902 10.707 14.707L12 13.414L13.293 14.707C13.488 14.902 13.744 15 14 15C14.256 15 14.512 14.902 14.707 14.707C15.098 14.316 15.098 13.684 14.707 13.293L13.414 12L14.707 10.707C15.098 10.316 15.098 9.684 14.707 9.293ZM12 20C7.589 20 4 16.411 4 12C4 7.589 7.589 4 12 4C16.411 4 20 7.589 20 12C20 16.411 16.411 20 12 20ZM12 2C6.486 2 2 6.486 2 12C2 17.514 6.486 22 12 22C17.514 22 22 17.514 22 12C22 6.486 17.514 2 12 2Z",
      fill: color
    }
  ) });
}
var init_close_circle = __esm({
  "src/icons/salonized/close-circle.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/clock.tsx
import { jsx as jsx258 } from "@emotion/react/jsx-runtime";
function Clock(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx258(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx258(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M16 11H13V8C13 7.447 12.552 7 12 7C11.448 7 11 7.447 11 8V12C11 12.553 11.448 13 12 13H16C16.553 13 17 12.553 17 12C17 11.447 16.553 11 16 11ZM12 20C7.589 20 4 16.411 4 12C4 7.589 7.589 4 12 4C16.411 4 20 7.589 20 12C20 16.411 16.411 20 12 20ZM12 2C6.486 2 2 6.486 2 12C2 17.514 6.486 22 12 22C17.514 22 22 17.514 22 12C22 6.486 17.514 2 12 2Z",
      fill: color
    }
  ) });
}
var init_clock = __esm({
  "src/icons/salonized/clock.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/clipboard.tsx
import { jsx as jsx259 } from "@emotion/react/jsx-runtime";
function Clipboard(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx259(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx259(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M19 19C19 19.552 18.551 20 18 20H6C5.449 20 5 19.552 5 19V8C5 7.448 5.449 7 6 7V8C6 9.103 6.897 10 8 10H16C17.103 10 18 9.103 18 8V7C18.551 7 19 7.448 19 8V19ZM8 4L16 4.003V5V8H8V5V4ZM18 5V4C18 2.897 17.103 2 16 2H8C6.897 2 6 2.897 6 4V5C4.346 5 3 6.346 3 8V19C3 20.654 4.346 22 6 22H18C19.654 22 21 20.654 21 19V8C21 6.346 19.654 5 18 5Z",
      fill: color
    }
  ) });
}
var init_clipboard = __esm({
  "src/icons/salonized/clipboard.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/chevron-up.tsx
import { jsx as jsx260 } from "@emotion/react/jsx-runtime";
function ChevronUp2(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx260(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx260(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M16 14.4999C15.744 14.4999 15.488 14.4019 15.293 14.2069L11.988 10.9019L8.69502 14.0819C8.29702 14.4659 7.66502 14.4559 7.28102 14.0569C6.89702 13.6599 6.90802 13.0259 7.30502 12.6429L11.305 8.78091C11.698 8.40191 12.322 8.40691 12.707 8.79291L16.707 12.7929C17.098 13.1839 17.098 13.8159 16.707 14.2069C16.512 14.4019 16.256 14.4999 16 14.4999Z",
      fill: color
    }
  ) });
}
var init_chevron_up = __esm({
  "src/icons/salonized/chevron-up.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/chevron-right.tsx
import { jsx as jsx261 } from "@emotion/react/jsx-runtime";
function ChevronRight2(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx261(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx261(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10.5002 17C10.2442 17 9.98825 16.902 9.79325 16.707C9.40225 16.316 9.40225 15.684 9.79325 15.293L13.0982 11.988L9.91825 8.695C9.53525 8.297 9.54625 7.664 9.94325 7.281C10.3412 6.898 10.9742 6.909 11.3572 7.305L15.2192 11.305C15.5982 11.698 15.5932 12.321 15.2072 12.707L11.2072 16.707C11.0122 16.902 10.7562 17 10.5002 17Z",
      fill: color
    }
  ) });
}
var init_chevron_right = __esm({
  "src/icons/salonized/chevron-right.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/chevron-left.tsx
import { jsx as jsx262 } from "@emotion/react/jsx-runtime";
function ChevronLeft2(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx262(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx262(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M13.362 17C13.1 17 12.839 16.898 12.643 16.695L8.78004 12.695C8.40204 12.302 8.40704 11.679 8.79304 11.293L12.793 7.29301C13.183 6.90201 13.816 6.90201 14.207 7.29301C14.597 7.68401 14.597 8.31601 14.207 8.70701L10.902 12.012L14.081 15.305C14.465 15.703 14.454 16.336 14.057 16.719C13.862 16.907 13.612 17 13.362 17Z",
      fill: color
    }
  ) });
}
var init_chevron_left = __esm({
  "src/icons/salonized/chevron-left.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/chevron-down.tsx
import { jsx as jsx263 } from "@emotion/react/jsx-runtime";
function ChevronDown2(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx263(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx263(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12.0002 15.5C11.7442 15.5 11.4883 15.402 11.2933 15.207L7.29325 11.207C6.90225 10.816 6.90225 10.184 7.29325 9.79301C7.68425 9.40201 8.31625 9.40201 8.70725 9.79301L12.0122 13.098L15.3053 9.91801C15.7043 9.53501 16.3352 9.54601 16.7192 9.94301C17.1032 10.34 17.0922 10.974 16.6952 11.357L12.6953 15.219C12.5002 15.407 12.2502 15.5 12.0002 15.5Z",
      fill: color
    }
  ) });
}
var init_chevron_down = __esm({
  "src/icons/salonized/chevron-down.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/checkmark.tsx
import { jsx as jsx264 } from "@emotion/react/jsx-runtime";
function Checkmark(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx264(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx264(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M9.86338 18.0001C9.58738 18.0001 9.32338 17.8861 9.13438 17.6851L4.27138 12.5061C3.89238 12.1041 3.91338 11.4711 4.31538 11.0931C4.71838 10.7151 5.35138 10.7351 5.72838 11.1371L9.85338 15.5281L18.2614 6.32611C18.6354 5.91711 19.2674 5.89011 19.6754 6.26211C20.0824 6.63411 20.1104 7.26711 19.7384 7.67411L10.6014 17.6741C10.4144 17.8801 10.1484 17.9981 9.87038 18.0001H9.86338Z",
      fill: color
    }
  ) });
}
var init_checkmark = __esm({
  "src/icons/salonized/checkmark.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/checkmark-square2.tsx
import { jsx as jsx265 } from "@emotion/react/jsx-runtime";
function CheckmarkSquare2(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx265(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx265(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M19 12.8335C19 12.2815 19.448 11.8335 20 11.8335C20.552 11.8335 21 12.2815 21 12.8335V18.3995C21 19.8335 19.833 21.0005 18.4 21.0005H5.6C4.167 21.0005 3 19.8335 3 18.3995V5.60049C3 4.16649 4.167 3.00049 5.6 3.00049H15.167C15.719 3.00049 16.167 3.44749 16.167 4.00049C16.167 4.55249 15.719 5.00049 15.167 5.00049H5.6C5.269 5.00049 5 5.26949 5 5.60049V18.3995C5 18.7305 5.269 19.0005 5.6 19.0005H18.4C18.731 19.0005 19 18.7305 19 18.3995V12.8335ZM9.3096 10.9465C9.7096 10.5645 10.3416 10.5805 10.7236 10.9795L12.2286 12.5575L18.2816 6.30449C18.6646 5.90849 19.2976 5.89649 19.6956 6.28149C20.0926 6.66549 20.1026 7.29849 19.7186 7.69549L12.9416 14.6955C12.7536 14.8905 12.4946 15.0005 12.2236 15.0005H12.2196C11.9476 14.9995 11.6876 14.8875 11.4996 14.6905L9.2766 12.3605C8.8946 11.9605 8.9106 11.3275 9.3096 10.9465Z",
      fill: color
    }
  ) });
}
var init_checkmark_square2 = __esm({
  "src/icons/salonized/checkmark-square2.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/checkmark-square.tsx
import { jsx as jsx266 } from "@emotion/react/jsx-runtime";
function CheckmarkSquare(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx266(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx266(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M14.7046 8.3945L10.9206 13.3635L9.2876 11.2775C8.9466 10.8415 8.3186 10.7655 7.8836 11.1065C7.4486 11.4465 7.3716 12.0755 7.7126 12.5095L10.1436 15.6165C10.3336 15.8585 10.6236 15.9995 10.9316 15.9995H10.9386C11.2476 15.9985 11.5396 15.8525 11.7266 15.6055L16.2956 9.6055C16.6306 9.1655 16.5456 8.5395 16.1056 8.2045C15.6656 7.8695 15.0376 7.9555 14.7046 8.3945ZM19 18C19 18.552 18.551 19 18 19H6C5.449 19 5 18.552 5 18V6C5 5.448 5.449 5 6 5H18C18.551 5 19 5.448 19 6V18ZM18 3H6C4.346 3 3 4.346 3 6V18C3 19.654 4.346 21 6 21H18C19.654 21 21 19.654 21 18V6C21 4.346 19.654 3 18 3Z",
      fill: color
    }
  ) });
}
var init_checkmark_square = __esm({
  "src/icons/salonized/checkmark-square.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/checkmark-circle2.tsx
import { jsx as jsx267 } from "@emotion/react/jsx-runtime";
function CheckmarkCircle2(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx267(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx267(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M20.997 10.974H21C21.551 10.974 21.999 11.42 22 11.971C22.008 14.642 20.975 17.157 19.091 19.051C17.208 20.945 14.7 21.992 12.029 22H12C9.33905 22 6.83605 20.968 4.94905 19.091C3.05505 17.208 2.00805 14.7 2.00005 12.029C1.99205 9.357 3.02505 6.843 4.90905 4.949C6.79205 3.055 9.30005 2.008 11.971 2C12.766 2.012 13.576 2.092 14.352 2.278C14.888 2.408 15.219 2.948 15.089 3.485C14.96 4.021 14.417 4.351 13.883 4.223C13.262 4.073 12.603 4.01 11.977 4C9.84005 4.006 7.83305 4.844 6.32705 6.359C4.82005 7.874 3.99405 9.886 4.00005 12.023C4.00605 14.16 4.84405 16.166 6.35905 17.673C7.86905 19.174 9.87105 20 12 20H12.023C14.16 19.994 16.167 19.156 17.673 17.641C19.18 16.125 20.006 14.114 20 11.977C19.999 11.425 20.445 10.975 20.997 10.974ZM8.29305 11.2929C8.68405 10.9019 9.31605 10.9019 9.70705 11.2929L11.951 13.5369L18.248 6.3409C18.612 5.9279 19.243 5.8839 19.659 6.2479C20.074 6.6109 20.116 7.2429 19.752 7.6589L12.752 15.6589C12.57 15.8669 12.31 15.9899 12.033 15.9999H12C11.735 15.9999 11.481 15.8949 11.293 15.7069L8.29305 12.7069C7.90205 12.3159 7.90205 11.6839 8.29305 11.2929Z",
      fill: color
    }
  ) });
}
var init_checkmark_circle2 = __esm({
  "src/icons/salonized/checkmark-circle2.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/checkmark-circle.tsx
import { jsx as jsx268 } from "@emotion/react/jsx-runtime";
function CheckmarkCircle(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx268(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx268(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M14.7046 8.3945L10.9206 13.3635L9.2876 11.2775C8.9476 10.8415 8.3176 10.7655 7.8836 11.1065C7.4486 11.4465 7.3716 12.0755 7.7126 12.5095L10.1436 15.6165C10.3336 15.8585 10.6236 15.9995 10.9316 15.9995H10.9386C11.2476 15.9985 11.5396 15.8525 11.7266 15.6055L16.2956 9.6055C16.6306 9.1655 16.5456 8.5395 16.1056 8.2045C15.6646 7.8695 15.0386 7.9555 14.7046 8.3945ZM12 20C7.589 20 4 16.411 4 12C4 7.589 7.589 4 12 4C16.411 4 20 7.589 20 12C20 16.411 16.411 20 12 20ZM12 2C6.477 2 2 6.478 2 12C2 17.522 6.477 22 12 22C17.523 22 22 17.522 22 12C22 6.478 17.523 2 12 2Z",
      fill: color
    }
  ) });
}
var init_checkmark_circle = __esm({
  "src/icons/salonized/checkmark-circle.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/cast.tsx
import { jsx as jsx269 } from "@emotion/react/jsx-runtime";
function Cast(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx269(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx269(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M5.59973 3H18.4007C19.8347 3 21.0007 4.246 21.0007 5.777V18.223C21.0007 19.754 19.8347 21 18.4007 21H17.0007C16.4477 21 16.0007 20.553 16.0007 20C16.0007 19.447 16.4477 19 17.0007 19H18.4007C18.7257 19 19.0007 18.644 19.0007 18.223V5.777C19.0007 5.356 18.7257 5 18.4007 5H5.59973C5.27473 5 5.00073 5.356 5.00073 5.777V7C5.00073 7.553 4.55273 8 4.00073 8C3.44773 8 3.00073 7.553 3.00073 7V5.777C3.00073 4.246 4.16673 3 5.59973 3ZM3.00963 15.17C2.93363 14.623 3.31663 14.118 3.86363 14.043C5.28363 13.849 6.66963 14.314 7.67763 15.321C9.01463 16.66 9.37763 18.71 8.57863 20.423C8.40863 20.786 8.04863 21 7.67163 21C7.52963 21 7.38563 20.97 7.24963 20.906C6.74963 20.673 6.53263 20.078 6.76563 19.577C7.21063 18.624 7.00963 17.481 6.26363 16.736C5.70163 16.175 4.92763 15.918 4.13663 16.023C3.58363 16.102 3.08463 15.717 3.00963 15.17ZM3.86263 10.0771C3.31563 10.1531 2.93363 10.6581 3.00963 11.2051C3.08563 11.7511 3.58863 12.1341 4.13763 12.0571C6.02863 11.7991 7.88563 12.4171 9.23463 13.7651C10.7906 15.3221 11.3756 17.6041 10.7596 19.7211C10.6056 20.2511 10.9106 20.8061 11.4406 20.9601C11.5346 20.9871 11.6286 21.0001 11.7196 21.0001C12.1536 21.0001 12.5526 20.7171 12.6796 20.2791C13.4996 17.4631 12.7206 14.4251 10.6486 12.3511C8.85363 10.5561 6.38463 9.7261 3.86263 10.0771ZM3.00033 19C3.00033 18.447 3.44733 18 4.00033 18C4.55333 18 5.00033 18.447 5.00033 19C5.00033 19.553 4.55333 20 4.00033 20C3.44733 20 3.00033 19.553 3.00033 19Z",
      fill: color
    }
  ) });
}
var init_cast = __esm({
  "src/icons/salonized/cast.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/car.tsx
import { jsx as jsx270 } from "@emotion/react/jsx-runtime";
function Car(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx270(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx270(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M19 18C19 18.552 18.552 19 18 19C17.448 19 17 18.552 17 18C17 17.448 17.448 17 18 17C18.552 17 19 17.448 19 18ZM12 15H4L4.016 5H15L14.984 15H12ZM7 18C7 18.552 6.552 19 6 19C5.448 19 5 18.552 5 18C5 17.448 5.448 17 6 17C6.552 17 7 17.448 7 18ZM20 12.48V15H17V10.081L20 12.48ZM21.625 11.219L17 7.519V5C17 3.897 16.187 3 15.187 3H3.812C2.813 3 2 3.897 2 5V15C2 15.873 2.513 16.609 3.221 16.882C3.081 17.228 3 17.604 3 18C3 19.654 4.346 21 6 21C7.654 21 9 19.654 9 18C9 17.647 8.928 17.314 8.815 17H12H15.185C15.072 17.314 15 17.647 15 18C15 19.654 16.346 21 18 21C19.654 21 21 19.654 21 18C21 17.647 20.928 17.314 20.815 17H21C21.553 17 22 16.553 22 16V12C22 11.696 21.862 11.409 21.625 11.219Z",
      fill: color
    }
  ) });
}
var init_car = __esm({
  "src/icons/salonized/car.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/camera.tsx
import { jsx as jsx271 } from "@emotion/react/jsx-runtime";
function Camera(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx271(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx271(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12 15.5C11.173 15.5 10.5 14.827 10.5 14C10.5 13.173 11.173 12.5 12 12.5C12.827 12.5 13.5 13.173 13.5 14C13.5 14.827 12.827 15.5 12 15.5ZM12 10.5C10.07 10.5 8.5 12.07 8.5 14C8.5 15.93 10.07 17.5 12 17.5C13.93 17.5 15.5 15.93 15.5 14C15.5 12.07 13.93 10.5 12 10.5ZM20 18C20 18.551 19.552 19 19 19H5C4.448 19 4 18.551 4 18V10C4 9.449 4.448 9 5 9H19C19.552 9 20 9.449 20 10V18ZM10 5.5C10 5.224 10.225 5 10.5 5H13.5C13.775 5 14 5.224 14 5.5V7H10V5.5ZM19 7H16V5.5C16 4.122 14.879 3 13.5 3H10.5C9.121 3 8 4.122 8 5.5V7H5C3.346 7 2 8.346 2 10V18C2 19.654 3.346 21 5 21H19C20.654 21 22 19.654 22 18V10C22 8.346 20.654 7 19 7Z",
      fill: color
    }
  ) });
}
var init_camera = __esm({
  "src/icons/salonized/camera.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/calendar.tsx
import { jsx as jsx272 } from "@emotion/react/jsx-runtime";
function Calendar2(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx272(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx272(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M7 16C7 15.45 7.45 15 8 15C8.55 15 9 15.45 9 16C9 16.55 8.55 17 8 17C7.45 17 7 16.55 7 16ZM12 15H16C16.55 15 17 15.45 17 16C17 16.55 16.55 17 16 17H12C11.45 17 11 16.55 11 16C11 15.45 11.45 15 12 15ZM18 20H6C5.449 20 5 19.551 5 19V13H19V19C19 19.551 18.551 20 18 20ZM6 6H7V7C7 7.55 7.45 8 8 8C8.55 8 9 7.55 9 7V6H15V7C15 7.55 15.45 8 16 8C16.55 8 17 7.55 17 7V6H18C18.551 6 19 6.449 19 7V11H5V7C5 6.449 5.449 6 6 6ZM18 4H17V3C17 2.45 16.55 2 16 2C15.45 2 15 2.45 15 3V4H9V3C9 2.45 8.55 2 8 2C7.45 2 7 2.45 7 3V4H6C4.346 4 3 5.346 3 7V19C3 20.654 4.346 22 6 22H18C19.654 22 21 20.654 21 19V7C21 5.346 19.654 4 18 4Z",
      fill: color
    }
  ) });
}
var init_calendar2 = __esm({
  "src/icons/salonized/calendar.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/bulb.tsx
import { jsx as jsx273 } from "@emotion/react/jsx-runtime";
function Bulb(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx273(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx273(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M13 5C13 5.553 12.552 6 12 6C11.448 6 11 5.553 11 5V3C11 2.447 11.448 2 12 2C12.552 2 13 2.447 13 3V5ZM13 15.4598C13 15.1028 13.191 14.7718 13.501 14.5928C14.426 14.0618 15 13.0678 15 11.9998C15 10.3458 13.654 8.9998 12 8.9998C10.346 8.9998 9 10.3458 9 11.9998C9 13.0678 9.574 14.0618 10.499 14.5928C10.809 14.7718 11 15.1028 11 15.4598V19.9998H13V15.4598ZM7 11.9998C7 9.2428 9.243 6.9998 12 6.9998C14.757 6.9998 17 9.2428 17 11.9998C17 13.5788 16.246 15.0618 15 15.9958V19.9998C15 21.1028 14.103 21.9998 13 21.9998H11C9.897 21.9998 9 21.1028 9 19.9998V15.9958C7.753 15.0618 7 13.5788 7 11.9998ZM21 11H19C18.447 11 18 11.447 18 12C18 12.553 18.447 13 19 13H21C21.553 13 22 12.553 22 12C22 11.447 21.553 11 21 11ZM3 11H5C5.552 11 6 11.447 6 12C6 12.553 5.552 13 5 13H3C2.448 13 2 12.553 2 12C2 11.447 2.448 11 3 11ZM7.6597 6.418L6.2207 5.028C5.8237 4.645 5.1917 4.657 4.8067 5.054C4.4227 5.45 4.4337 6.084 4.8307 6.468L6.2697 7.857C6.4647 8.045 6.7147 8.138 6.9647 8.138C7.2267 8.138 7.4877 8.035 7.6837 7.832C8.0677 7.436 8.0567 6.802 7.6597 6.418ZM17.7794 5.0297C18.1754 4.6467 18.8114 4.6577 19.1924 5.0537C19.5764 5.4497 19.5654 6.0837 19.1684 6.4667L17.7294 7.8567C17.5364 8.0437 17.2854 8.1377 17.0354 8.1377C16.7734 8.1377 16.5114 8.0347 16.3164 7.8317C15.9324 7.4357 15.9434 6.8017 16.3404 6.4187L17.7794 5.0297Z",
      fill: color
    }
  ) });
}
var init_bulb = __esm({
  "src/icons/salonized/bulb.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/brush.tsx
import { jsx as jsx274 } from "@emotion/react/jsx-runtime";
function Brush(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx274(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx274(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M17.7652 7.39249L11.8982 13.2575C11.7472 13.0315 11.5742 12.8175 11.3772 12.6215C11.1802 12.4245 10.9662 12.2525 10.7402 12.1045L16.6092 6.23749C16.9152 5.93049 17.4572 5.92949 17.7662 6.23849C17.9192 6.39149 18.0022 6.59149 17.9992 6.82749C18.0022 7.03849 17.9182 7.23849 17.7652 7.39249ZM8.24519 17.9405L6.01719 17.9815L6.05619 15.7505C6.07719 14.4845 7.12619 13.4345 8.39519 13.4125C8.40919 13.4125 8.42119 13.4115 8.43519 13.4115C9.01919 13.4115 9.56019 13.6315 9.96319 14.0355C10.3762 14.4475 10.5972 15.0035 10.5872 15.6015C10.5662 16.8695 9.51519 17.9185 8.24519 17.9405ZM19.9992 6.82749C20.0092 6.07149 19.7172 5.35949 19.1802 4.82349C18.1182 3.76249 16.2552 3.75949 15.1952 4.82349L8.58219 11.4335C8.50719 11.4295 8.43519 11.4135 8.36019 11.4125C6.02619 11.4545 4.09519 13.3855 4.05619 15.7165L3.99919 18.9825C3.99419 19.2535 4.10119 19.5155 4.29219 19.7065C4.48019 19.8945 4.73519 19.9995 4.99919 19.9995H5.01819L8.28419 19.9405C10.6162 19.8995 12.5462 17.9685 12.5872 15.6355C12.5882 15.5605 12.5722 15.4895 12.5702 15.4135L19.1792 8.80649C19.7172 8.26849 20.0092 7.55649 19.9992 6.82749Z",
      fill: color
    }
  ) });
}
var init_brush = __esm({
  "src/icons/salonized/brush.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/browser.tsx
import { jsx as jsx275 } from "@emotion/react/jsx-runtime";
function Browser(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx275(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx275(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M7 7C7 6.447 7.448 6 8 6C8.552 6 9 6.447 9 7C9 7.553 8.552 8 8 8C7.448 8 7 7.553 7 7ZM11 7C11 6.447 11.448 6 12 6C12.552 6 13 6.447 13 7C13 7.553 12.552 8 12 8C11.448 8 11 7.553 11 7ZM5 9V6C5 5.448 5.449 5 6 5H18C18.551 5 19 5.448 19 6V9H5ZM19 18C19 18.552 18.551 19 18 19H6C5.449 19 5 18.552 5 18V11H19V18ZM18 3H6C4.346 3 3 4.346 3 6V9V11V18C3 19.654 4.346 21 6 21H18C19.654 21 21 19.654 21 18V11V9V6C21 4.346 19.654 3 18 3Z",
      fill: color
    }
  ) });
}
var init_browser = __esm({
  "src/icons/salonized/browser.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/briefcase.tsx
import { jsx as jsx276 } from "@emotion/react/jsx-runtime";
function Briefcase(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx276(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx276(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M20 18C20 18.551 19.551 19 19 19H17V9H19C19.551 9 20 9.449 20 10V18ZM4 18V10C4 9.449 4.449 9 5 9H7V19H5C4.449 19 4 18.551 4 18ZM10 5.5C10 5.224 10.224 5 10.5 5H13.5C13.776 5 14 5.224 14 5.5V7H10V5.5ZM9 19H15V9H9V19ZM19 7H16V5.5C16 4.122 14.878 3 13.5 3H10.5C9.122 3 8 4.122 8 5.5V7H5C3.346 7 2 8.346 2 10V18C2 19.654 3.346 21 5 21H19C20.654 21 22 19.654 22 18V10C22 8.346 20.654 7 19 7Z",
      fill: color
    }
  ) });
}
var init_briefcase = __esm({
  "src/icons/salonized/briefcase.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/bookmark.tsx
import { jsx as jsx277 } from "@emotion/react/jsx-runtime";
function Bookmark(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx277(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx277(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11.821 15.506C11.99 15.506 12.16 15.549 12.313 15.635L17 18.286V5.334C17 5.133 16.879 5 16.8 5H7.2C7.12 5 7 5.133 7 5.334V18.234L11.306 15.649C11.465 15.554 11.643 15.506 11.821 15.506ZM6 21C5.83 21 5.66 20.957 5.507 20.87C5.194 20.693 5 20.36 5 20V5.334C5 4.047 5.987 3 7.2 3H16.8C18.013 3 19 4.047 19 5.334V20C19 20.356 18.811 20.685 18.504 20.864C18.196 21.044 17.818 21.047 17.508 20.871L11.836 17.663L6.514 20.858C6.356 20.952 6.178 21 6 21Z",
      fill: color
    }
  ) });
}
var init_bookmark = __esm({
  "src/icons/salonized/bookmark.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/book.tsx
import { jsx as jsx278 } from "@emotion/react/jsx-runtime";
function Book(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx278(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx278(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M7 19C6.449 19 6 18.551 6 18C6 17.449 6.449 17 7 17H18V19H7ZM7 5H18V15H7C6.647 15 6.314 15.072 6 15.184V6C6 5.449 6.449 5 7 5ZM19 3H7C5.346 3 4 4.346 4 6V18C4 19.654 5.346 21 7 21H18H19C19.552 21 20 20.552 20 20V19V17V4C20 3.448 19.552 3 19 3Z",
      fill: color
    }
  ) });
}
var init_book = __esm({
  "src/icons/salonized/book.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/book-open.tsx
import { jsx as jsx279 } from "@emotion/react/jsx-runtime";
function BookOpen(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx279(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx279(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M19 16.4022L13 17.7502V7.59723L19 6.25023V16.4022ZM5 6.25023L11 7.59723V17.7502L5 16.4022V6.25023ZM20.625 4.21823C20.387 4.02923 20.077 3.95723 19.78 4.02423L12 5.77223L4.22 4.02423C3.922 3.95623 3.613 4.02923 3.375 4.21823C3.138 4.40923 3 4.69623 3 5.00023V17.2022C3 17.6702 3.324 18.0752 3.78 18.1772L11.78 19.9752C11.854 19.9922 11.927 20.0002 12 20.0002C12.073 20.0002 12.146 19.9922 12.22 19.9752L20.22 18.1772C20.676 18.0752 21 17.6702 21 17.2022V5.00023C21 4.69623 20.862 4.40923 20.625 4.21823Z",
      fill: color
    }
  ) });
}
var init_book_open = __esm({
  "src/icons/salonized/book-open.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/bluetooth.tsx
import { jsx as jsx280 } from "@emotion/react/jsx-runtime";
function Bluetooth(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx280(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx280(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M13.0002 18.2494V14.1784L15.4672 16.5574L13.0002 18.2494ZM13.0002 5.76042L15.4972 7.49342L13.0002 9.85042V5.76042ZM13.6292 12.0064L17.6442 8.21642C17.8952 7.97842 18.0232 7.64642 17.9972 7.30442C17.9702 6.96142 17.7922 6.65142 17.5072 6.45442L12.8332 3.21042C12.4742 2.95842 12.0082 2.93042 11.6182 3.13342C11.2372 3.33242 11.0002 3.72042 11.0002 4.14542V10.3514L7.8072 6.37442C7.4602 5.94242 6.8322 5.87442 6.4012 6.22042C5.9702 6.56542 5.9012 7.19542 6.2472 7.62542L9.7212 11.9524L6.2162 16.3794C5.8732 16.8124 5.9462 17.4404 6.3792 17.7844C6.5632 17.9294 6.7822 17.9994 7.0002 17.9994C7.2942 17.9994 7.5862 17.8704 7.7842 17.6204L11.0002 13.5594V19.8534C11.0002 20.2774 11.2352 20.6644 11.6132 20.8644C11.7872 20.9554 11.9752 21.0004 12.1632 21.0004C12.3952 21.0004 12.6262 20.9314 12.8272 20.7944L17.4692 17.6084C17.7542 17.4124 17.9342 17.1034 17.9612 16.7614C17.9892 16.4204 17.8632 16.0884 17.6162 15.8514L13.6292 12.0064Z",
      fill: color
    }
  ) });
}
var init_bluetooth = __esm({
  "src/icons/salonized/bluetooth.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/bell.tsx
import { jsx as jsx281 } from "@emotion/react/jsx-runtime";
function Bell(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx281(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx281(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M5.51436 16.0001L6.69436 14.8181C7.07236 14.4401 7.28036 13.9381 7.28036 13.4041V8.72708C7.28036 7.37008 7.87036 6.07308 8.90036 5.17108C9.93836 4.26108 11.2604 3.86108 12.6374 4.04208C14.9644 4.35108 16.7194 6.45508 16.7194 8.93708V13.4041C16.7194 13.9381 16.9274 14.4401 17.3044 14.8171L18.4854 16.0001H5.51436ZM13.9994 18.3411C13.9994 19.2401 13.0834 20.0001 11.9994 20.0001C10.9154 20.0001 9.99936 19.2401 9.99936 18.3411V18.0001H13.9994V18.3411ZM20.5204 15.2081L18.7194 13.4041V8.93708C18.7194 5.45608 16.2174 2.49908 12.8994 2.06008C10.9774 1.80408 9.03736 2.39108 7.58236 3.66708C6.11836 4.94908 5.28036 6.79308 5.28036 8.72708L5.27936 13.4041L3.47836 15.2081C3.00936 15.6781 2.87036 16.3771 3.12436 16.9901C3.37936 17.6041 3.97236 18.0001 4.63636 18.0001H7.99936V18.3411C7.99936 20.3591 9.79336 22.0001 11.9994 22.0001C14.2054 22.0001 15.9994 20.3591 15.9994 18.3411V18.0001H19.3624C20.0264 18.0001 20.6184 17.6041 20.8724 16.9911C21.1274 16.3771 20.9894 15.6771 20.5204 15.2081Z",
      fill: color
    }
  ) });
}
var init_bell = __esm({
  "src/icons/salonized/bell.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/bell-off.tsx
import { jsx as jsx282 } from "@emotion/react/jsx-runtime";
function BellOff(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx282(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx282(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8.90073 5.17083C9.93874 4.26083 11.2617 3.86083 12.6377 4.04183C14.9647 4.35083 16.7197 6.45483 16.7197 8.93683V13.4038C16.7197 13.6058 16.7587 13.7998 16.8157 13.9868L20.4207 17.5908C20.6097 17.4278 20.7727 17.2328 20.8737 16.9908C21.1287 16.3778 20.9897 15.6768 20.5207 15.2078L18.7197 13.4038V8.93683C18.7197 5.45583 16.2177 2.49883 12.8997 2.05983C10.9757 1.80383 9.03973 2.39083 7.58373 3.66683C7.38874 3.83683 7.20774 4.01783 7.03574 4.20683L8.46774 5.63983C8.49888 5.60424 8.52958 5.5683 8.56027 5.53237L8.56028 5.53236C8.66756 5.40677 8.77477 5.28124 8.90073 5.17083ZM12.0003 19.9999C10.9163 19.9999 10.0003 19.2399 10.0003 18.3409V17.9999H14.0003V18.3409C14.0003 19.2399 13.0843 19.9999 12.0003 19.9999ZM14.0293 16.8569L13.1723 15.9999H5.51534L6.69434 14.8179C7.07234 14.4399 7.28034 13.9379 7.28034 13.4039V10.1079L5.31234 8.13993C5.29534 8.33493 5.28034 8.52993 5.28034 8.72693L5.27934 13.4039L3.47934 15.2079C3.01034 15.6779 2.87134 16.3769 3.12534 16.9899C3.38034 17.6039 3.97334 17.9999 4.63734 17.9999H8.00034V18.3409C8.00034 20.3589 9.79434 21.9999 12.0003 21.9999C14.0423 21.9999 15.7123 20.5889 15.9513 18.7799L15.1723 17.9999L14.0293 16.8569ZM19.4073 17.9929L20.7073 19.2929C21.0983 19.6839 21.0983 20.3159 20.7073 20.7069C20.5123 20.9019 20.2563 20.9999 20.0003 20.9999C19.7443 20.9999 19.4883 20.9019 19.2933 20.7069L16.5863 17.9999L16.0003 17.4139L14.6553 16.0689L14.5863 15.9999L7.28334 8.69693L5.53134 6.94593L3.29334 4.70693C2.90234 4.31593 2.90234 3.68393 3.29334 3.29293C3.68434 2.90193 4.31634 2.90193 4.70734 3.29293L6.42034 5.00593L7.88634 6.47093L17.4143 15.9999L19.4073 17.9929Z",
      fill: color
    }
  ) });
}
var init_bell_off = __esm({
  "src/icons/salonized/bell-off.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/behance.tsx
import { jsx as jsx283 } from "@emotion/react/jsx-runtime";
function Behance(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx283(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx283(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M13.25 9.703H16.25V9.203H13.25V9.703ZM15.788 12.294H13.727V12.284C13.727 11.666 14.139 11.188 14.765 11.188C15.385 11.188 15.788 11.661 15.788 12.284V12.294ZM14.755 10.297C13.401 10.297 12.475 11.134 12.475 12.549V12.99C12.475 14.469 13.396 15.297 14.808 15.297C16.186 15.297 16.855 14.527 16.977 13.754H15.793C15.686 14.146 15.327 14.382 14.818 14.382C14.168 14.382 13.727 13.918 13.727 13.186V13.054H17.025V12.58C17.025 11.192 16.157 10.297 14.755 10.297ZM9.219 14.237H8.26V12.304H9.487C10.244 12.304 10.657 12.68 10.657 13.294C10.657 13.913 10.24 14.237 9.219 14.237ZM8.26 9.67H9.405C10.01 9.67 10.364 9.994 10.364 10.522C10.364 11.089 9.981 11.408 9.113 11.408H8.26V9.67ZM10.518 11.784V11.728C11.165 11.57 11.64 11.094 11.64 10.304C11.64 9.309 10.873 8.703 9.703 8.703H6.975V15.203H9.698C11.026 15.203 11.975 14.532 11.975 13.37C11.975 12.395 11.304 11.86 10.518 11.784ZM12 20C7.589 20 4 16.411 4 12C4 7.589 7.589 4 12 4C16.411 4 20 7.589 20 12C20 16.411 16.411 20 12 20ZM12 2C6.486 2 2 6.486 2 12C2 17.514 6.486 22 12 22C17.514 22 22 17.514 22 12C22 6.486 17.514 2 12 2Z",
      fill: color
    }
  ) });
}
var init_behance = __esm({
  "src/icons/salonized/behance.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/batttery-charging.tsx
import { jsx as jsx284 } from "@emotion/react/jsx-runtime";
function BattteryCharging(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx284(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx284(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8.504 19.8679C8.66 19.9579 8.831 19.9999 8.999 19.9999C9.346 19.9999 9.684 19.8189 9.868 19.4959L13.868 12.4959C14.045 12.1869 14.044 11.8059 13.865 11.4979C13.686 11.1899 13.356 10.9999 13 10.9999H8.723L11.868 5.49588C12.142 5.01688 11.976 4.40588 11.496 4.13188C11.018 3.85888 10.406 4.02488 10.132 4.50388L6.132 11.5039C5.955 11.8129 5.956 12.1939 6.135 12.5019C6.314 12.8099 6.644 12.9999 7 12.9999H11.277L8.132 18.5039C7.858 18.9829 8.024 19.5939 8.504 19.8679ZM12.7315 5.99988H15.8335C17.0285 5.99988 18.0005 7.08888 18.0005 8.42888V15.5709C18.0005 16.9109 17.0285 17.9999 15.8335 17.9999H11.8755L13.0175 15.9999H15.8275C15.8795 15.9769 16.0005 15.8239 16.0005 15.5709V8.42888C16.0005 8.16988 15.8745 8.01688 15.8245 7.99888H11.5895L12.7315 5.99988ZM20 9.99988C20 9.44788 20.448 8.99988 21 8.99988C21.552 8.99988 22 9.44788 22 9.99988V13.9999C22 14.5519 21.552 14.9999 21 14.9999C20.448 14.9999 20 14.5519 20 13.9999V9.99988ZM4 15.5712V8.42818C4 8.17018 4.126 8.01618 4.167 8.00018L6.982 7.99918L8.125 6.00018H4.167C2.972 6.00018 2 7.08918 2 8.42818V15.5712C2 16.9102 2.972 18.0002 4.167 18.0002H7.268L8.41 16.0012H4.176C4.126 15.9832 4 15.8292 4 15.5712Z",
      fill: color
    }
  ) });
}
var init_batttery_charging = __esm({
  "src/icons/salonized/batttery-charging.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/battery.tsx
import { jsx as jsx285 } from "@emotion/react/jsx-runtime";
function Battery(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx285(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx285(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M15.828 16.0002C15.879 15.9772 16 15.8242 16 15.5712V8.42824C16 8.17024 15.874 8.01624 15.824 7.99824L4.167 8.00024C4.126 8.01624 4 8.17024 4 8.42824V15.5712C4 15.8292 4.126 15.9832 4.176 16.0012L15.828 16.0002ZM4.167 6.00024H15.833C17.028 6.00024 18 7.08924 18 8.42824V15.5712C18 16.9102 17.028 18.0002 15.833 18.0002H4.167C2.972 18.0002 2 16.9102 2 15.5712V8.42824C2 7.08924 2.972 6.00024 4.167 6.00024ZM20 9.99994C20 9.44794 20.448 8.99994 21 8.99994C21.552 8.99994 22 9.44794 22 9.99994V13.9999C22 14.5519 21.552 14.9999 21 14.9999C20.448 14.9999 20 14.5519 20 13.9999V9.99994Z",
      fill: color
    }
  ) });
}
var init_battery = __esm({
  "src/icons/salonized/battery.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/bar-chart2.tsx
import { jsx as jsx286 } from "@emotion/react/jsx-runtime";
function BarChart2(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx286(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx286(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M19 4C18.45 4 18 4.45 18 5V20C18 20.55 18.45 21 19 21C19.55 21 20 20.55 20 20V5C20 4.45 19.55 4 19 4ZM12 8C11.45 8 11 8.45 11 9V20C11 20.55 11.45 21 12 21C12.55 21 13 20.55 13 20V9C13 8.45 12.55 8 12 8ZM4 13C4 12.45 4.45 12 5 12C5.55 12 6 12.45 6 13V20C6 20.55 5.55 21 5 21C4.45 21 4 20.55 4 20V13Z",
      fill: color
    }
  ) });
}
var init_bar_chart2 = __esm({
  "src/icons/salonized/bar-chart2.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/bar-chart.tsx
import { jsx as jsx287 } from "@emotion/react/jsx-runtime";
function BarChart(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx287(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx287(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12 4C11.45 4 11 4.45 11 5V20C11 20.55 11.45 21 12 21C12.55 21 13 20.55 13 20V5C13 4.45 12.55 4 12 4ZM19 12C18.45 12 18 12.45 18 13V20C18 20.55 18.45 21 19 21C19.55 21 20 20.55 20 20V13C20 12.45 19.55 12 19 12ZM4 9C4 8.45 4.45 8 5 8C5.55 8 6 8.45 6 9V20C6 20.55 5.55 21 5 21C4.45 21 4 20.55 4 20V9Z",
      fill: color
    }
  ) });
}
var init_bar_chart = __esm({
  "src/icons/salonized/bar-chart.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/backspace.tsx
import { jsx as jsx288 } from "@emotion/react/jsx-runtime";
function Backspace(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx288(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx288(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11.2926 14.707C11.4876 14.902 11.7436 15 11.9996 15C12.2556 15 12.5116 14.902 12.7066 14.707L13.9996 13.414L15.2926 14.707C15.4876 14.902 15.7436 15 15.9996 15C16.2556 15 16.5116 14.902 16.7066 14.707C17.0976 14.316 17.0976 13.684 16.7066 13.293L15.4136 12L16.7066 10.707C17.0976 10.316 17.0976 9.684 16.7066 9.293C16.3156 8.902 15.6836 8.902 15.2926 9.293L13.9996 10.586L12.7066 9.293C12.3156 8.902 11.6836 8.902 11.2926 9.293C10.9016 9.684 10.9016 10.316 11.2926 10.707L12.5856 12L11.2926 13.293C10.9016 13.684 10.9016 14.316 11.2926 14.707ZM19.9996 18H10.3696C10.1206 18 9.88158 17.907 9.69658 17.739L4.36858 12.894L9.74558 6.219C9.92258 6.077 10.1426 6 10.3696 6H19.9996V18ZM20.1406 4H10.3696C9.62158 4 8.90458 4.277 8.35158 4.781C8.31258 4.815 8.27758 4.854 8.24558 4.894L2.22158 12.373C1.88958 12.785 1.93558 13.384 2.32658 13.74L8.35158 19.219C8.90458 19.723 9.62158 20 10.3696 20H20.1406C21.1656 20 21.9996 19.185 21.9996 18.182V5.818C21.9996 4.815 21.1656 4 20.1406 4Z",
      fill: color
    }
  ) });
}
var init_backspace = __esm({
  "src/icons/salonized/backspace.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/award.tsx
import { jsx as jsx289 } from "@emotion/react/jsx-runtime";
function Award(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx289(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx289(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12.3057 16.707C11.9947 16.536 11.6187 16.539 11.3157 16.72L7.56772 18.92L9.03572 13.21C9.91072 13.71 10.9217 14 11.9997 14C13.0777 14 14.0887 13.71 14.9647 13.21L16.4537 19.002L12.3057 16.707ZM11.9997 4C14.2057 4 15.9997 5.794 15.9997 8C15.9997 10.206 14.2057 12 11.9997 12C9.79372 12 7.99972 10.206 7.99972 8C7.99972 5.794 9.79372 4 11.9997 4ZM18.9687 20.751L16.6597 11.772C17.4957 10.74 17.9997 9.429 17.9997 8C17.9997 4.691 15.3087 2 11.9997 2C8.69172 2 5.99972 4.691 5.99972 8C5.99972 9.429 6.50372 10.74 7.33972 11.772L5.03172 20.751C4.93072 21.143 5.07572 21.556 5.39872 21.799C5.72072 22.042 6.15872 22.064 6.50572 21.862L11.8357 18.733L17.5157 21.875C17.6667 21.959 17.8337 22 17.9997 22C18.2167 22 18.4327 21.93 18.6127 21.791C18.9277 21.547 19.0687 21.138 18.9687 20.751Z",
      fill: color
    }
  ) });
}
var init_award = __esm({
  "src/icons/salonized/award.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/attach2.tsx
import { jsx as jsx290 } from "@emotion/react/jsx-runtime";
function Attach2(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx290(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx290(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M9.29305 21C7.63705 21 6.06305 20.334 4.86105 19.125C2.47305 16.722 2.37505 12.912 4.64205 10.631L12.0281 3.201C12.7971 2.427 13.8351 2 14.9501 2C16.1431 2 17.2771 2.479 18.1421 3.349C19.8631 5.08 19.9291 7.831 18.2881 9.481L10.8931 16.91C10.4141 17.393 9.76905 17.658 9.07705 17.658C8.34605 17.658 7.65305 17.366 7.12705 16.837C6.07405 15.776 6.04105 14.085 7.05405 13.065L13.8791 6.21C14.2691 5.818 14.9011 5.816 15.2931 6.206C15.6841 6.596 15.6861 7.229 15.2961 7.62L8.47205 14.476C8.23205 14.718 8.26505 15.145 8.54605 15.427C8.69205 15.574 8.88605 15.658 9.07705 15.658C9.18705 15.658 9.34505 15.631 9.47505 15.5L16.8701 8.071C17.7371 7.198 17.6721 5.713 16.7241 4.759C15.8171 3.847 14.2781 3.775 13.4461 4.611L6.06005 12.041C4.56605 13.544 4.66405 16.09 6.28005 17.715C7.10306 18.544 8.17305 19 9.29305 19C10.2941 19 11.2221 18.622 11.9041 17.936L19.2911 10.506C19.6801 10.115 20.3131 10.112 20.7051 10.502C21.0961 10.892 21.0981 11.524 20.7091 11.916L13.3221 19.346C12.2621 20.412 10.8311 21 9.29305 21Z",
      fill: color
    }
  ) });
}
var init_attach2 = __esm({
  "src/icons/salonized/attach2.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/attach.tsx
import { jsx as jsx291 } from "@emotion/react/jsx-runtime";
function Attach(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx291(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx291(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12 22C8.691 22 6 19.443 6 16.302V6.132C6 3.854 7.944 2 10.333 2C12.723 2 14.667 3.854 14.667 6.132L14.661 16.309C14.661 17.723 13.464 18.874 11.994 18.874C10.524 18.874 9.328 17.723 9.328 16.308L9.333 6.917C9.334 6.365 9.782 5.918 10.333 5.918H10.334C10.886 5.918 11.334 6.366 11.333 6.919L11.328 16.309C11.328 16.62 11.626 16.874 11.994 16.874C12.362 16.874 12.661 16.62 12.661 16.308L12.667 6.131C12.667 4.956 11.62 4 10.333 4C9.047 4 8 4.956 8 6.132V16.302C8 18.341 9.794 20 12 20C14.206 20 16 18.341 16 16.302V6.132C16 5.579 16.448 5.132 17 5.132C17.552 5.132 18 5.579 18 6.132V16.302C18 19.443 15.309 22 12 22Z",
      fill: color
    }
  ) });
}
var init_attach = __esm({
  "src/icons/salonized/attach.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/at.tsx
import { jsx as jsx292 } from "@emotion/react/jsx-runtime";
function At(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx292(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx292(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11.1817 15.0907C9.47772 15.0907 8.09072 13.7037 8.09072 11.9997C8.09072 10.2957 9.47772 8.9087 11.1817 8.9087C12.8857 8.9087 14.2727 10.2957 14.2727 11.9997C14.2727 13.7037 12.8857 15.0907 11.1817 15.0907ZM12.9547 2.0437C9.95372 1.7617 7.01872 2.8247 4.90572 4.9527C2.79172 7.0797 1.75072 10.0227 2.05072 13.0257C2.40872 16.5977 4.65972 19.7077 7.92672 21.1407C9.23372 21.7137 10.6197 21.9947 11.9957 21.9947C14.1637 21.9947 16.3087 21.2957 18.0797 19.9397C18.5187 19.6037 18.6017 18.9757 18.2657 18.5367C17.9297 18.0997 17.3027 18.0167 16.8637 18.3517C14.5457 20.1267 11.4297 20.4907 8.72972 19.3087C6.16172 18.1827 4.32272 15.6387 4.04072 12.8257C3.80072 10.4207 4.63272 8.0647 6.32472 6.3617C8.01472 4.6597 10.3667 3.8077 12.7697 4.0357C16.8247 4.4127 19.9997 8.0097 19.9997 12.2247V12.8997C19.9997 13.3677 19.8137 13.8037 19.4747 14.1277C19.1367 14.4517 18.6887 14.6177 18.2217 14.5977C17.3277 14.5587 16.5997 13.7177 16.5997 12.7237V8.3997C16.5997 7.8467 16.1527 7.3997 15.5997 7.3997C15.0907 7.3997 14.6887 7.7827 14.6247 8.2747C13.7167 7.4347 12.5127 6.9087 11.1817 6.9087C8.37472 6.9087 6.09072 9.1937 6.09072 11.9997C6.09072 14.8067 8.37472 17.0907 11.1817 17.0907C12.8817 17.0907 14.3807 16.2447 15.3057 14.9607C15.9507 15.9007 16.9737 16.5447 18.1337 16.5957C19.1467 16.6497 20.1207 16.2777 20.8577 15.5727C21.5947 14.8677 21.9997 13.9187 21.9997 12.8997V12.2247C21.9997 6.9877 18.0277 2.5167 12.9547 2.0437Z",
      fill: color
    }
  ) });
}
var init_at = __esm({
  "src/icons/salonized/at.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/arrrow-left.tsx
import { jsx as jsx293 } from "@emotion/react/jsx-runtime";
function ArrrowLeft(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx293(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx293(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8.678 12.002L13.5 15.985V8.09201L8.678 12.002ZM13.544 18.001C13.073 18.001 12.609 17.844 12.241 17.54L7.141 13.326C6.734 12.99 6.5 12.506 6.5 12C6.5 11.494 6.734 11.01 7.141 10.674L12.241 6.46101C12.849 5.95701 13.716 5.85601 14.45 6.20101C15.097 6.50701 15.5 7.11401 15.5 7.78701V16.213C15.5 16.886 15.097 17.493 14.45 17.799C14.161 17.935 13.851 18.001 13.544 18.001Z",
      fill: color
    }
  ) });
}
var init_arrrow_left = __esm({
  "src/icons/salonized/arrrow-left.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/arrowhead-up.tsx
import { jsx as jsx294 } from "@emotion/react/jsx-runtime";
function ArrowheadUp(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx294(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx294(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11.9891 7.29242L6.62715 11.6074C6.19715 11.9534 5.56815 11.8854 5.22115 11.4554C4.87515 11.0244 4.94315 10.3954 5.37315 10.0484L11.3731 5.22042C11.7441 4.92242 12.2741 4.92542 12.6401 5.23242L18.6401 10.2324C19.0651 10.5854 19.1221 11.2154 18.7681 11.6404C18.5701 11.8774 18.2861 12.0004 18.0001 12.0004C17.7741 12.0004 17.5471 11.9234 17.3601 11.7684L11.9891 7.29242ZM11.3732 12.2209C11.7442 11.9219 12.2742 11.9259 12.6402 12.2319L18.6402 17.2319C19.0642 17.5859 19.1212 18.2159 18.7682 18.6399C18.5702 18.8779 18.2862 18.9999 17.9992 18.9999C17.7742 18.9999 17.5472 18.9239 17.3602 18.7679L11.9892 14.2929L6.62725 18.6069C6.19725 18.9539 5.56825 18.8859 5.22125 18.4549C4.87425 18.0249 4.94325 17.3959 5.37325 17.0489L11.3732 12.2209Z",
      fill: color
    }
  ) });
}
var init_arrowhead_up = __esm({
  "src/icons/salonized/arrowhead-up.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/arrowhead-right.tsx
import { jsx as jsx295 } from "@emotion/react/jsx-runtime";
function ArrowheadRight(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx295(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx295(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M13.9513 5.373L18.7793 11.373C19.0783 11.744 19.0733 12.274 18.7683 12.64L13.7683 18.64C13.5703 18.877 13.2863 19 12.9993 19C12.7743 19 12.5473 18.924 12.3603 18.768C11.9353 18.415 11.8783 17.784 12.2323 17.36L16.7083 11.989L12.3923 6.627C12.0463 6.197 12.1143 5.567 12.5453 5.221C12.9753 4.874 13.6043 4.943 13.9513 5.373ZM5.54523 5.221C5.97523 4.875 6.60423 4.943 6.95123 5.373L11.7792 11.373C12.0772 11.744 12.0732 12.274 11.7682 12.64L6.76823 18.64C6.57023 18.877 6.28623 19 5.99923 19C5.77423 19 5.54723 18.924 5.36023 18.768C4.93523 18.415 4.87823 17.784 5.23223 17.36L9.70723 11.989L5.39223 6.627C5.04623 6.197 5.11523 5.567 5.54523 5.221Z",
      fill: color
    }
  ) });
}
var init_arrowhead_right = __esm({
  "src/icons/salonized/arrowhead-right.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/arrowhead-left.tsx
import { jsx as jsx296 } from "@emotion/react/jsx-runtime";
function ArrowheadLeft(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx296(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx296(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M18.7684 6.64031L14.2924 12.0113L18.6074 17.3733C18.9534 17.8033 18.8854 18.4323 18.4554 18.7793C18.2704 18.9283 18.0484 19.0003 17.8284 19.0003C17.5364 19.0003 17.2464 18.8723 17.0484 18.6273L12.2204 12.6273C11.9224 12.2563 11.9264 11.7253 12.2314 11.3603L17.2314 5.36031C17.5854 4.93531 18.2154 4.87931 18.6404 5.23231C19.0644 5.58531 19.1214 6.21631 18.7684 6.64031ZM10.232 5.36001C10.585 4.93601 11.215 4.87901 11.64 5.23201C12.064 5.58601 12.121 6.21601 11.768 6.64001L7.29204 12.011L11.607 17.373C11.953 17.803 11.885 18.433 11.455 18.779C11.27 18.928 11.049 19 10.828 19C10.536 19 10.246 18.873 10.049 18.627L5.22104 12.627C4.92204 12.256 4.92704 11.726 5.23204 11.36L10.232 5.36001Z",
      fill: color
    }
  ) });
}
var init_arrowhead_left = __esm({
  "src/icons/salonized/arrowhead-left.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/arrowhead-down.tsx
import { jsx as jsx297 } from "@emotion/react/jsx-runtime";
function ArrowheadDown(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx297(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx297(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12.0001 12.0001C11.7731 12.0001 11.5451 11.9231 11.3601 11.7681L5.36013 6.76807C4.93613 6.41407 4.87913 5.78407 5.23213 5.36007C5.58613 4.93507 6.21513 4.87907 6.64013 5.23207L12.0111 9.70707L17.3731 5.39307C17.8031 5.04707 18.4341 5.11507 18.7791 5.54507C19.1261 5.97507 19.0571 6.60407 18.6271 6.95107L12.6271 11.7791C12.4441 11.9261 12.2221 12.0001 12.0001 12.0001ZM12.0112 16.7076L17.3732 12.3926C17.8032 12.0476 18.4342 12.1156 18.7792 12.5446C19.1252 12.9756 19.0572 13.6046 18.6272 13.9516L12.6272 18.7796C12.4442 18.9266 12.2222 18.9996 12.0002 18.9996C11.7722 18.9996 11.5452 18.9226 11.3602 18.7676L5.36023 13.7676C4.93523 13.4146 4.87823 12.7846 5.23223 12.3596C5.58523 11.9356 6.21523 11.8776 6.64023 12.2316L12.0112 16.7076Z",
      fill: color
    }
  ) });
}
var init_arrowhead_down = __esm({
  "src/icons/salonized/arrowhead-down.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/arrow-up1.tsx
import { jsx as jsx298 } from "@emotion/react/jsx-runtime";
function ArrowUp1(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx298(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx298(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8.01414 14H15.9091L11.9981 9.17805L8.01414 14ZM16.2131 16H7.78714C7.11514 16 6.50714 15.598 6.20214 14.951C5.85714 14.218 5.95714 13.351 6.46014 12.741L10.6741 7.64205C11.3461 6.82505 12.6551 6.82505 13.3261 7.64205L17.5391 12.74C18.0431 13.351 18.1441 14.218 17.7981 14.951C17.4931 15.598 16.8861 16 16.2131 16Z",
      fill: color
    }
  ) });
}
var init_arrow_up1 = __esm({
  "src/icons/salonized/arrow-up1.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/arrow-up.tsx
import { jsx as jsx299 } from "@emotion/react/jsx-runtime";
function ArrowUp(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx299(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx299(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M5.23191 10.64C5.58591 11.064 6.21591 11.122 6.63991 10.768L10.9999 7.135V19C10.9999 19.552 11.4479 20 11.9999 20C12.5519 20 12.9999 19.552 12.9999 19V7.135L17.3599 10.768C17.7849 11.122 18.4149 11.064 18.7679 10.64C19.1219 10.216 19.0649 9.585 18.6399 9.232L12.6399 4.232C12.5929 4.192 12.5369 4.173 12.4849 4.143C12.4439 4.119 12.4079 4.091 12.3629 4.073C12.2459 4.027 12.1239 4 11.9999 4C11.8759 4 11.7539 4.027 11.6369 4.073C11.5919 4.091 11.5559 4.119 11.5149 4.143C11.4629 4.173 11.4069 4.192 11.3599 4.232L5.35991 9.232C4.93591 9.585 4.87791 10.216 5.23191 10.64Z",
      fill: color
    }
  ) });
}
var init_arrow_up = __esm({
  "src/icons/salonized/arrow-up.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/arrow-right1.tsx
import { jsx as jsx300 } from "@emotion/react/jsx-runtime";
function ArrowRight1(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx300(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx300(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10.5 8.01466V15.9087L15.321 11.9977L10.5 8.01466ZM10.456 18.0007C10.149 18.0007 9.839 17.9347 9.55 17.7987C8.902 17.4937 8.5 16.8857 8.5 16.2127V7.78666C8.5 7.11466 8.902 6.50666 9.55 6.20166C10.282 5.85666 11.15 5.95666 11.759 6.45966L16.858 10.6737C17.267 11.0097 17.5 11.4937 17.5 11.9997C17.5 12.5057 17.267 12.9907 16.858 13.3267L11.759 17.5387C11.391 17.8437 10.927 18.0007 10.456 18.0007Z",
      fill: color
    }
  ) });
}
var init_arrow_right1 = __esm({
  "src/icons/salonized/arrow-right1.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/arrow-right.tsx
import { jsx as jsx301 } from "@emotion/react/jsx-runtime";
function ArrowRight(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx301(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx301(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M5 13H16.865L13.232 17.36C12.878 17.784 12.936 18.415 13.36 18.768C13.785 19.122 14.415 19.064 14.769 18.64L19.769 12.64C19.808 12.593 19.827 12.538 19.856 12.486C19.88 12.444 19.909 12.408 19.927 12.362C19.972 12.247 19.999 12.126 19.999 12.004C19.999 12.003 20 12.001 20 12C20 11.999 19.999 11.997 19.999 11.996C19.999 11.874 19.972 11.753 19.927 11.638C19.909 11.592 19.88 11.556 19.856 11.514C19.827 11.462 19.808 11.407 19.769 11.36L14.769 5.36C14.57 5.123 14.286 5 14 5C13.774 5 13.547 5.076 13.36 5.232C12.936 5.585 12.878 6.216 13.232 6.64L16.865 11H5C4.448 11 4 11.448 4 12C4 12.552 4.448 13 5 13Z",
      fill: color
    }
  ) });
}
var init_arrow_right = __esm({
  "src/icons/salonized/arrow-right.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/arrow-left.tsx
import { jsx as jsx302 } from "@emotion/react/jsx-runtime";
function ArrowLeft(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx302(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx302(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M19 10.9999H7.135L10.768 6.63991C11.122 6.21591 11.064 5.58491 10.64 5.23191C10.215 4.87791 9.585 4.93591 9.232 5.35991L4.232 11.3599C4.193 11.4069 4.173 11.4619 4.144 11.5139C4.12 11.5559 4.091 11.5919 4.073 11.6379C4.028 11.7529 4.001 11.8739 4.001 11.9959C4.001 11.9969 4 11.9989 4 11.9999C4 12.0009 4.001 12.0029 4.001 12.0039C4.001 12.1259 4.028 12.2469 4.073 12.3619C4.091 12.4079 4.12 12.4439 4.144 12.4859C4.173 12.5379 4.193 12.5929 4.232 12.6399L9.232 18.6399C9.43 18.8769 9.714 18.9999 10 18.9999C10.226 18.9999 10.453 18.9239 10.64 18.7679C11.064 18.4149 11.122 17.7839 10.768 17.3599L7.135 12.9999H19C19.552 12.9999 20 12.5519 20 11.9999C20 11.4479 19.552 10.9999 19 10.9999Z",
      fill: color
    }
  ) });
}
var init_arrow_left = __esm({
  "src/icons/salonized/arrow-left.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/arrow-ios-up.tsx
import { jsx as jsx303 } from "@emotion/react/jsx-runtime";
function ArrowIosUp(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx303(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx303(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M17.9998 14.9999C17.7738 14.9999 17.5468 14.9239 17.3597 14.7679L11.9887 10.2919L6.62675 14.6069C6.19775 14.9539 5.56775 14.8859 5.22075 14.4549C4.87475 14.0249 4.94275 13.3959 5.37375 13.0489L11.3737 8.22092C11.7437 7.92192 12.2747 7.92592 12.6407 8.23192L18.6407 13.2319C19.0647 13.5849 19.1217 14.2159 18.7688 14.6399C18.5708 14.8769 18.2867 14.9999 17.9998 14.9999Z",
      fill: color
    }
  ) });
}
var init_arrow_ios_up = __esm({
  "src/icons/salonized/arrow-ios-up.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/arrow-ios-right.tsx
import { jsx as jsx304 } from "@emotion/react/jsx-runtime";
function ArrowIosRight(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx304(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx304(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M9.9995 19.0001C9.7735 19.0001 9.5465 18.9241 9.3595 18.7681C8.9355 18.4151 8.8785 17.7841 9.2315 17.3601L13.7075 11.9891L9.3925 6.62707C9.0465 6.19707 9.1145 5.56707 9.5445 5.22107C9.9755 4.87507 10.6045 4.94307 10.9515 5.37307L15.7795 11.3731C16.0775 11.7441 16.0735 12.2741 15.7685 12.6401L10.7685 18.6401C10.5705 18.8771 10.2865 19.0001 9.9995 19.0001Z",
      fill: color
    }
  ) });
}
var init_arrow_ios_right = __esm({
  "src/icons/salonized/arrow-ios-right.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/arrow-ios-left.tsx
import { jsx as jsx305 } from "@emotion/react/jsx-runtime";
function ArrowIosLeft(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx305(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx305(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M13.8287 19C13.5367 19 13.2467 18.873 13.0487 18.627L8.22066 12.627C7.92266 12.256 7.92666 11.726 8.23166 11.36L13.2317 5.35998C13.5847 4.93598 14.2157 4.87898 14.6407 5.23198C15.0647 5.58498 15.1217 6.21598 14.7677 6.63998L10.2927 12.011L14.6077 17.373C14.9537 17.803 14.8857 18.433 14.4547 18.779C14.2707 18.928 14.0487 19 13.8287 19Z",
      fill: color
    }
  ) });
}
var init_arrow_ios_left = __esm({
  "src/icons/salonized/arrow-ios-left.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/arrow-ios-down.tsx
import { jsx as jsx306 } from "@emotion/react/jsx-runtime";
function ArrowIosDown(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx306(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx306(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11.9999 16C11.7719 16 11.5449 15.923 11.3599 15.768L5.35991 10.768C4.93591 10.415 4.87791 9.78398 5.23191 9.35998C5.58491 8.93598 6.21491 8.87898 6.63991 9.23198L12.0109 13.708L17.3729 9.39298C17.8029 9.04698 18.4329 9.11498 18.7789 9.54498C19.1249 9.97498 19.0569 10.604 18.6269 10.951L12.6269 15.779C12.4439 15.926 12.2219 16 11.9999 16Z",
      fill: color
    }
  ) });
}
var init_arrow_ios_down = __esm({
  "src/icons/salonized/arrow-ios-down.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/arrow-down1.tsx
import { jsx as jsx307 } from "@emotion/react/jsx-runtime";
function ArrowDown1(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx307(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx307(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8.09208 10L12.0021 14.822L15.9871 10H8.09208ZM12.0001 17C11.4941 17 11.0101 16.767 10.6741 16.358L6.46108 11.26C5.95708 10.649 5.85708 9.782 6.20208 9.049C6.50708 8.402 7.11408 8 7.78708 8H16.2131C16.8861 8 17.4931 8.402 17.7981 9.049C18.1441 9.782 18.0431 10.649 17.5401 11.259L13.3261 16.358C12.9901 16.767 12.5061 17 12.0001 17Z",
      fill: color
    }
  ) });
}
var init_arrow_down1 = __esm({
  "src/icons/salonized/arrow-down1.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/arrow-down.tsx
import { jsx as jsx308 } from "@emotion/react/jsx-runtime";
function ArrowDown(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx308(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx308(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M18.7682 13.36C18.4142 12.936 17.7842 12.878 17.3602 13.232L13.0002 16.865V5C13.0002 4.448 12.5522 4 12.0002 4C11.4482 4 11.0002 4.448 11.0002 5V16.865L6.64023 13.232C6.21523 12.878 5.58523 12.936 5.23223 13.36C4.87823 13.784 4.93523 14.415 5.36023 14.768L11.3602 19.768C11.4072 19.808 11.4632 19.827 11.5152 19.857C11.5562 19.881 11.5922 19.909 11.6372 19.927C11.7542 19.973 11.8762 20 12.0002 20C12.1242 20 12.2462 19.973 12.3632 19.927C12.4082 19.909 12.4442 19.881 12.4852 19.857C12.5372 19.827 12.5932 19.808 12.6402 19.768L18.6402 14.768C19.0642 14.415 19.1222 13.784 18.7682 13.36Z",
      fill: color
    }
  ) });
}
var init_arrow_down = __esm({
  "src/icons/salonized/arrow-down.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/arrow-circle-up.tsx
import { jsx as jsx309 } from "@emotion/react/jsx-runtime";
function ArrowCircleUp(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx309(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx309(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12.7075 7.2935C12.6165 7.2015 12.5065 7.1285 12.3855 7.0785C12.2645 7.0275 12.1355 7.0015 12.0055 7.0015C12.0035 7.0015 12.0015 7.0005 11.9995 7.0005C11.9635 7.0005 11.9335 7.0165 11.8975 7.0205C11.8055 7.0305 11.7135 7.0405 11.6265 7.0755C11.5575 7.1035 11.5015 7.1505 11.4405 7.1925C11.3975 7.2225 11.3485 7.2395 11.3095 7.2765L8.3095 10.1385C7.9105 10.5205 7.8955 11.1525 8.2765 11.5525C8.6585 11.9525 9.2905 11.9665 9.6905 11.5855L10.9995 10.3365V16.0005C10.9995 16.5525 11.4475 17.0005 11.9995 17.0005C12.5525 17.0005 12.9995 16.5525 12.9995 16.0005V10.4145L14.2925 11.7075C14.4885 11.9025 14.7445 12.0005 14.9995 12.0005C15.2555 12.0005 15.5115 11.9025 15.7075 11.7075C16.0975 11.3165 16.0975 10.6835 15.7075 10.2935L12.7075 7.2935ZM12 20C7.589 20 4 16.411 4 12C4 7.589 7.589 4 12 4C16.411 4 20 7.589 20 12C20 16.411 16.411 20 12 20ZM12 2C6.486 2 2 6.486 2 12C2 17.514 6.486 22 12 22C17.514 22 22 17.514 22 12C22 6.486 17.514 2 12 2Z",
      fill: color
    }
  ) });
}
var init_arrow_circle_up = __esm({
  "src/icons/salonized/arrow-circle-up.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/arrow-circle-right.tsx
import { jsx as jsx310 } from "@emotion/react/jsx-runtime";
function ArrowCircleRight(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx310(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx310(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M16.999 12.0054C16.999 12.0034 17 12.0024 17 12.0004C17 11.9674 16.984 11.9404 16.981 11.9084C16.973 11.8124 16.961 11.7164 16.924 11.6264C16.897 11.5584 16.851 11.5044 16.81 11.4444C16.779 11.4004 16.762 11.3494 16.724 11.3094L13.861 8.3094C13.479 7.9094 12.847 7.8954 12.447 8.2764C12.048 8.6574 12.033 9.2904 12.414 9.6904L13.664 11.0004H8C7.448 11.0004 7 11.4474 7 12.0004C7 12.5524 7.448 13.0004 8 13.0004H13.586L12.293 14.2934C11.902 14.6834 11.902 15.3164 12.293 15.7074C12.488 15.9024 12.744 16.0004 13 16.0004C13.256 16.0004 13.512 15.9024 13.707 15.7074L16.707 12.7074C16.798 12.6164 16.872 12.5064 16.922 12.3854C16.973 12.2644 16.998 12.1354 16.999 12.0054ZM12 20C7.589 20 4 16.411 4 12C4 7.589 7.589 4 12 4C16.411 4 20 7.589 20 12C20 16.411 16.411 20 12 20ZM12 2C6.486 2 2 6.486 2 12C2 17.514 6.486 22 12 22C17.514 22 22 17.514 22 12C22 6.486 17.514 2 12 2Z",
      fill: color
    }
  ) });
}
var init_arrow_circle_right = __esm({
  "src/icons/salonized/arrow-circle-right.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/arrow-circle-left.tsx
import { jsx as jsx311 } from "@emotion/react/jsx-runtime";
function ArrowCircleLeft(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx311(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx311(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M16 11H10.336L11.586 9.69C11.967 9.291 11.952 8.658 11.553 8.276C11.153 7.896 10.521 7.91 10.139 8.31L7.276 11.31C7.238 11.35 7.221 11.4 7.19 11.445C7.149 11.504 7.103 11.558 7.076 11.626C7.039 11.717 7.027 11.812 7.019 11.909C7.016 11.94 7 11.968 7 12C7 12.002 7.001 12.003 7.001 12.005C7.002 12.135 7.027 12.264 7.078 12.386C7.128 12.507 7.202 12.616 7.293 12.708L10.293 15.707C10.488 15.902 10.744 16 11 16C11.256 16 11.512 15.902 11.707 15.707C12.098 15.316 12.098 14.684 11.707 14.293L10.414 13H16C16.552 13 17 12.552 17 12C17 11.448 16.552 11 16 11ZM12 20C7.589 20 4 16.411 4 12C4 7.589 7.589 4 12 4C16.411 4 20 7.589 20 12C20 16.411 16.411 20 12 20ZM12 2C6.486 2 2 6.486 2 12C2 17.514 6.486 22 12 22C17.514 22 22 17.514 22 12C22 6.486 17.514 2 12 2Z",
      fill: color
    }
  ) });
}
var init_arrow_circle_left = __esm({
  "src/icons/salonized/arrow-circle-left.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/arrow-circle-down.tsx
import { jsx as jsx312 } from "@emotion/react/jsx-runtime";
function ArrowCircleDown(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx312(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx312(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M14.3096 12.4141L12.9996 13.6641V8.0001C12.9996 7.4481 12.5526 7.0001 11.9996 7.0001C11.4476 7.0001 10.9996 7.4481 10.9996 8.0001V13.5861L9.7066 12.2931C9.3166 11.9021 8.6836 11.9021 8.2926 12.2931C7.9026 12.6841 7.9026 13.3161 8.2926 13.7071L11.2926 16.7061C11.3846 16.7991 11.4956 16.8721 11.6176 16.9231C11.7396 16.9741 11.8696 17.0001 11.9996 17.0001C12.1286 17.0001 12.2566 16.9731 12.3766 16.9241C12.4376 16.8991 12.4856 16.8561 12.5386 16.8201C12.5896 16.7871 12.6456 16.7671 12.6906 16.7241L15.6906 13.8611C16.0896 13.4801 16.1046 12.8471 15.7236 12.4471C15.3416 12.0471 14.7096 12.0331 14.3096 12.4141ZM12 20C7.589 20 4 16.411 4 12C4 7.589 7.589 4 12 4C16.411 4 20 7.589 20 12C20 16.411 16.411 20 12 20ZM12 2C6.486 2 2 6.486 2 12C2 17.514 6.486 22 12 22C17.514 22 22 17.514 22 12C22 6.486 17.514 2 12 2Z",
      fill: color
    }
  ) });
}
var init_arrow_circle_down = __esm({
  "src/icons/salonized/arrow-circle-down.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/archive.tsx
import { jsx as jsx313 } from "@emotion/react/jsx-runtime";
function Archive(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx313(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx313(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M9.8662 14H14.1342C14.6102 14 15.0002 13.61 15.0002 13.134V12.866C15.0002 12.39 14.6102 12 14.1342 12H9.8662C9.3892 12 9.0002 12.39 9.0002 12.866V13.134C9.0002 13.61 9.3892 14 9.8662 14ZM18 18C18 18.551 17.552 19 17 19H7C6.449 19 6 18.551 6 18V9H18V18ZM6 5H18C18.552 5 19 5.449 19 6C19 6.551 18.552 7 18 7H6C5.449 7 5 6.551 5 6C5 5.449 5.449 5 6 5ZM21 6C21 4.346 19.654 3 18 3H6C4.346 3 3 4.346 3 6C3 6.883 3.391 7.67 4 8.22V18C4 19.654 5.346 21 7 21H17C18.654 21 20 19.654 20 18V8.22C20.609 7.67 21 6.883 21 6Z",
      fill: color
    }
  ) });
}
var init_archive = __esm({
  "src/icons/salonized/archive.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/all-done.tsx
import { jsx as jsx314 } from "@emotion/react/jsx-runtime";
function AllDone(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx314(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx314(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M16.6163 6.21284C16.1823 5.87084 15.5543 5.94884 15.2133 6.38384L8.15833 15.3918L4.77933 11.1948C4.43133 10.7658 3.80333 10.6958 3.37333 11.0428C2.94233 11.3898 2.87533 12.0198 3.22033 12.4488L7.38933 17.6268C7.58033 17.8628 7.86633 17.9998 8.16933 17.9998H8.17633C8.48033 17.9978 8.76833 17.8568 8.95633 17.6158L16.7873 7.61584C17.1283 7.18184 17.0523 6.55284 16.6163 6.21284ZM21.6163 6.21284C21.1813 5.87084 20.5543 5.94884 20.2133 6.38384L13.1583 15.3918L12.5543 14.6428L11.2893 16.2598L12.3893 17.6268C12.5803 17.8628 12.8663 17.9998 13.1693 17.9998H13.1763C13.4803 17.9978 13.7683 17.8568 13.9563 17.6158L21.7873 7.61584C22.1283 7.18184 22.0523 6.55284 21.6163 6.21284ZM9.98003 11.4444L8.71303 13.0604L8.22103 12.4494C7.87503 12.0194 7.94203 11.3894 8.37303 11.0424C8.80403 10.6964 9.43303 10.7654 9.77903 11.1954L9.98003 11.4444Z",
      fill: color
    }
  ) });
}
var init_all_done = __esm({
  "src/icons/salonized/all-done.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/alert-triangle.tsx
import { jsx as jsx315 } from "@emotion/react/jsx-runtime";
function AlertTriangle(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx315(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx315(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11.0005 9C11.0005 8.448 11.4485 8 12.0005 8C12.5525 8 13.0005 8.448 13.0005 9V13C13.0005 13.552 12.5525 14 12.0005 14C11.4485 14 11.0005 13.552 11.0005 13V9ZM11.0005 16C11.0005 15.448 11.4485 15 12.0005 15C12.5525 15 13.0005 15.448 13.0005 16C13.0005 16.552 12.5525 17 12.0005 17C11.4485 17 11.0005 16.552 11.0005 16ZM20.8652 18.353C20.6362 18.758 20.1902 19 19.6722 19H4.32819C3.81019 19 3.36419 18.758 3.13619 18.353C3.02819 18.163 2.88619 17.776 3.15319 17.336L10.8242 4.618C11.2912 3.844 12.7092 3.844 13.1762 4.618L20.8482 17.336C21.1142 17.776 20.9732 18.163 20.8652 18.353ZM22.5612 16.303L14.8892 3.584C14.2902 2.592 13.2102 2 12.0002 2C10.7902 2 9.71019 2.592 9.11219 3.584L1.44019 16.303C0.871187 17.246 0.854187 18.38 1.39419 19.336C1.97319 20.363 3.09819 21 4.32819 21H19.6722C20.9032 21 22.0272 20.363 22.6072 19.336C23.1472 18.38 23.1302 17.246 22.5612 16.303Z",
      fill: color
    }
  ) });
}
var init_alert_triangle = __esm({
  "src/icons/salonized/alert-triangle.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/alert-circle.tsx
import { jsx as jsx316 } from "@emotion/react/jsx-runtime";
function AlertCircle(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx316(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx316(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11 8C11 7.448 11.448 7 12 7C12.552 7 13 7.448 13 8V13C13 13.552 12.552 14 12 14C11.448 14 11 13.552 11 13V8ZM11 16C11 15.448 11.448 15 12 15C12.552 15 13 15.448 13 16C13 16.552 12.552 17 12 17C11.448 17 11 16.552 11 16ZM12 20C7.589 20 4 16.411 4 12C4 7.589 7.589 4 12 4C16.411 4 20 7.589 20 12C20 16.411 16.411 20 12 20ZM12 2C6.477 2 2 6.477 2 12C2 17.523 6.477 22 12 22C17.523 22 22 17.523 22 12C22 6.477 17.523 2 12 2Z",
      fill: color
    }
  ) });
}
var init_alert_circle = __esm({
  "src/icons/salonized/alert-circle.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/activity.tsx
import { jsx as jsx317 } from "@emotion/react/jsx-runtime";
function Activity(props) {
  const { color, size } = props;
  return /* @__PURE__ */ jsx317(SvgIcon, { size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx317(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M14.329 20.0004C14.262 20.0004 14.193 19.9974 14.124 19.9904C13.244 19.9034 12.554 19.2824 12.364 18.4074L9.681 6.01542L6.918 12.3974C6.759 12.7634 6.398 13.0004 6 13.0004H3C2.447 13.0004 2 12.5524 2 12.0004C2 11.4474 2.447 11.0004 3 11.0004H5.344L7.85 5.21142C8.205 4.39542 8.987 3.92042 9.876 4.00942C10.756 4.09642 11.446 4.71742 11.636 5.59242L14.319 17.9844L17.082 11.6024C17.241 11.2364 17.601 11.0004 18 11.0004H21C21.553 11.0004 22 11.4474 22 12.0004C22 12.5524 21.553 13.0004 21 13.0004H18.656L16.15 18.7884C15.823 19.5414 15.122 20.0004 14.329 20.0004Z",
      fill: color
    }
  ) });
}
var init_activity = __esm({
  "src/icons/salonized/activity.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/salonized/index.ts
var init_salonized = __esm({
  "src/icons/salonized/index.ts"() {
    "use strict";
    init_workshop();
    init_wifi();
    init_wifi_off();
    init_weight();
    init_volume();
    init_volume_up();
    init_volume_off();
    init_volume_down();
    init_video();
    init_video_off();
    init_upload();
    init_unlock();
    init_undo();
    init_umbrella();
    init_twitter();
    init_tv();
    init_trending_up();
    init_trending_down();
    init_trash2();
    init_trash();
    init_toggle_right();
    init_toggle_left();
    init_timer();
    init_thermometer();
    init_thermometer_plus();
    init_thermometer_minus();
    init_text();
    init_sync();
    init_swap();
    init_sun();
    init_stop_circle();
    init_star2();
    init_square();
    init_speaker();
    init_smartphone();
    init_slash();
    init_skip_forward();
    init_skip_back();
    init_shuffle2();
    init_shuffle();
    init_shopping_cart();
    init_shopping_bag();
    init_shield();
    init_shield_off();
    init_share();
    init_shake();
    init_settings2();
    init_settings();
    init_search2();
    init_scissors();
    init_save();
    init_rewind_right();
    init_rewind_left();
    init_repeat();
    init_refresh();
    init_recording();
    init_radio();
    init_radio_button_on();
    init_radio_button_off();
    init_question_mark();
    init_question_mark_circle();
    init_printer();
    init_pricetag();
    init_power();
    init_plus();
    init_plus_square();
    init_plus_circle();
    init_play_circle();
    init_pin();
    init_pie_chart();
    init_phone();
    init_phone_off();
    init_phone_missed();
    init_phone_call();
    init_person2();
    init_person_remove();
    init_person_done();
    init_person_delete();
    init_percent();
    init_people();
    init_pause_circle();
    init_paper_plane();
    init_pantone();
    init_options2();
    init_options();
    init_npm();
    init_navigation2();
    init_navigation();
    init_music();
    init_move();
    init_more_vertical();
    init_more_horizontal();
    init_moon();
    init_monitor();
    init_minus2();
    init_minus_square();
    init_minus_circle();
    init_minimize();
    init_mic();
    init_mic_off();
    init_message_square();
    init_message_circle();
    init_menu2();
    init_menu();
    init_menu_arrow();
    init_maximize();
    init_map();
    init_log_out();
    init_log_in();
    init_lock();
    init_loader();
    init_list();
    init_linkedin();
    init_link2();
    init_link3();
    init_layout();
    init_layers();
    init_keypad();
    init_info();
    init_inbox();
    init_image();
    init_home2();
    init_height();
    init_heart2();
    init_headphones();
    init_hash();
    init_hard_drive();
    init_grid();
    init_google();
    init_globe2();
    init_globe();
    init_github();
    init_gift2();
    init_funnel();
    init_folder();
    init_folder_remove();
    init_folder_add();
    init_flip2();
    init_flip();
    init_flash();
    init_flash_off();
    init_flag();
    init_fire2();
    init_film();
    init_file();
    init_file_text();
    init_file_remove();
    init_file_add();
    init_facebook();
    init_eye();
    init_eye_off2();
    init_eye_off();
    init_external_link();
    init_expand2();
    init_email();
    init_edit2();
    init_edit();
    init_droplet();
    init_droplet_off();
    init_download();
    init_diagonal_arrow_right_up();
    init_diagonal_arrow_right_down();
    init_diagonal_arrow_left_up();
    init_diagonal_arrow_left_down();
    init_cube();
    init_crop();
    init_credit_card();
    init_corner_up_right();
    init_corner_up_left();
    init_corner_right_up();
    init_corner_right_down();
    init_corner_left_up();
    init_corner_left_down();
    init_corner_down_right();
    init_corner_down_left();
    init_copy();
    init_compass();
    init_color_picker();
    init_color_palette();
    init_collapse();
    init_code();
    init_code_download();
    init_cloud_upload();
    init_cloud_download();
    init_close2();
    init_close_circle1();
    init_close_circle();
    init_clock();
    init_clipboard();
    init_chevron_up();
    init_chevron_right();
    init_chevron_left();
    init_chevron_down();
    init_checkmark();
    init_checkmark_square2();
    init_checkmark_square();
    init_checkmark_circle2();
    init_checkmark_circle();
    init_cast();
    init_car();
    init_camera();
    init_calendar2();
    init_bulb();
    init_brush();
    init_browser();
    init_briefcase();
    init_bookmark();
    init_book();
    init_book_open();
    init_bluetooth();
    init_bell();
    init_bell_off();
    init_behance();
    init_batttery_charging();
    init_battery();
    init_bar_chart2();
    init_bar_chart();
    init_backspace();
    init_award();
    init_attach2();
    init_attach();
    init_at();
    init_arrrow_left();
    init_arrowhead_up();
    init_arrowhead_right();
    init_arrowhead_left();
    init_arrowhead_down();
    init_arrow_up1();
    init_arrow_up();
    init_arrow_right1();
    init_arrow_right();
    init_arrow_left();
    init_arrow_ios_up();
    init_arrow_ios_right();
    init_arrow_ios_left();
    init_arrow_ios_down();
    init_arrow_down1();
    init_arrow_down();
    init_arrow_circle_up();
    init_arrow_circle_right();
    init_arrow_circle_left();
    init_arrow_circle_down();
    init_archive();
    init_all_done();
    init_alert_triangle();
    init_alert_circle();
    init_activity();
  }
});

// src/icons/helpers.tsx
import { jsx as jsx318 } from "@emotion/react/jsx-runtime";
function getSize(size) {
  if (typeof size === "number") {
    return size;
  }
  if (size === "small" /* SMALL */) {
    return 16;
  }
  if (size === "large" /* LARGE */) {
    return 32;
  }
  if (size === "x-large" /* X_LARGE */) {
    return 40;
  }
  return 24;
}
function SvgIcon(props) {
  const { size, children, viewBox, rotate = 0 } = props;
  return /* @__PURE__ */ jsx318(
    "svg",
    {
      style: { display: "block", transform: `rotate(${rotate}deg)` },
      width: getSize(size),
      height: getSize(size),
      viewBox: viewBox || "0 0 12 12",
      xmlns: "http://www.w3.org/2000/svg",
      className: "tw-store-component-icon",
      children
    }
  );
}
function getIconFromName(iconEnum) {
  return iconsList[iconEnum];
}
var iconsList;
var init_helpers2 = __esm({
  "src/icons/helpers.tsx"() {
    "use strict";
    init_types();
    init_treatwell_pro();
    init_salonized();
    iconsList = {
      ["tw-pro:add-user" /* TW_PRO_ADD_USER */]: AddUser,
      ["tw-pro:arrow-back" /* TW_PRO_ARROW_BACK */]: ArrowBack,
      ["tw-pro:arrow-forward" /* TW_PRO_ARROW_FORWARD */]: ArrowForward,
      ["tw-pro:avatar" /* TW_PRO_AVATAR */]: Avatar,
      ["tw-pro:beard" /* TW_PRO_BEARD */]: Beard,
      ["tw-pro:bin" /* TW_PRO_BIN */]: Bin,
      ["tw-pro:box" /* TW_PRO_BOX */]: Box,
      ["tw-pro:calendar" /* TW_PRO_CALENDAR */]: Calendar,
      ["tw-pro:card" /* TW_PRO_CARD */]: Card,
      ["tw-pro:cart" /* TW_PRO_CART */]: Cart,
      ["tw-pro:cash" /* TW_PRO_CASH */]: Cash,
      ["tw-pro:caution" /* TW_PRO_CAUTION */]: Caution,
      ["tw-pro:chair" /* TW_PRO_CHAIR */]: Chair,
      ["tw-pro:check-filled" /* TW_PRO_CHECK_FILLED */]: CheckFilled,
      ["tw-pro:check-mark" /* TW_PRO_CHECK_MARK */]: CheckMark,
      ["tw-pro:chevron-add" /* TW_PRO_CHEVRON_ADD */]: ChevronAdd,
      ["tw-pro:chevron-down" /* TW_PRO_CHEVRON_DOWN */]: ChevronDown,
      ["tw-pro:chevron-left" /* TW_PRO_CHEVRON_LEFT */]: ChevronLeft,
      ["tw-pro:chevron-right" /* TW_PRO_CHEVRON_RIGHT */]: ChevronRight,
      ["tw-pro:chevron-up" /* TW_PRO_CHEVRON_UP */]: ChevronUp,
      ["tw-pro:close" /* TW_PRO_CLOSE */]: Close,
      ["tw-pro:discount-outline" /* TW_PRO_DISCOUNT_OUTLINE */]: DiscountOutline,
      ["tw-pro:expand" /* TW_PRO_EXPAND */]: Expand,
      ["tw-pro:face" /* TW_PRO_FACE */]: Face,
      ["tw-pro:fast-delivery" /* TW_PRO_FAST_DELIVERY */]: FastDelivery,
      ["tw-pro:fire" /* TW_PRO_FIRE */]: Fire,
      ["tw-pro:gift" /* TW_PRO_GIFT */]: Gift,
      ["tw-pro:hair" /* TW_PRO_HAIR */]: Hair,
      ["tw-pro:hair-removal" /* TW_PRO_HAIR_REMOVAL */]: HairRemoval,
      ["tw-pro:hamburger-nav" /* TW_PRO_HAMBURGER_NAV */]: HamburgerNav,
      ["tw-pro:happy" /* TW_PRO_HAPPY */]: Happy,
      ["tw-pro:heart-filled" /* TW_PRO_HEART_FILLED */]: HeartFilled,
      ["tw-pro:heart-outline" /* TW_PRO_HEART_OUTLINE */]: HeartOutline,
      ["tw-pro:hide" /* TW_PRO_HIDE */]: Hide,
      ["tw-pro:highlights" /* TW_PRO_HIGHLIGHTS */]: Highlights,
      ["tw-pro:home" /* TW_PRO_HOME */]: Home,
      ["tw-pro:home-base-salon" /* TW_PRO_HOME_BASED_SALON */]: HomeBasedSalon,
      ["tw-pro:loading" /* TW_PRO_LOADING */]: Loading,
      ["tw-pro:massage" /* TW_PRO_MASSAGE */]: Massage,
      ["tw-pro:minus" /* TW_PRO_MINUS */]: Minus,
      ["tw-pro:mobile-therapist" /* TW_PRO_MOBILE_THERAPIST */]: MobileTherapist,
      ["tw-pro:nails" /* TW_PRO_NAILS */]: Nails,
      ["tw-pro:new-venue" /* TW_PRO_NEW_VENUE */]: NewVenue,
      ["tw-pro:online" /* TW_PRO_ONLINE */]: Online,
      ["tw-pro:padlock" /* TW_PRO_PADLOCK */]: Padlock,
      ["tw-pro:pen" /* TW_PRO_PEN */]: Pen,
      ["tw-pro:person" /* TW_PRO_PERSON */]: Person,
      ["tw-pro:persons" /* TW_PRO_PERSONS */]: Persons,
      ["tw-pro:products" /* TW_PRO_PRODUCTS */]: Products,
      ["tw-pro:question" /* TW_PRO_QUESTION */]: Question,
      ["tw-pro:receipt" /* TW_PRO_RECEIPT */]: Receipt,
      ["tw-pro:search" /* TW_PRO_SEARCH */]: Search,
      ["tw-pro:show" /* TW_PRO_SHOW */]: Show,
      ["tw-pro:sort" /* TW_PRO_SORT */]: Sort,
      ["tw-pro:spa" /* TW_PRO_SPA */]: Spa,
      ["tw-pro:star-filled" /* TW_PRO_STAR_FILLED */]: StarFilled,
      ["tw-pro:star-half" /* TW_PRO_STAR_HALF */]: StarHalf,
      ["tw-pro:star-outlined" /* TW_PRO_STAR_OUTLINED */]: StarOutline,
      ["tw-pro:time" /* TW_PRO_TIME */]: Time,
      ["tw-pro:truck" /* TW_PRO_TRUCK */]: Truck,
      ["tw-pro:unhappy" /* TW_PRO_UNHAPPY */]: Unhappy,
      ["tw-pro:user" /* TW_PRO_USER */]: User,
      ["tw-pro:venue" /* TW_PRO_VENUE */]: Venue,
      ["tw-pro:venue-search" /* TW_PRO_VENUE_SEARCH */]: VenueSearch,
      ["tw-pro:voucher" /* TW_PRO_VOUCHER */]: Voucher,
      ["tw-pro:warning-outline" /* TW_PRO_WARNING_OUTLINE */]: WarningOutline,
      // Salonized icons
      ["salonized:activity" /* SALONIZED_ACTIVITY */]: Activity,
      ["salonized:alert-circle" /* SALONIZED_ALERT_CIRCLE */]: AlertCircle,
      ["salonized:alert-triangle" /* SALONIZED_ALERT_TRIANGLE */]: AlertTriangle,
      ["salonized:all-done" /* SALONIZED_ALL_DONE */]: AllDone,
      ["salonized:archive" /* SALONIZED_ARCHIVE */]: Archive,
      ["salonized:arrow-circle-down" /* SALONIZED_ARROW_CIRCLE_DOWN */]: ArrowCircleDown,
      ["salonized:arrow-circle-left" /* SALONIZED_ARROW_CIRCLE_LEFT */]: ArrowCircleLeft,
      ["salonized:arrow-circle-right" /* SALONIZED_ARROW_CIRCLE_RIGHT */]: ArrowCircleRight,
      ["salonized:arrow-circle-up" /* SALONIZED_ARROW_CIRCLE_UP */]: ArrowCircleUp,
      ["salonized:arrow-down" /* SALONIZED_ARROW_DOWN */]: ArrowDown,
      ["salonized:arrow-down1" /* SALONIZED_ARROW_DOWN1 */]: ArrowDown1,
      ["salonized:arrow-ios-down" /* SALONIZED_ARROW_IOS_DOWN */]: ArrowIosDown,
      ["salonized:arrow-ios-left" /* SALONIZED_ARROW_IOS_LEFT */]: ArrowIosLeft,
      ["salonized:arrow-ios-right" /* SALONIZED_ARROW_IOS_RIGHT */]: ArrowIosRight,
      ["salonized:arrow-ios-up" /* SALONIZED_ARROW_IOS_UP */]: ArrowIosUp,
      ["salonized:arrow-left" /* SALONIZED_ARROW_LEFT */]: ArrowLeft,
      ["salonized:arrow-right" /* SALONIZED_ARROW_RIGHT */]: ArrowRight,
      ["salonized:arrow-right1" /* SALONIZED_ARROW_RIGHT1 */]: ArrowRight1,
      ["salonized:arrow-up" /* SALONIZED_ARROW_UP */]: ArrowUp,
      ["salonized:arrow-up1" /* SALONIZED_ARROW_UP1 */]: ArrowUp1,
      ["salonized:arrowhead-down" /* SALONIZED_ARROWHEAD_DOWN */]: ArrowheadDown,
      ["salonized:arrowhead-left" /* SALONIZED_ARROWHEAD_LEFT */]: ArrowheadLeft,
      ["salonized:arrowhead-right" /* SALONIZED_ARROWHEAD_RIGHT */]: ArrowheadRight,
      ["salonized:arrowhead-up" /* SALONIZED_ARROWHEAD_UP */]: ArrowheadUp,
      ["salonized:arrrow-left" /* SALONIZED_ARRROW_LEFT */]: ArrrowLeft,
      ["salonized:at" /* SALONIZED_AT */]: At,
      ["salonized:attach" /* SALONIZED_ATTACH */]: Attach,
      ["salonized:attach2" /* SALONIZED_ATTACH2 */]: Attach2,
      ["salonized:award" /* SALONIZED_AWARD */]: Award,
      ["salonized:backspace" /* SALONIZED_BACKSPACE */]: Backspace,
      ["salonized:bar-chart" /* SALONIZED_BAR_CHART */]: BarChart,
      ["salonized:bar-chart2" /* SALONIZED_BAR_CHART2 */]: BarChart2,
      ["salonized:battery" /* SALONIZED_BATTERY */]: Battery,
      ["salonized:batttery-charging" /* SALONIZED_BATTTERY_CHARGING */]: BattteryCharging,
      ["salonized:behance" /* SALONIZED_BEHANCE */]: Behance,
      ["salonized:bell" /* SALONIZED_BELL */]: Bell,
      ["salonized:bell-off" /* SALONIZED_BELL_OFF */]: BellOff,
      ["salonized:bluetooth" /* SALONIZED_BLUETOOTH */]: Bluetooth,
      ["salonized:book" /* SALONIZED_BOOK */]: Book,
      ["salonized:book-open" /* SALONIZED_BOOK_OPEN */]: BookOpen,
      ["salonized:bookmark" /* SALONIZED_BOOKMARK */]: Bookmark,
      ["salonized:briefcase" /* SALONIZED_BRIEFCASE */]: Briefcase,
      ["salonized:browser" /* SALONIZED_BROWSER */]: Browser,
      ["salonized:brush" /* SALONIZED_BRUSH */]: Brush,
      ["salonized:bulb" /* SALONIZED_BULB */]: Bulb,
      ["salonized:calendar" /* SALONIZED_CALENDAR */]: Calendar2,
      ["salonized:camera" /* SALONIZED_CAMERA */]: Camera,
      ["salonized:car" /* SALONIZED_CAR */]: Car,
      ["salonized:cast" /* SALONIZED_CAST */]: Cast,
      ["salonized:checkmark" /* SALONIZED_CHECKMARK */]: Checkmark,
      ["salonized:checkmark-circle" /* SALONIZED_CHECKMARK_CIRCLE */]: CheckmarkCircle,
      ["salonized:checkmark-circle2" /* SALONIZED_CHECKMARK_CIRCLE2 */]: CheckmarkCircle2,
      ["salonized:checkmark-square" /* SALONIZED_CHECKMARK_SQUARE */]: CheckmarkSquare,
      ["salonized:checkmark-square2" /* SALONIZED_CHECKMARK_SQUARE2 */]: CheckmarkSquare2,
      ["salonized:chevron-down" /* SALONIZED_CHEVRON_DOWN */]: ChevronDown2,
      ["salonized:chevron-left" /* SALONIZED_CHEVRON_LEFT */]: ChevronLeft2,
      ["salonized:chevron-right" /* SALONIZED_CHEVRON_RIGHT */]: ChevronRight2,
      ["salonized:chevron-up" /* SALONIZED_CHEVRON_UP */]: ChevronUp2,
      ["salonized:clipboard" /* SALONIZED_CLIPBOARD */]: Clipboard,
      ["salonized:clock" /* SALONIZED_CLOCK */]: Clock,
      ["salonized:close" /* SALONIZED_CLOSE */]: Close2,
      ["salonized:close-circle" /* SALONIZED_CLOSE_CIRCLE */]: CloseCircle,
      ["salonized:close-circle1" /* SALONIZED_CLOSE_CIRCLE1 */]: CloseCircle1,
      ["salonized:cloud-download" /* SALONIZED_CLOUD_DOWNLOAD */]: CloudDownload,
      ["salonized:cloud-upload" /* SALONIZED_CLOUD_UPLOAD */]: CloudUpload,
      ["salonized:code" /* SALONIZED_CODE */]: Code,
      ["salonized:code-download" /* SALONIZED_CODE_DOWNLOAD */]: CodeDownload,
      ["salonized:color-palette" /* SALONIZED_COLOR_PALETTE */]: ColorPalette,
      ["salonized:color-picker" /* SALONIZED_COLOR_PICKER */]: ColorPicker,
      ["salonized:compass" /* SALONIZED_COMPASS */]: Compass,
      ["salonized:copy" /* SALONIZED_COPY */]: Copy,
      ["salonized:corner-down-left" /* SALONIZED_CORNER_DOWN_LEFT */]: CornerDownLeft,
      ["salonized:corner-down-right" /* SALONIZED_CORNER_DOWN_RIGHT */]: CornerDownRight,
      ["salonized:corner-left-down" /* SALONIZED_CORNER_LEFT_DOWN */]: CornerLeftDown,
      ["salonized:corner-left-up" /* SALONIZED_CORNER_LEFT_UP */]: CornerLeftUp,
      ["salonized:corner-right-down" /* SALONIZED_CORNER_RIGHT_DOWN */]: CornerRightDown,
      ["salonized:corner-right-up" /* SALONIZED_CORNER_RIGHT_UP */]: CornerRightUp,
      ["salonized:corner-up-left" /* SALONIZED_CORNER_UP_LEFT */]: CornerUpLeft,
      ["salonized:corner-up-right" /* SALONIZED_CORNER_UP_RIGHT */]: CornerUpRight,
      ["salonized:credit-card" /* SALONIZED_CREDIT_CARD */]: CreditCard,
      ["salonized:crop" /* SALONIZED_CROP */]: Crop,
      ["salonized:cube" /* SALONIZED_CUBE */]: Cube,
      ["salonized:diagonal-arrow-left-down" /* SALONIZED_DIAGONAL_ARROW_LEFT_DOWN */]: DiagonalArrowLeftDown,
      ["salonized:diagonal-arrow-left-up" /* SALONIZED_DIAGONAL_ARROW_LEFT_UP */]: DiagonalArrowLeftUp,
      ["salonized:diagonal-arrow-right-down" /* SALONIZED_DIAGONAL_ARROW_RIGHT_DOWN */]: DiagonalArrowRightDown,
      ["salonized:diagonal-arrow-right-up" /* SALONIZED_DIAGONAL_ARROW_RIGHT_UP */]: DiagonalArrowRightUp,
      ["salonized:download" /* SALONIZED_DOWNLOAD */]: Download,
      ["salonized:droplet" /* SALONIZED_DROPLET */]: Droplet,
      ["salonized:droplet-off" /* SALONIZED_DROPLET_OFF */]: DropletOff,
      ["salonized:edit" /* SALONIZED_EDIT */]: Edit,
      ["salonized:edit2" /* SALONIZED_EDIT2 */]: Edit2,
      ["salonized:email" /* SALONIZED_EMAIL */]: Email,
      ["salonized:expand" /* SALONIZED_EXPAND */]: Expand2,
      ["salonized:external-link" /* SALONIZED_EXTERNAL_LINK */]: ExternalLink,
      ["salonized:eye" /* SALONIZED_EYE */]: Eye,
      ["salonized:eye-off" /* SALONIZED_EYE_OFF */]: EyeOff,
      ["salonized:eye-off2" /* SALONIZED_EYE_OFF2 */]: EyeOff2,
      ["salonized:facebook" /* SALONIZED_FACEBOOK */]: Facebook,
      ["salonized:file" /* SALONIZED_FILE */]: File,
      ["salonized:file-add" /* SALONIZED_FILE_ADD */]: FileAdd,
      ["salonized:file-remove" /* SALONIZED_FILE_REMOVE */]: FileRemove,
      ["salonized:file-text" /* SALONIZED_FILE_TEXT */]: FileText,
      ["salonized:film" /* SALONIZED_FILM */]: Film,
      ["salonized:fire" /* SALONIZED_FIRE */]: Fire2,
      ["salonized:flag" /* SALONIZED_FLAG */]: Flag,
      ["salonized:flash" /* SALONIZED_FLASH */]: Flash,
      ["salonized:flash-off" /* SALONIZED_FLASH_OFF */]: FlashOff,
      ["salonized:flip" /* SALONIZED_FLIP */]: Flip,
      ["salonized:flip2" /* SALONIZED_FLIP2 */]: Flip2,
      ["salonized:folder" /* SALONIZED_FOLDER */]: Folder,
      ["salonized:folder-add" /* SALONIZED_FOLDER_ADD */]: FolderAdd,
      ["salonized:folder-remove" /* SALONIZED_FOLDER_REMOVE */]: FolderRemove,
      ["salonized:funnel" /* SALONIZED_FUNNEL */]: Funnel,
      ["salonized:gift" /* SALONIZED_GIFT */]: Gift2,
      ["salonized:github" /* SALONIZED_GITHUB */]: Github,
      ["salonized:globe" /* SALONIZED_GLOBE */]: Globe,
      ["salonized:globe2" /* SALONIZED_GLOBE2 */]: Globe2,
      ["salonized:google" /* SALONIZED_GOOGLE */]: Google,
      ["salonized:grid" /* SALONIZED_GRID */]: Grid,
      ["salonized:hard-drive" /* SALONIZED_HARD_DRIVE */]: HardDrive,
      ["salonized:hash" /* SALONIZED_HASH */]: Hash,
      ["salonized:headphones" /* SALONIZED_HEADPHONES */]: Headphones,
      ["salonized:heart" /* SALONIZED_HEART */]: Heart,
      ["salonized:height" /* SALONIZED_HEIGHT */]: Height,
      ["salonized:home" /* SALONIZED_HOME */]: Home2,
      ["salonized:image" /* SALONIZED_IMAGE */]: Image,
      ["salonized:inbox" /* SALONIZED_INBOX */]: Inbox,
      ["salonized:info" /* SALONIZED_INFO */]: Info,
      ["salonized:keypad" /* SALONIZED_KEYPAD */]: Keypad,
      ["salonized:layers" /* SALONIZED_LAYERS */]: Layers,
      ["salonized:layout" /* SALONIZED_LAYOUT */]: Layout,
      ["salonized:link" /* SALONIZED_LINK */]: Link3,
      ["salonized:link2" /* SALONIZED_LINK2 */]: Link2,
      ["salonized:linkedin" /* SALONIZED_LINKEDIN */]: Linkedin,
      ["salonized:list" /* SALONIZED_LIST */]: List,
      ["salonized:loader" /* SALONIZED_LOADER */]: Loader,
      ["salonized:lock" /* SALONIZED_LOCK */]: Lock,
      ["salonized:log-in" /* SALONIZED_LOG_IN */]: LogIn,
      ["salonized:log-out" /* SALONIZED_LOG_OUT */]: LogOut,
      ["salonized:map" /* SALONIZED_MAP */]: Map,
      ["salonized:maximize" /* SALONIZED_MAXIMIZE */]: Maximize,
      ["salonized:menu" /* SALONIZED_MENU */]: Menu,
      ["salonized:menu2" /* SALONIZED_MENU2 */]: Menu2,
      ["salonized:menu-arrow" /* SALONIZED_MENU_ARROW */]: MenuArrow,
      ["salonized:message-circle" /* SALONIZED_MESSAGE_CIRCLE */]: MessageCircle,
      ["salonized:message-square" /* SALONIZED_MESSAGE_SQUARE */]: MessageSquare,
      ["salonized:mic" /* SALONIZED_MIC */]: Mic,
      ["salonized:mic-off" /* SALONIZED_MIC_OFF */]: MicOff,
      ["salonized:minimize" /* SALONIZED_MINIMIZE */]: Minimize,
      ["salonized:minus" /* SALONIZED_MINUS */]: Minus2,
      ["salonized:minus-circle" /* SALONIZED_MINUS_CIRCLE */]: MinusCircle,
      ["salonized:minus-square" /* SALONIZED_MINUS_SQUARE */]: MinusSquare,
      ["salonized:monitor" /* SALONIZED_MONITOR */]: Monitor,
      ["salonized:moon" /* SALONIZED_MOON */]: Moon,
      ["salonized:more-horizontal" /* SALONIZED_MORE_HORIZONTAL */]: MoreHorizontal,
      ["salonized:more-vertical" /* SALONIZED_MORE_VERTICAL */]: MoreVertical,
      ["salonized:move" /* SALONIZED_MOVE */]: Move,
      ["salonized:music" /* SALONIZED_MUSIC */]: Music,
      ["salonized:navigation" /* SALONIZED_NAVIGATION */]: Navigation,
      ["salonized:navigation2" /* SALONIZED_NAVIGATION2 */]: Navigation2,
      ["salonized:npm" /* SALONIZED_NPM */]: Npm,
      ["salonized:options" /* SALONIZED_OPTIONS */]: Options,
      ["salonized:options2" /* SALONIZED_OPTIONS2 */]: Options2,
      ["salonized:pantone" /* SALONIZED_PANTONE */]: Pantone,
      ["salonized:paper-plane" /* SALONIZED_PAPER_PLANE */]: PaperPlane,
      ["salonized:pause-circle" /* SALONIZED_PAUSE_CIRCLE */]: PauseCircle,
      ["salonized:people" /* SALONIZED_PEOPLE */]: People,
      ["salonized:percent" /* SALONIZED_PERCENT */]: Percent,
      ["salonized:person" /* SALONIZED_PERSON */]: Person2,
      ["salonized:person-delete" /* SALONIZED_PERSON_DELETE */]: PersonDelete,
      ["salonized:person-done" /* SALONIZED_PERSON_DONE */]: PersonDone,
      ["salonized:person-remove" /* SALONIZED_PERSON_REMOVE */]: PersonRemove,
      ["salonized:phone" /* SALONIZED_PHONE */]: Phone,
      ["salonized:phone-call" /* SALONIZED_PHONE_CALL */]: PhoneCall,
      ["salonized:phone-missed" /* SALONIZED_PHONE_MISSED */]: PhoneMissed,
      ["salonized:phone-off" /* SALONIZED_PHONE_OFF */]: PhoneOff,
      ["salonized:pie-chart" /* SALONIZED_PIE_CHART */]: PieChart,
      ["salonized:pin" /* SALONIZED_PIN */]: Pin,
      ["salonized:play-circle" /* SALONIZED_PLAY_CIRCLE */]: PlayCircle,
      ["salonized:plus" /* SALONIZED_PLUS */]: Plus,
      ["salonized:plus-circle" /* SALONIZED_PLUS_CIRCLE */]: PlusCircle,
      ["salonized:plus-square" /* SALONIZED_PLUS_SQUARE */]: PlusSquare,
      ["salonized:power" /* SALONIZED_POWER */]: Power,
      ["salonized:pricetag" /* SALONIZED_PRICETAG */]: Pricetag,
      ["salonized:printer" /* SALONIZED_PRINTER */]: Printer,
      ["salonized:question-mark" /* SALONIZED_QUESTION_MARK */]: QuestionMark,
      ["salonized:question-mark-circle" /* SALONIZED_QUESTION_MARK_CIRCLE */]: QuestionMarkCircle,
      ["salonized:radio" /* SALONIZED_RADIO */]: Radio,
      ["salonized:radio-button-off" /* SALONIZED_RADIO_BUTTON_OFF */]: RadioButtonOff,
      ["salonized:radio-button-on" /* SALONIZED_RADIO_BUTTON_ON */]: RadioButtonOn,
      ["salonized:recording" /* SALONIZED_RECORDING */]: Recording,
      ["salonized:refresh" /* SALONIZED_REFRESH */]: Refresh,
      ["salonized:repeat" /* SALONIZED_REPEAT */]: Repeat,
      ["salonized:rewind-left" /* SALONIZED_REWIND_LEFT */]: RewindLeft,
      ["salonized:rewind-right" /* SALONIZED_REWIND_RIGHT */]: RewindRight,
      ["salonized:save" /* SALONIZED_SAVE */]: Save,
      ["salonized:scissors" /* SALONIZED_SCISSORS */]: Scissors,
      ["salonized:search" /* SALONIZED_SEARCH */]: Search2,
      ["salonized:settings" /* SALONIZED_SETTINGS */]: Settings,
      ["salonized:settings2" /* SALONIZED_SETTINGS2 */]: Settings2,
      ["salonized:shake" /* SALONIZED_SHAKE */]: Shake,
      ["salonized:share" /* SALONIZED_SHARE */]: Share,
      ["salonized:shield" /* SALONIZED_SHIELD */]: Shield,
      ["salonized:shield-off" /* SALONIZED_SHIELD_OFF */]: ShieldOff,
      ["salonized:shopping-bag" /* SALONIZED_SHOPPING_BAG */]: ShoppingBag,
      ["salonized:shopping-cart" /* SALONIZED_SHOPPING_CART */]: ShoppingCart,
      ["salonized:shuffle" /* SALONIZED_SHUFFLE */]: Shuffle,
      ["salonized:shuffle2" /* SALONIZED_SHUFFLE2 */]: Shuffle2,
      ["salonized:skip-back" /* SALONIZED_SKIP_BACK */]: SkipBack,
      ["salonized:skip-forward" /* SALONIZED_SKIP_FORWARD */]: SkipForward,
      ["salonized:slash" /* SALONIZED_SLASH */]: Slash,
      ["salonized:smartphone" /* SALONIZED_SMARTPHONE */]: Smartphone,
      ["salonized:speaker" /* SALONIZED_SPEAKER */]: Speaker,
      ["salonized:square" /* SALONIZED_SQUARE */]: Square,
      ["salonized:star" /* SALONIZED_STAR */]: Star,
      ["salonized:stop-circle" /* SALONIZED_STOP_CIRCLE */]: StopCircle,
      ["salonized:sun" /* SALONIZED_SUN */]: Sun,
      ["salonized:swap" /* SALONIZED_SWAP */]: Swap,
      ["salonized:sync" /* SALONIZED_SYNC */]: Sync,
      ["salonized:text" /* SALONIZED_TEXT */]: Text,
      ["salonized:thermometer" /* SALONIZED_THERMOMETER */]: Thermometer,
      ["salonized:thermometer-minus" /* SALONIZED_THERMOMETER_MINUS */]: ThermometerMinus,
      ["salonized:thermometer-plus" /* SALONIZED_THERMOMETER_PLUS */]: ThermometerPlus,
      ["salonized:timer" /* SALONIZED_TIMER */]: Timer,
      ["salonized:toggle-left" /* SALONIZED_TOGGLE_LEFT */]: ToggleLeft,
      ["salonized:toggle-right" /* SALONIZED_TOGGLE_RIGHT */]: ToggleRight,
      ["salonized:trash" /* SALONIZED_TRASH */]: Trash,
      ["salonized:trash2" /* SALONIZED_TRASH2 */]: Trash2,
      ["salonized:trending-down" /* SALONIZED_TRENDING_DOWN */]: TrendingDown,
      ["salonized:trending-up" /* SALONIZED_TRENDING_UP */]: TrendingUp,
      ["salonized:tv" /* SALONIZED_TV */]: Tv,
      ["salonized:twitter" /* SALONIZED_TWITTER */]: Twitter,
      ["salonized:umbrella" /* SALONIZED_UMBRELLA */]: Umbrella,
      ["salonized:undo" /* SALONIZED_UNDO */]: Undo,
      ["salonized:unlock" /* SALONIZED_UNLOCK */]: Unlock,
      ["salonized:upload" /* SALONIZED_UPLOAD */]: Upload,
      ["salonized:video" /* SALONIZED_VIDEO */]: Video,
      ["salonized:video-off" /* SALONIZED_VIDEO_OFF */]: VideoOff,
      ["salonized:volume" /* SALONIZED_VOLUME */]: Volume,
      ["salonized:volume-down" /* SALONIZED_VOLUME_DOWN */]: VolumeDown,
      ["salonized:volume-off" /* SALONIZED_VOLUME_OFF */]: VolumeOff,
      ["salonized:volume-up" /* SALONIZED_VOLUME_UP */]: VolumeUp,
      ["salonized:weight" /* SALONIZED_WEIGHT */]: Weight,
      ["salonized:wifi" /* SALONIZED_WIFI */]: Wifi,
      ["salonized:wifi-off" /* SALONIZED_WIFI_OFF */]: WifiOff,
      ["salonized:workshop" /* SALONIZED_WORKSHOP */]: Workshop
    };
  }
});

// src/icons/icon.tsx
import { jsx as jsx319 } from "@emotion/react/jsx-runtime";
function Icon(props) {
  const { name, color, size } = props;
  const IconComp = getIconFromName(name);
  return /* @__PURE__ */ jsx319(IconComp, { size, color });
}
var init_icon = __esm({
  "src/icons/icon.tsx"() {
    "use strict";
    init_helpers2();
  }
});

// src/icons/plain-icon.tsx
import { css } from "@emotion/react";
import { jsx as jsx320 } from "@emotion/react/jsx-runtime";
function PlainIcon(props) {
  const { backgroundColor, borderRadius, color, name, size, className } = props;
  return /* @__PURE__ */ jsx320(
    "div",
    {
      className,
      css: css({
        backgroundColor,
        borderRadius: borderRadius || getSize(size)
      }),
      children: /* @__PURE__ */ jsx320(Icon, { name, size, color })
    }
  );
}
var init_plain_icon = __esm({
  "src/icons/plain-icon.tsx"() {
    "use strict";
    init_helpers2();
    init_icon();
  }
});

// src/icons/index.ts
var init_icons = __esm({
  "src/icons/index.ts"() {
    "use strict";
    init_payments();
    init_types();
    init_icon();
    init_plain_icon();
  }
});

// raw:src/theme/pro/theme.css
var theme_default;
var init_theme = __esm({
  "raw:src/theme/pro/theme.css"() {
    theme_default = ":root{--aura-navy-800: #071948;--aura-navy-700: #36456b;--aura-navy-600: #515e7f;--aura-navy-500: #838ca3;--aura-navy-400: #b5bac8;--aura-navy-300: #e6e8ed;--aura-navy-200: #f3f4f6;--aura-navy-100: #f8f8fa;--aura-blue-700: #2c25a5;--aura-blue-600: #4036ed;--aura-blue-400: #7972f2;--aura-blue-200: #b2aef7;--aura-blue-100: #ebeafd;--aura-coral-700: #b24748;--aura-coral-600: #ff6668;--aura-coral-400: #ff9395;--aura-coral-200: #ffc1c2;--aura-coral-100: #ffefef;--aura-yellow-700: #b28e35;--aura-yellow-600: #ffcb4d;--aura-yellow-400: #ffda82;--aura-yellow-200: #ffeab7;--aura-yellow-100: #fff9ed;--aura-teal-700: #0b8a90;--aura-teal-600: #11c6cf;--aura-teal-400: #58d7dd;--aura-teal-200: #9fe8eb;--aura-teal-100: #e7f9fa;--aura-white: #ffffff}*,pre{font-family:Treatwell Sans;font-style:normal}.aura--h1,.aura--h2,.aura--h3,.aura--h3-constant,.aura--h4,.aura--h5,.aura--h5-constant,.aura--h6,.aura--h6-constant{color:var(--aura-navy-800)}.aura--link{color:var(--aura-blue-600);& path{fill:var(--aura-blue-600)}&:hover{color:var(--aura-blue-400);& path{fill:var(--aura-blue-400)}}&:active{color:var(--aura-blue-700);& path{fill:var(--aura-blue-700)}}}.aura--link-disruptive{color:var(--aura-coral-600);& path{fill:var(--aura-coral-600)}&:hover{color:var(--aura-coral-400);& path{fill:var(--aura-coral-400)}}&:active{color:var(--aura-coral-700);& path{fill:var(--aura-coral-700)}}}.aura--link-disabled{color:var(--aura-navy-400);& path{fill:var(--aura-navy-400)}&:hover{color:var(--aura-navy-400);& path{fill:var(--aura-navy-400)}}&:active{color:var(--aura-navy-400);& path{fill:var(--aura-navy-400)}}}.aura--label{background-color:var(--aura-teal-100);color:var(--aura-teal-700)}.aura--tag{background-color:var(--aura-blue-100);color:var(--aura-blue-600);&:hover{background-color:var(--aura-blue-200)}&.selected{color:var(--aura-white);background-color:var(--aura-blue-600)}}.aura--tag-counter{color:var(--aura-blue-600);background-color:var(--aura-white)}.aura--card{border:1px solid var(--aura-navy-300);background-color:var(--aura-white);border-radius:8px;&:hover{border:1px solid var(--aura-blue-600);box-shadow:0 2px 10px var(--aura-navy-300)}&:active{border:1px solid var(--aura-blue-600);box-shadow:0 2px 10px var(--aura-navy-300)}&:focus{border:1px solid var(--aura-blue-600);box-shadow:0 2px 10px var(--aura-navy-300)}}.aura--button-primary{background-color:var(--aura-blue-600);color:var(--aura-white);fill:var(--aura-white);&.aura--button-disruptive{background-color:var(--aura-coral-600)}&:disabled{background-color:var(--aura-navy-300)!important;color:var(--aura-navy-400)!important;fill:var(--aura-navy-400)!important;cursor:not-allowed!important}&:hover{background-color:var(--aura-blue-400);&.aura--button-disruptive{background-color:var(--aura-coral-400)}}&:active{background-color:var(--aura-blue-700);&.aura--button-disruptive{background-color:var(--aura-coral-700)}}}.aura--button-secondary{color:var(--aura-blue-600);fill:var(--aura-blue-600);border:1px solid var(--aura-navy-400);&.aura--button-disruptive{color:var(--aura-coral-600);fill:var(--aura-coral-600)}&:disabled{background-color:var(--aura-navy-300)!important;color:var(--aura-navy-400)!important;fill:var(--aura-navy-400)!important}&:hover{background-color:var(--aura-blue-100);border:1px solid var(--aura-blue-100);&.aura--button-disruptive{background-color:var(--aura-coral-100);border:1px solid var(--aura-coral-100)}}&:active{background-color:var(--aura-blue-100);color:var(--aura-blue-700);fill:var(--aura-blue-700);border:1px solid var(--aura-blue-100);&.aura--button-disruptive{background-color:var(--aura-coral-100);color:var(--aura-coral-700);fill:var(--aura-coral-700);border:1px solid var(--aura-coral-100)}}}.aura--button-tertiary{color:var(--aura-blue-600);fill:var(--aura-blue-600);border:none;&.aura--button-disruptive{color:var(--aura-coral-600);fill:var(--aura-coral-600)}&:disabled{color:var(--aura-navy-400)!important;fill:var(--aura-navy-400)!important}&:hover{color:var(--aura-blue-400);fill:var(--aura-blue-400);&.aura--button-disruptive{color:var(--aura-coral-400);fill:var(--aura-coral-400)}}&:active{color:var(--aura-blue-700);fill:var(--aura-blue-700);&.aura--button-disruptive{color:var(--aura-coral-700);fill:var(--aura-coral-700)}}}.aura--checkbox{color:var(--aura-blue-600);.aura--checkbox-empty{border-color:var(--aura-navy-400)}.aura--checkbox-checked{svg{path{fill:var(--aura-white)}}}&.checked{div{background-color:var(--aura-blue-600)}}&.read-only{div{background-color:var(--aura-navy-400)}}&.disabled{.aura--checkbox-empty{border:solid 1px var(--aura-navy-300)}div{background-color:var(--aura-navy-300)}}}.aura--flash-message{border:1px solid var(--aura-navy-400);background-color:var(--aura-navy-200);color:var(--aura-navy-800);&.aura--flash-message-default{border-color:var(--aura-navy-400);background-color:var(--aura-navy-200);.aura--flash-message-icon path,.aura--flash-message-icon polygon{fill:var(--aura-navy-800)}}&.aura--flash-message-success{border-color:var(--aura-teal-600);background-color:var(--aura-teal-100);.aura--flash-message-icon path,.aura--flash-message-icon polygon{fill:var(--aura-teal-600)}}&.aura--flash-message-error{border-color:var(--aura-coral-600);background-color:var(--aura-coral-100);.aura--flash-message-icon path,.aura--flash-message-icon polygon{fill:var(--aura-coral-600)}}&.aura--flash-message-warning{border-color:var(--aura-yellow-700);background-color:var(--aura-yellow-100);.aura--flash-message-icon path,.aura--flash-message-icon polygon{fill:var(--aura-yellow-700)}}.aura--flash-message-close-button path,.aura--flash-message-close-button polygon{fill:var(--aura-navy-800)}}.aura--input{border:none;border-radius:8px;color:var(--aura-navy-800)}.aura--input-fieldset{border:1px solid var(--aura-navy-400);border-radius:8px;background-color:transparent}.aura--input-label{color:var(--aura-navy-500)}.aura--input-container:focus-within{.aura--input-fieldset{border-color:var(--aura-blue-600)}&:not(.has-error) .aura--input-label{color:var(--aura-blue-600)}}.aura--input-container.has-error{.aura--input-fieldset{border-color:var(--aura-coral-600)}}.aura--input-inner-left-component-wrapper path{fill:var(--aura-navy-500)}.aura--error-label{color:var(--aura-coral-600)}.aura--success-label{color:var(--aura-teal-600)}.aura--select-input,.aura--select-option{background-color:var(--aura-white)}.aura--select-option:hover{background-color:var(--aura-navy-100)}.aura--select-option-selected{background-color:var(--aura-navy-200);&:hover{background-color:var(--aura-navy-200)}}.aura--select-options-container{box-shadow:0 2px 10px 0 var(--aura-navy-300)}.aura--otp-input{:focus{background-color:var(--aura-navy-200);border:1px solid var(--aura-navy-500)}border:1px solid var(--aura-navy-400)}\n";
  }
});

// src/theme/pro/index.ts
var pro_exports = {};
__export(pro_exports, {
  ProTheme: () => ProTheme
});
var ProTheme;
var init_pro = __esm({
  "src/theme/pro/index.ts"() {
    "use strict";
    init_icons();
    init_theme();
    ProTheme = {
      css: theme_default,
      icons: {
        checkBox: "tw-pro:check-mark" /* TW_PRO_CHECK_MARK */,
        flashMessageClose: "tw-pro:close" /* TW_PRO_CLOSE */,
        flashMessageDefault: "tw-pro:sort" /* TW_PRO_SORT */,
        flashMessageError: "tw-pro:caution" /* TW_PRO_CAUTION */,
        flashMessageSuccess: "tw-pro:check-mark" /* TW_PRO_CHECK_MARK */,
        flashMessageWarning: "tw-pro:warning-outline" /* TW_PRO_WARNING_OUTLINE */,
        inputError: "tw-pro:close" /* TW_PRO_CLOSE */,
        selectDropdown: "tw-pro:chevron-down" /* TW_PRO_CHEVRON_DOWN */,
        tagClose: "tw-pro:close" /* TW_PRO_CLOSE */
      }
    };
  }
});

// raw:src/theme/wavy/theme.css
var theme_default2;
var init_theme2 = __esm({
  "raw:src/theme/wavy/theme.css"() {
    theme_default2 = ":root{--wavy-blue-light: #f8fbfe;--wavy-blue-normal: #419fff;--wavy-blue-dark: #254873;--wavy-blue-darker: #132d4d;--wavy-white: #fff;--wavy-grey-lighter: #ebf0f2;--wavy-grey-light: #cccccc;--wavy-grey-dark: #737373;--wavy-grey-darker: #2c2b2c;--wavy-ocean-light: #a1c4e6;--wavy-red: #e66767;--wavy-black: #000;--wavy-transparent: rgba(0, 0, 0, 0)}*,pre{font-family:Whitney-Medium,system-ui,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Ubuntu,Helvetica Neue,sans-serif}.aura--h1,.aura--h2,.aura--h3,.aura--h3-constant,.aura--h4,.aura--h5,.aura--h5-constant,.aura--h6,.aura--h6-constant{color:var(--wavy-grey-darker)}.aura--link,aura--link-disruptive{color:var(--wavy-blue-dark);& path{fill:var(--wavy-blue-dark)}&:hover{color:var(--wavy-blue-dark);& path{fill:var(--wavy-blue-dark)}}&:active{color:var(--wavy-blue-dark);& path{fill:var(--wavy-blue-dark)}}}.aura--link-disabled{color:var(--wavy-grey-dark);& path{fill:var(--wavy-grey-dark)}&:hover{color:var(--wavy-grey-dark);& path{fill:var(--wavy-grey-dark)}}&:active{color:var(--wavy-grey-dark);& path{fill:var(--wavy-grey-dark)}}}.aura--label{background-color:var(--wavy-blue-darker);color:var(--wavy-white)}.aura--tag{background-color:var(--wavy-blue-darker);color:var(--wavy-white);&:hover{background-color:var(--wavy-blue-darker)}&.selected{color:var(--wavy-white);background-color:var(--wavy-blue-darker)}}.aura--tag-counter{color:var(--wavy-blue-darker);background-color:var(--wavy-white)}.aura--card{border:1px solid var(--wavy-grey-light);background-color:var(--wavy-white);border-radius:8px;&:hover{border:1px solid var(--wavy-blue-normal);box-shadow:0 2px 10px var(--wavy-grey-light)}&:active{border:1px solid var(--wavy-blue-normal);box-shadow:0 2px 10px var(--wavy-grey-light)}&:focus{border:1px solid var(--wavy-blue-normal);box-shadow:0 2px 10px var(--wavy-grey-light)}}.aura--button{font-weight:600;border-radius:4px;cursor:pointer;text-align:center;line-height:1.25}.aura--button-sm{height:32px;font-size:14px;line-height:28px;padding:2px 12px;border-radius:4px}.aura--button-md{height:40px;font-size:16px;line-height:36px;padding:2px 16px;border-radius:4px}.aura--button-primary{background-color:var(--wavy-blue-darker);color:var(--wavy-white);fill:var(--wavy-white);&.aura--button-disruptive{background-color:var(--wavy-blue-darker);&:disabled{background-color:var(--wavy-blue-darker)!important}}&:disabled{background-color:var(--wavy-blue-darker)!important;color:var(--wavy-white)!important;fill:var(--wavy-white)!important;opacity:.32}&:hover{background-color:var(--wavy-blue-darker);&.aura--button-disruptive{background-color:var(--wavy-blue-darker)}}&:active{background-color:var(--wavy-blue-darker);&.aura--button-disruptive{background-color:var(--wavy-blue-darker)}}}.aura--button-secondary{color:var(--wavy-blue-darker);fill:var(--wavy-blue-darker);border:1px solid var(--wavy-blue-dark);&.aura--button-disruptive{color:var(--wavy-blue-darker);fill:var(--wavy-blue-darker);border:1px solid var(--wavy-blue-dark)}&:disabled{background-color:var(--wavy-white)!important;color:var(--wavy-blue-darker)!important;fill:var(--wavy-blue-darker)!important;opacity:.32}&:hover{color:var(--wavy-blue-darker);fill:var(--wavy-blue-darker);border:1px solid var(--wavy-blue-dark);&.aura--button-disruptive{color:var(--wavy-blue-darker);fill:var(--wavy-blue-darker);border:1px solid var(--wavy-blue-dark)}}&:active{color:var(--wavy-blue-darker);fill:var(--wavy-blue-darker);border:1px solid var(--wavy-blue-dark);&.aura--button-disruptive{color:var(--wavy-blue-darker);fill:var(--wavy-blue-darker);border:1px solid var(--wavy-blue-dark)}}}.aura--button-tertiary{color:var(--wavy-blue-darker);fill:var(--wavy-blue-darker);border:none;&.aura--button-disruptive{color:var(--wavy-blue-darker);fill:var(--wavy-blue-darker)}&:disabled{color:var(--wavy-blue-darker)!important;fill:var(--wavy-blue-darker)!important}&:hover{color:var(--wavy-blue-darker);fill:var(--wavy-blue-darker);&.aura--button-disruptive{color:var(--wavy-blue-darker);fill:var(--wavy-blue-darker)}}&:active{color:var(--wavy-blue-darker);fill:var(--wavy-blue-darker);&.aura--button-disruptive{color:var(--wavy-blue-darker);fill:var(--wavy-blue-darker)}}}.aura--checkbox{color:var(--wavy-blue-normal);.aura--checkbox-empty{border-color:var(--wavy-grey-dark);border-radius:2px;width:16px;height:16px;box-sizing:border-box}.aura--checkbox-checked{box-sizing:border-box;border-radius:2px;width:16px;height:16px;display:flex;justify-content:center;align-items:center;svg{fill:var(--wavy-white);flex-shrink:0}}&.checked{div{background-color:var(--wavy-blue-normal);border-color:var(--wavy-blue-normal)}}&.read-only{div{border-color:var(--wavy-grey-dark);background-color:var(--wavy-grey-darker);svg{fill:var(--wavy-grey-dark)}}}&.disabled{.aura--checkbox-empty{border-color:var(--wavy-grey-dark);background-color:var(--wavy-grey-darker)}.aura--checkbox-checked{border-color:var(--wavy-grey-dark);background-color:var(--wavy-grey-darker);svg{fill:var(--wavy-grey-dark)}}}.aura--checkbox-label{font-size:14px;line-height:17px;font-weight:400;color:var(--wavy-grey-dark)}}.aura--flash-message{border:none;border-radius:4px;padding:8px;min-height:40px;font-size:14px;background-color:var(--wavy-blue-normal);color:var(--wavy-grey-dark);&.aura--flash-message-default{background-color:var(--wavy-white);.aura--flash-message-icon path,.aura--flash-message-icon polygon{fill:var(--wavy-blue-normal)}}&.aura--flash-message-success{background-color:var(--wavy-white);.aura--flash-message-icon path,.aura--flash-message-icon polygon{fill:var(--wavy-blue-normal)}}&.aura--flash-message-error{background-color:var(--wavy-white);.aura--flash-message-icon path,.aura--flash-message-icon polygon{fill:var(--wavy-blue-normal)}}&.aura--flash-message-warning{background-color:var(--wavy-white);.aura--flash-message-icon path,.aura--flash-message-icon polygon{fill:var(--wavy-blue-normal)}}.aura--flash-message-close-button path,.aura--flash-message-close-button polygon{fill:var(--wavy-grey-dark)}}.aura--input{border:none;border-radius:8px;color:var(--wavy-grey-darker)}.aura--input-fieldset{border:1px solid var(--wavy-grey-dark);border-radius:8px;background-color:transparent}.aura--input-label{color:var(--wavy-grey-dark)}.aura--input-container:focus-within{.aura--input-fieldset{border-color:var(--wavy-blue-normal)}.aura--input-label{color:var(--wavy-blue-normal)}}.aura--input-container.has-error{.aura--input-fieldset{border-color:var(--wavy-red)}}.aura--input-inner-left-component-wrapper path{fill:var(--wavy-grey-light)}.aura--error-label{color:var(--wavy-red)}.aura--success-label{color:var(--wavy-blue-normal)}.aura--select-input,.aura--select-option{background-color:var(--wavy-white)}.aura--select-option:hover{background-color:var(--wavy-blue-light)}.aura--select-option-selected{background-color:var(--wavy-grey-lighter);&:hover{background-color:var(--wavy-grey-light)}}.aura--select-options-container{box-shadow:0 2px 10px 0 var(--wavy-grey-light)}.aura--otp-input{:focus{background-color:var(--wavy-grey-light);border:1px solid var(--wavy-grey-dark)}border:1px solid var(--wavy-grey-dark)}\n";
  }
});

// src/theme/wavy/index.ts
var wavy_exports = {};
__export(wavy_exports, {
  WavyTheme: () => WavyTheme
});
var WavyTheme;
var init_wavy = __esm({
  "src/theme/wavy/index.ts"() {
    "use strict";
    init_icons();
    init_theme2();
    WavyTheme = {
      css: theme_default2,
      icons: {
        checkBox: "tw-pro:check-mark" /* TW_PRO_CHECK_MARK */,
        flashMessageClose: "tw-pro:close" /* TW_PRO_CLOSE */,
        flashMessageDefault: "tw-pro:sort" /* TW_PRO_SORT */,
        flashMessageError: "tw-pro:caution" /* TW_PRO_CAUTION */,
        flashMessageSuccess: "tw-pro:check-mark" /* TW_PRO_CHECK_MARK */,
        flashMessageWarning: "tw-pro:warning-outline" /* TW_PRO_WARNING_OUTLINE */,
        inputError: "tw-pro:close" /* TW_PRO_CLOSE */,
        selectDropdown: "tw-pro:chevron-down" /* TW_PRO_CHEVRON_DOWN */,
        tagClose: "tw-pro:close" /* TW_PRO_CLOSE */
      }
    };
  }
});

// raw:src/theme/salonized/theme.css
var theme_default3;
var init_theme3 = __esm({
  "raw:src/theme/salonized/theme.css"() {
    theme_default3 = ":root{--aura-navy-800: #383540;--aura-navy-700: #383540;--aura-navy-600: #686868;--aura-navy-500: #9c9aa0;--aura-navy-400: #bfbfbf;--aura-navy-300: #dbdbdb;--aura-navy-200: #dedede;--aura-navy-100: #f7f7f7;--aura-blue-700: #262563;--aura-blue-600: #393794;--aura-blue-400: #4c49c5;--aura-blue-200: #c9c8ee;--aura-blue-100: #f2f2fb;--aura-coral-700: #f04438;--aura-coral-600: #f97066;--aura-coral-400: #fecdca;--aura-coral-200: #fee4e2;--aura-coral-100: #fee4e2;--aura-yellow-700: #fdb022;--aura-yellow-600: #fedf89;--aura-yellow-400: #fef0c7;--aura-yellow-200: #fffaeb;--aura-yellow-100: #fffaeb;--aura-teal-700: #026853;--aura-teal-600: #029b7c;--aura-teal-400: #03cfa5;--aura-teal-200: #b3f1e4;--aura-teal-100: #b3f1e4;--aura-white: #ffffff}*,pre{font-family:Circular Std,serif;font-style:normal}.aura--h1,.aura--h2,.aura--h3,.aura--h3-constant,.aura--h4,.aura--h5,.aura--h5-constant,.aura--h6,.aura--h6-constant{color:var(--aura-navy-800)}.aura--link{color:var(--aura-blue-600);& path{fill:var(--aura-blue-600)}&:hover{color:var(--aura-blue-400);& path{fill:var(--aura-blue-400)}}&:active{color:var(--aura-blue-700);& path{fill:var(--aura-blue-700)}}}.aura--link-disruptive{color:var(--aura-coral-600);& path{fill:var(--aura-coral-600)}&:hover{color:var(--aura-coral-400);& path{fill:var(--aura-coral-400)}}&:active{color:var(--aura-coral-700);& path{fill:var(--aura-coral-700)}}}.aura--link-disabled{color:var(--aura-navy-400);& path{fill:var(--aura-navy-400)}&:hover{color:var(--aura-navy-400);& path{fill:var(--aura-navy-400)}}&:active{color:var(--aura-navy-400);& path{fill:var(--aura-navy-400)}}}.aura--label{background-color:var(--aura-teal-100);color:var(--aura-teal-700)}.aura--tag{background-color:var(--aura-blue-100);color:var(--aura-blue-600);&:hover{background-color:var(--aura-blue-200)}&.selected{color:var(--aura-white);background-color:var(--aura-blue-600)}}.aura--tag-counter{color:var(--aura-blue-600);background-color:var(--aura-white)}.aura--card{border:1px solid var(--aura-navy-300);background-color:var(--aura-white);border-radius:8px;&:hover{border:1px solid var(--aura-blue-600);box-shadow:0 2px 10px var(--aura-navy-300)}&:active{border:1px solid var(--aura-blue-600);box-shadow:0 2px 10px var(--aura-navy-300)}&:focus{border:1px solid var(--aura-blue-600);box-shadow:0 2px 10px var(--aura-navy-300)}}.aura--button-primary{background-color:var(--aura-blue-400);color:var(--aura-white);fill:var(--aura-white);&.aura--button-disruptive{background-color:var(--aura-coral-600)}&:disabled{background-color:var(--aura-navy-300)!important;color:var(--aura-navy-400)!important;fill:var(--aura-navy-400)!important;cursor:not-allowed!important}&:hover{background-color:var(--aura-blue-600);&.aura--button-disruptive{background-color:var(--aura-coral-400)}}&:active{background-color:var(--aura-blue-700);&.aura--button-disruptive{background-color:var(--aura-coral-700)}}}.aura--button-secondary{color:var(--aura-blue-400);fill:var(--aura-blue-400);border:1px solid var(--aura-navy-600);&.aura--button-disruptive{color:var(--aura-coral-400);fill:var(--aura-coral-400)}&:disabled{background-color:var(--aura-navy-300)!important;color:var(--aura-navy-600)!important;fill:var(--aura-navy-600)!important}&:hover{background-color:var(--aura-blue-100);border:1px solid var(--aura-blue-100);&.aura--button-disruptive{background-color:var(--aura-coral-100);border:1px solid var(--aura-coral-100)}}&:active{background-color:var(--aura-blue-100);color:var(--aura-blue-700);fill:var(--aura-blue-700);border:1px solid var(--aura-blue-100);&.aura--button-disruptive{background-color:var(--aura-coral-100);color:var(--aura-coral-700);fill:var(--aura-coral-700);border:1px solid var(--aura-coral-100)}}}.aura--button-tertiary{color:var(--aura-blue-400);fill:var(--aura-blue-400);border:none;&.aura--button-disruptive{color:var(--aura-coral-600);fill:var(--aura-coral-600)}&:disabled{color:var(--aura-navy-600)!important;fill:var(--aura-navy-600)!important}&:hover{color:var(--aura-blue-600);fill:var(--aura-blue-600);&.aura--button-disruptive{color:var(--aura-coral-400);fill:var(--aura-coral-400)}}&:active{color:var(--aura-blue-700);fill:var(--aura-blue-700);&.aura--button-disruptive{color:var(--aura-coral-700);fill:var(--aura-coral-700)}}}.aura--checkbox{color:var(--aura-blue-400);.aura--checkbox-empty{border-color:var(--aura-navy-600)}.aura--checkbox-checked{svg{path{fill:var(--aura-white)}}}&.checked{div{background-color:var(--aura-blue-400)}}&.read-only{div{background-color:var(--aura-navy-600)}}&.disabled{.aura--checkbox-empty{border:solid 1px var(--aura-navy-300)}div{background-color:var(--aura-navy-300)}}}.aura--flash-message{border:1px solid var(--aura-navy-400);background-color:var(--aura-navy-200);color:var(--aura-navy-800);&.aura--flash-message-default{border-color:var(--aura-navy-400);background-color:var(--aura-navy-200);.aura--flash-message-icon path,.aura--flash-message-icon polygon{fill:var(--aura-navy-800)}}&.aura--flash-message-success{border-color:var(--aura-teal-600);background-color:var(--aura-teal-100);.aura--flash-message-icon path,.aura--flash-message-icon polygon{fill:var(--aura-teal-600)}}&.aura--flash-message-error{border-color:var(--aura-coral-600);background-color:var(--aura-coral-100);.aura--flash-message-icon path,.aura--flash-message-icon polygon{fill:var(--aura-coral-600)}}&.aura--flash-message-warning{border-color:var(--aura-yellow-700);background-color:var(--aura-yellow-100);.aura--flash-message-icon path,.aura--flash-message-icon polygon{fill:var(--aura-yellow-700)}}.aura--flash-message-close-button path,.aura--flash-message-close-button polygon{fill:var(--aura-navy-800)}}.aura--input{border:none;border-radius:8px;color:var(--aura-navy-800)}.aura--input-fieldset{border:1px solid var(--aura-navy-400);border-radius:8px;background-color:transparent}.aura--input-label{color:var(--aura-navy-500)}.aura--input-container:focus-within{.aura--input-fieldset{border-color:var(--aura-blue-600)}&:not(.has-error) .aura--input-label{color:var(--aura-blue-600)}}.aura--input-container.has-error{.aura--input-fieldset{border-color:var(--aura-coral-600)}}.aura--input-inner-left-component-wrapper path{fill:var(--aura-navy-500)}.aura--error-label{color:var(--aura-coral-600)}.aura--success-label{color:var(--aura-teal-600)}.aura--select-input,.aura--select-option{background-color:var(--aura-white)}.aura--select-option:hover{background-color:var(--aura-navy-100)}.aura--select-option-selected{background-color:var(--aura-navy-200);&:hover{background-color:var(--aura-navy-200)}}.aura--select-options-container{box-shadow:0 2px 10px 0 var(--aura-navy-300)}.aura--otp-input{:focus{background-color:var(--aura-navy-200);border:1px solid var(--aura-navy-500)}border:1px solid var(--aura-navy-400)}\n";
  }
});

// src/theme/salonized/index.ts
var salonized_exports2 = {};
__export(salonized_exports2, {
  SalonizedTheme: () => SalonizedTheme
});
var SalonizedTheme;
var init_salonized2 = __esm({
  "src/theme/salonized/index.ts"() {
    "use strict";
    init_icons();
    init_theme3();
    SalonizedTheme = {
      css: theme_default3,
      icons: {
        checkBox: "salonized:checkmark" /* SALONIZED_CHECKMARK */,
        flashMessageClose: "salonized:close" /* SALONIZED_CLOSE */,
        flashMessageDefault: "tw-pro:sort" /* TW_PRO_SORT */,
        flashMessageError: "tw-pro:caution" /* TW_PRO_CAUTION */,
        flashMessageSuccess: "salonized:checkmark" /* SALONIZED_CHECKMARK */,
        flashMessageWarning: "tw-pro:warning-outline" /* TW_PRO_WARNING_OUTLINE */,
        inputError: "salonized:close" /* SALONIZED_CLOSE */,
        selectDropdown: "tw-pro:chevron-down" /* TW_PRO_CHEVRON_DOWN */,
        tagClose: "salonized:close" /* SALONIZED_CLOSE */
      }
    };
  }
});

// src/index.ts
init_icons();

// src/helpers/classnames.ts
var cx = (...classes) => {
  const result = classes.flatMap((c) => {
    if (!c) {
      return null;
    }
    if (typeof c === "string") {
      return c;
    }
    return Object.keys(c).map((key) => c[key] ? key : null).filter((key) => !!key);
  });
  return result.filter((c) => !!c).join(" ");
};

// src/helpers/random-string.ts
function randomString() {
  return (Math.random() + 1).toString(36).substring(7);
}

// src/hooks/use-safe-handler.ts
import { useRef, useMemo } from "react";
function useSafeHandler(handler) {
  const processing = useRef(false);
  return useMemo(() => {
    if (!handler) {
      return void 0;
    }
    return async (...t) => {
      if (processing.current) {
        return void 0;
      }
      processing.current = true;
      try {
        return await handler(...t);
      } finally {
        processing.current = false;
      }
    };
  }, [handler]);
}

// src/components/button/button.tsx
import { jsx as jsx321 } from "@emotion/react/jsx-runtime";
var flavorToClassName = {
  primary: "aura--button-primary",
  secondary: "aura--button-secondary",
  tertiary: "aura--button-tertiary"
};
function buttonClassNames({
  flavor,
  block = false,
  className,
  disruptive = false,
  size
}) {
  return cx(
    "aura--button",
    size === "medium" ? "aura--button-md" : "aura--button-sm",
    flavorToClassName[flavor],
    { "aura--button-block": block },
    { "aura--button-disruptive": disruptive },
    className
  );
}
function Button({
  children,
  flavor,
  size,
  block = false,
  onClick,
  type = "button",
  disabled,
  disruptive = false,
  className
}) {
  const onClickHandler = useSafeHandler(onClick);
  return /* @__PURE__ */ jsx321(
    "button",
    {
      onClick: onClickHandler,
      disabled,
      className: buttonClassNames({
        block,
        className,
        disruptive,
        flavor,
        size
      }),
      type,
      children
    }
  );
}

// src/components/button/button-as-link.tsx
init_icons();
import { Fragment } from "react";
import { jsx as jsx322 } from "@emotion/react/jsx-runtime";
function ButtonAsLink({
  children,
  leftIconName,
  rightIconName,
  onClick,
  className,
  size = "normal",
  disruptive,
  disabled
}) {
  const onClickHandler = useSafeHandler(onClick);
  const elements = [];
  if (leftIconName) {
    elements.push(
      /* @__PURE__ */ jsx322(
        Icon,
        {
          name: leftIconName,
          size: "small" /* SMALL */,
          color: "#000000"
        },
        "left"
      )
    );
  }
  elements.push(/* @__PURE__ */ jsx322(Fragment, { children }, "center"));
  if (rightIconName) {
    elements.push(
      /* @__PURE__ */ jsx322(
        Icon,
        {
          name: rightIconName,
          size: "small" /* SMALL */,
          color: "#000000"
        },
        "right"
      )
    );
  }
  const classNames = [
    "aura--link-button",
    "aura--link",
    size === "small" ? "aura--link-sm" : "",
    disruptive ? "aura--link-disruptive" : "",
    disabled ? "aura--link-disabled" : ""
  ];
  if (className) {
    classNames.push(className);
  }
  return /* @__PURE__ */ jsx322(
    "button",
    {
      type: "button",
      className: classNames.join(" "),
      onClick: onClickHandler,
      disabled,
      children: elements
    }
  );
}

// src/components/checkbox/index.tsx
init_icons();
import {
  useEffect,
  useMemo as useMemo2,
  useState
} from "react";

// src/theme/index.ts
init_icons();
import { useTheme } from "@emotion/react";

// src/theme/pro/colors.ts
var Colors = {
  navy: {
    800: "#071948",
    700: "#36456B",
    600: "#515E7F",
    500: "#838CA3",
    400: "#B5BAC8",
    300: "#E6E8ED",
    200: "#F3F4F6",
    100: "#F8F8FA"
  },
  blue: {
    700: "#2C25A5",
    600: "#4036ED",
    400: "#7972F2",
    200: "#B2AEF7",
    100: "#EBEAFD"
  },
  coral: {
    700: "#B24748",
    600: "#FF6668",
    400: "#FF9395",
    200: "#FFC1C2",
    100: "#FFEFEF"
  },
  teal: {
    700: "#0B8A90",
    600: "#11C6CF",
    400: "#58D7DD",
    200: "#9FE8EB",
    100: "#E7F9FA"
  },
  yellow: {
    700: "#B28E35",
    600: "#FFCB4D",
    400: "#FFDA82",
    200: "#FFEAB7",
    100: "#FFF9ED"
  },
  purple: {
    700: "#633EB2",
    600: "#8E5AFF",
    400: "#AF8BFF",
    200: "#D1BDFF",
    100: "#F3EEFF"
  },
  pink: {
    700: "#B28085",
    600: "#FFB8BE",
    400: "#FFCDD1",
    200: "#FFE2E5",
    100: "#FFF7F8"
  },
  white: "#FFFFFF",
  black: "#000000",
  transparent: "rgba(0, 0, 0, 0)"
};

// src/theme/wavy/colors.ts
var Colors2 = {
  blue: {
    light: "#F8FBFE",
    normal: "#419FFF",
    dark: "#254873",
    darker: "#132D4D"
  },
  white: "#FFF",
  grey: {
    lighter: "#EBF0F2",
    light: "#CCCCCC",
    dark: "#737373",
    darker: "#2C2B2C"
  },
  ocean: {
    light: "#A1C4E6"
  },
  orange: {
    normal: "#F2B252"
  },
  red: "#E66767",
  black: "#000",
  transparent: "rgba(0, 0, 0, 0)"
};

// src/theme/salonized/colors.ts
var SalonizedColors = {
  brandColors: {
    logoRed: "#ff6575",
    red: "#eb4762",
    pink: "#d53a79",
    green: "#03cfa5",
    blue: "#39B7DC",
    blue2: "#2D9CDB"
  },
  gray: {
    background: "#F9FAFB",
    borderLight: "#F7F7F7",
    borderDark: "#DEDEDE",
    placeholder: "#DBDBDB",
    iconSecondary: "#BFBFBF",
    textSecondary: "#9C9AA0",
    icon: "#686868",
    text: "#383540"
  },
  brand: {
    15: "#F5F6FA",
    25: "#F2F2FB",
    50: "#c9c8ee",
    100: "#4c49c5",
    200: "#393794",
    400: "#262563"
  },
  error: {
    50: "#FEE4E2",
    100: "#FECDCA",
    200: "#F97066",
    400: "#F04438"
  },
  warning: {
    50: "#FFFAEB",
    100: "#FEF0C7",
    200: "#FEDF89",
    400: "#FDB022"
  },
  success: {
    50: "#B3F1E4",
    100: "#03CFA5",
    200: "#029B7C",
    400: "#026853"
  },
  white: "#FFFFFF",
  black: "#000000",
  transparent: "rgba(0, 0, 0, 0)"
};
var Colors3 = {
  navy: {
    800: SalonizedColors.gray.text,
    700: SalonizedColors.gray.text,
    600: SalonizedColors.gray.icon,
    500: SalonizedColors.gray.textSecondary,
    400: SalonizedColors.gray.iconSecondary,
    300: SalonizedColors.gray.placeholder,
    200: SalonizedColors.gray.borderDark,
    100: SalonizedColors.gray.borderLight
  },
  blue: {
    700: SalonizedColors.brand[400],
    600: SalonizedColors.brand[200],
    400: SalonizedColors.brand[100],
    200: SalonizedColors.brand[50],
    100: SalonizedColors.brand[25]
  },
  coral: {
    700: SalonizedColors.error[400],
    600: SalonizedColors.error[200],
    400: SalonizedColors.error[100],
    200: SalonizedColors.error[50],
    100: SalonizedColors.error[50]
  },
  teal: {
    700: SalonizedColors.success[400],
    600: SalonizedColors.success[200],
    400: SalonizedColors.success[100],
    200: SalonizedColors.success[50],
    100: SalonizedColors.success[50]
  },
  yellow: {
    700: SalonizedColors.warning[400],
    600: SalonizedColors.warning[200],
    400: SalonizedColors.warning[100],
    200: SalonizedColors.warning[50],
    100: SalonizedColors.warning[50]
  },
  purple: {
    700: "#633EB2",
    600: "#8E5AFF",
    400: "#AF8BFF",
    200: "#D1BDFF",
    100: "#F3EEFF"
  },
  pink: {
    700: "#B28085",
    600: "#FFB8BE",
    400: "#FFCDD1",
    200: "#FFE2E5",
    100: "#FFF7F8"
  },
  white: "#FFFFFF",
  black: "#000000",
  transparent: "rgba(0, 0, 0, 0)"
};

// src/theme/index.ts
var FALLBACK_ICON = "tw-pro:question" /* TW_PRO_QUESTION */;
function useIcon(location) {
  const theme = useTheme();
  return theme?.icons?.[location] || FALLBACK_ICON;
}
var ThemeName = /* @__PURE__ */ ((ThemeName2) => {
  ThemeName2["TW_PRO"] = "TW_PRO";
  ThemeName2["WAVY"] = "WAVY";
  ThemeName2["SALONIZED"] = "SALONIZED";
  return ThemeName2;
})(ThemeName || {});
async function loadTheme(theme) {
  switch (theme) {
    case "TW_PRO" /* TW_PRO */:
      return (await Promise.resolve().then(() => (init_pro(), pro_exports))).ProTheme;
    case "WAVY" /* WAVY */:
      return (await Promise.resolve().then(() => (init_wavy(), wavy_exports))).WavyTheme;
    case "SALONIZED" /* SALONIZED */:
      return (await Promise.resolve().then(() => (init_salonized2(), salonized_exports2))).SalonizedTheme;
    default:
      throw new Error(`Unknown theme ${theme}`);
  }
}

// src/components/checkbox/index.tsx
import { jsx as jsx323, jsxs as jsxs14 } from "@emotion/react/jsx-runtime";
function CheckBox({
  ariaLabel,
  checked = false,
  disabled = false,
  id,
  label,
  onChange,
  readOnly = false,
  required = false,
  children,
  className
}) {
  const icon = useIcon("checkBox");
  const checkBoxId = useMemo2(() => id || randomString(), [id]);
  const [isChecked, setIsChecked] = useState(checked);
  const _children = useMemo2(() => {
    if (children) {
      return children;
    }
    if (label) {
      return /* @__PURE__ */ jsx323("span", { className: "aura--checkbox-label", children: label });
    }
    return null;
  }, [children, label]);
  useEffect(() => {
    setIsChecked(checked);
  }, [checked]);
  return /* @__PURE__ */ jsxs14(
    "label",
    {
      className: cx(
        "aura--checkbox",
        {
          disabled,
          "read-only": readOnly,
          checked: isChecked
        },
        className
      ),
      "aria-label": ariaLabel || label || void 0,
      htmlFor: checkBoxId,
      children: [
        isChecked && /* @__PURE__ */ jsx323(
          PlainIcon,
          {
            color: "",
            size: 0,
            backgroundColor: "",
            name: icon,
            className: "aura--checkbox-checked"
          }
        ),
        !isChecked && /* @__PURE__ */ jsx323("div", { className: "aura--checkbox-empty" }),
        /* @__PURE__ */ jsx323(
          "input",
          {
            disabled,
            id: checkBoxId,
            checked: isChecked,
            onChange: (e) => {
              setIsChecked(e.currentTarget.checked);
              onChange(e.currentTarget.checked);
            },
            readOnly,
            type: "checkbox",
            required
          }
        ),
        _children
      ]
    }
  );
}

// src/components/flash-message/index.tsx
import { css as css2 } from "@emotion/react";
init_icons();
import { jsx as jsx324, jsxs as jsxs15 } from "@emotion/react/jsx-runtime";
var flavorToClassName2 = {
  default: "aura--flash-message-default",
  success: "aura--flash-message-success",
  warning: "aura--flash-message-warning",
  error: "aura--flash-message-error"
};
function FlashMessageIcon(props) {
  const successIcon = useIcon("flashMessageSuccess");
  const warningIcon = useIcon("flashMessageWarning");
  const errorIcon = useIcon("flashMessageError");
  const defaultIcon = useIcon("flashMessageDefault");
  switch (props.flavor) {
    case "success":
      return /* @__PURE__ */ jsx324(Icon, { name: successIcon, size: "small" /* SMALL */ });
    case "warning":
      return /* @__PURE__ */ jsx324(Icon, { name: warningIcon, size: "small" /* SMALL */ });
    case "error":
      return /* @__PURE__ */ jsx324(Icon, { name: errorIcon, size: "small" /* SMALL */ });
    case "default":
    default:
      return /* @__PURE__ */ jsx324(Icon, { name: defaultIcon, size: "small" /* SMALL */ });
  }
}
function FlashMessage({
  flavor,
  message,
  onDismiss,
  className
}) {
  const onDismissHandler = useSafeHandler(onDismiss);
  const closeIcon = useIcon("flashMessageClose");
  return /* @__PURE__ */ jsxs15(
    "div",
    {
      className: cx(
        "aura--flash-message",
        flavorToClassName2[flavor],
        className
      ),
      children: [
        /* @__PURE__ */ jsxs15(
          "div",
          {
            className: "aura--copy-sm-constant",
            css: css2({
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              gap: 16
            }),
            children: [
              /* @__PURE__ */ jsx324("div", { className: "aura--flash-message-icon", children: /* @__PURE__ */ jsx324(FlashMessageIcon, { flavor }) }),
              /* @__PURE__ */ jsx324("div", { children: message })
            ]
          }
        ),
        onDismissHandler && /* @__PURE__ */ jsx324(
          "button",
          {
            className: "aura--flash-message-close-button",
            onClick: onDismissHandler,
            children: /* @__PURE__ */ jsx324(Icon, { name: closeIcon, size: "small" /* SMALL */ })
          }
        )
      ]
    }
  );
}

// src/components/grid/index.tsx
import { forwardRef } from "react";
import { jsx as jsx325 } from "@emotion/react/jsx-runtime";
var Grid2 = forwardRef(
  (props, ref) => {
    const classNames = ["aura--grid"];
    if (props.className) {
      classNames.push(props.className);
    }
    return /* @__PURE__ */ jsx325("div", { className: classNames.join(" "), ref, children: props.children });
  }
);

// src/components/icon-button/index.tsx
init_icons();
import { jsx as jsx326 } from "@emotion/react/jsx-runtime";
var flavorToClassName3 = {
  primary: "aura--button-primary",
  secondary: "aura--button-secondary",
  tertiary: "aura--button-tertiary"
};
function IconButton({
  backgroundColor,
  ariaLabel,
  name,
  flavor,
  size,
  disabled,
  onClick,
  color,
  type,
  disruptive = false,
  className
}) {
  const onClickHandler = useSafeHandler(onClick);
  return /* @__PURE__ */ jsx326(
    "button",
    {
      "aria-label": ariaLabel,
      disabled,
      onClick: onClickHandler,
      className: cx(
        size === "medium" ? "aura--icon-button-md" : "aura--icon-button-sm",
        flavorToClassName3[flavor],
        { "aura--button-disruptive": disruptive },
        className
      ),
      style: {
        backgroundColor
      },
      type,
      children: /* @__PURE__ */ jsx326(Icon, { name, size, color })
    }
  );
}

// src/components/input/index.tsx
import {
  useState as useState2,
  useEffect as useEffect2,
  useCallback
} from "react";
import { css as css3 } from "@emotion/react";
import { jsx as jsx327, jsxs as jsxs16 } from "@emotion/react/jsx-runtime";
function Input(props) {
  const {
    label,
    id,
    type,
    value,
    onValueChange,
    floatLabel = true,
    onFocus,
    onBlur,
    onKeyDown,
    disabled,
    autoFocus,
    autoComplete,
    innerRightComponent,
    subText,
    subTextFlavor,
    innerLeftComponent,
    onInputRef,
    inputMode,
    maxLength,
    pattern
  } = props;
  const [inputRef, setInputRef] = useState2(null);
  const [autofill, setAutofill] = useState2(false);
  const [left, setLeft] = useState2(0);
  const [right, setRight] = useState2(0);
  const measuredLeftRef = useCallback((node) => {
    if (node) {
      setLeft(node.getBoundingClientRect().width + 8);
    } else {
      setLeft(0);
    }
  }, []);
  const measuredRightRef = useCallback((node) => {
    if (node) {
      setRight(node.getBoundingClientRect().width + 8);
    } else {
      setRight(0);
    }
  }, []);
  useEffect2(() => {
    onInputRef?.(inputRef);
  }, [onInputRef, inputRef]);
  const onAnimationStart = useCallback((e) => {
    if (e.animationName === "onautofillstart") {
      setAutofill(true);
    } else if (e.animationName === "onautofillcancel") {
      setAutofill(false);
    }
  }, []);
  useEffect2(() => {
    if (!inputRef) {
      return void 0;
    }
    inputRef.addEventListener("animationstart", onAnimationStart);
    return () => {
      inputRef.removeEventListener("animationstart", onAnimationStart);
    };
  }, [inputRef, onAnimationStart, autofill]);
  return /* @__PURE__ */ jsxs16(
    "div",
    {
      className: cx("aura--input-container", {
        "has-value": !!value.length,
        "has-error": subTextFlavor === "error",
        "has-autofill": autofill,
        "no-float": floatLabel === false
      }),
      children: [
        /* @__PURE__ */ jsx327(
          "label",
          {
            htmlFor: id,
            className: "aura--input-label",
            css: css3({
              left: left || 18,
              right: right || 18
            }),
            children: label
          }
        ),
        /* @__PURE__ */ jsxs16("div", { className: "aura--input-internal-container", children: [
          innerLeftComponent && /* @__PURE__ */ jsx327(
            "div",
            {
              ref: measuredLeftRef,
              className: "aura--input-inner-left-component-wrapper",
              children: /* @__PURE__ */ jsx327("div", { children: innerLeftComponent })
            }
          ),
          /* @__PURE__ */ jsx327(
            "input",
            {
              id,
              ref: setInputRef,
              className: "aura--input",
              css: css3({
                padding: 0,
                margin: 0,
                paddingLeft: left || 18,
                paddingRight: right || 18,
                marginLeft: -left,
                marginRight: -right,
                width: `calc(100% + ${left}px + ${right}px)`
              }),
              value,
              onChange: (e) => onValueChange(e.target.value),
              type,
              onFocus,
              onBlur,
              onKeyDown,
              disabled,
              autoFocus,
              autoComplete,
              inputMode,
              maxLength,
              pattern
            }
          ),
          /* @__PURE__ */ jsx327(
            "fieldset",
            {
              className: "aura--input-fieldset",
              css: css3({
                paddingLeft: (left || 18) - 8,
                height: "calc(100% + 8px)"
              }),
              children: /* @__PURE__ */ jsx327("legend", { className: "aura--input-legend", children: label })
            }
          ),
          innerRightComponent && /* @__PURE__ */ jsx327(
            "div",
            {
              ref: measuredRightRef,
              className: "aura--input-inner-right-component-wrapper",
              children: /* @__PURE__ */ jsx327("div", { children: innerRightComponent })
            }
          )
        ] }),
        subText && /* @__PURE__ */ jsx327(
          "div",
          {
            className: cx("aura--input-subtext", {
              "aura--error-label": subTextFlavor === "error",
              "aura--success-label": subTextFlavor === "success"
            }),
            children: subText
          }
        )
      ]
    }
  );
}

// src/components/label/index.tsx
import { css as css4 } from "@emotion/react";
import { jsxs as jsxs17 } from "@emotion/react/jsx-runtime";
function Label({
  label,
  color,
  backgroundColor,
  size = "normal",
  leftIcon,
  rightIcon
}) {
  return /* @__PURE__ */ jsxs17(
    "span",
    {
      className: cx(
        "aura--label",
        size === "normal" ? "aura--copy-normal" : "aura--copy-xs"
      ),
      css: css4({
        backgroundColor,
        color,
        borderRadius: 4
      }),
      children: [
        leftIcon,
        label,
        rightIcon
      ]
    }
  );
}

// src/components/link/internal.tsx
init_icons();
import { Fragment as Fragment2 } from "react";
import { jsx as jsx328 } from "@emotion/react/jsx-runtime";
var InternalLinkComponent = DefaultLinkComponent;
function setLinkComponent(LinkComponent) {
  InternalLinkComponent = LinkComponent;
}
function DefaultLinkComponent({
  to,
  children,
  className,
  onClick
}) {
  return /* @__PURE__ */ jsx328("a", { href: to, className, onClick, children });
}
function InternalLink({
  children,
  to,
  leftIconName,
  rightIconName,
  className,
  state,
  onClick
}) {
  const elements = [];
  if (leftIconName) {
    elements.push(
      /* @__PURE__ */ jsx328(
        Icon,
        {
          name: leftIconName,
          size: "small" /* SMALL */,
          color: "#000000"
        },
        "left"
      )
    );
  }
  elements.push(/* @__PURE__ */ jsx328(Fragment2, { children }, "center"));
  if (rightIconName) {
    elements.push(
      /* @__PURE__ */ jsx328(
        Icon,
        {
          name: rightIconName,
          size: "small" /* SMALL */,
          color: "#000000"
        },
        "right"
      )
    );
  }
  return /* @__PURE__ */ jsx328(
    InternalLinkComponent,
    {
      onClick,
      to,
      className,
      state,
      children: elements
    }
  );
}

// src/components/link/link.tsx
import { jsx as jsx329 } from "@emotion/react/jsx-runtime";
function Link4({
  children,
  to,
  leftIconName,
  rightIconName,
  state,
  className,
  onClick
}) {
  return /* @__PURE__ */ jsx329(
    InternalLink,
    {
      to,
      className: ["aura--link", className].join(" ").trim(),
      leftIconName,
      rightIconName,
      state,
      onClick,
      children
    }
  );
}

// src/components/link/link-as-button.tsx
import { jsx as jsx330 } from "@emotion/react/jsx-runtime";
function LinkAsButton({
  children,
  to,
  leftIconName,
  rightIconName,
  state,
  size,
  disruptive,
  className,
  block,
  flavor,
  onClick
}) {
  return /* @__PURE__ */ jsx330(
    InternalLink,
    {
      to,
      leftIconName,
      rightIconName,
      state,
      className: buttonClassNames({
        size,
        flavor,
        disruptive,
        className: ["aura--link-as-button", className].join(" ").trim(),
        block
      }),
      onClick,
      children
    }
  );
}

// src/components/link/raw-link.tsx
import { jsx as jsx331 } from "@emotion/react/jsx-runtime";
function RawLink({
  children,
  to,
  leftIconName,
  rightIconName,
  state,
  className
}) {
  return /* @__PURE__ */ jsx331(
    InternalLink,
    {
      to,
      leftIconName,
      rightIconName,
      state,
      className,
      children
    }
  );
}

// src/components/loader/pro.tsx
import { css as css5, keyframes } from "@emotion/react";
import { jsx as jsx332, jsxs as jsxs18 } from "@emotion/react/jsx-runtime";
function LoaderPro({ size = 64 }) {
  const rotation = keyframes({
    "0%": {
      transform: "rotate(0deg)"
    },
    "100%": {
      transform: "rotate(360deg)"
    }
  });
  return /* @__PURE__ */ jsx332(
    "div",
    {
      css: css5({
        flexGrow: 1,
        height: "100%",
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      }),
      children: /* @__PURE__ */ jsxs18(
        "svg",
        {
          width: size,
          height: size,
          viewBox: "0 0 64 64",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          css: css5({
            animation: `${rotation} 1s linear infinite`
          }),
          children: [
            /* @__PURE__ */ jsx332(
              "path",
              {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M32 60C47.464 60 60 47.464 60 32C60 16.536 47.464 4 32 4C16.536 4 4 16.536 4 32C4 47.464 16.536 60 32 60ZM32 64C49.6731 64 64 49.6731 64 32C64 14.3269 49.6731 0 32 0C14.3269 0 0 14.3269 0 32C0 49.6731 14.3269 64 32 64Z",
                fill: "white"
              }
            ),
            /* @__PURE__ */ jsx332(
              "path",
              {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M2 30C3.10457 30 4 30.8954 4 32C4 47.464 16.536 60 32 60C33.1046 60 34 60.8954 34 62C34 63.1046 33.1046 64 32 64C14.3269 64 0 49.6731 0 32C0 30.8954 0.89543 30 2 30Z",
                fill: "#4036ED"
              }
            )
          ]
        }
      )
    }
  );
}

// src/components/loader/wavy.tsx
import { css as css6, keyframes as keyframes2 } from "@emotion/react";
import { jsx as jsx333, jsxs as jsxs19 } from "@emotion/react/jsx-runtime";
function LoaderWavy({ size = 36 }) {
  const rotation = keyframes2({
    "0%": {
      transform: "rotate(0deg)"
    },
    "100%": {
      transform: "rotate(360deg)"
    }
  });
  return /* @__PURE__ */ jsx333(
    "div",
    {
      css: css6({
        flexGrow: 1,
        height: "100%",
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      }),
      children: /* @__PURE__ */ jsxs19(
        "svg",
        {
          width: size,
          height: size,
          viewBox: "0 0 32 32",
          css: css6({
            animationTimingFunction: "linear",
            animationDuration: "0.75s",
            animationName: rotation,
            animationIterationCount: "infinite"
          }),
          children: [
            /* @__PURE__ */ jsx333(
              "circle",
              {
                cx: "16",
                cy: "16",
                fill: "none",
                r: "14",
                strokeWidth: "4",
                style: { stroke: "rgb(155, 155, 155)", opacity: 0.2 }
              }
            ),
            /* @__PURE__ */ jsx333(
              "circle",
              {
                cx: "16",
                cy: "16",
                fill: "none",
                r: "14",
                strokeWidth: "4",
                style: {
                  stroke: "rgb(155, 155, 155)",
                  strokeDasharray: 80,
                  strokeDashoffset: 60
                }
              }
            )
          ]
        }
      )
    }
  );
}

// src/components/otp-input/index.tsx
import { useRef as useRef2, useCallback as useCallback2, useEffect as useEffect3 } from "react";
import { css as css7 } from "@emotion/react";
import { jsx as jsx334, jsxs as jsxs20 } from "@emotion/react/jsx-runtime";
var OTPInput = ({
  length,
  value,
  onValueChange,
  subText,
  subTextFlavor,
  autoFocus
}) => {
  const inputsRef = useRef2(new Array(length));
  const handleChange = useCallback2(
    (element, index) => {
      const { value: inputValue } = element;
      const newOtp = value.split("");
      newOtp[index] = inputValue;
      onValueChange(newOtp.join(""));
      if (index < length - 1 && inputValue) {
        inputsRef.current[index + 1]?.focus();
      }
    },
    [length, value, onValueChange]
  );
  const handlePaste = useCallback2(
    (event) => {
      const pasteData = event.clipboardData.getData("text").replace(/[^0-9]/g, "").slice(0, length);
      onValueChange(pasteData);
      event.preventDefault();
    },
    [length, onValueChange]
  );
  const handleKeyDown = useCallback2(
    (event) => {
      if (event.key === "Backspace" || event.key === "Delete") {
        event.preventDefault();
        onValueChange(value.slice(0, -1));
      }
    },
    [value, onValueChange]
  );
  const hasSomeFocus = useRef2(false);
  const onFocus = useCallback2(() => {
    inputsRef.current[value.length]?.focus();
    hasSomeFocus.current = true;
  }, [value]);
  const onBlur = useCallback2(() => {
    hasSomeFocus.current = false;
  }, []);
  useEffect3(() => {
    if (hasSomeFocus.current) {
      inputsRef.current[value.length]?.focus();
    }
  }, [value]);
  return /* @__PURE__ */ jsxs20("div", { children: [
    /* @__PURE__ */ jsx334("fieldset", { className: "aura--otp-input-fieldset", children: new Array(length).fill("").map((_, index) => /* @__PURE__ */ jsx334(
      "input",
      {
        className: "aura--otp-input",
        type: "text",
        maxLength: 1,
        value: value[index] || "",
        onChange: (e) => handleChange(e.target, index),
        onPaste: handlePaste,
        onKeyDown: handleKeyDown,
        onFocus,
        onBlur,
        ref: (el) => {
          inputsRef.current[index] = el;
        },
        tabIndex: index === 0 ? 0 : -1,
        autoFocus: autoFocus && index === 0
      },
      index
    )) }),
    subText && /* @__PURE__ */ jsx334(
      "div",
      {
        className: cx("aura--input-subtext", {
          "aura--error-label": subTextFlavor === "error",
          "aura--success-label": subTextFlavor === "success"
        }),
        css: css7({
          marginLeft: 0,
          marginTop: 8
        }),
        children: subText
      }
    )
  ] });
};

// src/components/select/index.tsx
init_icons();
import {
  useCallback as useCallback3,
  useRef as useRef3,
  useState as useState3,
  useEffect as useEffect4
} from "react";
import { css as css8 } from "@emotion/react";
import { jsx as jsx335, jsxs as jsxs21 } from "@emotion/react/jsx-runtime";
var defaultFilterOptionFn = (input, option) => {
  return option.label.toLowerCase().startsWith(input.toLowerCase());
};
function DropdownIndicator() {
  const icon = useIcon("selectDropdown");
  return /* @__PURE__ */ jsx335(Icon, { name: icon, size: "small" /* SMALL */, color: "" });
}
function SelectOption(props) {
  const { option, onClick, selected } = props;
  const wrappedOnClick = useCallback3(() => {
    onClick(option);
  }, [option, onClick]);
  const wrappedSafeOnClick = useSafeHandler(wrappedOnClick);
  const onMouseDown = useCallback3((e) => {
    e.preventDefault();
  }, []);
  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions
    /* @__PURE__ */ jsx335(
      "div",
      {
        onMouseDown,
        onClick: wrappedSafeOnClick,
        className: cx(
          "aura--select-option",
          selected ? "aura--select-option-selected" : void 0
        ),
        children: option.component || option.label
      }
    )
  );
}
function Select(props) {
  const {
    id,
    label,
    value,
    options,
    onChange,
    onInputChange,
    autoClearInput = true,
    filterOptionsFn = defaultFilterOptionFn,
    iconName,
    className,
    disabled = false,
    autoComplete = "off",
    subText,
    subTextFlavor,
    innerRightComponent,
    onBlur: onBlurProp
  } = props;
  const [open, setOpen] = useState3(false);
  const [inputValue, setInputValue] = useState3("");
  const inputRef = useRef3(null);
  const onFocus = useCallback3(() => {
    setOpen(true);
  }, []);
  const onBlur = useCallback3(
    (e) => {
      onBlurProp?.(e);
      if (autoClearInput) {
        setInputValue("");
      }
      setOpen(false);
    },
    [autoClearInput, onBlurProp]
  );
  const onClickOption = useCallback3(
    (option) => {
      if (autoClearInput) {
        setInputValue("");
      }
      onChange(option);
      inputRef.current?.blur();
      setOpen(false);
    },
    [onChange, autoClearInput]
  );
  const onKeyDown = (e) => {
    if (e.key === "Escape") {
      inputRef.current?.blur();
    }
  };
  useEffect4(() => {
    onInputChange?.(inputValue);
  }, [onInputChange, inputValue]);
  const matchingOptions = options.filter((option) => filterOptionsFn(inputValue, option)).map((option) => /* @__PURE__ */ jsx335(
    SelectOption,
    {
      option,
      onClick: onClickOption,
      selected: option.value === value?.value
    },
    option.key || `${option.value}`
  ));
  return /* @__PURE__ */ jsxs21("div", { className: `aura--select ${className || ""}`, children: [
    /* @__PURE__ */ jsx335("div", { className: "aura--select-input", children: /* @__PURE__ */ jsx335(
      Input,
      {
        onInputRef: (r) => {
          inputRef.current = r;
        },
        disabled,
        id,
        label,
        type: "text",
        value: open ? inputValue : value?.label || "",
        onValueChange: setInputValue,
        innerRightComponent: innerRightComponent || (disabled ? void 0 : /* @__PURE__ */ jsx335(DropdownIndicator, {})),
        onFocus,
        onBlur,
        onKeyDown,
        autoComplete,
        innerLeftComponent: iconName ? /* @__PURE__ */ jsx335(Icon, { name: iconName, size: "small" /* SMALL */, color: "#000000" }) : void 0,
        subText,
        subTextFlavor
      }
    ) }),
    /* @__PURE__ */ jsx335(
      "div",
      {
        className: "aura--select-options-section",
        css: css8({ display: open ? void 0 : "none" }),
        children: /* @__PURE__ */ jsx335("div", { className: "aura--select-options-container", children: /* @__PURE__ */ jsx335("div", { className: "aura--select-options", children: matchingOptions }) })
      }
    )
  ] });
}

// src/components/tag/index.tsx
init_icons();
import { jsx as jsx336, jsxs as jsxs22 } from "@emotion/react/jsx-runtime";
function Tag({
  label,
  selected,
  counter,
  onSetSelected,
  hideClose
}) {
  const icon = useIcon("tagClose");
  const onSetSelectedHandler = useSafeHandler(onSetSelected);
  const hasCounter = typeof counter === "number";
  return /* @__PURE__ */ jsx336(
    "button",
    {
      onClick: () => onSetSelectedHandler(!selected),
      className: cx("aura--tag", selected ? "selected" : void 0),
      type: "button",
      children: /* @__PURE__ */ jsxs22("div", { className: "aura--tag-row", children: [
        label,
        hasCounter && /* @__PURE__ */ jsx336("div", { className: "aura--captions-xs aura--tag-counter", children: counter }),
        selected && !hideClose && /* @__PURE__ */ jsx336(Icon, { name: icon, size: "small" /* SMALL */, color: "White" })
      ] })
    }
  );
}

// src/hooks/use-media-query.ts
import { useEffect as useEffect5, useState as useState4 } from "react";
var getMatches = (q) => window.matchMedia(q).matches;
function useMediaQuery(query) {
  const [matches, setMatches] = useState4(getMatches(query));
  useEffect5(() => {
    const handleChange = () => {
      setMatches(getMatches(query));
    };
    const matchMedia = window.matchMedia(query);
    handleChange();
    try {
      matchMedia.addEventListener("change", handleChange);
    } catch {
      matchMedia.addListener(handleChange);
    }
    return () => {
      try {
        matchMedia.removeEventListener("change", handleChange);
      } catch {
        matchMedia.removeListener(handleChange);
      }
    };
  }, [query]);
  return matches;
}

// src/hooks/use-screen-size.ts
import { useState as useState5, useEffect as useEffect6, useCallback as useCallback4 } from "react";
var ScreenSize = /* @__PURE__ */ ((ScreenSize2) => {
  ScreenSize2["XXS"] = "XXS";
  ScreenSize2["XS"] = "XS";
  ScreenSize2["SM"] = "SM";
  ScreenSize2["MD"] = "MD";
  ScreenSize2["L"] = "L";
  ScreenSize2["XL"] = "XL";
  ScreenSize2["XXL"] = "XXL";
  ScreenSize2["XXSAndOver"] = "XXSAndOver";
  ScreenSize2["XSAndOver"] = "XSAndOver";
  ScreenSize2["SMAndOver"] = "SMAndOver";
  ScreenSize2["MDAndOver"] = "MDAndOver";
  ScreenSize2["LAndOver"] = "LAndOver";
  ScreenSize2["XLAndOver"] = "XLAndOver";
  ScreenSize2["XXLAndOver"] = "XXLAndOver";
  ScreenSize2["XXSAndUnder"] = "XXSAndUnder";
  ScreenSize2["XSAndUnder"] = "XSAndUnder";
  ScreenSize2["SMAndUnder"] = "SMAndUnder";
  ScreenSize2["MDAndUnder"] = "MDAndUnder";
  ScreenSize2["LAndUnder"] = "LAndUnder";
  ScreenSize2["XLAndUnder"] = "XLAndUnder";
  ScreenSize2["XXLAndUnder"] = "XXLAndUnder";
  return ScreenSize2;
})(ScreenSize || {});
var ScreenSizeMediaQueries = {
  ["XXS" /* XXS */]: "only screen and (max-width: 375px)",
  ["XS" /* XS */]: "only screen and (min-width: 376px) and (max-width: 479px)",
  ["SM" /* SM */]: "only screen and (min-width: 480px) and (max-width: 767px)",
  ["MD" /* MD */]: "only screen and (min-width: 768px) and (max-width: 1023px)",
  ["L" /* L */]: "only screen and (min-width: 1024px) and (max-width: 1279px)",
  ["XL" /* XL */]: "only screen and (min-width: 1280px) and (max-width: 1439px)",
  ["XXL" /* XXL */]: "only screen and (min-width: 1440px)",
  ["XXSAndOver" /* XXSAndOver */]: "only screen and (min-width: 0px)",
  // always true
  ["XSAndOver" /* XSAndOver */]: "only screen and (min-width: 376px)",
  ["SMAndOver" /* SMAndOver */]: "only screen and (min-width: 480px)",
  ["MDAndOver" /* MDAndOver */]: "only screen and (min-width: 768px)",
  ["LAndOver" /* LAndOver */]: "only screen and (min-width: 1024px)",
  ["XLAndOver" /* XLAndOver */]: "only screen and (min-width: 1280px)",
  ["XXLAndOver" /* XXLAndOver */]: "only screen and (min-width: 1440px)",
  ["XXSAndUnder" /* XXSAndUnder */]: "only screen and (max-width: 375px)",
  ["XSAndUnder" /* XSAndUnder */]: "only screen and (max-width: 479px)",
  ["SMAndUnder" /* SMAndUnder */]: "only screen and (max-width: 767px)",
  ["MDAndUnder" /* MDAndUnder */]: "only screen and (max-width: 1023px)",
  ["LAndUnder" /* LAndUnder */]: "only screen and (max-width: 1279px)",
  ["XLAndUnder" /* XLAndUnder */]: "only screen and (max-width: 1439px)",
  ["XXLAndUnder" /* XXLAndUnder */]: "only screen and (min-width: 0px)"
  // always true
};
function useIsScreenSize(screenSize) {
  return useMediaQuery(ScreenSizeMediaQueries[screenSize]);
}
function useScreenSize() {
  const [dimensions, setDimensions] = useState5({
    height: window.innerHeight,
    width: window.innerWidth
  });
  const handleResize = useCallback4(() => {
    setDimensions({
      height: window.innerHeight,
      width: window.innerWidth
    });
  }, []);
  useEffect6(() => {
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [handleResize]);
  return dimensions;
}
export {
  Button,
  ButtonAsLink,
  CheckBox,
  FlashMessage,
  Grid2 as Grid,
  Icon,
  IconButton,
  IconName,
  IconSize,
  Input,
  Label,
  Link4 as Link,
  LinkAsButton,
  LoaderPro,
  LoaderWavy,
  OTPInput,
  PaymentCardBrand,
  PaymentIconSize,
  PaymentIconWrapper,
  PaymentMethodIcon,
  PaymentMethodType,
  PlainIcon,
  Colors as ProColors,
  RawLink,
  Colors3 as SalonizedColors,
  ScreenSize,
  Select,
  Tag,
  ThemeName,
  Colors2 as WavyColors,
  buttonClassNames,
  flavorToClassName2 as flavorToClassName,
  loadTheme,
  setLinkComponent,
  useIcon,
  useIsScreenSize,
  useMediaQuery,
  useScreenSize
};
